import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  UUID: any,
  Duration: any,
  DateTime: any,
  BigDecimal: any,
  InvariantDate: any,
  Long: any,
  Json: any,
};

export type _Service = {
   __typename?: '_Service',
  sdl: Scalars['String'],
};

export type AbTestVariant = {
   __typename?: 'AbTestVariant',
  testName: Scalars['String'],
  variant: Scalars['String'],
};

export type AccountCompanyInfluenceView = {
   __typename?: 'AccountCompanyInfluenceView',
  id: Scalars['UUID'],
  account_id: Scalars['UUID'],
  company_id: Scalars['Int'],
  created_at: Scalars['DateTime'],
  company_name: Scalars['String'],
};

export type AccountDealOrderView = {
   __typename?: 'AccountDealOrderView',
  accountId: Scalars['UUID'],
  companyId: Scalars['Int'],
  orderType: OrderType,
  isClosed: Scalars['Boolean'],
  dateFullyAccrued?: Maybe<Scalars['InvariantDate']>,
  volume: Scalars['BigDecimal'],
  revenue: Scalars['BigDecimal'],
  numShares: Scalars['Long'],
  sharePrice: Scalars['BigDecimal'],
  company: CompanyView,
};

export type AccountDealView = {
   __typename?: 'AccountDealView',
  companyId: Scalars['Int'],
  orderType: OrderType,
  isClosed: Scalars['Boolean'],
  dateFullyAccrued?: Maybe<Scalars['InvariantDate']>,
  orders: Array<AccountDealOrderView>,
  totalSellSideVolume: Scalars['BigDecimal'],
  totalSellSideRevenue: Scalars['BigDecimal'],
  totalBuySideVolume: Scalars['BigDecimal'],
  totalBuySideRevenue: Scalars['BigDecimal'],
  totalNumShares: Scalars['Long'],
  orderCount: Scalars['Int'],
  avgSharePrice: Scalars['BigDecimal'],
  company: CompanyView,
};

export type AccountDetailsFormInput = {
  id: Scalars['UUID'],
  type: Scalars['String'],
  client_type_id?: Maybe<Scalars['UUID']>,
  country?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  is_investor: Scalars['Boolean'],
  is_shareholder: Scalars['Boolean'],
  aum?: Maybe<Scalars['String']>,
  aum_secondaries?: Maybe<Scalars['String']>,
  has_done_secondaries_before?: Maybe<Scalars['Boolean']>,
  has_done_primaries_before?: Maybe<Scalars['Boolean']>,
  net_worth?: Maybe<Scalars['String']>,
  shareholder_notes?: Maybe<Scalars['String']>,
  investor_notes?: Maybe<Scalars['String']>,
  has_referrer?: Maybe<Scalars['Boolean']>,
  referrer_type?: Maybe<Scalars['String']>,
  referrer_id?: Maybe<Scalars['UUID']>,
  referral_notes?: Maybe<Scalars['String']>,
  investor_preferences?: Maybe<UpdateInvestorPreferencesFormInput>,
};

export type AccountHeaderFormInput = {
  id: Scalars['UUID'],
  name: Scalars['String'],
  is_investor: Scalars['Boolean'],
  is_shareholder: Scalars['Boolean'],
  client_type_id?: Maybe<Scalars['UUID']>,
  country?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  is_account_of_interest: Scalars['Boolean'],
  account_of_interest_reason?: Maybe<Scalars['String']>,
  is_forge_declined: Scalars['Boolean'],
  forge_declined_reason?: Maybe<Scalars['String']>,
  previous_location: DerivedLocationViewInput,
};

export type AccountRelationshipFormInput = {
  id?: Maybe<Scalars['UUID']>,
  sourceAccountId: Scalars['UUID'],
  sourceParentOrgId?: Maybe<Scalars['UUID']>,
  destAccountId?: Maybe<Scalars['UUID']>,
  destAccountName: Scalars['String'],
  destAccountType: Scalars['String'],
  destAccountClientTypeId?: Maybe<Scalars['UUID']>,
  destParentOrgId?: Maybe<Scalars['UUID']>,
  relationship: RelationshipType,
  startDate?: Maybe<Scalars['InvariantDate']>,
  title?: Maybe<Scalars['String']>,
  isIntermediary: Scalars['Boolean'],
};

export enum AccountRelationshipType {
  Employs = 'employs',
  AffiliatedWith = 'affiliated_with',
  ChildCompanyOf = 'child_company_of',
  Introduced = 'introduced'
}

export type AccountRelationshipView = {
   __typename?: 'AccountRelationshipView',
  id: Scalars['UUID'],
  child_account_id: Scalars['UUID'],
  parent_account_id: Scalars['UUID'],
  child_ranking: Scalars['Int'],
  title?: Maybe<Scalars['String']>,
  start_date?: Maybe<Scalars['InvariantDate']>,
  parent_to_child_relationship?: Maybe<AccountRelationshipType>,
  is_point_of_contact: Scalars['Boolean'],
  created_at: Scalars['DateTime'],
  introduction?: Maybe<IntroductionView>,
  parent_account: AccountView,
  child_account: AccountView,
};

export type AccountSearchView = {
   __typename?: 'AccountSearchView',
  individual_accounts: Array<AccountView>,
  organization_accounts: Array<AccountView>,
  issuer_accounts: Array<AccountView>,
};

export type AccountSource = {
   __typename?: 'AccountSource',
  account: AccountView,
};

export type AccountSuggestionView = {
   __typename?: 'AccountSuggestionView',
  id: Scalars['UUID'],
  admin_id: Scalars['Int'],
  front_contact_id: Scalars['UUID'],
  status: Scalars['String'],
  created_at: Scalars['DateTime'],
  front_contact: FrontContactView,
  recent_messages: Array<FrontMessageGroupView>,
};

export enum AccountType {
  Organization = 'organization',
  Individual = 'individual',
  Issuer = 'issuer'
}

export type AccountTypeaheadFilterInput = {
  types: Array<Scalars['String']>,
};

export type AccountUserView = {
   __typename?: 'AccountUserView',
  id: Scalars['UUID'],
  net_worth?: Maybe<Scalars['String']>,
  has_done_secondaries_before?: Maybe<Scalars['Boolean']>,
  has_private_market_experience?: Maybe<Scalars['Boolean']>,
  has_done_primaries_before?: Maybe<Scalars['Boolean']>,
  investor_preferences?: Maybe<InvestorAccountPreferencesRead>,
  primary_contact_method?: Maybe<Scalars['String']>,
};


export type AccountUserViewPrimary_Contact_MethodArgs = {
  channel: ContactMethodChannel
};

export type AccountView = {
   __typename?: 'AccountView',
  id: Scalars['UUID'],
  first_name?: Maybe<Scalars['String']>,
  last_name?: Maybe<Scalars['String']>,
  organization_name?: Maybe<Scalars['String']>,
  type: AccountType,
  is_investor?: Maybe<Scalars['Boolean']>,
  is_shareholder?: Maybe<Scalars['Boolean']>,
  client_type_id?: Maybe<Scalars['UUID']>,
  country?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  aum?: Maybe<Scalars['String']>,
  aum_secondaries?: Maybe<Scalars['String']>,
  net_worth?: Maybe<Scalars['String']>,
  notes?: Maybe<Scalars['String']>,
  has_done_secondaries_before?: Maybe<Scalars['Boolean']>,
  has_private_market_experience?: Maybe<Scalars['Boolean']>,
  has_done_primaries_before?: Maybe<Scalars['Boolean']>,
  shareholder_notes?: Maybe<Scalars['String']>,
  investor_notes?: Maybe<Scalars['String']>,
  relationship_strength?: Maybe<Scalars['String']>,
  relationship_sensitivity?: Maybe<Scalars['String']>,
  relationship_notes?: Maybe<Scalars['String']>,
  ownable_id?: Maybe<Scalars['UUID']>,
  has_referrer?: Maybe<Scalars['Boolean']>,
  referrer_type?: Maybe<Scalars['String']>,
  referrer_id?: Maybe<Scalars['UUID']>,
  referral_notes?: Maybe<Scalars['String']>,
  marketplace_notes?: Maybe<Scalars['String']>,
  partnerships_relationship_strength?: Maybe<Scalars['String']>,
  partnerships_relationship_sensitivity?: Maybe<Scalars['String']>,
  partnerships_relationship_notes?: Maybe<Scalars['String']>,
  partnerships_notes?: Maybe<Scalars['String']>,
  source: Scalars['String'],
  folder_id?: Maybe<Scalars['Int']>,
  outreach_schedule?: Maybe<Scalars['Duration']>,
  outreach_schedule_overriden: Scalars['Boolean'],
  is_account_of_interest?: Maybe<Scalars['Boolean']>,
  account_of_interest_set_by?: Maybe<Scalars['Int']>,
  account_of_interest_reason?: Maybe<Scalars['String']>,
  is_forge_declined: Scalars['Boolean'],
  forge_declined_set_by?: Maybe<Scalars['Int']>,
  forge_declined_reason?: Maybe<Scalars['String']>,
  created_by?: Maybe<Scalars['Int']>,
  created_at: Scalars['DateTime'],
  qualified?: Maybe<Scalars['Boolean']>,
  business_development_tier?: Maybe<Scalars['Int']>,
  name: Scalars['String'],
  admin_created_by?: Maybe<UserView>,
  img: Scalars['String'],
  user?: Maybe<UserView>,
  intermediary?: Maybe<AccountRelationshipView>,
  entities: Array<EntityView>,
  client_type?: Maybe<Scalars['String']>,
  investor_preferences?: Maybe<InvestorPreferencesView>,
  interactions: Array<InteractionView>,
  relationships: Array<AccountRelationshipView>,
  parents: Array<AccountRelationshipView>,
  introducedRelationships: Array<AccountRelationshipView>,
  introducedByRelationships: Array<AccountRelationshipView>,
  opportunities: Array<OpportunityView>,
  transacted_as: Array<Scalars['String']>,
  issuer_account?: Maybe<IssuerAccountView>,
  referrer?: Maybe<AccountView>,
  owners: Array<OwnerView>,
  participates_in_secondaries?: Maybe<Scalars['Boolean']>,
  holdings: Array<HoldingView>,
  has_influence_with: Array<AccountCompanyInfluenceView>,
  contact_methods: Array<ContactMethodView>,
  email?: Maybe<Scalars['String']>,
  phone_number?: Maybe<Scalars['String']>,
  formatted_phone_number?: Maybe<Scalars['String']>,
  bid_companies: Array<CompanyView>,
  ask_companies: Array<CompanyView>,
  last_order_created_date?: Maybe<Scalars['DateTime']>,
  last_order_closed_date?: Maybe<Scalars['InvariantDate']>,
  avg_order_size?: Maybe<Scalars['BigDecimal']>,
  num_active_orders: Scalars['Int'],
  num_closed_orders: Scalars['Int'],
  num_closed_deals: Scalars['Int'],
  num_active_deals: Scalars['Int'],
  deals: Array<AccountDealView>,
  order_structures: Array<Scalars['String']>,
  companies_of_interest: Array<CompanyView>,
  purchased_companies: Array<CompanyView>,
  account_level?: Maybe<Scalars['Int']>,
  derived_location: DerivedLocationView,
  last_outreach_at?: Maybe<Scalars['DateTime']>,
  last_outreach_by?: Maybe<UserView>,
  last_outreach_interaction?: Maybe<InteractionView>,
  last_front_message_id?: Maybe<Scalars['String']>,
  do_not_contact_reasons: Array<DoNotContactReason>,
  account_of_interest_set_by_admin?: Maybe<UserView>,
  forge_declined_set_by_admin?: Maybe<UserView>,
  linkedin_job?: Maybe<LinkedinJobView>,
  last_opportunity_created_date?: Maybe<Scalars['DateTime']>,
  num_outreaches_past_month: Scalars['Int'],
  average_days_between_outreach_past_6_months?: Maybe<Scalars['Float']>,
  std_dev_days_between_outreach_past_6_months?: Maybe<Scalars['Float']>,
  average_days_between_outreach_past_year?: Maybe<Scalars['Float']>,
  std_dev_days_between_outreach_past_year?: Maybe<Scalars['Float']>,
  region?: Maybe<Scalars['String']>,
  files: Array<FileView>,
  introducer_accounts: Array<AccountView>,
  last_outreach_by_anyone?: Maybe<Scalars['DateTime']>,
  last_outreach_by_anyone_admin?: Maybe<UserView>,
  num_introductions: Scalars['Int'],
  profilingAssignees: Array<Maybe<UserView>>,
  leadStatus?: Maybe<TodoItemStatusType>,
};


export type AccountViewInteractionsArgs = {
  groupFilter?: Maybe<InteractionFilter>
};


export type AccountViewDealsArgs = {
  onlyClosed: Scalars['Boolean'],
  orderType?: Maybe<OrderType>
};

export type AccreditationRead = {
   __typename?: 'AccreditationRead',
  id: Scalars['Int'],
  accreditation_entity_id: Scalars['Int'],
  total_household_income?: Maybe<Scalars['String']>,
  marital_status?: Maybe<Scalars['String']>,
  will_income_level_repeat_this_year?: Maybe<Scalars['Boolean']>,
  net_worth_excluding_primary_residence?: Maybe<Scalars['String']>,
  is_trust_revocable?: Maybe<Scalars['Boolean']>,
  value_of_trusts_assets?: Maybe<Scalars['String']>,
  value_of_companys_assets?: Maybe<Scalars['String']>,
  are_all_company_owners_accredited?: Maybe<Scalars['Boolean']>,
  are_all_company_owners_qualified_purchasers?: Maybe<Scalars['Boolean']>,
  net_worth_greater_than_million?: Maybe<Scalars['Boolean']>,
  net_income_greater_than_200k?: Maybe<Scalars['Boolean']>,
  company_is_bd_or_other_legit_entity?: Maybe<Scalars['Boolean']>,
  entity_with_greater_than_5m?: Maybe<Scalars['Boolean']>,
  entity_with_owner_meeting_one_of_the_above?: Maybe<Scalars['Boolean']>,
  user_has_attested_is_accredited?: Maybe<Scalars['Boolean']>,
  user_has_attested_is_qualified_purchaser?: Maybe<Scalars['Boolean']>,
  are_all_trustees_accredited?: Maybe<Scalars['Boolean']>,
  is_accredited_employee_benefit_plan?: Maybe<Scalars['Boolean']>,
  is_company_type_exempt_or_plan_with_5m_assets?: Maybe<Scalars['Boolean']>,
  is_company_over_5m_not_formed_for_transaction?: Maybe<Scalars['Boolean']>,
  qp_qualification?: Maybe<Scalars['String']>,
  entity_id: Scalars['Int'],
  passes_accreditation_requirements: Scalars['Boolean'],
  passes_qualified_purchaser_requirements: Scalars['Boolean'],
};

export type Action = {
   __typename?: 'Action',
  name: Scalars['String'],
  params: Array<ActionParam>,
  kind: ActionKind,
  mutation: ColumnMutation,
  onlyInColumn: Scalars['Boolean'],
  onlyIfVisible: Scalars['Boolean'],
  onlyIfExists: Scalars['Boolean'],
  onlyIfNotExists: Scalars['Boolean'],
  onlyIfValue?: Maybe<Scalars['Json']>,
  onlyIfValues?: Maybe<Scalars['Json']>,
  displayName: Scalars['String'],
  multiRowAction: Scalars['Boolean'],
  refetchPolicy: Scalars['String'],
};

export type ActionKind = {
   __typename?: 'ActionKind',
  name: Scalars['String'],
  data: Scalars['Json'],
};

export type ActionParam = {
   __typename?: 'ActionParam',
  fieldName: Scalars['String'],
  columnType: ColumnType,
  required: Scalars['Boolean'],
};

export type Address = {
   __typename?: 'Address',
  address_street_1?: Maybe<Scalars['String']>,
  address_street_2?: Maybe<Scalars['String']>,
  address_city?: Maybe<Scalars['String']>,
  address_state?: Maybe<Scalars['String']>,
  address_postal_code?: Maybe<Scalars['String']>,
  address_country_code?: Maybe<Scalars['String']>,
};

export type AdminEmailPreferences = {
   __typename?: 'AdminEmailPreferences',
  opt_in_newsletter_emails: Scalars['Boolean'],
  opt_in_opportunity_emails: Scalars['Boolean'],
  opt_in_general_marketing_emails: Scalars['Boolean'],
};

export type Answer = {
   __typename?: 'Answer',
  id: Scalars['Int'],
  answer: Scalars['String'],
  blockscore_id: Scalars['Int'],
};

export type AskRead = {
   __typename?: 'AskRead',
  id: Scalars['UUID'],
  entity_id?: Maybe<Scalars['Int']>,
  status: Scalars['String'],
  share_price?: Maybe<Scalars['BigDecimal']>,
  min_dollar_amount?: Maybe<Scalars['BigDecimal']>,
  max_dollar_amount?: Maybe<Scalars['BigDecimal']>,
  min_num_shares?: Maybe<Scalars['Long']>,
  max_num_shares?: Maybe<Scalars['Long']>,
  company_id: Scalars['Int'],
  pricing_type?: Maybe<Scalars['String']>,
  asset_type?: Maybe<Scalars['String']>,
  acceptable_structures: Array<Scalars['String']>,
  valuation?: Maybe<Scalars['BigDecimal']>,
  expired_at?: Maybe<Scalars['DateTime']>,
  offering_id?: Maybe<Scalars['UUID']>,
  loi_contract_id?: Maybe<Scalars['Int']>,
  date_created: Scalars['DateTime'],
  num_shares?: Maybe<Scalars['Long']>,
  dollar_amount?: Maybe<Scalars['BigDecimal']>,
  entity?: Maybe<EntityRead>,
  company: CompanyRead,
  is_expired: Scalars['Boolean'],
  structure?: Maybe<Scalars['String']>,
  offering?: Maybe<OfferingRead>,
  letter_of_intent?: Maybe<ContractRead>,
  is_loi_signed: Scalars['Boolean'],
  net_share_price?: Maybe<Scalars['BigDecimal']>,
  net_dollar_amount?: Maybe<Scalars['BigDecimal']>,
};

export type AuthCodeView = {
   __typename?: 'AuthCodeView',
  id: Scalars['Int'],
  user_id: Scalars['Int'],
  issuer_id?: Maybe<Scalars['Int']>,
  expiry_date: Scalars['DateTime'],
  bypass_2fa: Scalars['Boolean'],
  num_permitted_uses: Scalars['Int'],
  num_consumed_uses: Scalars['Int'],
  redirect_to?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  date_created: Scalars['DateTime'],
  stored_mutation_id?: Maybe<Scalars['UUID']>,
  mutation_params?: Maybe<Scalars['String']>,
  META: Meta,
  user: UserView,
  issuer?: Maybe<UserView>,
  graphql_mutation?: Maybe<Scalars['String']>,
};

export type AuthHandle = {
   __typename?: 'AuthHandle',
  status: AuthStatus,
  session: SessionHandle,
};

export type AuthorizedBankAccountCollectionView = {
   __typename?: 'AuthorizedBankAccountCollectionView',
  value: CollectionOfBankAccountView,
};

export enum AuthStatus {
  Ready = 'Ready',
  Requires2Fa = 'Requires2FA',
  Anonymous = 'Anonymous'
}

export type BankAccountDetailsInput = {
  entity_id: Scalars['Int'],
  bank_name: Scalars['String'],
  entity_is_customer_of_bank?: Maybe<Scalars['Boolean']>,
  country_code: Scalars['String'],
  nickname?: Maybe<Scalars['String']>,
  routing_number?: Maybe<Scalars['String']>,
  swift_code?: Maybe<Scalars['String']>,
  account_number?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  protocol?: Maybe<Scalars['String']>,
  iban_number?: Maybe<Scalars['String']>,
  brokerage_name?: Maybe<Scalars['String']>,
  ffc_name?: Maybe<Scalars['String']>,
  ffc_account_number?: Maybe<Scalars['String']>,
  investor_only?: Maybe<Scalars['Boolean']>,
};

export type BankAccountMutations = {
   __typename?: 'BankAccountMutations',
  delete: Scalars['Boolean'],
};

export type BankAccountRead = {
   __typename?: 'BankAccountRead',
  id: Scalars['Int'],
  bank_name?: Maybe<Scalars['String']>,
  nickname?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  protocol?: Maybe<Scalars['String']>,
  country_code?: Maybe<Scalars['String']>,
  entity_is_customer_of_bank?: Maybe<Scalars['Boolean']>,
  brokerage_name?: Maybe<Scalars['String']>,
  ffc_name?: Maybe<Scalars['String']>,
  ffc_account_number?: Maybe<Scalars['String']>,
  account_number_last_4_digits?: Maybe<Scalars['String']>,
  entity_id?: Maybe<Scalars['Int']>,
  secure_fields: BankAccountSecureFields,
  country?: Maybe<Scalars['String']>,
  mutations: BankAccountMutations,
};


export type BankAccountReadSecure_FieldsArgs = {
  password: Scalars['String']
};

export type BankAccountSecureFields = {
   __typename?: 'BankAccountSecureFields',
  account_number?: Maybe<Scalars['String']>,
  iban_number?: Maybe<Scalars['String']>,
};

export type BankAccountView = {
   __typename?: 'BankAccountView',
  id: Scalars['Int'],
  bank_name?: Maybe<Scalars['String']>,
  nickname?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  protocol?: Maybe<Scalars['String']>,
  account_number?: Maybe<Scalars['String']>,
  routing_number?: Maybe<Scalars['String']>,
  swift_code?: Maybe<Scalars['String']>,
  country_code?: Maybe<Scalars['String']>,
  entity_is_customer_of_bank?: Maybe<Scalars['Boolean']>,
  iban_number?: Maybe<Scalars['String']>,
  brokerage_name?: Maybe<Scalars['String']>,
  ffc_name?: Maybe<Scalars['String']>,
  ffc_account_number?: Maybe<Scalars['String']>,
  entity_id?: Maybe<Scalars['Int']>,
};

export type BeneficialOwnerDetails = {
   __typename?: 'BeneficialOwnerDetails',
  id: Scalars['Int'],
  company_name?: Maybe<Scalars['String']>,
  first_name?: Maybe<Scalars['String']>,
  last_name?: Maybe<Scalars['String']>,
  address_street_1?: Maybe<Scalars['String']>,
  address_street_2?: Maybe<Scalars['String']>,
  address_city?: Maybe<Scalars['String']>,
  address_state?: Maybe<Scalars['String']>,
  address_postal_code?: Maybe<Scalars['String']>,
  address_country_code?: Maybe<Scalars['String']>,
};

export type BidAskSummaryView = {
   __typename?: 'BidAskSummaryView',
  company_id: Scalars['Int'],
  bid_volume: Scalars['BigDecimal'],
  bid_structures: Scalars['String'],
  bid_actionable: Scalars['BigDecimal'],
  ask_volume: Scalars['BigDecimal'],
  ask_structures: Scalars['String'],
  ask_actionable: Scalars['BigDecimal'],
};

export type BidRead = {
   __typename?: 'BidRead',
  id: Scalars['UUID'],
  entity_id?: Maybe<Scalars['Int']>,
  status: Scalars['String'],
  share_price?: Maybe<Scalars['BigDecimal']>,
  min_dollar_amount?: Maybe<Scalars['BigDecimal']>,
  max_dollar_amount?: Maybe<Scalars['BigDecimal']>,
  min_num_shares?: Maybe<Scalars['Long']>,
  max_num_shares?: Maybe<Scalars['Long']>,
  company_id: Scalars['Int'],
  pricing_type?: Maybe<Scalars['String']>,
  asset_type?: Maybe<Scalars['String']>,
  acceptable_structures: Array<Scalars['String']>,
  valuation?: Maybe<Scalars['BigDecimal']>,
  expired_at?: Maybe<Scalars['DateTime']>,
  offering_id?: Maybe<Scalars['UUID']>,
  loi_contract_id?: Maybe<Scalars['Int']>,
  date_created: Scalars['DateTime'],
  num_shares?: Maybe<Scalars['Long']>,
  dollar_amount?: Maybe<Scalars['BigDecimal']>,
  entity?: Maybe<EntityRead>,
  company: CompanyRead,
  is_expired: Scalars['Boolean'],
  structure?: Maybe<Scalars['String']>,
  offering?: Maybe<OfferingRead>,
  letter_of_intent?: Maybe<ContractRead>,
  is_loi_signed: Scalars['Boolean'],
  orders: Array<OrderRead>,
  net_share_price?: Maybe<Scalars['BigDecimal']>,
  net_dollar_amount?: Maybe<Scalars['BigDecimal']>,
};


export type BrokerProfileView = {
   __typename?: 'BrokerProfileView',
  broker_entity_id: Scalars['Int'],
  informal_name: Scalars['String'],
  entity: EntityView,
  name: Scalars['String'],
};

export type BusinessSegmentCategoryView = {
   __typename?: 'BusinessSegmentCategoryView',
  id: Scalars['Int'],
  name: Scalars['String'],
  subcategories: Array<Scalars['String']>,
};

export enum Capability {
  Always = 'Always',
  AggregatedOrderBookView = 'AggregatedOrderBookView',
  Never = 'Never',
  ManagesClients = 'ManagesClients',
  AssureView = 'AssureView',
  AssureSign = 'AssureSign',
  AssureReview = 'AssureReview',
  CareDemoView = 'CareDemoView',
  KrakenView = 'KrakenView',
  PortfolioView = 'PortfolioView',
  DetailedOrderBookView = 'DetailedOrderBookView',
  TrustedInstitution = 'TrustedInstitution',
  ForgeGlobalAdvisorsSignatory = 'ForgeGlobalAdvisorsSignatory',
  SalesIntern = 'SalesIntern',
  SensitivePiiRead = 'SensitivePIIRead',
  Sales = 'Sales',
  InstitutionalSales = 'InstitutionalSales',
  AdminView = 'AdminView',
  EquidateEmployee = 'EquidateEmployee',
  Root = 'Root',
  System = 'System',
  DeleteDocument = 'DeleteDocument',
  OperationsAdmin = 'OperationsAdmin',
  FcsAdmin = 'FCSAdmin',
  ClientRelationships = 'ClientRelationships',
  Operations = 'Operations',
  SalesAdmin = 'SalesAdmin',
  EditAccrualDate = 'EditAccrualDate',
  LegalIntern = 'LegalIntern',
  EngineerAdmin = 'EngineerAdmin',
  PiiRead = 'PIIRead',
  SupervisingPrincipal = 'SupervisingPrincipal',
  Engineer = 'Engineer',
  Marketplace = 'Marketplace',
  OperationsIntern = 'OperationsIntern',
  Partnerships = 'Partnerships',
  Legal = 'Legal',
  DirectDatabaseRead = 'DirectDatabaseRead',
  EquiamEmployee = 'EquiamEmployee',
  MutableTableWrite = 'MutableTableWrite',
  DirectDatabaseWrite = 'DirectDatabaseWrite',
  Admin = 'Admin',
  LegalAdmin = 'LegalAdmin',
  RegisteredRep = 'RegisteredRep',
  DocumentAdmin = 'DocumentAdmin',
  OperationsSuperAdmin = 'OperationsSuperAdmin',
  EngineerIntern = 'EngineerIntern',
  CaymanAuthorizedSignatory = 'CaymanAuthorizedSignatory',
  UserSignedContractSlackNotification = 'UserSignedContractSlackNotification',
  ProofDocReview = 'ProofDocReview',
  KpmgView = 'KpmgView',
  PartnerSchemaView = 'PartnerSchemaView'
}

export type CapabilityView = {
   __typename?: 'CapabilityView',
  id: Scalars['Int'],
  user_id: Scalars['Int'],
  grantor_id: Scalars['Int'],
  tag: Scalars['String'],
  date_created: Scalars['DateTime'],
  date_expiry: Scalars['DateTime'],
  META: Meta,
  status: Scalars['String'],
  user: UserView,
  grantor: UserView,
};

export type CapTableDealRead = {
   __typename?: 'CapTableDealRead',
  id: Scalars['Int'],
  status: DealStatusType,
  date_created: Scalars['DateTime'],
  status_last_updated_at: Scalars['DateTime'],
  company_id: Scalars['Int'],
  orders: Array<CapTableTradeView>,
  deal_status: DealTradeStatus,
  is_buy_anchor: Scalars['Boolean'],
  trades: Array<CapTableTradeRead>,
  userTrades: Array<CapTableTradeRead>,
};

export type CapTableEntryEquityAdminRead = {
   __typename?: 'CapTableEntryEquityAdminRead',
  id: Scalars['Int'],
  relationship_with_issuer: Scalars['String'],
  cost_center?: Maybe<Scalars['String']>,
  name: Scalars['String'],
  email: Scalars['String'],
  invited: Scalars['Boolean'],
  accepted_invitation: Scalars['Boolean'],
  ask_submitted: Scalars['Boolean'],
  num_granted_shares: Scalars['Long'],
  num_vested_shares: Scalars['Long'],
  num_exercised_shares: Scalars['Long'],
  num_tradable_shares: Scalars['Long'],
  employmentTenureInDays?: Maybe<Scalars['Long']>,
  employment_start_date?: Maybe<Scalars['DateTime']>,
  grants: Array<CapTableEntryGrantEquityAdminRead>,
};

export type CapTableEntryGrantEquityAdminRead = {
   __typename?: 'CapTableEntryGrantEquityAdminRead',
  id: Scalars['Int'],
  class: Scalars['String'],
  type: HoldingType,
  vesting_date?: Maybe<Scalars['DateTime']>,
  num_granted_shares: Scalars['Long'],
  num_vested_shares: Scalars['Long'],
  num_exercised_shares: Scalars['Long'],
  num_tradable_shares: Scalars['Long'],
};

export type CapTableEntryInput = {
  cap_table_provider_id?: Maybe<Scalars['String']>,
  employee_id?: Maybe<Scalars['String']>,
  employment_start_date?: Maybe<Scalars['InvariantDate']>,
  employment_end_date?: Maybe<Scalars['InvariantDate']>,
  shareholder_name: Scalars['String'],
  shareholder_email: Scalars['String'],
  shareholder_date_of_birth?: Maybe<Scalars['InvariantDate']>,
  shareholder_country_of_residency?: Maybe<Scalars['String']>,
  shareholder_address?: Maybe<Scalars['String']>,
  shareholder_tax_id?: Maybe<Scalars['String']>,
  shareholder_payroll_id?: Maybe<Scalars['String']>,
  entity_type: EntityType,
  relationship_with_issuer: Scalars['String'],
  cost_center?: Maybe<Scalars['String']>,
  class_of_stock: Scalars['String'],
  holding_type: HoldingType,
  vesting_start_date?: Maybe<Scalars['InvariantDate']>,
  vesting_duration_months?: Maybe<Scalars['Int']>,
  stock_vesting_interval?: Maybe<StockVestingInterval>,
  stock_option_vesting_interval?: Maybe<StockOptionVestingInterval>,
  rsu_vesting_interval?: Maybe<RsuVestingInterval>,
  vesting_cliff_months?: Maybe<Scalars['Int']>,
  num_vested_shares?: Maybe<Scalars['Long']>,
  num_exercised_shares?: Maybe<Scalars['Long']>,
  exercise_or_purchase_price?: Maybe<Scalars['BigDecimal']>,
  num_fully_diluted_shares?: Maybe<Scalars['Long']>,
  latest_exercise_date?: Maybe<Scalars['InvariantDate']>,
  num_tradable_shares?: Maybe<Scalars['Long']>,
};

export type CapTableEntryRead = {
   __typename?: 'CapTableEntryRead',
  id: Scalars['Int'],
  cap_table_id: Scalars['Int'],
  holding_id: Scalars['Int'],
  num_tradable_shares?: Maybe<Scalars['Long']>,
  net_tradable_shares: Scalars['Long'],
  liquidity_event: LiquidityEventRead,
  cap_table: CapTableRead,
};

export type CapTableEntryView = {
   __typename?: 'CapTableEntryView',
  id: Scalars['Int'],
  cap_table_id: Scalars['Int'],
  holding_id: Scalars['Int'],
  num_tradable_shares?: Maybe<Scalars['Long']>,
};

export type CapTableInputInput = {
  liquidity_event_id: Scalars['Int'],
  num_fully_diluted_shares: Scalars['Long'],
  num_outstanding_shares?: Maybe<Scalars['Long']>,
  num_unallocated_shares: Scalars['Long'],
};

export type CapTableRead = {
   __typename?: 'CapTableRead',
  id: Scalars['Int'],
  liquidity_event_id?: Maybe<Scalars['Int']>,
  num_fully_diluted_shares: Scalars['Long'],
  num_outstanding_shares?: Maybe<Scalars['Long']>,
  num_unallocated_shares: Scalars['Long'],
  liquidity_event?: Maybe<LiquidityEventRead>,
  entries: Array<CapTableEntryEquityAdminRead>,
  excelDownloadLink: FileRead,
};

export type CapTableTradeIntentView = {
   __typename?: 'CapTableTradeIntentView',
  account_name: Scalars['String'],
  trade_intent: AskRead,
  holding: HoldingRead,
};

export type CapTableTradeRead = {
   __typename?: 'CapTableTradeRead',
  buy_order: CapTableTradeView,
  sell_order: CapTableTradeView,
  is_buy_anchor: Scalars['Boolean'],
  trade_status: DealTradeStatus,
};

export type CapTableTradeView = {
   __typename?: 'CapTableTradeView',
  type: TradeIntentType,
  account_name: Scalars['String'],
  order: OrderRead,
  entity: EntityRead,
  holding?: Maybe<HoldingRead>,
  trade_intent: TradeIntentRead,
};

export type ClientDetailsFormInput = {
  id: Scalars['UUID'],
  owners: Array<Scalars['Int']>,
  has_influence_with: Array<Scalars['Int']>,
  relationship_strength?: Maybe<Scalars['String']>,
  relationship_sensitivity?: Maybe<Scalars['String']>,
  relationship_notes?: Maybe<Scalars['String']>,
  business_development_tier?: Maybe<Scalars['Int']>,
  outreach_schedule?: Maybe<Scalars['Duration']>,
  notes?: Maybe<Scalars['String']>,
};

export type ClientGiftView = {
   __typename?: 'ClientGiftView',
  id: Scalars['UUID'],
  user_id: Scalars['Int'],
  created_by: Scalars['Int'],
  is_sent: Scalars['Boolean'],
  gift?: Maybe<Scalars['String']>,
  personal_note?: Maybe<Scalars['String']>,
  created_at: Scalars['DateTime'],
  META: Meta,
  user: UserView,
  creator: UserView,
  address_recently_confirmed: Scalars['Boolean'],
};

export type ClientTypeView = {
   __typename?: 'ClientTypeView',
  id: Scalars['UUID'],
  account_type: Scalars['String'],
  name: Scalars['String'],
};

export type ClosingView = {
   __typename?: 'ClosingView',
  id: Scalars['Int'],
  uuid: Scalars['UUID'],
  status: Scalars['String'],
  nickname?: Maybe<Scalars['String']>,
  equibank_id?: Maybe<Scalars['Int']>,
  company_id: Scalars['Int'],
  admin_note?: Maybe<Scalars['String']>,
  date_created: Scalars['DateTime'],
  META: Meta,
  serial: Scalars['String'],
  company: CompanyView,
  buy_volume: Scalars['BigDecimal'],
  sell_volume: Scalars['BigDecimal'],
  buy_shares: Scalars['Long'],
  sell_shares: Scalars['Long'],
  share_difference: Scalars['Long'],
  volume_difference: Scalars['BigDecimal'],
  tradeIntents: Array<TradeIntentView>,
  orders: Array<OrderView>,
  matches: Array<MatchView>,
  equifund?: Maybe<EquifundView>,
  average_share_price?: Maybe<Scalars['BigDecimal']>,
  split_adjusted_average_share_price?: Maybe<Scalars['BigDecimal']>,
  insurance_period: Scalars['String'],
  insurance_status?: Maybe<Scalars['String']>,
  securitization?: Maybe<Scalars['String']>,
  deal_creation_date: Scalars['DateTime'],
  closing_creation_date: Scalars['DateTime'],
  has_transformed_or_transformation_orders: Scalars['Boolean'],
  match_accrued_months: Scalars['String'],
  order_signed_dates: Scalars['String'],
  owners: Array<UserView>,
};

export type CollectionOfBankAccountView = {
   __typename?: 'CollectionOfBankAccountView',
  nodes: Array<BankAccountView>,
};

export type Column = {
   __typename?: 'Column',
  column: Scalars['String'],
  table?: Maybe<Scalars['String']>,
  required: Scalars['Boolean'],
  renderer: Scalars['String'],
  editor: Scalars['String'],
  aggregation: Scalars['String'],
  readCapability: Capability,
  discriminator: Scalars['String'],
  token: Scalars['String'],
  type: ColumnType,
  mutation: ColumnMutation,
  actions: Array<Action>,
  action?: Maybe<Action>,
};


export type ColumnActionArgs = {
  name: Scalars['String']
};

export type ColumnMutation = {
   __typename?: 'ColumnMutation',
  shouldConfirm: Scalars['Boolean'],
  requiresNote: Scalars['Boolean'],
  capability: Scalars['String'],
  permitted: Scalars['Boolean'],
  handler: Scalars['Int'],
  uuidHandler: Scalars['Int'],
};


export type ColumnMutationHandlerArgs = {
  id: Scalars['Int'],
  value: Scalars['Json']
};


export type ColumnMutationUuidHandlerArgs = {
  id: Scalars['UUID'],
  value: Scalars['Json']
};

export type ColumnType = {
   __typename?: 'ColumnType',
  name: Scalars['String'],
  default: Scalars['Json'],
  values: Array<Scalars['Json']>,
  display_field?: Maybe<Scalars['String']>,
  warning_values: Array<Scalars['Json']>,
};

export type CommissionScheduleRead = {
   __typename?: 'CommissionScheduleRead',
  min_order_size: Scalars['BigDecimal'],
  commission: Scalars['BigDecimal'],
  id: Scalars['UUID'],
};

export type CompanyAcquisitionInfo = {
   __typename?: 'CompanyAcquisitionInfo',
  acquirer_name?: Maybe<Scalars['String']>,
  price?: Maybe<Scalars['Long']>,
  acquisition_date?: Maybe<Scalars['DateTime']>,
};

export type CompanyBlockView = {
   __typename?: 'CompanyBlockView',
  id: Scalars['Int'],
  company_id: Scalars['Int'],
  company_description?: Maybe<Scalars['String']>,
  dollar_amount: Scalars['BigDecimal'],
  all_in_share_price: Scalars['BigDecimal'],
  notes?: Maybe<Scalars['String']>,
  date_created: Scalars['DateTime'],
  META: Meta,
  company: CompanyView,
};

export type CompanyDetails = {
   __typename?: 'CompanyDetails',
  id: Scalars['Int'],
  entity_id?: Maybe<Scalars['Int']>,
  name: Scalars['String'],
  website: Scalars['String'],
  logo_url: Scalars['String'],
  address_street_1: Scalars['String'],
  address_street_2?: Maybe<Scalars['String']>,
  address_city: Scalars['String'],
  address_state: Scalars['String'],
  address_postal_code: Scalars['String'],
  address_country_code: Scalars['String'],
  phone_country_code: Scalars['Int'],
  phone_number: Scalars['String'],
};

export type CompanyDetailsInput = {
  id: Scalars['Int'],
  entity_id?: Maybe<Scalars['Int']>,
  name: Scalars['String'],
  website: Scalars['String'],
  logo_url: Scalars['String'],
  address_street_1: Scalars['String'],
  address_street_2?: Maybe<Scalars['String']>,
  address_city: Scalars['String'],
  address_state: Scalars['String'],
  address_postal_code: Scalars['String'],
  address_country_code: Scalars['String'],
  phone_country_code: Scalars['Int'],
  phone_number: Scalars['String'],
};

export type CompanyEntityDetails = {
   __typename?: 'CompanyEntityDetails',
  id: Scalars['Int'],
  incorporation_year?: Maybe<Scalars['Int']>,
  incorporation_month?: Maybe<Scalars['Int']>,
  incorporation_day?: Maybe<Scalars['Int']>,
  subject_to_erisa_or_ira?: Maybe<Scalars['Boolean']>,
  subject_to_foia?: Maybe<Scalars['Boolean']>,
  company_type?: Maybe<Scalars['String']>,
  incorporation_date?: Maybe<Scalars['InvariantDate']>,
  beneficial_owners: Array<BeneficialOwnerDetails>,
};

export type CompanyInfo = {
   __typename?: 'CompanyInfo',
  id: Scalars['Int'],
  name: Scalars['String'],
  website: Scalars['String'],
  logo_url: Scalars['String'],
  status: FcsOnboardingStatus,
  current_step: Scalars['String'],
};

export type CompanyPlatformSettingsInput = {
  companyId: Scalars['Int'],
  show_pricing_data: Scalars['Boolean'],
  default_share_price_investor?: Maybe<Scalars['BigDecimal']>,
  default_share_price_shareholder?: Maybe<Scalars['BigDecimal']>,
  featured: Scalars['Boolean'],
};

export type CompanyPub = {
   __typename?: 'CompanyPub',
  id: Scalars['Int'],
  name: Scalars['String'],
  color?: Maybe<Scalars['String']>,
  token: Scalars['String'],
  crunchbase_org_id?: Maybe<Scalars['Int']>,
  crunchbase_handle: Scalars['String'],
  current_market_event?: Maybe<Scalars['Boolean']>,
  domain: Scalars['String'],
  homepage_url?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  is_available: Scalars['Boolean'],
  is_acquired?: Maybe<Scalars['Boolean']>,
  is_subsidiary: Scalars['Boolean'],
  is_tradable_override?: Maybe<Scalars['Boolean']>,
  stage?: Maybe<Scalars['String']>,
  stage_bucket?: Maybe<Scalars['String']>,
  valuation?: Maybe<Scalars['Long']>,
  valuation_bucket?: Maybe<Scalars['String']>,
  cumulative_funding?: Maybe<Scalars['Long']>,
  cumulative_funding_bucket?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  long_description?: Maybe<Scalars['String']>,
  founded_year?: Maybe<Scalars['Int']>,
  geo_address?: Maybe<Scalars['String']>,
  geo_city?: Maybe<Scalars['String']>,
  geo_state?: Maybe<Scalars['String']>,
  geo_country?: Maybe<Scalars['String']>,
  funding_raised?: Maybe<Scalars['Long']>,
  num_employees?: Maybe<Scalars['Int']>,
  google_rank?: Maybe<Scalars['Int']>,
  alexa_us_rank?: Maybe<Scalars['Int']>,
  alexa_global_rank?: Maybe<Scalars['Int']>,
  angellist_handle?: Maybe<Scalars['String']>,
  linkedin_handle?: Maybe<Scalars['String']>,
  twitter_handle?: Maybe<Scalars['String']>,
  facebook_handle?: Maybe<Scalars['String']>,
  twitter_followers?: Maybe<Scalars['Int']>,
  angellist_followers?: Maybe<Scalars['Int']>,
  facebook_likes?: Maybe<Scalars['Int']>,
  tier?: Maybe<Scalars['Int']>,
  weight?: Maybe<Scalars['Int']>,
  special_note?: Maybe<Scalars['String']>,
  min_transaction_size_investor?: Maybe<Scalars['BigDecimal']>,
  min_transaction_size_shareholder?: Maybe<Scalars['BigDecimal']>,
  default_share_price_investor?: Maybe<Scalars['BigDecimal']>,
  default_share_price_shareholder?: Maybe<Scalars['BigDecimal']>,
  share_price_variance?: Maybe<Scalars['BigDecimal']>,
  show_pricing_data: Scalars['Boolean'],
  featured: Scalars['Boolean'],
  news_feed: Array<NewsArticle>,
  default_share_price_average?: Maybe<Scalars['BigDecimal']>,
  logo_url: Scalars['String'],
  lg_logo_url: Scalars['String'],
  funding_rounds: Array<FundingRound>,
  acquisition_info?: Maybe<CompanyAcquisitionInfo>,
  similar_companies: Array<CompanyPub>,
  stock_splits: Array<StockSplitPub>,
  crunchbase_org?: Maybe<CrunchbaseOrgPub>,
};


export type CompanyPubNews_FeedArgs = {
  prevId?: Maybe<Scalars['Int']>,
  keyword?: Maybe<Array<Scalars['String']>>,
  sources?: Maybe<Array<Scalars['String']>>
};

export type CompanyRead = {
   __typename?: 'CompanyRead',
  id: Scalars['Int'],
  privco_company_id?: Maybe<Scalars['Int']>,
  public: CompanyPub,
  funding_rounds: Array<FundingRound>,
  last_round?: Maybe<FundingRound>,
  follows: Array<FollowRead>,
  orderBookBidBlocks: Array<OrderBookBlockRead>,
  orderBookAskBlocks: Array<OrderBookBlockRead>,
  trade_structures: Array<TradeStructureRead>,
  privco_data?: Maybe<PrivCoCompanyRead>,
  liquidity_events: Array<LiquidityEventRead>,
};


export type CompanyReadOrderBookBidBlocksArgs = {
  structures: Array<Scalars['String']>
};


export type CompanyReadOrderBookAskBlocksArgs = {
  structures: Array<Scalars['String']>
};

export type CompanyView = {
   __typename?: 'CompanyView',
  id: Scalars['Int'],
  name: Scalars['String'],
  legal_name?: Maybe<Scalars['String']>,
  color?: Maybe<Scalars['String']>,
  token: Scalars['String'],
  domain: Scalars['String'],
  weight?: Maybe<Scalars['Int']>,
  is_available: Scalars['Boolean'],
  type?: Maybe<Scalars['String']>,
  is_acquired?: Maybe<Scalars['Boolean']>,
  is_subsidiary: Scalars['Boolean'],
  tier?: Maybe<Scalars['Int']>,
  featured: Scalars['Boolean'],
  min_transaction_size_investor?: Maybe<Scalars['BigDecimal']>,
  min_transaction_size_shareholder?: Maybe<Scalars['BigDecimal']>,
  default_share_price_investor?: Maybe<Scalars['BigDecimal']>,
  default_share_price_shareholder?: Maybe<Scalars['BigDecimal']>,
  share_price_variance?: Maybe<Scalars['BigDecimal']>,
  show_pricing_data: Scalars['Boolean'],
  current_market_event?: Maybe<Scalars['Boolean']>,
  special_note?: Maybe<Scalars['String']>,
  is_supply_needed: Scalars['Boolean'],
  crunchbase_handle: Scalars['String'],
  crunchbase_logo_url?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  long_description?: Maybe<Scalars['String']>,
  stage?: Maybe<Scalars['String']>,
  stage_bucket?: Maybe<Scalars['String']>,
  valuation?: Maybe<Scalars['Long']>,
  valuation_bucket?: Maybe<Scalars['String']>,
  cumulative_funding?: Maybe<Scalars['Long']>,
  cumulative_funding_bucket?: Maybe<Scalars['String']>,
  is_tradable_override?: Maybe<Scalars['Boolean']>,
  linkedin_id?: Maybe<Scalars['String']>,
  crunchbase_org_id?: Maybe<Scalars['Int']>,
  date_created: Scalars['DateTime'],
  is_visible: Scalars['Boolean'],
  META: Meta,
  equifunds: Array<EquifundView>,
  asks: Array<TradeIntentView>,
  unfilled_ask_volume: Scalars['BigDecimal'],
  bids: Array<TradeIntentView>,
  unfilled_bid_volume: Scalars['BigDecimal'],
  closings: Array<ClosingView>,
  orders: Array<OrderView>,
  funding_rounds: Array<FundingRound>,
  last_round?: Maybe<FundingRound>,
  last_round_valuation?: Maybe<Scalars['Long']>,
  last_round_share_price?: Maybe<Scalars['BigDecimal']>,
  last_round_estimated_number_of_shares?: Maybe<Scalars['Long']>,
  stock_splits: Array<StockSplitView>,
  logo_url: Scalars['String'],
  market_price_history: Array<MarketPriceView>,
  holdings: Array<HoldingView>,
  crunchbase_org?: Maybe<CrunchbaseOrgView>,
  primary_contacts: Array<UserView>,
  crm_account: AccountView,
  shareholder_hunt_job?: Maybe<ShareholderHuntJobView>,
  order_book_bid_blocks: Array<OrderBookBlockRead>,
  order_book_ask_blocks: Array<OrderBookBlockRead>,
  last_buy_order?: Maybe<OrderView>,
  last_sell_order?: Maybe<OrderView>,
  active_bids_count: Scalars['Int'],
  active_asks_count: Scalars['Int'],
  total_bid_volume: Scalars['BigDecimal'],
  total_ask_volume: Scalars['BigDecimal'],
  bid_ask_summary: BidAskSummaryView,
};


export type CompanyViewOrder_Book_Bid_BlocksArgs = {
  structures?: Maybe<Array<ListingStructureType>>,
  qualifiedOnly?: Maybe<Scalars['Boolean']>
};


export type CompanyViewOrder_Book_Ask_BlocksArgs = {
  structures?: Maybe<Array<ListingStructureType>>,
  qualifiedOnly?: Maybe<Scalars['Boolean']>
};


export type CompanyViewLast_Buy_OrderArgs = {
  structures?: Maybe<Array<ListingStructureType>>
};


export type CompanyViewLast_Sell_OrderArgs = {
  structures?: Maybe<Array<ListingStructureType>>
};


export type CompanyViewActive_Bids_CountArgs = {
  structures?: Maybe<Array<ListingStructureType>>,
  qualifiedOnly: Scalars['Boolean']
};


export type CompanyViewActive_Asks_CountArgs = {
  structures?: Maybe<Array<ListingStructureType>>,
  qualifiedOnly: Scalars['Boolean']
};


export type CompanyViewTotal_Bid_VolumeArgs = {
  structures?: Maybe<Array<ListingStructureType>>,
  qualifiedOnly: Scalars['Boolean']
};


export type CompanyViewTotal_Ask_VolumeArgs = {
  structures?: Maybe<Array<ListingStructureType>>,
  qualifiedOnly: Scalars['Boolean']
};

export type ComplianceFormRead = {
   __typename?: 'ComplianceFormRead',
  id: Scalars['Int'],
  entity_id: Scalars['Int'],
  backup_contact_name: Scalars['String'],
  backup_contact_relationship: Scalars['String'],
  backup_contact_email: Scalars['String'],
  backup_contact_phone: Scalars['String'],
  typical_public_trade_size: Scalars['BigDecimal'],
  typical_pre_ipo_trade_size: Scalars['BigDecimal'],
  typical_early_stage_trade_size: Scalars['BigDecimal'],
  credit_check_consent: Scalars['Boolean'],
  background_check_consent: Scalars['Boolean'],
  affiliated_with_securities_or_regulatory_industry: Scalars['Boolean'],
  company_exec_or_major_shareholder: Scalars['Boolean'],
  affiliated_entity_names: Scalars['String'],
  affiliated_entity_type?: Maybe<Scalars['String']>,
  company_exec_or_major_shareholder_company?: Maybe<Scalars['String']>,
  entity_created_for_sole_purpose_of_equidate_investment: Scalars['Boolean'],
  date_created: Scalars['DateTime'],
};

export type Config = {
   __typename?: 'Config',
  layout: Layout,
};

export enum ContactMethodChannel {
  Email = 'email',
  Linkedin = 'linkedin',
  Whatsapp = 'whatsapp',
  Wechat = 'wechat',
  Phone = 'phone'
}

export type ContactMethodFormInput = {
  id?: Maybe<Scalars['UUID']>,
  account_id: Scalars['UUID'],
  channel: ContactMethodChannel,
  notes?: Maybe<Scalars['String']>,
  is_primary: Scalars['Boolean'],
  channel_value: Scalars['String'],
};

export type ContactMethodView = {
   __typename?: 'ContactMethodView',
  id: Scalars['UUID'],
  account_id: Scalars['UUID'],
  channel: ContactMethodChannel,
  notes?: Maybe<Scalars['String']>,
  is_primary: Scalars['Boolean'],
  channel_value?: Maybe<Scalars['String']>,
  created_at: Scalars['DateTime'],
  formatted_channel_value?: Maybe<Scalars['String']>,
  email_preferences?: Maybe<AdminEmailPreferences>,
};

export type ContractRead = {
   __typename?: 'ContractRead',
  id: Scalars['Int'],
  status: Scalars['String'],
  folder_id?: Maybe<Scalars['Int']>,
  executed_md5?: Maybe<Scalars['String']>,
  field_values: Scalars['String'],
  date_created: Scalars['DateTime'],
  template?: Maybe<TemplateRead>,
  download?: Maybe<FileRead>,
  signatures: Array<SignatureRead>,
  sign: Scalars['Int'],
  is_signed: Scalars['Boolean'],
  regenerate: Scalars['Int'],
};

export type ContractView = {
   __typename?: 'ContractView',
  id: Scalars['Int'],
  status: Scalars['String'],
  template_id?: Maybe<Scalars['Int']>,
  signed_file_id?: Maybe<Scalars['Int']>,
  date_created: Scalars['DateTime'],
  deleted_at?: Maybe<Scalars['DateTime']>,
  META: Meta,
  template?: Maybe<TemplateView>,
  download?: Maybe<FileView>,
  word_doc_download?: Maybe<FileView>,
  signatures: Array<SignatureView>,
  assure_signed?: Maybe<Scalars['Boolean']>,
  client_signed: Scalars['Boolean'],
  is_signed: Scalars['Boolean'],
  name: Scalars['String'],
  regenerateDocument: Scalars['Int'],
  registered_rep_can_sign: Scalars['Boolean'],
  registered_rep_signature?: Maybe<Scalars['String']>,
  principal_signature?: Maybe<Scalars['String']>,
  principal_can_sign: Scalars['Boolean'],
  contract_tags: Array<TagView>,
  can_authorized_signatory_counter_sign: Scalars['Boolean'],
};


export type ContractViewRegenerateDocumentArgs = {
  force: Scalars['Boolean']
};

export type ConvertibleNoteInvestmentDetails = {
   __typename?: 'ConvertibleNoteInvestmentDetails',
  investment_date?: Maybe<Scalars['InvariantDate']>,
  investment_dollar_amount?: Maybe<Scalars['BigDecimal']>,
  valuation_cap?: Maybe<Scalars['BigDecimal']>,
  discount_percentage?: Maybe<Scalars['BigDecimal']>,
  interest_rate?: Maybe<Scalars['BigDecimal']>,
};

export type CreateAccountFormInput = {
  name: Scalars['String'],
  type: AccountType,
  is_investor: Scalars['Boolean'],
  is_shareholder: Scalars['Boolean'],
  client_type_id?: Maybe<Scalars['UUID']>,
  country?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  notes?: Maybe<Scalars['String']>,
  primary_email?: Maybe<Scalars['String']>,
  create_platform_user: Scalars['Boolean'],
  company_id?: Maybe<Scalars['Int']>,
  account_suggestion_id?: Maybe<Scalars['UUID']>,
  is_account_of_interest: Scalars['Boolean'],
  account_of_interest_reason?: Maybe<Scalars['String']>,
};

export type CreateModalData = {
   __typename?: 'CreateModalData',
  type?: Maybe<Scalars['String']>,
  accountId?: Maybe<Scalars['String']>,
  accountName?: Maybe<Scalars['String']>,
  companyId?: Maybe<Scalars['Int']>,
  companyName?: Maybe<Scalars['String']>,
};

export type CreateModalDataInput = {
  type?: Maybe<Scalars['String']>,
  accountId?: Maybe<Scalars['String']>,
  accountName?: Maybe<Scalars['String']>,
  companyId?: Maybe<Scalars['Int']>,
  companyName?: Maybe<Scalars['String']>,
};

export type CreateOfferingFormInput = {
  company_id: Scalars['Int'],
  name: Scalars['String'],
  owner_ids: Array<Scalars['Int']>,
};

export type CreateOrUpdateSegmentFormInput = {
  id?: Maybe<Scalars['UUID']>,
  query: Scalars['String'],
  name: Scalars['String'],
};

export type CrunchbaseAcquisitionPub = {
   __typename?: 'CrunchbaseAcquisitionPub',
  id: Scalars['Int'],
  acquiree_id: Scalars['Int'],
  acquirer_id: Scalars['Int'],
  type?: Maybe<Scalars['String']>,
  acquired_on?: Maybe<Scalars['InvariantDate']>,
  price_usd?: Maybe<Scalars['Long']>,
  price?: Maybe<Scalars['Long']>,
  price_currency_code?: Maybe<Scalars['String']>,
  acquirer: CrunchbaseOrgPub,
  acquiree: CrunchbaseOrgPub,
};

export type CrunchbaseFundingRoundView = {
   __typename?: 'CrunchbaseFundingRoundView',
  id: Scalars['Int'],
  investment_type?: Maybe<Scalars['String']>,
  announced_on?: Maybe<Scalars['InvariantDate']>,
  raised_amount_usd?: Maybe<Scalars['Long']>,
  post_money_valuation_usd?: Maybe<Scalars['Long']>,
  cb_url?: Maybe<Scalars['String']>,
  investments: Array<CrunchbaseRoundInvestmentView>,
};

export type CrunchbaseInvestorPub = {
   __typename?: 'CrunchbaseInvestorPub',
  id: Scalars['Int'],
  name: Scalars['String'],
  domain?: Maybe<Scalars['String']>,
  cb_url?: Maybe<Scalars['String']>,
  logo_url?: Maybe<Scalars['String']>,
  person?: Maybe<CrunchbasePersonPub>,
  invested_in: Array<CrunchbaseOrgPub>,
};

export type CrunchbaseIpoPub = {
   __typename?: 'CrunchbaseIPOPub',
  id: Scalars['Int'],
  crunchbase_org_id: Scalars['Int'],
  stock_exchange_symbol?: Maybe<Scalars['String']>,
  stock_symbol?: Maybe<Scalars['String']>,
  went_public_on?: Maybe<Scalars['InvariantDate']>,
  price_usd?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
  price_currency_code?: Maybe<Scalars['String']>,
  money_raised_usd?: Maybe<Scalars['Long']>,
};

export type CrunchbaseJobPub = {
   __typename?: 'CrunchbaseJobPub',
  person_id: Scalars['Int'],
  organization_id: Scalars['Int'],
  started_on?: Maybe<Scalars['InvariantDate']>,
  ended_on?: Maybe<Scalars['InvariantDate']>,
  is_current?: Maybe<Scalars['Boolean']>,
  title?: Maybe<Scalars['String']>,
  job_type?: Maybe<Scalars['String']>,
  person: CrunchbasePersonPub,
};

export type CrunchbaseOrgInvestorView = {
   __typename?: 'CrunchbaseOrgInvestorView',
  investor_id: Scalars['Int'],
  crunchbase_org_id: Scalars['Int'],
  name: Scalars['String'],
  domain?: Maybe<Scalars['String']>,
  cb_url?: Maybe<Scalars['String']>,
  logo_url?: Maybe<Scalars['String']>,
  participated_rounds: Array<CrunchbaseFundingRoundView>,
  portfolio_companies: Array<Scalars['String']>,
};

export type CrunchbaseOrgPub = {
   __typename?: 'CrunchbaseOrgPub',
  id: Scalars['Int'],
  name: Scalars['String'],
  domain?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  permalink?: Maybe<Scalars['String']>,
  logo_url?: Maybe<Scalars['String']>,
  closed_on?: Maybe<Scalars['InvariantDate']>,
  company?: Maybe<CompanyPub>,
  parent?: Maybe<CrunchbaseOrgPub>,
  children: Array<CrunchbaseOrgPub>,
  acquisitions: Array<CrunchbaseAcquisitionPub>,
  investors: Array<CrunchbaseInvestorPub>,
  executives: Array<CrunchbaseJobPub>,
  advisors: Array<CrunchbaseJobPub>,
  board_members: Array<CrunchbaseJobPub>,
  ipo?: Maybe<CrunchbaseIpoPub>,
};

export type CrunchbaseOrgView = {
   __typename?: 'CrunchbaseOrgView',
  id: Scalars['Int'],
  name: Scalars['String'],
  domain?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  permalink?: Maybe<Scalars['String']>,
  logo_url?: Maybe<Scalars['String']>,
  closed_on?: Maybe<Scalars['InvariantDate']>,
  parent?: Maybe<CrunchbaseOrgView>,
  children: Array<CrunchbaseOrgView>,
  acquisitions: Array<CrunchbaseAcquisitionPub>,
  investors: Array<CrunchbaseOrgInvestorView>,
  executives: Array<CrunchbaseJobPub>,
  advisors: Array<CrunchbaseJobPub>,
  board_members: Array<CrunchbaseJobPub>,
  ipo?: Maybe<CrunchbaseIpoPub>,
  funding_rounds: Array<CrunchbaseFundingRoundView>,
};

export type CrunchbasePersonPub = {
   __typename?: 'CrunchbasePersonPub',
  id: Scalars['Int'],
  first_name?: Maybe<Scalars['String']>,
  last_name?: Maybe<Scalars['String']>,
  primary_organization?: Maybe<Scalars['Int']>,
  primary_title?: Maybe<Scalars['String']>,
  logo_url?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  cb_url?: Maybe<Scalars['String']>,
  primary_org?: Maybe<CrunchbaseOrgPub>,
  parsed_description?: Maybe<Scalars['String']>,
};

export type CrunchbaseRoundInvestmentView = {
   __typename?: 'CrunchbaseRoundInvestmentView',
  id: Scalars['Int'],
  investor_id: Scalars['Int'],
  is_lead_investor: Scalars['Boolean'],
  name: Scalars['String'],
  domain?: Maybe<Scalars['String']>,
  cb_url?: Maybe<Scalars['String']>,
  logo_url?: Maybe<Scalars['String']>,
};

export type DataRoomFileRead = {
   __typename?: 'DataRoomFileRead',
  id: Scalars['String'],
  name: Scalars['String'],
  downloadLink: Scalars['String'],
};


export enum DealStatusType {
  Cancelled = 'cancelled',
  Qualified = 'qualified',
  PreClosings = 'pre_closings',
  Pipeline = 'pipeline',
  Closed = 'closed',
  Deleted = 'deleted',
  Closings = 'closings'
}

export type DealTradeFormInput = {
  deal_id: Scalars['Int'],
  type: TradeIntentType,
  entity_id?: Maybe<Scalars['Int']>,
  account_id: Scalars['UUID'],
  share_price?: Maybe<Scalars['BigDecimal']>,
  num_shares?: Maybe<Scalars['Int']>,
  dollar_amount?: Maybe<Scalars['BigDecimal']>,
  fee: Scalars['BigDecimal'],
  share_price_recorded_as?: Maybe<SharePriceRecordedAsType>,
  postToSlackChannel?: Maybe<Scalars['String']>,
};

export enum DealTradeStatus {
  TransferContractsPending = 'transferContractsPending',
  PoaPending = 'poaPending',
  SellIntentSubmitted = 'sellIntentSubmitted',
  Completed = 'completed',
  PaymentPending = 'paymentPending',
  NoTrade = 'noTrade',
  SellerSignaturesPending = 'sellerSignaturesPending'
}

export type DealTradeView = {
   __typename?: 'DealTradeView',
  is_anchor: Scalars['Boolean'],
  type: TradeIntentType,
  matched_volume: Scalars['BigDecimal'],
  match: MatchView,
  account: AccountView,
  order: OrderView,
  trade_intent: TradeIntentView,
  trade_intent_status_matches_deal: Scalars['Boolean'],
};

export type DealView = {
   __typename?: 'DealView',
  id: Scalars['Int'],
  date_created: Scalars['DateTime'],
  status_last_updated_at: Scalars['DateTime'],
  company_id: Scalars['Int'],
  probability_to_close: Scalars['BigDecimal'],
  active_deal_status: DealStatusType,
  issuer: AccountView,
  owners: Array<OwnerView>,
  volume_bids: Scalars['BigDecimal'],
  volume_asks: Scalars['BigDecimal'],
  trades: Array<DealTradeView>,
  templates: Array<TemplateView>,
};

export type DeepEntityView = {
   __typename?: 'DeepEntityView',
  id: Scalars['Int'],
  type: EntityType,
  name: Scalars['String'],
  email?: Maybe<Scalars['String']>,
  phone_number?: Maybe<Scalars['String']>,
  is_accredited?: Maybe<Scalars['Boolean']>,
  address: Address,
  roles: Array<DeepRoleView>,
  holdings: Array<DeepHoldingView>,
  contracts: Array<ContractView>,
  process_steps: Array<ProcessStepView>,
  needs_special_attention: Scalars['Boolean'],
  special_attention_comment: Scalars['String'],
  META: Meta,
  individual?: Maybe<IndividualEntityDetails>,
  company?: Maybe<CompanyEntityDetails>,
  trust?: Maybe<TrustEntityDetails>,
  users: Scalars['String'],
  formatted_phone_number?: Maybe<Scalars['String']>,
};

export type DeepHoldingView = {
   __typename?: 'DeepHoldingView',
  id: Scalars['Int'],
  type?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  entity_id: Scalars['Int'],
  is_deleted: Scalars['Boolean'],
  date_created: Scalars['DateTime'],
  company: CompanyView,
  META: Meta,
  entity: EntityView,
};

export type DeepRoleView = {
   __typename?: 'DeepRoleView',
  id: Scalars['Int'],
  entity_id: Scalars['Int'],
  type: Scalars['String'],
  title?: Maybe<Scalars['String']>,
  permission: Scalars['String'],
  user_id: Scalars['Int'],
  signatory_auth_proof_doc_id?: Maybe<Scalars['Int']>,
  date_created: Scalars['DateTime'],
  user: UserView,
  META: Meta,
  entity: EntityView,
  signatory_proof_doc?: Maybe<ProofDocView>,
};

export type DelinquentOrdersView = {
   __typename?: 'DelinquentOrdersView',
  unmatched_orders: Array<OrderView>,
  unsigned_orders: Array<OrderView>,
  unpaid_orders: Array<OrderView>,
  unfulfilled_orders: Array<OrderView>,
};

export enum DerivedLocationSource {
  CrmAdmin = 'crm_admin',
  EntityAddress = 'entity_address',
  SignupLocation = 'signup_location'
}

export type DerivedLocationView = {
   __typename?: 'DerivedLocationView',
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  countryCode?: Maybe<Scalars['String']>,
  source?: Maybe<DerivedLocationSource>,
};

export type DerivedLocationViewInput = {
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  countryCode?: Maybe<Scalars['String']>,
  source?: Maybe<DerivedLocationSource>,
};

export type DirectStockInvestmentDetails = {
   __typename?: 'DirectStockInvestmentDetails',
  purchase_date?: Maybe<Scalars['InvariantDate']>,
  num_shares?: Maybe<Scalars['Long']>,
  share_price?: Maybe<Scalars['BigDecimal']>,
  investment_dollar_amount?: Maybe<Scalars['BigDecimal']>,
  valuation?: Maybe<Scalars['BigDecimal']>,
};

export enum DoNotContactReason {
  IsUnsubscribedFromDealRelatedEmails = 'is_unsubscribed_from_deal_related_emails',
  IsInRestrictedLocation = 'is_in_restricted_location',
  HasIntermediary = 'has_intermediary',
  IsForgeDeclined = 'is_forge_declined',
  IsHighSensitivity = 'is_high_sensitivity'
}


export type EmailCampaignFilterInput = {
  accreditedOnly: Scalars['Boolean'],
  qpOnly: Scalars['Boolean'],
  userIds?: Maybe<Array<Scalars['Int']>>,
};

export type EmailQueueView = {
   __typename?: 'EmailQueueView',
  id: Scalars['UUID'],
  email_metadata: Scalars['Json'],
  recipient_id?: Maybe<Scalars['Int']>,
  enqueued_at: Scalars['DateTime'],
  sent_at?: Maybe<Scalars['DateTime']>,
  snoozed_until?: Maybe<Scalars['DateTime']>,
  approved_by?: Maybe<Scalars['Int']>,
  rejected_by?: Maybe<Scalars['Int']>,
  type?: Maybe<Scalars['Json']>,
  first_opened_at?: Maybe<Scalars['DateTime']>,
  delay_until?: Maybe<Scalars['DateTime']>,
  marked_spam?: Maybe<Scalars['Boolean']>,
  bounced?: Maybe<Scalars['Boolean']>,
  unsubscribed?: Maybe<Scalars['Boolean']>,
  address?: Maybe<Scalars['String']>,
  META: Meta,
  recipient?: Maybe<UserView>,
  category: Scalars['String'],
  order?: Maybe<OrderView>,
};

export type EmailSenderInput = {
  fromName: Scalars['String'],
  fromEmail: Scalars['String'],
};

export type EntityMutations = {
   __typename?: 'EntityMutations',
  delete: Scalars['Int'],
  regenerate_documents: Array<Scalars['Int']>,
  submitAccreditationCheckRequest: Scalars['Boolean'],
  confirm_contact_info: Scalars['Int'],
  confirm_share_commitments: Scalars['Int'],
  consent_to_third_party_kyc: Scalars['Int'],
};


export type EntityMutationsRegenerate_DocumentsArgs = {
  force: Scalars['Boolean']
};


export type EntityMutationsSubmitAccreditationCheckRequestArgs = {
  offeringId?: Maybe<Scalars['UUID']>
};

export type EntityNcfUploadInput = {
  entity_id: Scalars['Int'],
  file_serial?: Maybe<Scalars['String']>,
  file_tags?: Maybe<Array<Scalars['UUID']>>,
  primary_contact_name?: Maybe<Scalars['String']>,
  primary_contact_email?: Maybe<Scalars['String']>,
  primary_contact_phone?: Maybe<Scalars['String']>,
  primary_contact_title?: Maybe<Scalars['String']>,
  entity_govt_id_type?: Maybe<Scalars['String']>,
  entity_govt_id_number?: Maybe<Scalars['String']>,
  entity_domicile_country_code?: Maybe<Scalars['String']>,
  entity_address_street_1?: Maybe<Scalars['String']>,
  entity_address_street_2?: Maybe<Scalars['String']>,
  entity_address_city?: Maybe<Scalars['String']>,
  entity_address_state?: Maybe<Scalars['String']>,
  entity_address_postal_code?: Maybe<Scalars['String']>,
  entity_address_country_code?: Maybe<Scalars['String']>,
  typical_public_trade_size: Scalars['Long'],
  typical_pre_ipo_trade_size: Scalars['Long'],
  typical_early_stage_trade_size: Scalars['Long'],
  affiliated_with_securities_or_regulatory_industry: Scalars['Boolean'],
  company_exec_or_major_shareholder: Scalars['Boolean'],
  affiliated_entity_names?: Maybe<Scalars['String']>,
  affiliated_entity_type?: Maybe<Scalars['String']>,
  company_exec_or_major_shareholder_company?: Maybe<Scalars['String']>,
  entity_created_for_sole_purpose_of_equidate_investment: Scalars['Boolean'],
  consent_to_background_check: Scalars['Boolean'],
  consent_to_credit_check: Scalars['Boolean'],
  total_household_income?: Maybe<Scalars['String']>,
  individual_net_worth?: Maybe<Scalars['String']>,
  company_aum?: Maybe<Scalars['String']>,
  value_of_trusts_assets?: Maybe<Scalars['String']>,
  are_all_trustees_accredited?: Maybe<Scalars['Boolean']>,
  legal_first_name?: Maybe<Scalars['String']>,
  legal_last_name?: Maybe<Scalars['String']>,
  birth_date_day?: Maybe<Scalars['Int']>,
  birth_date_month?: Maybe<Scalars['Int']>,
  birth_date_year?: Maybe<Scalars['Int']>,
  subject_to_erisa_or_ira?: Maybe<Scalars['Boolean']>,
  subject_to_foia?: Maybe<Scalars['Boolean']>,
  are_all_company_owners_accredited?: Maybe<Scalars['Boolean']>,
  are_all_company_owners_qualified_purchasers?: Maybe<Scalars['Boolean']>,
  company_type?: Maybe<Scalars['String']>,
};

export type EntityPerformance = {
   __typename?: 'EntityPerformance',
  holding_id: Scalars['Int'],
  round_id?: Maybe<Scalars['Long']>,
  dollar_amount: Scalars['BigDecimal'],
  date: Scalars['InvariantDate'],
};

export type EntityRead = {
   __typename?: 'EntityRead',
  id: Scalars['Int'],
  type: Scalars['String'],
  name: Scalars['String'],
  email?: Maybe<Scalars['String']>,
  phone_number?: Maybe<Scalars['String']>,
  profile_picture_url?: Maybe<Scalars['String']>,
  is_accredited?: Maybe<Scalars['Boolean']>,
  is_qualified_purchaser?: Maybe<Scalars['Boolean']>,
  domicile_country_code?: Maybe<Scalars['String']>,
  domicile_state_code?: Maybe<Scalars['String']>,
  govt_id_type?: Maybe<Scalars['String']>,
  address: Address,
  form?: Maybe<Scalars['String']>,
  consent_to_third_party_kyc: Scalars['Boolean'],
  govt_id_num_last_4?: Maybe<Scalars['String']>,
  accreditation?: Maybe<AccreditationRead>,
  complianceForm?: Maybe<ComplianceFormRead>,
  roles: Array<RoleRead>,
  role: RoleRead,
  holdings: Array<HoldingRead>,
  historical_performance: Array<EntityPerformance>,
  individual?: Maybe<IndividualEntityDetails>,
  company?: Maybe<CompanyEntityDetails>,
  trust?: Maybe<TrustEntityDetails>,
  bank_accounts: Array<BankAccountRead>,
  process_steps: Array<ProcessStepRead>,
  contracts: Array<ContractRead>,
  regenerate_documents: Array<Scalars['Int']>,
  verified_accreditation_user_auth_url: Scalars['String'],
  accreditation_verification_url?: Maybe<Scalars['String']>,
  verified_accreditation_status?: Maybe<Scalars['String']>,
  cayman_kyc_docs: Array<FileRead>,
  is_ncf_fully_signed: Scalars['Boolean'],
  is_ncf_rr_signed: Scalars['Boolean'],
  share_commitments: Array<ShareCommitmentRead>,
  mutations: EntityMutations,
};


export type EntityReadRegenerate_DocumentsArgs = {
  force: Scalars['Boolean']
};


export type EntityReadVerified_Accreditation_User_Auth_UrlArgs = {
  redirectUrl?: Maybe<Scalars['String']>
};

export enum EntityType {
  Individual = 'individual',
  Company = 'company',
  Broker = 'broker',
  Trust = 'trust'
}

export type EntityView = {
   __typename?: 'EntityView',
  id: Scalars['Int'],
  uuid: Scalars['UUID'],
  type: Scalars['String'],
  name: Scalars['String'],
  phone_number?: Maybe<Scalars['String']>,
  is_qualified_purchaser?: Maybe<Scalars['Boolean']>,
  domicile_country_code?: Maybe<Scalars['String']>,
  govt_id_type?: Maybe<Scalars['String']>,
  address: Address,
  folder_id?: Maybe<Scalars['Int']>,
  admin_note?: Maybe<Scalars['String']>,
  form?: Maybe<Scalars['String']>,
  reviewed_at?: Maybe<Scalars['DateTime']>,
  approved_at?: Maybe<Scalars['DateTime']>,
  needs_special_attention?: Maybe<Scalars['Boolean']>,
  special_attention_comment?: Maybe<Scalars['String']>,
  META: Meta,
  classification?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  serial: Scalars['String'],
  compliance_form?: Maybe<ComplianceFormRead>,
  accreditation?: Maybe<AccreditationRead>,
  govt_id_num_last_4?: Maybe<Scalars['String']>,
  individual?: Maybe<IndividualEntityDetails>,
  company?: Maybe<CompanyEntityDetails>,
  trust?: Maybe<TrustEntityDetails>,
  roles: Array<RoleView>,
  holdings: Array<HoldingView>,
  orders: Array<OrderView>,
  bids: Array<TradeIntentView>,
  asks: Array<TradeIntentView>,
  contracts: Array<ContractView>,
  process_steps: Array<ProcessStepView>,
  users: Scalars['String'],
  files: Array<FileView>,
  beneficial_owners: Array<EntityView>,
  w8_w9_signed: Scalars['String'],
  credit_score_status: Scalars['String'],
  mis_background_check: Scalars['Boolean'],
  new_client_form_status: Scalars['String'],
  new_client_form_signed: Scalars['Boolean'],
  approved_as_seller: Scalars['Boolean'],
  approved_as_investor?: Maybe<Scalars['Boolean']>,
  kyc_approved: Scalars['Boolean'],
  idv_complete: Scalars['Boolean'],
  sig_auth_and_entity_doc_status: Scalars['String'],
  has_signed_active_orders: Scalars['Boolean'],
  reviewed: Scalars['Boolean'],
  approved: Scalars['Boolean'],
  owners: Array<UserView>,
  is_accredited?: Maybe<Scalars['Boolean']>,
  verified_accreditation_status?: Maybe<Scalars['String']>,
  crm_account?: Maybe<AccountView>,
  linkedin_url?: Maybe<Scalars['String']>,
  bank_accounts: Array<BankAccountRead>,
  protected_bank_account_collection: ProtectedViewOfBankAccountCollectionView,
};

export type EquidateInvestmentDetails = {
   __typename?: 'EquidateInvestmentDetails',
  order_id: Scalars['Int'],
  order: Array<OrderRead>,
};

export type EquifundRead = {
   __typename?: 'EquifundRead',
  id: Scalars['Int'],
  name: Scalars['String'],
  legal_name: Scalars['String'],
  share_class?: Maybe<Scalars['String']>,
  is_cayman_fund: Scalars['Boolean'],
  qp_only: Scalars['Boolean'],
  bank_account_number?: Maybe<Scalars['String']>,
};

export type EquifundView = {
   __typename?: 'EquifundView',
  id: Scalars['Int'],
  name: Scalars['String'],
  legal_name: Scalars['String'],
  company_id?: Maybe<Scalars['Int']>,
  asset_type?: Maybe<Scalars['String']>,
  qp_only: Scalars['Boolean'],
  ein?: Maybe<Scalars['String']>,
  folder_id?: Maybe<Scalars['Int']>,
  is_cayman_fund: Scalars['Boolean'],
  is_deprecated: Scalars['Boolean'],
  date_created: Scalars['DateTime'],
  formation_date?: Maybe<Scalars['InvariantDate']>,
  share_class?: Maybe<Scalars['String']>,
  form?: Maybe<Scalars['String']>,
  META: Meta,
  company?: Maybe<CompanyView>,
  files: Array<FileView>,
  bank_account_number?: Maybe<Scalars['String']>,
  num_active_orders: Scalars['Int'],
  num_closed_orders: Scalars['Int'],
};

export enum EventGoalMetricType {
  DollarVolume = 'dollar_volume'
}

export type EventGoalRead = {
   __typename?: 'EventGoalRead',
  id: Scalars['Int'],
  metric_type: EventGoalMetricType,
  target_value: Scalars['BigDecimal'],
};

export enum FcsOnboardingStatus {
  Active = 'active',
  Complete = 'complete',
  Inactive = 'inactive'
}

export type FeeView = {
   __typename?: 'FeeView',
  id: Scalars['UUID'],
  order_id: Scalars['Int'],
  paying_entity_id: Scalars['Int'],
  receiving_entity_id: Scalars['Int'],
  type: Scalars['String'],
  percent_amount?: Maybe<Scalars['BigDecimal']>,
  absolute_amount?: Maybe<Scalars['BigDecimal']>,
  approved: Scalars['Boolean'],
  percentage_withheld?: Maybe<Scalars['BigDecimal']>,
  created_at: Scalars['DateTime'],
  META: Meta,
  unpaid_amount: Scalars['BigDecimal'],
  total_amount: Scalars['BigDecimal'],
  order: OrderView,
  paying_entity: EntityView,
  receiving_entity: EntityView,
};

export type FieldChangeView = {
   __typename?: 'FieldChangeView',
  id: Scalars['UUID'],
  user_name: Scalars['String'],
  is_platform_user: Scalars['Boolean'],
  old_value: Scalars['String'],
  field_name: Scalars['String'],
  changed_at: Scalars['DateTime'],
};

export type FileRead = {
   __typename?: 'FileRead',
  id: Scalars['Int'],
  serial?: Maybe<Scalars['String']>,
  filename?: Maybe<Scalars['String']>,
  folder_id?: Maybe<Scalars['Int']>,
  user_id?: Maybe<Scalars['Int']>,
  date_created?: Maybe<Scalars['DateTime']>,
  user?: Maybe<UserPub>,
  url: Scalars['String'],
};

export type FileView = {
   __typename?: 'FileView',
  id: Scalars['Int'],
  serial?: Maybe<Scalars['String']>,
  filename?: Maybe<Scalars['String']>,
  folder_id?: Maybe<Scalars['Int']>,
  user_id?: Maybe<Scalars['Int']>,
  date_created?: Maybe<Scalars['DateTime']>,
  META: Meta,
  user?: Maybe<UserView>,
  url: Scalars['String'],
  tags: Array<TagView>,
};

export type FilterRangeInput = {
  min: Scalars['BigDecimal'],
  max: Scalars['BigDecimal'],
};

export type FlowMutations = {
   __typename?: 'FlowMutations',
  id: Scalars['UUID'],
  updateFlow: Scalars['Int'],
};


export type FlowMutationsUpdateFlowArgs = {
  segment?: Maybe<Scalars['String']>,
  sub_segment?: Maybe<Scalars['String']>
};

export type FlowRead = {
   __typename?: 'FlowRead',
  id: Scalars['UUID'],
  flow_type: Scalars['String'],
  segment?: Maybe<Scalars['String']>,
  sub_segment?: Maybe<Scalars['String']>,
  investor_account_preferences: InvestorAccountPreferencesRead,
  account: AccountUserView,
  entity: EntityRead,
  has_completed_self_accreditation: Scalars['Boolean'],
  location_constraints: Array<Scalars['String']>,
  has_set_email_preferences: Scalars['Boolean'],
  has_defined_institution_relationship: Scalars['Boolean'],
  mutations: FlowMutations,
};

export type FolderRead = {
   __typename?: 'FolderRead',
  id: Scalars['Int'],
  name: Scalars['String'],
  date_created: Scalars['DateTime'],
  files: Array<FileRead>,
};

export type FollowRead = {
   __typename?: 'FollowRead',
  id: Scalars['Int'],
  company_id: Scalars['Int'],
  date_created: Scalars['DateTime'],
  company: CompanyRead,
};

export type FollowView = {
   __typename?: 'FollowView',
  id: Scalars['Int'],
  company_id: Scalars['Int'],
  date_created: Scalars['DateTime'],
  company: CompanyView,
};

export type FrontContactView = {
   __typename?: 'FrontContactView',
  id: Scalars['UUID'],
  front_contact_id?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  created_at: Scalars['DateTime'],
};

export type FrontMessageContactView = {
   __typename?: 'FrontMessageContactView',
  id: Scalars['UUID'],
  role: Scalars['String'],
  email: Scalars['String'],
  account_id?: Maybe<Scalars['UUID']>,
  account?: Maybe<AccountView>,
};

export type FrontMessageGroupView = {
   __typename?: 'FrontMessageGroupView',
  id: Scalars['UUID'],
  subject: Scalars['String'],
  content: Scalars['String'],
  has_attachments: Scalars['Boolean'],
  is_inbound: Scalars['Boolean'],
  front_created_at: Scalars['DateTime'],
  created_at: Scalars['DateTime'],
  front_message: FrontMessageView,
  message_contacts: Array<FrontMessageContactView>,
};

export type FrontMessageView = {
   __typename?: 'FrontMessageView',
  id: Scalars['UUID'],
  front_msg_id: Scalars['String'],
  front_conversation_id: Scalars['String'],
  created_at: Scalars['DateTime'],
};

export type FundingRound = {
   __typename?: 'FundingRound',
  id: Scalars['Int'],
  amount?: Maybe<Scalars['Long']>,
  company_id: Scalars['Int'],
  round_date?: Maybe<Scalars['InvariantDate']>,
  investors: Array<Scalars['String']>,
  round_type?: Maybe<Scalars['String']>,
  stage?: Maybe<Scalars['String']>,
  est_num_shares?: Maybe<Scalars['Long']>,
  price_per_share?: Maybe<Scalars['BigDecimal']>,
  valuation?: Maybe<Scalars['Long']>,
};

export enum HoldingAcquisitionSource {
  Employee = 'employee',
  Founder = 'founder',
  SecondaryInvestment = 'secondary_investment',
  AdvisorOrOther = 'advisor_or_other',
  PrimaryRoundInvestment = 'primary_round_investment'
}

export type HoldingDocRead = {
   __typename?: 'HoldingDocRead',
  id: Scalars['Int'],
  document_type: Scalars['String'],
  proof_doc: ProofDocRead,
};

export type HoldingDocView = {
   __typename?: 'HoldingDocView',
  id: Scalars['Int'],
  document_type: Scalars['String'],
  holding_id: Scalars['Int'],
  proof_doc: ProofDocView,
  holding: HoldingView,
};

export type HoldingMutations = {
   __typename?: 'HoldingMutations',
  delete: Scalars['Int'],
};

export type HoldingPerformance = {
   __typename?: 'HoldingPerformance',
  round_id?: Maybe<Scalars['Long']>,
  dollar_amount: Scalars['BigDecimal'],
  date: Scalars['InvariantDate'],
};

export type HoldingRead = {
   __typename?: 'HoldingRead',
  id: Scalars['Int'],
  type?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  entity_id?: Maybe<Scalars['Int']>,
  company_id: Scalars['Int'],
  confirmed_num_shares?: Maybe<Scalars['Int']>,
  num_vested_shares?: Maybe<Scalars['Long']>,
  vested_shares_date?: Maybe<Scalars['InvariantDate']>,
  date_acquired?: Maybe<Scalars['InvariantDate']>,
  acquisition_source?: Maybe<HoldingAcquisitionSource>,
  share_class?: Maybe<Scalars['String']>,
  liquidity_interest?: Maybe<Scalars['String']>,
  share_dollar_amt_est?: Maybe<Scalars['String']>,
  is_sub_holding: Scalars['Boolean'],
  is_deleted: Scalars['Boolean'],
  date_created: Scalars['InvariantDate'],
  entity?: Maybe<EntityRead>,
  company: CompanyRead,
  display_name: Scalars['String'],
  process_steps: Array<ProcessStepRead>,
  summary?: Maybe<HoldingSummary>,
  holding_docs: Array<HoldingDocRead>,
  holding_doc_types: Array<Scalars['String']>,
  historical_performance: Array<HoldingPerformance>,
  stock_grant_holding?: Maybe<StockGrantDetails>,
  stock_grant_holding_gain_loss_per_share?: Maybe<Scalars['BigDecimal']>,
  stock_grant_total_gain_loss?: Maybe<Scalars['BigDecimal']>,
  stock_grant_total_value?: Maybe<Scalars['BigDecimal']>,
  stock_option_grant_holding?: Maybe<StockOptionGrantDetails>,
  stock_option_grant_holding_gain_loss_per_share?: Maybe<Scalars['BigDecimal']>,
  stock_option_grant_total_gain_loss?: Maybe<Scalars['BigDecimal']>,
  stock_option_grant_total_value?: Maybe<Scalars['BigDecimal']>,
  convertible_note_investment_holding?: Maybe<ConvertibleNoteInvestmentDetails>,
  direct_stock_investment_holding?: Maybe<DirectStockInvestmentDetails>,
  rsu_grant_holding?: Maybe<RsuGrantDetails>,
  safe_note_investment_holding?: Maybe<SafeNoteInvestmentDetails>,
  spv_gp_carry_holding?: Maybe<SpvGpCarryDetails>,
  spv_lp_investment_holding?: Maybe<SpvLpInvestmentDetails>,
  equidate_investment_holding?: Maybe<EquidateInvestmentDetails>,
  percent_vested?: Maybe<Scalars['BigDecimal']>,
  capTableEntry?: Maybe<CapTableEntryRead>,
  active_trade_intents: Array<TradeIntentRead>,
  mutations: HoldingMutations,
};

export type HoldingSummary = {
   __typename?: 'HoldingSummary',
  amount: Scalars['BigDecimal'],
  unit: Scalars['String'],
  current_value: Scalars['BigDecimal'],
  amount_format: Scalars['String'],
};

export enum HoldingType {
  SpvLpInvestment = 'spv_lp_investment',
  SafeNoteInvestment = 'safe_note_investment',
  SpvGpCarry = 'spv_gp_carry',
  RsuGrant = 'rsu_grant',
  StockOptionExercise = 'stock_option_exercise',
  EquidateInvestment = 'equidate_investment',
  StockGrant = 'stock_grant',
  StockOptionGrant = 'stock_option_grant',
  DirectStockInvestment = 'direct_stock_investment',
  ConvertibleNoteInvestment = 'convertible_note_investment'
}

export type HoldingView = {
   __typename?: 'HoldingView',
  id: Scalars['Int'],
  type?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  entity_id?: Maybe<Scalars['Int']>,
  company_id: Scalars['Int'],
  is_deleted: Scalars['Boolean'],
  acquisition_source?: Maybe<Scalars['String']>,
  liquidity_interest?: Maybe<Scalars['String']>,
  share_dollar_amt_est?: Maybe<Scalars['String']>,
  estimated_num_shares?: Maybe<Scalars['Int']>,
  confirmed_num_shares?: Maybe<Scalars['Int']>,
  share_class?: Maybe<Scalars['String']>,
  crm_account_id?: Maybe<Scalars['UUID']>,
  updated_at: Scalars['DateTime'],
  date_created: Scalars['DateTime'],
  META: Meta,
  company: CompanyView,
  entity?: Maybe<EntityView>,
  summary?: Maybe<HoldingSummary>,
  current_value?: Maybe<Scalars['BigDecimal']>,
  documents: Array<HoldingDocView>,
  primary_contacts: Array<UserView>,
  account?: Maybe<AccountView>,
  cap_table_entry: Array<CapTableEntryView>,
};

export type IdentificationDocumentMutations = {
   __typename?: 'IdentificationDocumentMutations',
  set_status: Scalars['Boolean'],
};


export type IdentificationDocumentMutationsSet_StatusArgs = {
  status: Scalars['String']
};

export type IdentificationDocumentRead = {
   __typename?: 'IdentificationDocumentRead',
  id: Scalars['Int'],
  status: Scalars['String'],
  user_id?: Maybe<Scalars['Int']>,
  file_id?: Maybe<Scalars['Int']>,
  date_created: Scalars['DateTime'],
  download?: Maybe<FileRead>,
};

export type IdentificationDocumentView = {
   __typename?: 'IdentificationDocumentView',
  id: Scalars['Int'],
  status: Scalars['String'],
  user_id?: Maybe<Scalars['Int']>,
  file_id?: Maybe<Scalars['Int']>,
  date_created: Scalars['DateTime'],
  META: Meta,
  user?: Maybe<UserView>,
  download?: Maybe<FileView>,
  mutations: IdentificationDocumentMutations,
};

export type IdentityVerificationQuestions = {
   __typename?: 'IdentityVerificationQuestions',
  id: Scalars['Int'],
  identity_verification_id: Scalars['Int'],
  created_at: Scalars['InvariantDate'],
  score: Scalars['Float'],
  questions: Array<Question>,
};

export type IdentityVerificationRead = {
   __typename?: 'IdentityVerificationRead',
  id: Scalars['Int'],
  status?: Maybe<Scalars['String']>,
  is_valid?: Maybe<Scalars['Boolean']>,
};

export type IndividualEntityDetails = {
   __typename?: 'IndividualEntityDetails',
  id: Scalars['Int'],
  birth_year?: Maybe<Scalars['Int']>,
  birth_month?: Maybe<Scalars['Int']>,
  birth_day?: Maybe<Scalars['Int']>,
  gender?: Maybe<Scalars['String']>,
  marital_status?: Maybe<Scalars['String']>,
  legal_first_name?: Maybe<Scalars['String']>,
  legal_middle_name?: Maybe<Scalars['String']>,
  legal_last_name?: Maybe<Scalars['String']>,
  birth_date?: Maybe<Scalars['InvariantDate']>,
  most_recent_idv_attempt?: Maybe<IdentityVerificationRead>,
  num_remaining_idv_attempts: Scalars['Int'],
  num_remaining_question_answer_attempts: Scalars['Int'],
  identity_verification_questions?: Maybe<IdentityVerificationQuestions>,
  spouse?: Maybe<UserPub>,
};

export enum InteractionFilter {
  All = 'all',
  Sales = 'sales',
  Partnerships = 'partnerships'
}

export type InteractionFormInput = {
  notes: Scalars['String'],
  tagged_value: Scalars['String'],
  tokens: Array<InteractionTokenInput>,
};

export enum InteractionLogObjectType {
  Account = 'account',
  TradeIntent = 'tradeIntent',
  Referral = 'referral'
}

export type InteractionTokenInput = {
  id: Scalars['UUID'],
  type: TokenType,
};

export enum InteractionType {
  Note = 'note',
  InPerson = 'in_person',
  Messaging = 'messaging',
  Email = 'email',
  PhoneCall = 'phone_call'
}

export type InteractionView = {
   __typename?: 'InteractionView',
  id: Scalars['UUID'],
  type: Scalars['String'],
  notes?: Maybe<Scalars['String']>,
  tagged_value?: Maybe<Scalars['Json']>,
  recorded_by?: Maybe<Scalars['Int']>,
  source_account_id?: Maybe<Scalars['UUID']>,
  source_trade_intent_id?: Maybe<Scalars['UUID']>,
  front_message_group_id?: Maybe<Scalars['UUID']>,
  created_at: Scalars['DateTime'],
  rolled_up_from_child_accounts: Array<AccountView>,
  rolled_up_to_parent_accounts: Array<AccountView>,
  front_message_group?: Maybe<FrontMessageGroupView>,
  recorder?: Maybe<UserView>,
  rollup_to_account?: Maybe<AccountView>,
  rollup_from_account?: Maybe<AccountView>,
  source?: Maybe<Source>,
};


export type InteractionViewRolled_Up_From_Child_AccountsArgs = {
  accountId: Scalars['UUID']
};


export type InteractionViewRolled_Up_To_Parent_AccountsArgs = {
  accountId: Scalars['UUID']
};

export type IntroductionView = {
   __typename?: 'IntroductionView',
  id: Scalars['UUID'],
  relationship_id: Scalars['UUID'],
  child_org_account_id?: Maybe<Scalars['UUID']>,
  parent_org_account_id?: Maybe<Scalars['UUID']>,
  parent_broker_account?: Maybe<AccountView>,
  child_broker_account?: Maybe<AccountView>,
};


export type InvestorAccountPreferencesRead = {
   __typename?: 'InvestorAccountPreferencesRead',
  id: Scalars['UUID'],
  target_check_size?: Maybe<Scalars['String']>,
};

export type InvestorDetailsFormInput = {
  id: Scalars['UUID'],
  aum?: Maybe<Scalars['String']>,
  net_worth?: Maybe<Scalars['String']>,
  investor_notes?: Maybe<Scalars['String']>,
  investor_preferences: UpdateInvestorPreferencesFormInput,
};

export type InvestorPreferencesView = {
   __typename?: 'InvestorPreferencesView',
  id: Scalars['UUID'],
  account_id: Scalars['UUID'],
  investment_structure_comfort: Array<Scalars['String']>,
  target_check_size?: Maybe<Scalars['String']>,
  target_regions: Array<Scalars['String']>,
  has_cash_on_hand?: Maybe<Scalars['Boolean']>,
  minimum_company_valuation?: Maybe<Scalars['Long']>,
  minimum_company_revenue?: Maybe<Scalars['Long']>,
  minimum_growth_rate?: Maybe<Scalars['BigDecimal']>,
  company_stages: Array<Scalars['String']>,
  only_profitable_companies?: Maybe<Scalars['Boolean']>,
  opportunities_of_interest: Array<Scalars['String']>,
  created_at: Scalars['DateTime'],
  sectors_interested: Array<Scalars['String']>,
  sectors_avoid: Array<Scalars['String']>,
};

export type IssuerAccountView = {
   __typename?: 'IssuerAccountView',
  id: Scalars['UUID'],
  company_id: Scalars['Int'],
  has_run_tender_before?: Maybe<Scalars['Boolean']>,
  sensitivity?: Maybe<Scalars['String']>,
  sensitivity_notes?: Maybe<Scalars['String']>,
  forge_on_cap_table?: Maybe<Scalars['Boolean']>,
  is_actionable?: Maybe<Scalars['Boolean']>,
  account_id: Scalars['UUID'],
  created_at: Scalars['DateTime'],
  company: CompanyView,
  has_transacted: Scalars['Boolean'],
  transaction_summary?: Maybe<TransactionSummaryView>,
  bid_ask_summary: BidAskSummaryView,
  deals: Array<IssuerDeal>,
  new_deals: Array<DealView>,
};

export type IssuerDeal = {
   __typename?: 'IssuerDeal',
  issuerId: Scalars['UUID'],
  orders: Array<IssuerDealOrder>,
  dateFullyAccrued: Scalars['InvariantDate'],
  structure: OrderStructureType,
  id: Scalars['UUID'],
  totalVolume: Scalars['BigDecimal'],
  dateClosed: Scalars['InvariantDate'],
  netRevenue: Scalars['BigDecimal'],
  totalShares: Scalars['Long'],
  averageTakeRate: Scalars['BigDecimal'],
  grossPricePerShare: Scalars['BigDecimal'],
  numParticipants: Scalars['Int'],
};

export type IssuerDealOrder = {
   __typename?: 'IssuerDealOrder',
  issuerAccountId: Scalars['UUID'],
  entityId: Scalars['Int'],
  dateFullyAccrued: Scalars['InvariantDate'],
  volume: Scalars['BigDecimal'],
  revenue: Scalars['BigDecimal'],
  numShares: Scalars['Long'],
  sharePrice: Scalars['BigDecimal'],
  structure: OrderStructureType,
};

export type IssuerHeaderFormInput = {
  id: Scalars['UUID'],
  organizationName: Scalars['String'],
  country?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  notes?: Maybe<Scalars['String']>,
};

export type IssuerMarketplaceCoverageFormInput = {
  id: Scalars['UUID'],
  relationship_strength?: Maybe<Scalars['String']>,
  relationship_sensitivity?: Maybe<Scalars['String']>,
  relationship_notes?: Maybe<Scalars['String']>,
  owners: Array<Scalars['Int']>,
  marketplace_notes?: Maybe<Scalars['String']>,
};

export type IssuerMarketplaceSettingsFormInput = {
  id: Scalars['UUID'],
  owners: Array<Scalars['Int']>,
  min_transaction_size_investor?: Maybe<Scalars['BigDecimal']>,
  show_pricing_data: Scalars['Boolean'],
  default_share_price_investor?: Maybe<Scalars['BigDecimal']>,
  default_share_price_shareholder?: Maybe<Scalars['BigDecimal']>,
  share_price_variance?: Maybe<Scalars['BigDecimal']>,
  featured: Scalars['Boolean'],
  is_available?: Maybe<Scalars['Boolean']>,
  weight?: Maybe<Scalars['Int']>,
};

export type IssuerPartnershipsCoverageFormInput = {
  id: Scalars['UUID'],
  partnerships_relationship_strength?: Maybe<Scalars['String']>,
  partnerships_relationship_sensitivity?: Maybe<Scalars['String']>,
  partnerships_relationship_notes?: Maybe<Scalars['String']>,
  owners: Array<Scalars['Int']>,
  partnerships_notes?: Maybe<Scalars['String']>,
};

export enum IssuerSortColumn {
  MinTransactionSize = 'MinTransactionSize',
  Weight = 'Weight',
  IsFeatured = 'IsFeatured',
  ImpliedBid = 'ImpliedBid',
  ImpliedAsk = 'ImpliedAsk',
  IsAvailable = 'IsAvailable',
  Name = 'Name',
  Variance = 'Variance',
  IsPricingDataDisplayed = 'IsPricingDataDisplayed'
}


export type Layout = {
   __typename?: 'Layout',
  w: Scalars['Int'],
  h: Scalars['Int'],
};

export type LinkedinJobView = {
   __typename?: 'LinkedinJobView',
  employment_name?: Maybe<Scalars['String']>,
  employment_title?: Maybe<Scalars['String']>,
  employment_domain?: Maybe<Scalars['String']>,
  employment_role?: Maybe<Scalars['String']>,
};

export enum LiquidityEventInviteStatus {
  NotInvited = 'NotInvited',
  Invited = 'Invited',
  Accepted = 'Accepted'
}

export type LiquidityEventRead = {
   __typename?: 'LiquidityEventRead',
  id: Scalars['Int'],
  company: Scalars['Int'],
  folder_id?: Maybe<Scalars['Int']>,
  max_tradable_pct?: Maybe<Scalars['BigDecimal']>,
  grant_type_restriction?: Maybe<Array<HoldingType>>,
  share_class_restriction?: Maybe<Array<Scalars['String']>>,
  liquidity_event_type: LiquidityEventType,
  share_price?: Maybe<Scalars['BigDecimal']>,
  prismic_header_id?: Maybe<Scalars['String']>,
  minimum_ask_quantity?: Maybe<Scalars['Int']>,
  minimum_ask_dollar_amount?: Maybe<Scalars['BigDecimal']>,
  liquidity_event_company: CompanyRead,
  start_time?: Maybe<Scalars['DateTime']>,
  end_time?: Maybe<Scalars['DateTime']>,
  shareholder_count: Scalars['Int'],
  goal: EventGoalRead,
  invited: Scalars['Int'],
  accepted: Scalars['Int'],
  ask_volume: Scalars['BigDecimal'],
  ask_shares: Scalars['BigDecimal'],
  ask_count: Scalars['Int'],
  cap_tables: Array<CapTableRead>,
  active_cap_table?: Maybe<CapTableRead>,
  folder?: Maybe<FolderRead>,
  deals: Array<CapTableDealRead>,
  dealsV2: Array<TradesTabDealRead>,
  asks: Array<CapTableTradeIntentView>,
  data_room_files: Array<DataRoomFileRead>,
};

export type LiquidityEventShareholderRead = {
   __typename?: 'LiquidityEventShareholderRead',
  id: Scalars['Int'],
  company: Scalars['Int'],
  max_tradable_pct?: Maybe<Scalars['BigDecimal']>,
  grant_type_restriction?: Maybe<Array<HoldingType>>,
  share_class_restriction?: Maybe<Array<Scalars['String']>>,
  liquidity_event_type: LiquidityEventType,
  share_price?: Maybe<Scalars['BigDecimal']>,
  prismic_header_id?: Maybe<Scalars['String']>,
  minimum_ask_quantity?: Maybe<Scalars['Int']>,
  minimum_ask_dollar_amount?: Maybe<Scalars['BigDecimal']>,
  is_onboarded: Scalars['Boolean'],
  is_disclosure_signed: Scalars['Boolean'],
  liquidity_event_company: CompanyRead,
  start_time?: Maybe<Scalars['DateTime']>,
  end_time?: Maybe<Scalars['DateTime']>,
  data_room_files: Array<DataRoomFileRead>,
};

export enum LiquidityEventType {
  DirectListing = 'direct_listing',
  TenderOffer = 'tender_offer'
}

export enum ListingStructureType {
  DirectShareTransfer = 'direct_share_transfer',
  ForwardBackedFundInterest = 'forward_backed_fund_interest',
  ShareBackedFundInterest = 'share_backed_fund_interest'
}


export type MarketPriceView = {
   __typename?: 'MarketPriceView',
  id: Scalars['UUID'],
  company_id: Scalars['Int'],
  structure: Scalars['String'],
  price: Scalars['BigDecimal'],
  price_date: Scalars['DateTime'],
  is_system_generated: Scalars['Boolean'],
  creator_id?: Maybe<Scalars['Int']>,
  created_at: Scalars['DateTime'],
  split_adjusted_price: Scalars['BigDecimal'],
};

export type MatchView = {
   __typename?: 'MatchView',
  id: Scalars['Int'],
  status: Scalars['String'],
  order_id?: Maybe<Scalars['Int']>,
  deal_id?: Maybe<Scalars['Int']>,
  num_shares?: Maybe<Scalars['Long']>,
  insurance_quarter?: Maybe<Scalars['String']>,
  date_accrued?: Maybe<Scalars['InvariantDate']>,
  date_created: Scalars['DateTime'],
  META: Meta,
  closing_id?: Maybe<Scalars['Int']>,
  order?: Maybe<OrderView>,
  closing?: Maybe<ClosingView>,
  dollar_amount: Scalars['BigDecimal'],
  order_match_name: Scalars['String'],
  percent_of_order: Scalars['BigDecimal'],
  match_commission: Scalars['BigDecimal'],
  emllc_net_proceeds: Scalars['BigDecimal'],
  equidate_inc_net_proceeds: Scalars['BigDecimal'],
  emllc_commission_expense: Scalars['BigDecimal'],
  ga_charged_to_equidate_inc: Scalars['BigDecimal'],
  ga_charged_by_emllc: Scalars['BigDecimal'],
  total_transfer_fees: Scalars['BigDecimal'],
  equidate_volume: Scalars['BigDecimal'],
  gaap_revenue: Scalars['BigDecimal'],
  net_revenue: Scalars['BigDecimal'],
  gross_margin: Scalars['BigDecimal'],
  insurance_cost: Scalars['BigDecimal'],
  insurance_cost_delta: Scalars['BigDecimal'],
  year_accrued?: Maybe<Scalars['Int']>,
  month_accrued?: Maybe<Scalars['String']>,
  quarter_accrued?: Maybe<Scalars['String']>,
  order_date: Scalars['InvariantDate'],
  year_order_created: Scalars['Int'],
  month_order_created: Scalars['String'],
  quarter_order_created: Scalars['String'],
  company: Scalars['String'],
  entity: Scalars['String'],
  insured_amount: Scalars['BigDecimal'],
};

export type Meta = {
   __typename?: 'Meta',
  tokens: Array<Scalars['String']>,
};

export type MutableTable = {
   __typename?: 'MutableTable',
  fields: Array<Scalars['String']>,
};

export type MutableTables = {
   __typename?: 'MutableTables',
  placeholder: Scalars['Int'],
  dynamic: MutableTable,
};


export type MutableTablesDynamicArgs = {
  table: Scalars['String']
};

export type Mutation = {
   __typename?: 'Mutation',
  activatePrePendingOrder: OrderView,
  addLead: AccountView,
  addProfileAccountTodo?: Maybe<TodoItemView>,
  addShareholdersToCapTable: Scalars['Boolean'],
  addTradeIntentToDeal: DealView,
  allColumns: Array<Column>,
  appendError?: Maybe<Scalars['Int']>,
  applyOpportunityAction: OpportunityView,
  assignLead: AccountView,
  associateEntityWithAccount: Scalars['Int'],
  blockUser: Scalars['Int'],
  cancelDeal: Scalars['Int'],
  clearErrors?: Maybe<Scalars['Int']>,
  closeCreateModal?: Maybe<Scalars['Int']>,
  closeCreateOpportunity?: Maybe<Scalars['Int']>,
  column: Column,
  columns: Array<Column>,
  createAccount: AccountView,
  createBankAccount: Scalars['Int'],
  createBrokerDebitPaymentMapping: Scalars['Int'],
  createBrokerProfile: Scalars['Boolean'],
  createCompanyOrIssuerAccount: Scalars['Boolean'],
  createDealFromTradeIntent: DealView,
  createDealTemplate: Scalars['Int'],
  createDealTrade: DealView,
  createEmailCampaign: Scalars['Int'],
  createEntity: Scalars['Boolean'],
  createHolding: HoldingView,
  createInteraction: InteractionView,
  createLiquidityEvent: Scalars['Int'],
  createNonUserEmailCampaign: Scalars['Int'],
  createOffering: OfferingView,
  createOrUpdateAccountRelationship: AccountRelationshipView,
  createOrUpdateContactMethod: ContactMethodView,
  createOrUpdateOpportunity: OpportunityView,
  createOrUpdateSegment: SegmentQueryView,
  createRecord: Scalars['Int'],
  createRole: Scalars['Int'],
  createSector: SectorView,
  createTag: TagView,
  createTemplate: Scalars['Int'],
  deleteAccount: Scalars['Int'],
  deleteAccountRelationship: Scalars['Int'],
  deleteContactMethod: Scalars['Int'],
  deleteDataroomFile: OfferingView,
  deleteDealTemplate: Scalars['Boolean'],
  deleteFile: Scalars['Boolean'],
  deleteInteraction: Scalars['Int'],
  deleteLiquidityEventTrade: Scalars['Int'],
  deleteOffering: Scalars['Int'],
  disableUser: Scalars['Int'],
  dismissLead: AccountView,
  dismissTodo: Scalars['Int'],
  downloadLogos: Scalars['Boolean'],
  enqueueShareholderConfirms: Scalars['Int'],
  enrichSegment: Scalars['Boolean'],
  enrichSegmentUser: Scalars['Boolean'],
  expireListing: Scalars['Int'],
  exportAccountsQueryToCsv: FileView,
  fcsCreateTag: Scalars['Int'],
  fcsSaveOnboarding: Scalars['Int'],
  fcsSetActive: Scalars['Int'],
  generateOrderAuthCode: Scalars['Int'],
  ghostUser: AuthHandle,
  importCapTable: Scalars['Int'],
  inviteEquityAdminToCompanySolutions: Scalars['Boolean'],
  ipGeocodingBackfill: Scalars['Int'],
  markFileContract: Scalars['Int'],
  mergeAccounts: AccountView,
  mergeCompanies: CompanyView,
  migrateInteractionLogOpportunitiesToTradeIntents: Scalars['Boolean'],
  mutableTable: MutableTables,
  openCreateModal?: Maybe<Scalars['Int']>,
  openCreateOpportunity?: Maybe<Scalars['Int']>,
  processAccountMetaCSV: Array<Scalars['String']>,
  profileLead: AccountView,
  publishOffering: OfferingView,
  quickAssignFirstOwner: AccountView,
  rejectAccountSuggestion: Scalars['Int'],
  removeMentionFromAllConversation: Scalars['Int'],
  removeTradeFromDeal: DealView,
  renewListing: Scalars['Int'],
  requestOrderForOpportunity: Scalars['Int'],
  resetOutreachSchedule: AccountView,
  restoreTodo: Scalars['Int'],
  seedLiquidityEventTrade: Scalars['Int'],
  sendDummyOfferingEmails: Scalars['Int'],
  sendFCSOnboardingEmail: UserInfo,
  sendOfferingEmails: Scalars['Int'],
  sendOfferingFeedbackEmails: Scalars['Int'],
  sendOfferingInviteEmails: Scalars['Int'],
  sendOfferingOrderReminderEmails: Scalars['Int'],
  sendOfferingReminderEmails: Scalars['Int'],
  setDealAnchor: Scalars['Int'],
  setDealOwners: DealView,
  setIntermediaryAccount: AccountView,
  setLiquidityEventInviteStatus: Scalars['Int'],
  setOrderBrokerOfRecord: OrderView,
  setOrderCommission: OrderView,
  setOrderDollarAmount: OrderView,
  setOrderEntity: OrderView,
  setOrderNumShares: OrderView,
  setOrderSharePrice: OrderView,
  setOutreachSchedule: AccountView,
  setPointOfContact: AccountRelationshipView,
  shareDraftOffering: Scalars['Boolean'],
  startShareholderHunt: Scalars['Int'],
  unpublishOffering: OfferingView,
  updateAccount: AccountView,
  updateAccountHeader: AccountView,
  updateClientDetails: AccountView,
  updateCompanyPlatformSettings: CompanyView,
  updateDealProbabilityToClose: DealView,
  updateDealStatus: DealView,
  updateInteraction: InteractionView,
  updateInvestorDetails: AccountView,
  updateIssuerHeader: AccountView,
  updateIssuerMarketplaceCoverage: AccountView,
  updateIssuerMarketplaceSettings: AccountView,
  updateIssuerPartnershipsCoverage: AccountView,
  updateMentionIdOnAllConversations: Scalars['Int'],
  updateOffering: OfferingView,
  updateOfferingEmailReminder: OfferingView,
  updateOpportunityDetails: OpportunityView,
  updatePublishedOffering: OfferingView,
  updateShareholderDetails: AccountView,
  uploadAccountFile: AccountView,
  uploadCompanyFundingRounds: Scalars['Int'],
  uploadEntityFile: Scalars['Int'],
  uploadEntityNCF: Scalars['Boolean'],
  uploadInvitationCSVs: OfferingView,
  uploadOfferingDataRoomFiles: OfferingView,
  uploadPaymentExport: Scalars['Boolean'],
};


export type MutationActivatePrePendingOrderArgs = {
  id: Scalars['Int']
};


export type MutationAddLeadArgs = {
  accountId: Scalars['UUID']
};


export type MutationAddProfileAccountTodoArgs = {
  assigneeId: Scalars['Int'],
  accountId: Scalars['UUID']
};


export type MutationAddShareholdersToCapTableArgs = {
  capTableId: Scalars['Int'],
  entries: Array<CapTableEntryInput>
};


export type MutationAddTradeIntentToDealArgs = {
  dealId: Scalars['Int'],
  tradeIntentId: Scalars['UUID']
};


export type MutationAppendErrorArgs = {
  errorMsg: Scalars['String']
};


export type MutationApplyOpportunityActionArgs = {
  form: OpportunityActionInput
};


export type MutationAssignLeadArgs = {
  accountId: Scalars['UUID'],
  assigneeId: Scalars['Int']
};


export type MutationAssociateEntityWithAccountArgs = {
  entityId: Scalars['Int'],
  moveToAccountId: Scalars['UUID']
};


export type MutationBlockUserArgs = {
  userId: Scalars['Int']
};


export type MutationCancelDealArgs = {
  dealId: Scalars['Int']
};


export type MutationClearErrorsArgs = {
  errorMsg?: Maybe<Scalars['String']>
};


export type MutationCloseCreateModalArgs = {
  id?: Maybe<Scalars['String']>
};


export type MutationCloseCreateOpportunityArgs = {
  id?: Maybe<Scalars['String']>
};


export type MutationColumnArgs = {
  token: Scalars['String']
};


export type MutationColumnsArgs = {
  tokens: Array<Scalars['String']>
};


export type MutationCreateAccountArgs = {
  form: CreateAccountFormInput
};


export type MutationCreateBankAccountArgs = {
  from: BankAccountDetailsInput
};


export type MutationCreateBrokerDebitPaymentMappingArgs = {
  paymentMapping: NewPaymentMappingInput
};


export type MutationCreateBrokerProfileArgs = {
  profileForm: NewBrokerProfileInput
};


export type MutationCreateCompanyOrIssuerAccountArgs = {
  crunchbaseURL?: Maybe<Scalars['String']>,
  companyToken?: Maybe<Scalars['String']>
};


export type MutationCreateDealFromTradeIntentArgs = {
  tradeIntentId: Scalars['UUID']
};


export type MutationCreateDealTemplateArgs = {
  from: NewTemplateInput,
  deal_id: Scalars['Int'],
  order_type?: Maybe<OrderType>
};


export type MutationCreateDealTradeArgs = {
  form: DealTradeFormInput
};


export type MutationCreateEmailCampaignArgs = {
  template: Scalars['String'],
  linkTo: Scalars['String'],
  from?: Maybe<EmailSenderInput>,
  filter: EmailCampaignFilterInput,
  templateVariables: Scalars['Json'],
  sendAt?: Maybe<Scalars['DateTime']>
};


export type MutationCreateEntityArgs = {
  from: NewEntityInput
};


export type MutationCreateHoldingArgs = {
  form: NewHoldingInput
};


export type MutationCreateInteractionArgs = {
  form: NewInteractionInput
};


export type MutationCreateLiquidityEventArgs = {
  companyId: Scalars['Int'],
  eventType: LiquidityEventType,
  equityAdminEmail: Scalars['String'],
  templateIds: Array<Scalars['Int']>
};


export type MutationCreateNonUserEmailCampaignArgs = {
  template: Scalars['String'],
  from?: Maybe<EmailSenderInput>,
  templateVariables: Scalars['Json'],
  fileSerial: Scalars['String'],
  sendAt?: Maybe<Scalars['DateTime']>
};


export type MutationCreateOfferingArgs = {
  form: CreateOfferingFormInput
};


export type MutationCreateOrUpdateAccountRelationshipArgs = {
  form: AccountRelationshipFormInput
};


export type MutationCreateOrUpdateContactMethodArgs = {
  form: ContactMethodFormInput
};


export type MutationCreateOrUpdateOpportunityArgs = {
  form: OpportunityFormInput
};


export type MutationCreateOrUpdateSegmentArgs = {
  form: CreateOrUpdateSegmentFormInput
};


export type MutationCreateRecordArgs = {
  recordType: Scalars['String'],
  record: Scalars['Json']
};


export type MutationCreateRoleArgs = {
  from: NewRoleInput
};


export type MutationCreateSectorArgs = {
  name: Scalars['String']
};


export type MutationCreateTagArgs = {
  tag: Scalars['String']
};


export type MutationCreateTemplateArgs = {
  from: NewTemplateInput
};


export type MutationDeleteAccountArgs = {
  accountId: Scalars['UUID']
};


export type MutationDeleteAccountRelationshipArgs = {
  relationshipId: Scalars['UUID']
};


export type MutationDeleteContactMethodArgs = {
  id: Scalars['UUID']
};


export type MutationDeleteDataroomFileArgs = {
  offeringId: Scalars['UUID'],
  fileId: Scalars['Int']
};


export type MutationDeleteDealTemplateArgs = {
  deal_id: Scalars['Int'],
  template_id: Scalars['Int']
};


export type MutationDeleteFileArgs = {
  fileId: Scalars['Int']
};


export type MutationDeleteInteractionArgs = {
  id: Scalars['UUID']
};


export type MutationDeleteLiquidityEventTradeArgs = {
  dealId: Scalars['Int'],
  eventId: Scalars['Int']
};


export type MutationDeleteOfferingArgs = {
  offeringId: Scalars['UUID']
};


export type MutationDisableUserArgs = {
  userId: Scalars['Int']
};


export type MutationDismissLeadArgs = {
  accountId: Scalars['UUID']
};


export type MutationDismissTodoArgs = {
  id: Scalars['UUID']
};


export type MutationDownloadLogosArgs = {
  missingLogosOnly: Scalars['Boolean'],
  companyIds?: Maybe<Array<Scalars['Int']>>
};


export type MutationEnqueueShareholderConfirmsArgs = {
  companyId: Scalars['Int'],
  entityExclusions: Array<Scalars['Int']>,
  emailTemplate: Scalars['String']
};


export type MutationEnrichSegmentArgs = {
  userOffset: Scalars['Int']
};


export type MutationEnrichSegmentUserArgs = {
  id: Scalars['Int']
};


export type MutationExpireListingArgs = {
  listingId: Scalars['UUID']
};


export type MutationExportAccountsQueryToCsvArgs = {
  query: Scalars['String']
};


export type MutationFcsCreateTagArgs = {
  tag: Scalars['String'],
  desc: Scalars['String']
};


export type MutationFcsSaveOnboardingArgs = {
  onboarding: OnboardingDetailsFormInput
};


export type MutationFcsSetActiveArgs = {
  company_id: Scalars['Int'],
  active: Scalars['Boolean']
};


export type MutationGenerateOrderAuthCodeArgs = {
  userId: Scalars['Int'],
  orderId: Scalars['Int']
};


export type MutationGhostUserArgs = {
  userId: Scalars['Int']
};


export type MutationImportCapTableArgs = {
  cap_table: CapTableInputInput,
  csv_file_serial: Scalars['String']
};


export type MutationInviteEquityAdminToCompanySolutionsArgs = {
  companyId: Scalars['Int'],
  email: Scalars['String'],
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>
};


export type MutationMarkFileContractArgs = {
  type: Scalars['String'],
  typeId: Scalars['Int'],
  fileId: Scalars['Int'],
  unsafe: Scalars['Boolean']
};


export type MutationMergeAccountsArgs = {
  fromAccountId: Scalars['UUID'],
  toAccountId: Scalars['UUID']
};


export type MutationMergeCompaniesArgs = {
  fromCompanyId: Scalars['Int'],
  toCompanyId: Scalars['Int']
};


export type MutationOpenCreateModalArgs = {
  data: CreateModalDataInput
};


export type MutationOpenCreateOpportunityArgs = {
  accountId?: Maybe<Scalars['String']>,
  accountName?: Maybe<Scalars['String']>
};


export type MutationProcessAccountMetaCsvArgs = {
  fileSerials: Scalars['String']
};


export type MutationProfileLeadArgs = {
  accountId: Scalars['UUID'],
  qualified: Scalars['Boolean']
};


export type MutationPublishOfferingArgs = {
  offeringId: Scalars['UUID']
};


export type MutationQuickAssignFirstOwnerArgs = {
  accountId: Scalars['UUID'],
  ownerId: Scalars['Int']
};


export type MutationRejectAccountSuggestionArgs = {
  id: Scalars['UUID']
};


export type MutationRemoveMentionFromAllConversationArgs = {
  tokenId: Scalars['UUID']
};


export type MutationRemoveTradeFromDealArgs = {
  dealId: Scalars['Int'],
  orderId: Scalars['Int']
};


export type MutationRenewListingArgs = {
  listingId: Scalars['UUID'],
  expiration: Scalars['InvariantDate']
};


export type MutationRequestOrderForOpportunityArgs = {
  opportunityId: Scalars['UUID'],
  assigneeAdminId?: Maybe<Scalars['Int']>,
  notes: Scalars['String']
};


export type MutationResetOutreachScheduleArgs = {
  accountId: Scalars['UUID']
};


export type MutationRestoreTodoArgs = {
  id: Scalars['UUID']
};


export type MutationSeedLiquidityEventTradeArgs = {
  capTableId: Scalars['Int'],
  holdingId: Scalars['Int'],
  buyerEmail: Scalars['String'],
  numShares: Scalars['Int'],
  price: Scalars['BigDecimal'],
  status: DealTradeStatus
};


export type MutationSendDummyOfferingEmailsArgs = {
  offeringId: Scalars['UUID'],
  emailType: OfferingEmailType
};


export type MutationSendFcsOnboardingEmailArgs = {
  userId: Scalars['Int'],
  companyId: Scalars['Int']
};


export type MutationSendOfferingEmailsArgs = {
  offeringId: Scalars['UUID'],
  emailType: OfferingEmailType
};


export type MutationSendOfferingFeedbackEmailsArgs = {
  offeringId: Scalars['UUID'],
  userIds?: Maybe<Array<Scalars['Int']>>
};


export type MutationSendOfferingInviteEmailsArgs = {
  offeringId: Scalars['UUID']
};


export type MutationSendOfferingOrderReminderEmailsArgs = {
  offeringId: Scalars['UUID'],
  userIds?: Maybe<Array<Scalars['Int']>>
};


export type MutationSendOfferingReminderEmailsArgs = {
  offeringId: Scalars['UUID'],
  userIds?: Maybe<Array<Scalars['Int']>>
};


export type MutationSetDealAnchorArgs = {
  tradeIntentId: Scalars['UUID'],
  dealId: Scalars['Int']
};


export type MutationSetDealOwnersArgs = {
  dealId: Scalars['Int'],
  ownerIds: Array<Scalars['Int']>
};


export type MutationSetIntermediaryAccountArgs = {
  form: SetIntermediaryFormInput
};


export type MutationSetLiquidityEventInviteStatusArgs = {
  email: Scalars['String'],
  eventId: Scalars['Int'],
  status: LiquidityEventInviteStatus
};


export type MutationSetOrderBrokerOfRecordArgs = {
  orderId: Scalars['Int'],
  entityId: Scalars['Int']
};


export type MutationSetOrderCommissionArgs = {
  id: Scalars['Int'],
  commission: Scalars['BigDecimal']
};


export type MutationSetOrderDollarAmountArgs = {
  id: Scalars['Int'],
  amount: Scalars['BigDecimal']
};


export type MutationSetOrderEntityArgs = {
  id: Scalars['Int'],
  entityId: Scalars['Int']
};


export type MutationSetOrderNumSharesArgs = {
  id: Scalars['Int'],
  numShares: Scalars['Long']
};


export type MutationSetOrderSharePriceArgs = {
  id: Scalars['Int'],
  price: Scalars['BigDecimal']
};


export type MutationSetOutreachScheduleArgs = {
  accountId: Scalars['UUID'],
  schedule?: Maybe<Scalars['Duration']>
};


export type MutationSetPointOfContactArgs = {
  relationshipId: Scalars['UUID'],
  isPointOfContact: Scalars['Boolean']
};


export type MutationShareDraftOfferingArgs = {
  offeringId: Scalars['UUID'],
  adminId: Scalars['Int']
};


export type MutationStartShareholderHuntArgs = {
  companyId: Scalars['Int']
};


export type MutationUnpublishOfferingArgs = {
  offeringId: Scalars['UUID']
};


export type MutationUpdateAccountArgs = {
  form: AccountDetailsFormInput
};


export type MutationUpdateAccountHeaderArgs = {
  form: AccountHeaderFormInput
};


export type MutationUpdateClientDetailsArgs = {
  form: ClientDetailsFormInput
};


export type MutationUpdateCompanyPlatformSettingsArgs = {
  companyPlatformSettings: CompanyPlatformSettingsInput
};


export type MutationUpdateDealProbabilityToCloseArgs = {
  dealId: Scalars['Int'],
  newProbability: Scalars['BigDecimal']
};


export type MutationUpdateDealStatusArgs = {
  dealId: Scalars['Int'],
  newStatus: DealStatusType
};


export type MutationUpdateInteractionArgs = {
  form: UpdateInteractionInput
};


export type MutationUpdateInvestorDetailsArgs = {
  form: InvestorDetailsFormInput
};


export type MutationUpdateIssuerHeaderArgs = {
  form: IssuerHeaderFormInput
};


export type MutationUpdateIssuerMarketplaceCoverageArgs = {
  form: IssuerMarketplaceCoverageFormInput
};


export type MutationUpdateIssuerMarketplaceSettingsArgs = {
  form: IssuerMarketplaceSettingsFormInput
};


export type MutationUpdateIssuerPartnershipsCoverageArgs = {
  form: IssuerPartnershipsCoverageFormInput
};


export type MutationUpdateMentionIdOnAllConversationsArgs = {
  oldId: Scalars['UUID'],
  newId: Scalars['UUID']
};


export type MutationUpdateOfferingArgs = {
  form: OfferingDetailsFormInput
};


export type MutationUpdateOfferingEmailReminderArgs = {
  offeringId: Scalars['UUID'],
  emailType: OfferingEmailType,
  sendReminderAt?: Maybe<Scalars['DateTime']>
};


export type MutationUpdateOpportunityDetailsArgs = {
  form: UpdateOpportunityDetailsFormInput
};


export type MutationUpdatePublishedOfferingArgs = {
  form: UpdatePublishedOfferingFormInput
};


export type MutationUpdateShareholderDetailsArgs = {
  form: ShareholderDetailsFormInput
};


export type MutationUploadAccountFileArgs = {
  accountId: Scalars['UUID'],
  fileSerial: Scalars['String'],
  tags: Array<Scalars['UUID']>
};


export type MutationUploadCompanyFundingRoundsArgs = {
  companyId: Scalars['Int'],
  fileSerial: Scalars['String']
};


export type MutationUploadEntityFileArgs = {
  entitySerial: Scalars['String'],
  fileSerial: Scalars['String'],
  tags: Array<Scalars['UUID']>
};


export type MutationUploadEntityNcfArgs = {
  form: EntityNcfUploadInput
};


export type MutationUploadInvitationCsVsArgs = {
  offeringId: Scalars['UUID'],
  fileSerials: Array<Scalars['String']>
};


export type MutationUploadOfferingDataRoomFilesArgs = {
  offeringId: Scalars['UUID'],
  fileSerials: Array<Scalars['String']>
};


export type MutationUploadPaymentExportArgs = {
  fileSerial: Scalars['String'],
  source: Scalars['String']
};

export type NewBrokerProfileInput = {
  entityId: Scalars['Int'],
  informalName: Scalars['String'],
  infoEmail: Scalars['String'],
  opsEmail: Scalars['String'],
  securitiesOfferedThrough: Scalars['String'],
  isNewClientFormRequired: Scalars['Boolean'],
  isForgeBranded: Scalars['Boolean'],
  logoForEmails: Scalars['String'],
  logoForDocuments: Scalars['String'],
  masterEntityName: Scalars['String'],
  phoneNumber?: Maybe<Scalars['String']>,
  address?: Maybe<Scalars['String']>,
  angellistUrl?: Maybe<Scalars['String']>,
  facebookUrl?: Maybe<Scalars['String']>,
  twitterUrl?: Maybe<Scalars['String']>,
  linkedinUrl?: Maybe<Scalars['String']>,
};

export type NewEntityInput = {
  name: Scalars['String'],
  crm_account_id: Scalars['UUID'],
  type: EntityType,
  email?: Maybe<Scalars['String']>,
  user_id?: Maybe<Scalars['Int']>,
  classification?: Maybe<Scalars['String']>,
};

export type NewHoldingInput = {
  account_id: Scalars['UUID'],
  company_id: Scalars['Int'],
  estimated_num_shares?: Maybe<Scalars['Int']>,
  confirmed_num_shares?: Maybe<Scalars['Int']>,
  date_acquired?: Maybe<Scalars['InvariantDate']>,
  share_class?: Maybe<Scalars['String']>,
  create_bid: Scalars['Boolean'],
  create_ask: Scalars['Boolean'],
};

export type NewInteractionInput = {
  object_type: InteractionLogObjectType,
  object_id: Scalars['UUID'],
  rollup_to_id?: Maybe<Scalars['UUID']>,
  rollup_from_id: Scalars['UUID'],
  contact_method: InteractionType,
  notes: Scalars['String'],
  tagged_value?: Maybe<Scalars['String']>,
  tokens: Array<InteractionTokenInput>,
  postToSlackChannel?: Maybe<Scalars['String']>,
};

export type NewPaymentMappingInput = {
  amount: Scalars['BigDecimal'],
  mapping_description: Scalars['String'],
  order_id?: Maybe<Scalars['Int']>,
  fee_id?: Maybe<Scalars['UUID']>,
  broker_id?: Maybe<Scalars['Int']>,
  admin_note?: Maybe<Scalars['String']>,
  reason_for_size?: Maybe<Scalars['String']>,
  payment_type?: Maybe<Scalars['String']>,
};

export type NewRoleInput = {
  user_id: Scalars['Int'],
  entity_id: Scalars['Int'],
  type: Scalars['String'],
  permission: Scalars['String'],
  title?: Maybe<Scalars['String']>,
};

export type NewsArticle = {
   __typename?: 'NewsArticle',
  id: Scalars['Int'],
  publisher_name: Scalars['String'],
  title: Scalars['String'],
  external_link: Scalars['String'],
  first_line?: Maybe<Scalars['String']>,
  image_url?: Maybe<Scalars['String']>,
  date: Scalars['DateTime'],
};

export type NewTemplateInput = {
  type: Scalars['String'],
  name: Scalars['String'],
  version: Scalars['String'],
  tag_id: Scalars['UUID'],
  file_path?: Maybe<Scalars['String']>,
  file_serial?: Maybe<Scalars['String']>,
};

export type OfferingAllocation = {
   __typename?: 'OfferingAllocation',
  offering_id: Scalars['UUID'],
  bid_id?: Maybe<Scalars['UUID']>,
  ask_id?: Maybe<Scalars['UUID']>,
  user_id: Scalars['Int'],
  allocation_share_price: Scalars['BigDecimal'],
  allocation_num_shares: Scalars['Long'],
  offering: OfferingView,
  bid?: Maybe<TradeIntentView>,
  ask?: Maybe<TradeIntentView>,
};

export type OfferingDetailsFormInput = {
  id: Scalars['UUID'],
  name: Scalars['String'],
  owner_ids?: Maybe<Array<Scalars['Int']>>,
  offering_type: Scalars['String'],
  block_type: Scalars['String'],
  equifund_id?: Maybe<Scalars['Int']>,
  description?: Maybe<Scalars['String']>,
  company_description?: Maybe<Scalars['String']>,
  num_available_shares: Scalars['Long'],
  est_num_company_shares?: Maybe<Scalars['Long']>,
  starting_share_price: Scalars['BigDecimal'],
  min_listing_size?: Maybe<Scalars['BigDecimal']>,
  min_direct_size?: Maybe<Scalars['BigDecimal']>,
  min_shares_to_close: Scalars['BigDecimal'],
  available_from: Scalars['DateTime'],
  available_to: Scalars['DateTime'],
  auto_reminder_email_at?: Maybe<Scalars['DateTime']>,
  auto_order_reminder_email_at?: Maybe<Scalars['DateTime']>,
  auto_feedback_email_at?: Maybe<Scalars['DateTime']>,
  min_num_shares?: Maybe<Scalars['Int']>,
  max_num_shares?: Maybe<Scalars['Int']>,
  possible_structures: Array<Scalars['String']>,
  custom_valuation_disclaimer?: Maybe<Scalars['String']>,
  custom_closing_timeline?: Maybe<Scalars['String']>,
  commission?: Maybe<Scalars['BigDecimal']>,
  valuation_type: ValuationType,
  custom_contact_message?: Maybe<Scalars['String']>,
  custom_contact_id?: Maybe<Scalars['Int']>,
  custom_consideration?: Maybe<Scalars['String']>,
  custom_transaction_timeline?: Maybe<Scalars['String']>,
  custom_transaction_structure?: Maybe<Scalars['String']>,
  custom_fund_structure?: Maybe<Scalars['String']>,
  custom_offering_process?: Maybe<Scalars['String']>,
  custom_offering_process_details?: Maybe<Scalars['String']>,
};

export enum OfferingEmailType {
  Invitation = 'Invitation',
  Feedback = 'Feedback',
  OrderReminder = 'OrderReminder',
  Reminder = 'Reminder'
}

export type OfferingMutations = {
   __typename?: 'OfferingMutations',
  accept: Scalars['Int'],
};

export type OfferingParticipationRead = {
   __typename?: 'OfferingParticipationRead',
  id: Scalars['UUID'],
  status: Scalars['String'],
  status_updated_at?: Maybe<Scalars['DateTime']>,
  accepted_nda?: Maybe<Scalars['Boolean']>,
  expected_total_investment?: Maybe<Scalars['String']>,
  kraken_public_account_id?: Maybe<Scalars['String']>,
  created_at: Scalars['DateTime'],
  entities: Array<EntityRead>,
  orders: Array<OrderRead>,
  last_invite_sent_at?: Maybe<Scalars['DateTime']>,
};

export type OfferingParticipationView = {
   __typename?: 'OfferingParticipationView',
  id: Scalars['UUID'],
  user_id: Scalars['Int'],
  status: Scalars['String'],
  status_updated_at?: Maybe<Scalars['DateTime']>,
  accepted_nda?: Maybe<Scalars['Boolean']>,
  expected_total_investment?: Maybe<Scalars['String']>,
  created_at: Scalars['DateTime'],
  META: Meta,
  entities: Array<EntityView>,
  user: UserView,
  bids: Array<TradeIntentView>,
  asks: Array<TradeIntentView>,
  last_invite_sent_at?: Maybe<Scalars['DateTime']>,
};

export type OfferingRead = {
   __typename?: 'OfferingRead',
  id: Scalars['UUID'],
  name: Scalars['String'],
  company_id: Scalars['Int'],
  company_description?: Maybe<Scalars['String']>,
  primary_round_details?: Maybe<Scalars['String']>,
  offering_type: Scalars['String'],
  block_type: Scalars['String'],
  token: Scalars['String'],
  folder_id?: Maybe<Scalars['Int']>,
  num_available_shares?: Maybe<Scalars['Long']>,
  starting_share_price?: Maybe<Scalars['BigDecimal']>,
  min_listing_size?: Maybe<Scalars['BigDecimal']>,
  min_direct_size?: Maybe<Scalars['BigDecimal']>,
  min_shares_to_close?: Maybe<Scalars['BigDecimal']>,
  min_num_shares?: Maybe<Scalars['Int']>,
  max_num_shares?: Maybe<Scalars['Int']>,
  available_from?: Maybe<Scalars['DateTime']>,
  available_to: Scalars['DateTime'],
  valuation_type: ValuationType,
  custom_contact_message?: Maybe<Scalars['String']>,
  equifund_id?: Maybe<Scalars['Int']>,
  data_room_files_downloadable: Scalars['Boolean'],
  box_folder_id?: Maybe<Scalars['String']>,
  fcff_closing_days?: Maybe<Scalars['Int']>,
  custom_consideration?: Maybe<Scalars['String']>,
  custom_transaction_timeline?: Maybe<Scalars['String']>,
  custom_transaction_structure?: Maybe<Scalars['String']>,
  custom_fund_structure?: Maybe<Scalars['String']>,
  custom_offering_process?: Maybe<Scalars['String']>,
  custom_offering_process_details?: Maybe<Scalars['String']>,
  commission_schedule: Array<CommissionScheduleRead>,
  commission?: Maybe<Scalars['BigDecimal']>,
  status: Scalars['String'],
  valuation_disclaimer_text: Scalars['String'],
  closing_timeline_text: Scalars['String'],
  participation: OfferingParticipationRead,
  dollar_amount_at_starting_price?: Maybe<Scalars['BigDecimal']>,
  starting_share_price_net_of_fees: Array<SharePriceWithFees>,
  box_access_token?: Maybe<Scalars['String']>,
  total_listing_volume: Scalars['BigDecimal'],
  dollar_amount_remaining?: Maybe<Scalars['BigDecimal']>,
  num_shares_remaining?: Maybe<Scalars['Long']>,
  num_participants: Scalars['Int'],
  num_listings: Scalars['Int'],
  highest_bid_price?: Maybe<Scalars['BigDecimal']>,
  implied_valuation_at_starting_price?: Maybe<Scalars['BigDecimal']>,
  company: CompanyRead,
  bids: Array<BidRead>,
  asks: Array<AskRead>,
  data_room?: Maybe<FolderRead>,
  contact_phone_number: Scalars['String'],
  contact_email: Scalars['String'],
  custom_contact?: Maybe<UserRead>,
  mutations: OfferingMutations,
  equifund?: Maybe<EquifundRead>,
};

export enum OfferingType {
  FcsSecondary = 'fcs_secondary',
  FirstComeFirstFillAuction = 'first_come_first_fill_auction',
  FcsPrimary = 'fcs_primary',
  OpenBidAuction = 'open_bid_auction',
  SealedBidSecondHighestPriceAuction = 'sealed_bid_second_highest_price_auction'
}

export type OfferingView = {
   __typename?: 'OfferingView',
  id: Scalars['UUID'],
  company_id: Scalars['Int'],
  offering_type: Scalars['String'],
  block_type: Scalars['String'],
  name: Scalars['String'],
  token: Scalars['String'],
  company_description?: Maybe<Scalars['String']>,
  folder_id?: Maybe<Scalars['Int']>,
  num_available_shares?: Maybe<Scalars['Long']>,
  est_num_company_shares?: Maybe<Scalars['Long']>,
  starting_share_price?: Maybe<Scalars['BigDecimal']>,
  min_listing_size?: Maybe<Scalars['BigDecimal']>,
  min_direct_size?: Maybe<Scalars['BigDecimal']>,
  min_shares_to_close?: Maybe<Scalars['BigDecimal']>,
  breakup_fee?: Maybe<Scalars['BigDecimal']>,
  is_block_fully_committed: Scalars['Boolean'],
  is_private: Scalars['Boolean'],
  min_num_shares?: Maybe<Scalars['Int']>,
  max_num_shares?: Maybe<Scalars['Int']>,
  available_from: Scalars['DateTime'],
  available_to: Scalars['DateTime'],
  auto_reminder_email_at?: Maybe<Scalars['DateTime']>,
  auto_order_reminder_email_at?: Maybe<Scalars['DateTime']>,
  auto_feedback_email_at?: Maybe<Scalars['DateTime']>,
  valuation_type?: Maybe<Scalars['String']>,
  custom_valuation_disclaimer?: Maybe<Scalars['String']>,
  custom_disclaimer_updated_at?: Maybe<Scalars['DateTime']>,
  custom_contact_message?: Maybe<Scalars['String']>,
  custom_contact_id?: Maybe<Scalars['Int']>,
  custom_closing_timeline?: Maybe<Scalars['String']>,
  possible_structures: Array<Scalars['String']>,
  insurance_status: Scalars['String'],
  interface: Scalars['String'],
  securitization: Scalars['String'],
  equifund_id?: Maybe<Scalars['Int']>,
  allocation_confirmed?: Maybe<Scalars['Boolean']>,
  fcff_closing_days?: Maybe<Scalars['Int']>,
  box_folder_id?: Maybe<Scalars['String']>,
  data_room_files_downloadable: Scalars['Boolean'],
  primary_round_details?: Maybe<Scalars['String']>,
  META: Meta,
  ownable_id?: Maybe<Scalars['UUID']>,
  custom_consideration?: Maybe<Scalars['String']>,
  custom_transaction_timeline?: Maybe<Scalars['String']>,
  custom_transaction_structure?: Maybe<Scalars['String']>,
  custom_fund_structure?: Maybe<Scalars['String']>,
  custom_offering_process?: Maybe<Scalars['String']>,
  custom_offering_process_details?: Maybe<Scalars['String']>,
  status: Scalars['String'],
  commission_schedule: Array<CommissionScheduleRead>,
  commission?: Maybe<Scalars['BigDecimal']>,
  company: CompanyView,
  participants: Array<OfferingParticipationView>,
  paginatedParticipants: PaginatedView_Schema_Admin_Types_Offerings_OfferingParticipationView,
  bids: Array<TradeIntentView>,
  asks: Array<TradeIntentView>,
  tradeIntents: Array<TradeIntentView>,
  files: Array<FileView>,
  dollar_amount_at_starting_price?: Maybe<Scalars['BigDecimal']>,
  implied_valuation_at_starting_price?: Maybe<Scalars['BigDecimal']>,
  dollar_amount_allocated: Scalars['BigDecimal'],
  total_listing_volume: Scalars['BigDecimal'],
  dollar_amount_at_starting_price_gross?: Maybe<Scalars['BigDecimal']>,
  dollar_amount_at_starting_price_net?: Maybe<Scalars['BigDecimal']>,
  dollar_amount_allocated_gross: Scalars['BigDecimal'],
  dollar_amount_allocated_net: Scalars['BigDecimal'],
  implied_valuation_at_starting_price_gross?: Maybe<Scalars['BigDecimal']>,
  implied_valuation_at_starting_price_net?: Maybe<Scalars['BigDecimal']>,
  total_listing_volume_gross: Scalars['BigDecimal'],
  total_listing_volume_net: Scalars['BigDecimal'],
  allocations: Array<OfferingAllocation>,
  dollar_amount_fees_paid: Scalars['BigDecimal'],
  dollar_amount_paid: Scalars['BigDecimal'],
  invites_sent: Scalars['Int'],
  invites_clicked: Scalars['Int'],
  invites_opened: Scalars['Int'],
  num_participants: Scalars['Int'],
  num_invites_sent: Scalars['Int'],
  num_invites_clicked: Scalars['Int'],
  num_invites_opened: Scalars['Int'],
  num_ndas_signed: Scalars['Int'],
  num_bids_placed: Scalars['Int'],
  num_orders_signed: Scalars['Int'],
  num_payments_received: Scalars['Int'],
  primary_contacts: Array<UserView>,
  custom_contact?: Maybe<UserView>,
  num_shares_remaining?: Maybe<Scalars['Long']>,
  previous_invitation_email_at?: Maybe<Scalars['DateTime']>,
  previous_reminder_email_at?: Maybe<Scalars['DateTime']>,
  previous_order_reminder_email_at?: Maybe<Scalars['DateTime']>,
  previous_feedback_email_at?: Maybe<Scalars['DateTime']>,
};


export type OfferingViewPaginatedParticipantsArgs = {
  offset: Scalars['Int'],
  limit: Scalars['Int']
};

export type OnboardingDetails = {
   __typename?: 'OnboardingDetails',
  current_step?: Maybe<Scalars['String']>,
  status: FcsOnboardingStatus,
  steps?: Maybe<Array<OnboardingStepState>>,
  company: CompanyDetails,
  users: Array<UserInfo>,
  tags: Array<OnboardingFileTag>,
};

export type OnboardingDetailsFormInput = {
  company: CompanyDetailsInput,
  users: Array<UserInfoInput>,
  tags: Array<OnboardingFileTagInput>,
};

export type OnboardingFileTag = {
   __typename?: 'OnboardingFileTag',
  name: Scalars['String'],
  required: Scalars['Boolean'],
};

export type OnboardingFileTagInput = {
  name: Scalars['String'],
  required: Scalars['Boolean'],
};

export type OnboardingStepState = {
   __typename?: 'OnboardingStepState',
  id: Scalars['Int'],
  name: Scalars['String'],
  completed: Scalars['Boolean'],
};

export type OpportunityActionInput = {
  opportunityId: Scalars['UUID'],
  status?: Maybe<TradeIntentStatusType>,
  expired?: Maybe<Scalars['Boolean']>,
  cancellation?: Maybe<OpportunityCancellationFormInput>,
};

export type OpportunityCancellationFormInput = {
  cancellation_type: OpportunityCancellationType,
  reason?: Maybe<Scalars['String']>,
  notes?: Maybe<Scalars['String']>,
  competitor?: Maybe<Scalars['String']>,
  lost_transaction_pricing?: Maybe<PricingDetailsFormInput>,
};

export enum OpportunityCancellationType {
  LostToCompetitor = 'lost_to_competitor',
  FellThrough = 'fell_through',
  NoIntent = 'no_intent',
  Closed = 'closed'
}

export enum OpportunityCertainty {
  Theory = 'theory',
  Soft = 'soft',
  Firm = 'firm',
  Cancelled = 'cancelled',
  Serious = 'serious'
}

export type OpportunityFilterInput = {
  companyId?: Maybe<Scalars['Int']>,
  type?: Maybe<TradeIntentType>,
  status?: Maybe<Scalars['String']>,
  structures?: Maybe<Array<ListingStructureType>>,
  expired: Scalars['Boolean'],
  sortField?: Maybe<Scalars['String']>,
  sortDirection?: Maybe<SortDirection>,
  owners?: Maybe<Array<Scalars['Int']>>,
};

export type OpportunityFormInput = {
  id?: Maybe<Scalars['UUID']>,
  account_id: Scalars['UUID'],
  company_id: Scalars['Int'],
  type: TradeIntentType,
  structure?: Maybe<Array<ListingStructureType>>,
  share_price?: Maybe<Scalars['BigDecimal']>,
  valuation?: Maybe<Scalars['BigDecimal']>,
  min_num_shares?: Maybe<Scalars['Int']>,
  max_num_shares?: Maybe<Scalars['Int']>,
  fee?: Maybe<Scalars['BigDecimal']>,
  min_dollar_amount?: Maybe<Scalars['BigDecimal']>,
  max_dollar_amount?: Maybe<Scalars['BigDecimal']>,
  latest_activity?: Maybe<Scalars['String']>,
  status?: Maybe<TradeIntentStatusType>,
  entity_id?: Maybe<Scalars['Int']>,
  certainty: OpportunityCertainty,
  owner_ids?: Maybe<Array<Scalars['Int']>>,
  renew: Scalars['Boolean'],
  postToSlackChannel?: Maybe<Scalars['String']>,
  interaction?: Maybe<InteractionFormInput>,
  share_price_recorded_as?: Maybe<SharePriceRecordedAsType>,
};

export type OpportunitySource = {
   __typename?: 'OpportunitySource',
  opportunity: OpportunityView,
};

export type OpportunityTradeIntentFormInput = {
  id: Scalars['UUID'],
  fee?: Maybe<Scalars['BigDecimal']>,
  share_type_description?: Maybe<Scalars['String']>,
  asset_type?: Maybe<Scalars['String']>,
  additional_diligence_notes?: Maybe<Scalars['String']>,
  has_time_constraints?: Maybe<Scalars['Boolean']>,
  time_constraint_notes?: Maybe<Scalars['String']>,
  has_flexibility?: Maybe<Scalars['Boolean']>,
  flexibility_notes?: Maybe<Scalars['String']>,
};

export type OpportunityView = {
   __typename?: 'OpportunityView',
  id: Scalars['UUID'],
  type: TradeIntentType,
  account_id: Scalars['UUID'],
  company_id: Scalars['Int'],
  certainty: OpportunityCertainty,
  source: Scalars['String'],
  status: TradeIntentStatusType,
  creator_id: Scalars['Int'],
  expired_at?: Maybe<Scalars['DateTime']>,
  interaction_log_id?: Maybe<Scalars['UUID']>,
  latest_activity?: Maybe<Scalars['String']>,
  notes?: Maybe<Scalars['String']>,
  ownable_id?: Maybe<Scalars['UUID']>,
  deal_blockers: Array<Scalars['String']>,
  date_created: Scalars['DateTime'],
  date_updated: Scalars['DateTime'],
  renewed_at?: Maybe<Scalars['DateTime']>,
  entity_id?: Maybe<Scalars['Int']>,
  min_dollar_amount?: Maybe<Scalars['BigDecimal']>,
  max_dollar_amount?: Maybe<Scalars['BigDecimal']>,
  min_num_shares?: Maybe<Scalars['Long']>,
  max_num_shares?: Maybe<Scalars['Long']>,
  share_price?: Maybe<Scalars['BigDecimal']>,
  pricing_type?: Maybe<Scalars['String']>,
  valuation?: Maybe<Scalars['BigDecimal']>,
  asset_type?: Maybe<Scalars['String']>,
  is_visible: Scalars['Boolean'],
  admin_note?: Maybe<Scalars['String']>,
  loi_contract_id?: Maybe<Scalars['Int']>,
  acceptable_structures: Array<ListingStructureType>,
  include_in_order_book: Scalars['Boolean'],
  include_in_brightpool: Scalars['Boolean'],
  expiration_confirmed: Scalars['Boolean'],
  offering_id?: Maybe<Scalars['UUID']>,
  is_trade_restricted: Scalars['Boolean'],
  additional_diligence_notes?: Maybe<Scalars['String']>,
  has_time_constraints?: Maybe<Scalars['Boolean']>,
  time_constraint_notes?: Maybe<Scalars['String']>,
  has_flexibility?: Maybe<Scalars['Boolean']>,
  flexibility_notes?: Maybe<Scalars['String']>,
  fee?: Maybe<Scalars['BigDecimal']>,
  share_type_description?: Maybe<Scalars['String']>,
  holding_id?: Maybe<Scalars['Int']>,
  size_type?: Maybe<TradeIntentSizeType>,
  share_price_recorded_as: SharePriceRecordedAsType,
  trade_intent: TradeIntentView,
  created_by: Scalars['Int'],
  created_at: Scalars['DateTime'],
  updated_at: Scalars['DateTime'],
  last_refreshed_at: Scalars['DateTime'],
  company: CompanyView,
  owners: Array<OwnerView>,
  account: AccountView,
  stakeholders: Array<AccountRelationshipView>,
  interactions: Array<InteractionView>,
  active_deals: Array<DealView>,
  dollar_amount?: Maybe<Scalars['BigDecimal']>,
  num_shares?: Maybe<Scalars['Long']>,
  entity?: Maybe<EntityView>,
  order_id?: Maybe<Scalars['Int']>,
  order?: Maybe<OrderView>,
  creator: UserView,
  is_expired: Scalars['Boolean'],
  primary_contacts: Array<UserView>,
  is_admin_created: Scalars['Boolean'],
  offering?: Maybe<OfferingView>,
  liquidity_event?: Maybe<LiquidityEventRead>,
  is_loi_signed: Scalars['Boolean'],
  loi?: Maybe<ContractView>,
  latest_price_change?: Maybe<FieldChangeView>,
  holding?: Maybe<HoldingView>,
};


export type OpportunityViewInteractionsArgs = {
  groupFilter?: Maybe<InteractionFilter>
};

export type OrderBookBlockRead = {
   __typename?: 'OrderBookBlockRead',
  volume: Scalars['BigDecimal'],
  structures: Scalars['String'],
  price_bucket_low: Scalars['BigDecimal'],
  price_bucket_high: Scalars['BigDecimal'],
  percentage_of_last_round_low?: Maybe<Scalars['BigDecimal']>,
  percentage_of_last_round_high?: Maybe<Scalars['BigDecimal']>,
  is_trade_restricted: Scalars['String'],
};

export type OrderBookFilterInput = {
  valuation?: Maybe<Array<FilterRangeInput>>,
  bidVolumeActive?: Maybe<Array<FilterRangeInput>>,
  askVolumeActive?: Maybe<Array<FilterRangeInput>>,
  tradeStructuresActive?: Maybe<Array<ListingStructureType>>,
};

export type OrderBookFilterParamsInput = {
  structure?: Maybe<Array<Scalars['String']>>,
  type?: Maybe<Array<Scalars['String']>>,
  sortBy?: Maybe<Scalars['String']>,
  sortDirection?: Maybe<Scalars['String']>,
  companyId?: Maybe<Scalars['Int']>,
  owner?: Maybe<Scalars['Int']>,
  activeOnly?: Maybe<Scalars['Boolean']>,
  adminCreatedOnly?: Maybe<Scalars['Boolean']>,
  needsReview?: Maybe<Scalars['Boolean']>,
};

export type OrderbookListingView = {
   __typename?: 'OrderbookListingView',
  id: Scalars['UUID'],
  type: Scalars['String'],
  entity_id?: Maybe<Scalars['Int']>,
  status: Scalars['String'],
  num_shares?: Maybe<Scalars['Long']>,
  share_price?: Maybe<Scalars['BigDecimal']>,
  company_id: Scalars['Int'],
  pricing_type?: Maybe<Scalars['String']>,
  dollar_amount?: Maybe<Scalars['BigDecimal']>,
  valuation?: Maybe<Scalars['BigDecimal']>,
  is_visible: Scalars['Boolean'],
  creator_id: Scalars['Int'],
  expired_at?: Maybe<Scalars['DateTime']>,
  expiration_confirmed: Scalars['Boolean'],
  renewed_at?: Maybe<Scalars['DateTime']>,
  certainty?: Maybe<Scalars['String']>,
  date_created: Scalars['DateTime'],
  date_updated?: Maybe<Scalars['DateTime']>,
  admin_note?: Maybe<Scalars['String']>,
  acceptable_structures: Array<Scalars['String']>,
  include_in_brightpool: Scalars['Boolean'],
  broker_id?: Maybe<Scalars['Int']>,
  is_trade_restricted: Scalars['Boolean'],
  account_id: Scalars['UUID'],
  META: Meta,
  entity?: Maybe<EntityView>,
  broker?: Maybe<Scalars['String']>,
  company: CompanyView,
  creator: UserView,
  is_expired: Scalars['Boolean'],
  needs_review: Scalars['Boolean'],
  net_of_fees_price?: Maybe<Scalars['BigDecimal']>,
  primary_contacts: Array<UserView>,
  is_admin_created: Scalars['Boolean'],
  opportunity: OpportunityView,
  account: AccountView,
};

export type OrderMutations = {
   __typename?: 'OrderMutations',
  add_contract: Scalars['Boolean'],
  generateTradeConfirm: Scalars['Int'],
};


export type OrderMutationsAdd_ContractArgs = {
  templateId: Scalars['Int']
};

export type OrderRead = {
   __typename?: 'OrderRead',
  id: Scalars['Int'],
  serial?: Maybe<Scalars['String']>,
  type: Scalars['String'],
  asset_type: Scalars['String'],
  securitization?: Maybe<Scalars['String']>,
  interface?: Maybe<Scalars['String']>,
  status: Scalars['String'],
  payment_status: Scalars['String'],
  payment_confirmed_at?: Maybe<Scalars['DateTime']>,
  entity_id: Scalars['Int'],
  company_id: Scalars['Int'],
  folder_id?: Maybe<Scalars['Int']>,
  share_price?: Maybe<Scalars['BigDecimal']>,
  num_shares?: Maybe<Scalars['Long']>,
  dollar_amount?: Maybe<Scalars['BigDecimal']>,
  bank_account_id?: Maybe<Scalars['Int']>,
  equifund_id?: Maybe<Scalars['Int']>,
  form?: Maybe<Scalars['String']>,
  spouse_invited?: Maybe<Scalars['Boolean']>,
  transformation_type?: Maybe<Scalars['String']>,
  transformed_status?: Maybe<Scalars['String']>,
  transformed_order_id?: Maybe<Scalars['Int']>,
  offering_id?: Maybe<Scalars['UUID']>,
  broker_of_record_id?: Maybe<Scalars['Int']>,
  date_created: Scalars['DateTime'],
  entity: EntityRead,
  offering?: Maybe<OfferingRead>,
  company: CompanyRead,
  commission: Scalars['BigDecimal'],
  transaction_fee: Scalars['BigDecimal'],
  bank_account?: Maybe<BankAccountRead>,
  process_steps: Array<ProcessStepRead>,
  closing_contracts: Array<ContractRead>,
  contracts: Array<ContractRead>,
  is_signed: Scalars['Boolean'],
  equifund?: Maybe<EquifundRead>,
  holdings: Array<HoldingRead>,
  matching_asset_type?: Maybe<Scalars['String']>,
  matching_securitization?: Maybe<Scalars['String']>,
  split_adjusted_share_price: Scalars['BigDecimal'],
  split_adjusted_num_shares: Scalars['BigDecimal'],
  permission?: Maybe<Scalars['String']>,
  regenerate_documents: Scalars['Int'],
  net_of_fees_price: Scalars['BigDecimal'],
  is_forge_broker_of_record: Scalars['Boolean'],
  liquidity_event_type?: Maybe<LiquidityEventType>,
};


export type OrderReadRegenerate_DocumentsArgs = {
  force: Scalars['Boolean']
};

export enum OrderStructureType {
  Forward = 'forward',
  ShareBackedSpv = 'share_backed_spv',
  ForeignLpBackedSpv = 'foreign_lp_backed_spv',
  DirectForward = 'direct_forward',
  Direct = 'direct'
}

export enum OrderType {
  Bid = 'bid',
  Ask = 'ask'
}

export type OrderView = {
   __typename?: 'OrderView',
  id: Scalars['Int'],
  serial?: Maybe<Scalars['String']>,
  type: Scalars['String'],
  status: Scalars['String'],
  transformation_type?: Maybe<Scalars['String']>,
  transformed_status?: Maybe<Scalars['String']>,
  doc_status: Scalars['String'],
  payment_status: Scalars['String'],
  entity_id: Scalars['Int'],
  company_id: Scalars['Int'],
  folder_id?: Maybe<Scalars['Int']>,
  share_price?: Maybe<Scalars['BigDecimal']>,
  num_shares?: Maybe<Scalars['Long']>,
  dollar_amount?: Maybe<Scalars['BigDecimal']>,
  fund_closing_batch?: Maybe<Scalars['Int']>,
  broker_ga?: Maybe<Scalars['BigDecimal']>,
  insurance_status?: Maybe<Scalars['String']>,
  equifund_id?: Maybe<Scalars['Int']>,
  bank_account_id?: Maybe<Scalars['Int']>,
  interface?: Maybe<Scalars['String']>,
  securitization?: Maybe<Scalars['String']>,
  admin_note?: Maybe<Scalars['String']>,
  form?: Maybe<Scalars['String']>,
  asset_type: Scalars['String'],
  fully_signed_at?: Maybe<Scalars['DateTime']>,
  trade_confirm_sent: Scalars['Boolean'],
  transformed_order_id?: Maybe<Scalars['Int']>,
  date_created: Scalars['DateTime'],
  broker_of_record_id?: Maybe<Scalars['Int']>,
  offering_id?: Maybe<Scalars['UUID']>,
  confidential: Scalars['Boolean'],
  META: Meta,
  entity: EntityView,
  company: CompanyView,
  commission: Scalars['BigDecimal'],
  transaction_fee: Scalars['BigDecimal'],
  process_steps: Array<ProcessStepView>,
  make_process_steps: Array<ProcessStepView>,
  contracts: Array<ContractView>,
  is_fully_signed: Scalars['Boolean'],
  signed_file_tags: Array<Scalars['UUID']>,
  broker_of_record?: Maybe<BrokerProfileView>,
  required_contracts: Array<TagView>,
  assure_signed?: Maybe<Scalars['Boolean']>,
  client_signed: Scalars['Boolean'],
  regenerateDocuments: Scalars['Int'],
  equifund?: Maybe<EquifundView>,
  matches: Array<MatchView>,
  bank_account?: Maybe<BankAccountView>,
  entity_bank_accounts: Array<BankAccountView>,
  wire_info_sent: Scalars['Boolean'],
  wire_amount: Scalars['BigDecimal'],
  can_wire_info_be_sent: Scalars['Boolean'],
  percent_matched: Scalars['BigDecimal'],
  matched_shares: Scalars['Long'],
  rofr_deadline?: Maybe<Scalars['DateTime']>,
  extra_fees: Array<FeeView>,
  files: Array<FileView>,
  transformed_order?: Maybe<OrderView>,
  transforming_orders: Array<OrderView>,
  unpaid_amount: Scalars['BigDecimal'],
  split_adjusted_share_price: Scalars['BigDecimal'],
  split_adjusted_num_shares: Scalars['BigDecimal'],
  payment_mappings: Array<PaymentMappingView>,
  emllc_net_proceeds: Scalars['BigDecimal'],
  ga_charged_by_emllc: Scalars['BigDecimal'],
  equidate_inc_net_proceeds: Scalars['BigDecimal'],
  ga_charged_to_equidate_inc: Scalars['BigDecimal'],
  total_transfer_fees: Scalars['BigDecimal'],
  equidate_volume: Scalars['BigDecimal'],
  gaap_revenue: Scalars['BigDecimal'],
  net_revenue: Scalars['BigDecimal'],
  insurance_cost: Scalars['BigDecimal'],
  insurance_cost_delta: Scalars['BigDecimal'],
  date_fully_accrued?: Maybe<Scalars['InvariantDate']>,
  broker: Scalars['String'],
  owners: Array<UserView>,
  entity_reviewed: Scalars['Boolean'],
  entity_approved: Scalars['Boolean'],
  structure?: Maybe<Scalars['String']>,
  is_modifiable: Scalars['Boolean'],
  mutations: OrderMutations,
};


export type OrderViewRegenerateDocumentsArgs = {
  force: Scalars['Boolean']
};

export type OwnerView = {
   __typename?: 'OwnerView',
  id: Scalars['UUID'],
  ownable_id: Scalars['UUID'],
  owner_id: Scalars['Int'],
  ranking: Scalars['Int'],
  owner_group?: Maybe<Scalars['String']>,
  created_at: Scalars['DateTime'],
  name: Scalars['String'],
  first_name: Scalars['String'],
  last_name: Scalars['String'],
  user: UserView,
  admin_id: Scalars['Int'],
};

export type PaginatedView_Schema_Admin_Types_BrokerProfileView = {
   __typename?: 'PaginatedView_schema_admin_types_BrokerProfileView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<BrokerProfileView>,
};

export type PaginatedView_Schema_Admin_Types_CapabilityView = {
   __typename?: 'PaginatedView_schema_admin_types_CapabilityView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<CapabilityView>,
};

export type PaginatedView_Schema_Admin_Types_ClientGiftView = {
   __typename?: 'PaginatedView_schema_admin_types_ClientGiftView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<ClientGiftView>,
};

export type PaginatedView_Schema_Admin_Types_ClosingView = {
   __typename?: 'PaginatedView_schema_admin_types_ClosingView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<ClosingView>,
};

export type PaginatedView_Schema_Admin_Types_CompanyBlockView = {
   __typename?: 'PaginatedView_schema_admin_types_CompanyBlockView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<CompanyBlockView>,
};

export type PaginatedView_Schema_Admin_Types_CompanyView = {
   __typename?: 'PaginatedView_schema_admin_types_CompanyView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<CompanyView>,
};

export type PaginatedView_Schema_Admin_Types_ContractView = {
   __typename?: 'PaginatedView_schema_admin_types_ContractView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<ContractView>,
};

export type PaginatedView_Schema_Admin_Types_Crm_Accounts_AccountSuggestionView = {
   __typename?: 'PaginatedView_schema_admin_types_crm_accounts_AccountSuggestionView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<AccountSuggestionView>,
};

export type PaginatedView_Schema_Admin_Types_Crm_Accounts_AccountView = {
   __typename?: 'PaginatedView_schema_admin_types_crm_accounts_AccountView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<AccountView>,
};

export type PaginatedView_Schema_Admin_Types_Crm_Opportunities_OpportunityView = {
   __typename?: 'PaginatedView_schema_admin_types_crm_opportunities_OpportunityView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<OpportunityView>,
};

export type PaginatedView_Schema_Admin_Types_EmailQueueView = {
   __typename?: 'PaginatedView_schema_admin_types_EmailQueueView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<EmailQueueView>,
};

export type PaginatedView_Schema_Admin_Types_EntityView = {
   __typename?: 'PaginatedView_schema_admin_types_EntityView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<EntityView>,
};

export type PaginatedView_Schema_Admin_Types_EquifundView = {
   __typename?: 'PaginatedView_schema_admin_types_EquifundView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<EquifundView>,
};

export type PaginatedView_Schema_Admin_Types_IdentificationDocumentView = {
   __typename?: 'PaginatedView_schema_admin_types_IdentificationDocumentView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<IdentificationDocumentView>,
};

export type PaginatedView_Schema_Admin_Types_MatchView = {
   __typename?: 'PaginatedView_schema_admin_types_MatchView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<MatchView>,
};

export type PaginatedView_Schema_Admin_Types_Offerings_OfferingParticipationView = {
   __typename?: 'PaginatedView_schema_admin_types_offerings_OfferingParticipationView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<OfferingParticipationView>,
};

export type PaginatedView_Schema_Admin_Types_Offerings_OfferingView = {
   __typename?: 'PaginatedView_schema_admin_types_offerings_OfferingView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<OfferingView>,
};

export type PaginatedView_Schema_Admin_Types_OrderView = {
   __typename?: 'PaginatedView_schema_admin_types_OrderView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<OrderView>,
};

export type PaginatedView_Schema_Admin_Types_PaymentImportView = {
   __typename?: 'PaginatedView_schema_admin_types_PaymentImportView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<PaymentImportView>,
};

export type PaginatedView_Schema_Admin_Types_PaymentMappingView = {
   __typename?: 'PaginatedView_schema_admin_types_PaymentMappingView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<PaymentMappingView>,
};

export type PaginatedView_Schema_Admin_Types_ProofDocView = {
   __typename?: 'PaginatedView_schema_admin_types_ProofDocView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<ProofDocView>,
};

export type PaginatedView_Schema_Admin_Types_ShareholderHuntLeadView = {
   __typename?: 'PaginatedView_schema_admin_types_ShareholderHuntLeadView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<ShareholderHuntLeadView>,
};

export type PaginatedView_Schema_Admin_Types_SignatureView = {
   __typename?: 'PaginatedView_schema_admin_types_SignatureView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<SignatureView>,
};

export type PaginatedView_Schema_Admin_Types_TemplateView = {
   __typename?: 'PaginatedView_schema_admin_types_TemplateView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<TemplateView>,
};

export type PaginatedView_Schema_Admin_Types_TradeIntentView = {
   __typename?: 'PaginatedView_schema_admin_types_TradeIntentView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<TradeIntentView>,
};

export type PaginatedView_Schema_Admin_Types_UserView = {
   __typename?: 'PaginatedView_schema_admin_types_UserView',
  count: Scalars['Int'],
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  data: Array<UserView>,
};

export type PaymentImportView = {
   __typename?: 'PaymentImportView',
  id: Scalars['UUID'],
  source: Scalars['String'],
  payment_date: Scalars['DateTime'],
  ref_number?: Maybe<Scalars['String']>,
  amount: Scalars['BigDecimal'],
  payment_direction: Scalars['String'],
  payment_method: Scalars['String'],
  originator_name?: Maybe<Scalars['String']>,
  beneficiary_name?: Maybe<Scalars['String']>,
  unallocated_amount: Scalars['BigDecimal'],
  unallocated_amount_reason?: Maybe<Scalars['String']>,
  metadata: Scalars['Json'],
  created_at: Scalars['DateTime'],
  META: Meta,
  details: Scalars['String'],
  account_owner?: Maybe<Scalars['String']>,
  payment_mappings: Array<PaymentMappingView>,
};

export type PaymentMappingView = {
   __typename?: 'PaymentMappingView',
  id: Scalars['UUID'],
  amount: Scalars['BigDecimal'],
  payment_type?: Maybe<Scalars['String']>,
  payment_id?: Maybe<Scalars['UUID']>,
  mapping_description?: Maybe<Scalars['String']>,
  order_id?: Maybe<Scalars['Int']>,
  fee_id?: Maybe<Scalars['UUID']>,
  broker_id?: Maybe<Scalars['Int']>,
  admin_note?: Maybe<Scalars['String']>,
  status: Scalars['String'],
  reason_for_size?: Maybe<Scalars['String']>,
  is_system_generated: Scalars['Boolean'],
  confirmed_by?: Maybe<Scalars['Int']>,
  created_at: Scalars['DateTime'],
  META: Meta,
  order?: Maybe<OrderView>,
  fee?: Maybe<FeeView>,
  payment?: Maybe<PaymentImportView>,
};

export type PricingDetailsFormInput = {
  share_price?: Maybe<Scalars['BigDecimal']>,
  valuation?: Maybe<Scalars['BigDecimal']>,
  min_num_shares?: Maybe<Scalars['Int']>,
  max_num_shares?: Maybe<Scalars['Int']>,
  min_dollar_amount?: Maybe<Scalars['BigDecimal']>,
  max_dollar_amount?: Maybe<Scalars['BigDecimal']>,
  share_price_recorded_as?: Maybe<SharePriceRecordedAsType>,
};

export type PriorityCompanyView = {
   __typename?: 'PriorityCompanyView',
  id: Scalars['Int'],
  name: Scalars['String'],
  order_statuses: Array<Scalars['String']>,
  bid_statuses: Array<Scalars['String']>,
  ask_statuses: Array<Scalars['String']>,
  closing_statuses: Array<Scalars['String']>,
};

export type PrivCoCompanyRead = {
   __typename?: 'PrivCoCompanyRead',
  id: Scalars['Int'],
  revenue_growth_rate_1yr?: Maybe<Scalars['Float']>,
  revenue_growth_rate_3yr?: Maybe<Scalars['Float']>,
  employee_growth_rate_1yr?: Maybe<Scalars['Float']>,
  employee_growth_rate_3yr?: Maybe<Scalars['Float']>,
  created_at: Scalars['DateTime'],
  data: Array<PrivCoDataRead>,
};

export type PrivCoDataRead = {
   __typename?: 'PrivCoDataRead',
  id: Scalars['UUID'],
  title?: Maybe<Scalars['String']>,
  currency?: Maybe<Scalars['String']>,
  year?: Maybe<Scalars['Int']>,
  month?: Maybe<Scalars['Int']>,
  value?: Maybe<Scalars['String']>,
};

export type ProcessStepRead = {
   __typename?: 'ProcessStepRead',
  id: Scalars['Int'],
  step: Scalars['String'],
  type: Scalars['String'],
  type_id: Scalars['Int'],
  date_created: Scalars['DateTime'],
  status: Scalars['String'],
  reconcile: ProcessStepStatus,
};

export type ProcessStepStatus = {
   __typename?: 'ProcessStepStatus',
  last_status: Scalars['String'],
  status: Scalars['String'],
};

export type ProcessStepView = {
   __typename?: 'ProcessStepView',
  id: Scalars['Int'],
  step: Scalars['String'],
  type: Scalars['String'],
  type_id: Scalars['Int'],
  date_created: Scalars['DateTime'],
  status: Scalars['String'],
  reconcile: ProcessStepStatus,
};

export type ProofDocMutations = {
   __typename?: 'ProofDocMutations',
  update_verification_status: Scalars['Boolean'],
};


export type ProofDocMutationsUpdate_Verification_StatusArgs = {
  status: Scalars['String']
};

export type ProofDocRead = {
   __typename?: 'ProofDocRead',
  id: Scalars['Int'],
  type: Scalars['String'],
  folder_id?: Maybe<Scalars['Int']>,
  description?: Maybe<Scalars['String']>,
  verification_status: Scalars['String'],
  date_created?: Maybe<Scalars['DateTime']>,
  folder?: Maybe<FolderRead>,
};

export type ProofDocView = {
   __typename?: 'ProofDocView',
  id: Scalars['Int'],
  type: Scalars['String'],
  folder_id?: Maybe<Scalars['Int']>,
  description?: Maybe<Scalars['String']>,
  verification_status: Scalars['String'],
  date_created?: Maybe<Scalars['DateTime']>,
  META: Meta,
  files: Array<FileView>,
  role?: Maybe<RoleView>,
  holding_doc?: Maybe<HoldingDocView>,
  mutations: ProofDocMutations,
};

export type ProtectedViewOfBankAccountCollectionView = UnauthorizedView | AuthorizedBankAccountCollectionView;

export type Query = {
   __typename?: 'Query',
  _fieldSet: Scalars['String'],
  _service: _Service,
  account: AccountView,
  accountCreationSuggestions: PaginatedView_Schema_Admin_Types_Crm_Accounts_AccountSuggestionView,
  accountFromEmail?: Maybe<AccountView>,
  accountFromFrontContactId?: Maybe<AccountView>,
  accountRelationshipsTypeahead: Array<AccountRelationshipView>,
  accounts: Array<AccountView>,
  accountSearch: AccountSearchView,
  accountsTableSchema: TableDefinition,
  accountsTypeahead: Array<AccountView>,
  accruedMatches: PaginatedView_Schema_Admin_Types_MatchView,
  activeClosings: PaginatedView_Schema_Admin_Types_ClosingView,
  activeOrders: PaginatedView_Schema_Admin_Types_OrderView,
  adminsWithAccountCoverage: Array<UserView>,
  adminTypeAhead: Array<UserView>,
  allActiveDeals: Array<DealView>,
  allAdmins: Array<UserView>,
  allAsks: PaginatedView_Schema_Admin_Types_TradeIntentView,
  allBids: PaginatedView_Schema_Admin_Types_TradeIntentView,
  allBrokersProfiles: PaginatedView_Schema_Admin_Types_BrokerProfileView,
  allCapabilities: PaginatedView_Schema_Admin_Types_CapabilityView,
  allClosings: PaginatedView_Schema_Admin_Types_ClosingView,
  allColumns: Array<Column>,
  allCompanies: PaginatedView_Schema_Admin_Types_CompanyView,
  allCompanyBlocks: PaginatedView_Schema_Admin_Types_CompanyBlockView,
  allContracts: PaginatedView_Schema_Admin_Types_ContractView,
  allEntities: PaginatedView_Schema_Admin_Types_EntityView,
  allEquifunds: PaginatedView_Schema_Admin_Types_EquifundView,
  allIdentificationDocs: PaginatedView_Schema_Admin_Types_IdentificationDocumentView,
  allMatches: PaginatedView_Schema_Admin_Types_MatchView,
  allOfferings: PaginatedView_Schema_Admin_Types_Offerings_OfferingView,
  allOrders: PaginatedView_Schema_Admin_Types_OrderView,
  allPaymentImports: Array<PaymentImportView>,
  allPaymentMappings: PaginatedView_Schema_Admin_Types_PaymentMappingView,
  allSignatures: PaginatedView_Schema_Admin_Types_SignatureView,
  allStockSplits: Array<StockSplitView>,
  allTags: Array<TagView>,
  allTemplates: PaginatedView_Schema_Admin_Types_TemplateView,
  allTodos: Array<TodoItemView>,
  allTradeIntents: PaginatedView_Schema_Admin_Types_TradeIntentView,
  allUsers: PaginatedView_Schema_Admin_Types_UserView,
  allUsersByCapability: Array<UserView>,
  ask: TradeIntentView,
  asks: Array<TradeIntentView>,
  bid: TradeIntentView,
  bids: Array<TradeIntentView>,
  brokersTypeahead: Array<AccountView>,
  brokerTypeahead: Array<EntityView>,
  businessSegmentCategories: Array<BusinessSegmentCategoryView>,
  capability: CapabilityView,
  caymanFundOrders: PaginatedView_Schema_Admin_Types_OrderView,
  client_types: Array<ClientTypeView>,
  clientGift: ClientGiftView,
  clientGifts: PaginatedView_Schema_Admin_Types_ClientGiftView,
  closedOrders: PaginatedView_Schema_Admin_Types_OrderView,
  closing: ClosingView,
  closings: Array<ClosingView>,
  column: Column,
  columns: Array<Column>,
  companies: Array<CompanyView>,
  company: CompanyView,
  companyAsks: PaginatedView_Schema_Admin_Types_TradeIntentView,
  companyBids: PaginatedView_Schema_Admin_Types_TradeIntentView,
  companyBlock: CompanyBlockView,
  companyClosings: PaginatedView_Schema_Admin_Types_ClosingView,
  companyOrders: PaginatedView_Schema_Admin_Types_OrderView,
  companyTradeIntents: PaginatedView_Schema_Admin_Types_TradeIntentView,
  companyTypeahead: Array<CompanyView>,
  completedTodos: Array<TodoItemView>,
  config: Config,
  contact_role: AccountRelationshipView,
  contract: ContractView,
  contracts: Array<ContractView>,
  create_modal_data?: Maybe<CreateModalData>,
  create_opportunity_account_id?: Maybe<Scalars['String']>,
  create_opportunity_name?: Maybe<Scalars['String']>,
  currentAdmin: UserView,
  deal: DealView,
  dealsByIssuer: Array<DealView>,
  deepEntities: Array<DeepEntityView>,
  delinquentOrders: DelinquentOrdersView,
  dynamicAccountsQuery: PaginatedView_Schema_Admin_Types_Crm_Accounts_AccountView,
  dynamicQuery: PaginatedView_Schema_Admin_Types_Crm_Accounts_AccountView,
  emailExists: Scalars['Boolean'],
  emailQueue: PaginatedView_Schema_Admin_Types_EmailQueueView,
  emailQueueCount: Scalars['Int'],
  entities: Array<EntityView>,
  entitiesForReview: PaginatedView_Schema_Admin_Types_EntityView,
  entitiesWithContracts: PaginatedView_Schema_Admin_Types_EntityView,
  entity: EntityView,
  entityTypeahead: Array<EntityView>,
  equifund: EquifundView,
  equifunds: Array<EquifundView>,
  errors?: Maybe<Array<Scalars['String']>>,
  fcsCompanies: Array<CompanyInfo>,
  fcsOnboardingDetails: OnboardingDetails,
  fcsTags: Array<TagInfo>,
  fee: FeeView,
  file: FileView,
  fileSearch: Array<FileView>,
  filterAccounts: PaginatedView_Schema_Admin_Types_Crm_Accounts_AccountView,
  filteredTradeIntents: Array<TradeIntentView>,
  getAccountsByOwners: PaginatedView_Schema_Admin_Types_Crm_Accounts_AccountView,
  holding: HoldingView,
  holdingDocs: PaginatedView_Schema_Admin_Types_ProofDocView,
  identificationDoc: IdentificationDocumentView,
  is_create_modal_open?: Maybe<Scalars['Boolean']>,
  is_create_opportunity_open?: Maybe<Scalars['Boolean']>,
  issuers: Array<AccountView>,
  managedCompanies: Array<CompanyView>,
  match: MatchView,
  matches: Array<MatchView>,
  newEntities: Array<EntityView>,
  offering: OfferingView,
  offeringParticipation: OfferingParticipationView,
  opportunities: PaginatedView_Schema_Admin_Types_Crm_Opportunities_OpportunityView,
  opportunitiesTypeahead: Array<OpportunityView>,
  opportunity: OpportunityView,
  order: OrderView,
  orderBook: Array<OrderbookListingView>,
  orderBookCompanies: PaginatedView_Schema_Admin_Types_CompanyView,
  orderBookListing: OrderbookListingView,
  orderBookListings: Array<OrderbookListingView>,
  orderBookNeedsReview: Scalars['Boolean'],
  orderFromSerial: OrderView,
  orderPaymentMappings: Array<PaymentMappingView>,
  orders: Array<OrderView>,
  orderTypeahead: Array<OrderView>,
  paymentImport: PaymentImportView,
  pricedIssuers: PaginatedView_Schema_Admin_Types_Crm_Accounts_AccountView,
  priorityCompanies: Array<PriorityCompanyView>,
  proofDoc: ProofDocView,
  proofDocs: Array<ProofDocView>,
  queuedEmail: EmailQueueView,
  sectors: Array<SectorView>,
  segmentQueries: Array<SegmentQueryView>,
  segmentQuery: SegmentQueryView,
  shareholderHuntLeads: PaginatedView_Schema_Admin_Types_ShareholderHuntLeadView,
  signature: SignatureView,
  signatures: Array<SignatureView>,
  stockSplit: Array<StockSplitView>,
  tradeIntent: TradeIntentView,
  tradeIntents: Array<TradeIntentView>,
  unmappedPaymentImports: PaginatedView_Schema_Admin_Types_PaymentImportView,
  unpaidFees: Array<FeeView>,
  unpaidOrders: PaginatedView_Schema_Admin_Types_OrderView,
  user: UserView,
  users: Array<UserView>,
  userTypeahead: Array<UserView>,
};


export type QueryAccountArgs = {
  id: Scalars['UUID']
};


export type QueryAccountCreationSuggestionsArgs = {
  offset: Scalars['Int'],
  limit: Scalars['Int']
};


export type QueryAccountFromEmailArgs = {
  email: Scalars['String']
};


export type QueryAccountFromFrontContactIdArgs = {
  frontContactId: Scalars['String']
};


export type QueryAccountRelationshipsTypeaheadArgs = {
  query: Scalars['String'],
  limit: Scalars['Int'],
  accountId: Scalars['UUID']
};


export type QueryAccountSearchArgs = {
  query: Scalars['String'],
  limit: Scalars['Int']
};


export type QueryAccountsTypeaheadArgs = {
  query: Scalars['String'],
  limit: Scalars['Int'],
  filter: AccountTypeaheadFilterInput
};


export type QueryAccruedMatchesArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryActiveClosingsArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryActiveOrdersArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryAdminTypeAheadArgs = {
  query: Scalars['String'],
  limit: Scalars['Int']
};


export type QueryAllAsksArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryAllBidsArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryAllBrokersProfilesArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryAllCapabilitiesArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryAllClosingsArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryAllCompaniesArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryAllCompanyBlocksArgs = {
  blockType?: Maybe<Scalars['String']>,
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryAllContractsArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryAllEntitiesArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryAllEquifundsArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryAllIdentificationDocsArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryAllMatchesArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryAllOfferingsArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int'],
  offeringType?: Maybe<OfferingType>
};


export type QueryAllOrdersArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryAllPaymentMappingsArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryAllSignaturesArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryAllStockSplitsArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryAllTradeIntentsArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int'],
  bidOrAsk?: Maybe<TradeIntentType>
};


export type QueryAllUsersArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryAllUsersByCapabilityArgs = {
  capability: Capability
};


export type QueryAskArgs = {
  id: Scalars['UUID']
};


export type QueryAsksArgs = {
  ids: Array<Scalars['UUID']>
};


export type QueryBidArgs = {
  id: Scalars['UUID']
};


export type QueryBidsArgs = {
  ids: Array<Scalars['UUID']>
};


export type QueryBrokersTypeaheadArgs = {
  query: Scalars['String'],
  limit: Scalars['Int']
};


export type QueryBrokerTypeaheadArgs = {
  query: Scalars['String'],
  limit: Scalars['Int']
};


export type QueryCapabilityArgs = {
  id: Scalars['Int']
};


export type QueryCaymanFundOrdersArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryClient_TypesArgs = {
  accountType?: Maybe<Scalars['String']>
};


export type QueryClientGiftArgs = {
  id: Scalars['UUID']
};


export type QueryClientGiftsArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryClosedOrdersArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryClosingArgs = {
  id: Scalars['Int']
};


export type QueryClosingsArgs = {
  ids: Array<Scalars['Int']>
};


export type QueryColumnArgs = {
  token: Scalars['String']
};


export type QueryColumnsArgs = {
  tokens: Array<Scalars['String']>
};


export type QueryCompaniesArgs = {
  ids: Array<Scalars['Int']>
};


export type QueryCompanyArgs = {
  id: Scalars['Int']
};


export type QueryCompanyAsksArgs = {
  companyId: Scalars['Int'],
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryCompanyBidsArgs = {
  companyId: Scalars['Int'],
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryCompanyBlockArgs = {
  id: Scalars['Int']
};


export type QueryCompanyClosingsArgs = {
  companyId: Scalars['Int'],
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryCompanyOrdersArgs = {
  companyId: Scalars['Int'],
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryCompanyTradeIntentsArgs = {
  companyId: Scalars['Int'],
  limit: Scalars['Int'],
  offset: Scalars['Int'],
  bidOrAsk?: Maybe<TradeIntentType>
};


export type QueryCompanyTypeaheadArgs = {
  query: Scalars['String'],
  limit: Scalars['Int']
};


export type QueryContact_RoleArgs = {
  id: Scalars['UUID']
};


export type QueryContractArgs = {
  id: Scalars['Int']
};


export type QueryContractsArgs = {
  ids: Array<Scalars['Int']>
};


export type QueryDealArgs = {
  id: Scalars['Int']
};


export type QueryDealsByIssuerArgs = {
  issuerId: Scalars['UUID']
};


export type QueryDynamicAccountsQueryArgs = {
  filters: Array<Scalars['UUID']>,
  params: Scalars['Json'],
  offset: Scalars['Int'],
  limit: Scalars['Int']
};


export type QueryDynamicQueryArgs = {
  filter: Scalars['Json'],
  offset: Scalars['Int'],
  limit: Scalars['Int']
};


export type QueryEmailExistsArgs = {
  email: Scalars['String']
};


export type QueryEmailQueueArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryEntitiesArgs = {
  ids: Array<Scalars['Int']>
};


export type QueryEntitiesForReviewArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryEntitiesWithContractsArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryEntityArgs = {
  id: Scalars['Int']
};


export type QueryEntityTypeaheadArgs = {
  query: Scalars['String'],
  limit: Scalars['Int']
};


export type QueryEquifundArgs = {
  id: Scalars['Int']
};


export type QueryEquifundsArgs = {
  ids: Array<Scalars['Int']>
};


export type QueryFcsOnboardingDetailsArgs = {
  company_id: Scalars['Int']
};


export type QueryFeeArgs = {
  id: Scalars['UUID']
};


export type QueryFileArgs = {
  id: Scalars['Int']
};


export type QueryFileSearchArgs = {
  entityId?: Maybe<Scalars['Int']>,
  tags: Array<Scalars['UUID']>,
  filename?: Maybe<Scalars['String']>,
  folderId?: Maybe<Scalars['Int']>
};


export type QueryFilterAccountsArgs = {
  query: Scalars['String'],
  limit: Scalars['Int'],
  offset: Scalars['Int'],
  unroll?: Maybe<Scalars['Boolean']>
};


export type QueryFilteredTradeIntentsArgs = {
  filter: TradeIntentFilterInput
};


export type QueryGetAccountsByOwnersArgs = {
  owners: Array<Scalars['Int']>,
  offset: Scalars['Int'],
  limit: Scalars['Int']
};


export type QueryHoldingArgs = {
  id: Scalars['Int']
};


export type QueryHoldingDocsArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryIdentificationDocArgs = {
  id: Scalars['Int']
};


export type QueryMatchArgs = {
  id: Scalars['Int']
};


export type QueryMatchesArgs = {
  ids: Array<Scalars['Int']>
};


export type QueryOfferingArgs = {
  id: Scalars['UUID']
};


export type QueryOfferingParticipationArgs = {
  id: Scalars['UUID']
};


export type QueryOpportunitiesArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int'],
  filter: OpportunityFilterInput
};


export type QueryOpportunitiesTypeaheadArgs = {
  accountId: Scalars['UUID'],
  query: Scalars['String'],
  limit: Scalars['Int']
};


export type QueryOpportunityArgs = {
  id: Scalars['UUID']
};


export type QueryOrderArgs = {
  id: Scalars['Int']
};


export type QueryOrderBookCompaniesArgs = {
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>,
  filter?: Maybe<OrderBookFilterInput>,
  sort?: Maybe<SortInput>
};


export type QueryOrderBookListingArgs = {
  id: Scalars['UUID']
};


export type QueryOrderBookListingsArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int'],
  filter: OrderBookFilterParamsInput
};


export type QueryOrderFromSerialArgs = {
  serial: Scalars['String']
};


export type QueryOrderPaymentMappingsArgs = {
  id: Scalars['Int']
};


export type QueryOrdersArgs = {
  ids: Array<Scalars['Int']>
};


export type QueryOrderTypeaheadArgs = {
  query: Scalars['String'],
  limit: Scalars['Int']
};


export type QueryPaymentImportArgs = {
  id: Scalars['UUID']
};


export type QueryPricedIssuersArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int'],
  sortBy?: Maybe<IssuerSortColumn>,
  sortingDirection?: Maybe<SortDirection>
};


export type QueryPriorityCompaniesArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryProofDocArgs = {
  id: Scalars['Int']
};


export type QueryProofDocsArgs = {
  type: Scalars['String']
};


export type QueryQueuedEmailArgs = {
  id: Scalars['UUID']
};


export type QuerySegmentQueryArgs = {
  id: Scalars['UUID']
};


export type QueryShareholderHuntLeadsArgs = {
  companyId: Scalars['Int'],
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QuerySignatureArgs = {
  id: Scalars['Int']
};


export type QuerySignaturesArgs = {
  ids: Array<Scalars['Int']>
};


export type QueryStockSplitArgs = {
  id: Scalars['UUID']
};


export type QueryTradeIntentArgs = {
  id: Scalars['UUID']
};


export type QueryTradeIntentsArgs = {
  ids: Array<Scalars['UUID']>
};


export type QueryUnmappedPaymentImportsArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryUnpaidOrdersArgs = {
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueryUserArgs = {
  id: Scalars['Int']
};


export type QueryUsersArgs = {
  ids: Array<Scalars['Int']>
};


export type QueryUserTypeaheadArgs = {
  query: Scalars['String'],
  limit: Scalars['Int']
};

export type Question = {
   __typename?: 'Question',
  id: Scalars['Int'],
  question: Scalars['String'],
  answers: Array<Answer>,
  blockscore_id: Scalars['Int'],
};

export enum RelationshipType {
  WasIntroducedBy = 'was_introduced_by',
  IsSubOrgOf = 'is_sub_org_of',
  IsAffiliatedWith = 'is_affiliated_with',
  IsEmployedBy = 'is_employed_by',
  Employs = 'employs',
  Introduced = 'introduced',
  IsParentCompanyOf = 'is_parent_company_of'
}

export type RoleRead = {
   __typename?: 'RoleRead',
  id: Scalars['Int'],
  entity_id: Scalars['Int'],
  type: Scalars['String'],
  title?: Maybe<Scalars['String']>,
  permission: Scalars['String'],
  user_id: Scalars['Int'],
  signatory_auth_proof_doc_id?: Maybe<Scalars['Int']>,
  date_created: Scalars['DateTime'],
  user: UserPub,
  entity: EntityRead,
  signatory_auth_proof_doc?: Maybe<ProofDocRead>,
  signature_block: Scalars['String'],
};

export type RoleView = {
   __typename?: 'RoleView',
  id: Scalars['Int'],
  entity_id: Scalars['Int'],
  type: Scalars['String'],
  title?: Maybe<Scalars['String']>,
  permission: Scalars['String'],
  user_id: Scalars['Int'],
  signatory_auth_proof_doc_id?: Maybe<Scalars['Int']>,
  date_created: Scalars['DateTime'],
  META: Meta,
  entity: EntityView,
  user: UserView,
  signatory_proof_doc?: Maybe<ProofDocView>,
};

export type RsuGrantDetails = {
   __typename?: 'RsuGrantDetails',
  num_shares?: Maybe<Scalars['Long']>,
  vesting_duration_months?: Maybe<Scalars['Int']>,
  vesting_interval?: Maybe<Scalars['String']>,
  vesting_start_date?: Maybe<Scalars['InvariantDate']>,
  vesting_cliff_months?: Maybe<Scalars['Int']>,
  employment_start_date?: Maybe<Scalars['InvariantDate']>,
  employment_end_date?: Maybe<Scalars['InvariantDate']>,
};

export enum RsuVestingInterval {
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Yearly = 'yearly'
}

export type SafeNoteInvestmentDetails = {
   __typename?: 'SafeNoteInvestmentDetails',
  investment_date?: Maybe<Scalars['InvariantDate']>,
  investment_dollar_amount?: Maybe<Scalars['BigDecimal']>,
  valuation_cap?: Maybe<Scalars['BigDecimal']>,
  discount_percentage?: Maybe<Scalars['BigDecimal']>,
};

export type SectorView = {
   __typename?: 'SectorView',
  id: Scalars['UUID'],
  name: Scalars['String'],
};

export type SegmentQueryView = {
   __typename?: 'SegmentQueryView',
  id: Scalars['UUID'],
  query: Scalars['String'],
  name: Scalars['String'],
  created_at: Scalars['DateTime'],
  last_run_at?: Maybe<Scalars['DateTime']>,
  last_run_count?: Maybe<Scalars['Int']>,
  last_changed_by: UserView,
  last_changed_at: Scalars['DateTime'],
  created_by: UserView,
};

export enum SelfAccreditationType {
  OrganizationAccreditedInvestors = 'organization_accredited_investors',
  NetWorth = 'net_worth',
  OrganizationExperience = 'organization_experience',
  None = 'none',
  Income = 'income'
}

export type SessionHandle = {
   __typename?: 'SessionHandle',
  key: Scalars['String'],
  value: Scalars['String'],
};

export type SetIntermediaryFormInput = {
  accountId: Scalars['UUID'],
  intermediaryAccountId?: Maybe<Scalars['UUID']>,
};

export type ShareCommitmentRead = {
   __typename?: 'ShareCommitmentRead',
  company_id: Scalars['Int'],
  equifund_id: Scalars['Int'],
  securitization: Scalars['String'],
  num_shares: Scalars['BigDecimal'],
  id: Scalars['UUID'],
  company: CompanyRead,
  equifund: EquifundRead,
};

export type ShareholderDetailsFormInput = {
  id: Scalars['UUID'],
  shareholder_notes?: Maybe<Scalars['String']>,
  has_done_secondaries_before?: Maybe<Scalars['Boolean']>,
};

export type ShareholderHuntJobView = {
   __typename?: 'ShareholderHuntJobView',
  id: Scalars['UUID'],
  job_id: Scalars['String'],
  url: Scalars['String'],
  company_id: Scalars['Int'],
  type: Scalars['String'],
  status: Scalars['String'],
  total_links?: Maybe<Scalars['Int']>,
  crawled_links?: Maybe<Scalars['Int']>,
  percent_complete?: Maybe<Scalars['Int']>,
  estimated_completion?: Maybe<Scalars['String']>,
  created_at: Scalars['DateTime'],
  updated_at: Scalars['DateTime'],
};

export type ShareholderHuntLeadView = {
   __typename?: 'ShareholderHuntLeadView',
  id: Scalars['UUID'],
  member_id: Scalars['String'],
  email: Scalars['String'],
  url: Scalars['String'],
  name: Scalars['String'],
  title: Scalars['String'],
  location: Scalars['String'],
  description: Scalars['String'],
  company_name: Scalars['String'],
  working_from: Scalars['String'],
  employment_type?: Maybe<ShareholderLeadEmploymentType>,
  company_id: Scalars['Int'],
  location_city?: Maybe<Scalars['String']>,
  location_state?: Maybe<Scalars['String']>,
  location_country?: Maybe<Scalars['String']>,
  start_date_raw?: Maybe<Scalars['String']>,
  start_date?: Maybe<Scalars['InvariantDate']>,
  end_date_raw?: Maybe<Scalars['String']>,
  end_date?: Maybe<Scalars['InvariantDate']>,
  working_duration_raw?: Maybe<Scalars['String']>,
  working_months?: Maybe<Scalars['Int']>,
  has_valid_company_url?: Maybe<Scalars['Boolean']>,
  created_at: Scalars['DateTime'],
  updated_at: Scalars['DateTime'],
  META: Meta,
  company: CompanyView,
};

export enum ShareholderLeadEmploymentType {
  Past = 'past',
  Current = 'current'
}

export enum SharePriceRecordedAsType {
  Ntb = 'ntb',
  Nts = 'nts',
  Gross = 'gross'
}

export type SharePriceWithFees = {
   __typename?: 'SharePriceWithFees',
  commission: Scalars['BigDecimal'],
  min_order_size: Scalars['BigDecimal'],
  net_price: Scalars['BigDecimal'],
  id: Scalars['UUID'],
};

export type SignatureRead = {
   __typename?: 'SignatureRead',
  id: Scalars['Int'],
  name: Scalars['String'],
  role_id?: Maybe<Scalars['Int']>,
  status: Scalars['String'],
  contract_id: Scalars['Int'],
  executed_md5?: Maybe<Scalars['String']>,
  ip_address?: Maybe<Scalars['String']>,
  user_agent?: Maybe<Scalars['String']>,
  signed_at?: Maybe<Scalars['DateTime']>,
  date_created: Scalars['DateTime'],
  user?: Maybe<RoleRead>,
  contract: ContractRead,
  is_signed: Scalars['Boolean'],
};

export type SignatureView = {
   __typename?: 'SignatureView',
  id: Scalars['Int'],
  name: Scalars['String'],
  role_id?: Maybe<Scalars['Int']>,
  status: Scalars['String'],
  contract_id: Scalars['Int'],
  executed_md5?: Maybe<Scalars['String']>,
  ip_address?: Maybe<Scalars['String']>,
  user_agent?: Maybe<Scalars['String']>,
  signed_at?: Maybe<Scalars['DateTime']>,
  signatory_type?: Maybe<Scalars['String']>,
  date_created: Scalars['DateTime'],
  META: Meta,
  user?: Maybe<RoleView>,
  contract: ContractView,
  is_signed: Scalars['Boolean'],
};

export enum SortDirection {
  Descending = 'descending',
  Ascending = 'ascending'
}

export type SortInput = {
  field: Scalars['String'],
  direction: SortDirection,
};

export type Source = AccountSource | OpportunitySource;

export type SpvGpCarryDetails = {
   __typename?: 'SpvGpCarryDetails',
  holding_id?: Maybe<Scalars['Int']>,
  carry_percentage_earned?: Maybe<Scalars['BigDecimal']>,
  carry_grant_date?: Maybe<Scalars['InvariantDate']>,
  holding?: Maybe<HoldingRead>,
};

export type SpvLpInvestmentDetails = {
   __typename?: 'SpvLpInvestmentDetails',
  holding_id?: Maybe<Scalars['Int']>,
  carry_percentage_charged?: Maybe<Scalars['BigDecimal']>,
  investment_date?: Maybe<Scalars['InvariantDate']>,
  holding?: Maybe<HoldingRead>,
};

export type StockGrantDetails = {
   __typename?: 'StockGrantDetails',
  num_shares?: Maybe<Scalars['Long']>,
  share_price?: Maybe<Scalars['BigDecimal']>,
  vesting_duration_months?: Maybe<Scalars['Int']>,
  vesting_interval?: Maybe<Scalars['String']>,
  vesting_start_date?: Maybe<Scalars['InvariantDate']>,
  vesting_cliff_months?: Maybe<Scalars['Int']>,
  employment_start_date?: Maybe<Scalars['InvariantDate']>,
  employment_end_date?: Maybe<Scalars['InvariantDate']>,
};

export type StockOptionExerciseDetails = {
   __typename?: 'StockOptionExerciseDetails',
  stock_option_grant_holding_id: Scalars['Int'],
  exercise_date?: Maybe<Scalars['InvariantDate']>,
  num_shares?: Maybe<Scalars['Long']>,
};

export type StockOptionGrantDetails = {
   __typename?: 'StockOptionGrantDetails',
  id?: Maybe<Scalars['Int']>,
  num_shares?: Maybe<Scalars['Long']>,
  exercise_price?: Maybe<Scalars['BigDecimal']>,
  vesting_duration_months?: Maybe<Scalars['Int']>,
  vesting_interval?: Maybe<Scalars['String']>,
  vesting_start_date?: Maybe<Scalars['InvariantDate']>,
  vesting_cliff_months?: Maybe<Scalars['Int']>,
  employment_start_date?: Maybe<Scalars['InvariantDate']>,
  employment_end_date?: Maybe<Scalars['InvariantDate']>,
  exercises: Array<StockOptionExerciseDetails>,
};

export enum StockOptionVestingInterval {
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Yearly = 'yearly'
}

export type StockSplitPub = {
   __typename?: 'StockSplitPub',
  id: Scalars['UUID'],
  company_id: Scalars['Int'],
  split_ratio: Scalars['BigDecimal'],
  split_date: Scalars['DateTime'],
  created_at: Scalars['DateTime'],
};

export type StockSplitView = {
   __typename?: 'StockSplitView',
  id: Scalars['UUID'],
  company_id: Scalars['Int'],
  split_ratio: Scalars['BigDecimal'],
  split_date: Scalars['DateTime'],
  created_by: Scalars['Int'],
  created_at: Scalars['DateTime'],
  META: Meta,
  company: CompanyView,
  creator: UserView,
};

export enum StockVestingInterval {
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Yearly = 'yearly'
}

export type TableDefinition = {
   __typename?: 'TableDefinition',
  name: Scalars['String'],
  fields: Array<Scalars['Json']>,
};

export type TagInfo = {
   __typename?: 'TagInfo',
  id: Scalars['UUID'],
  tag: Scalars['String'],
  description?: Maybe<Scalars['String']>,
};

export type TagView = {
   __typename?: 'TagView',
  id: Scalars['UUID'],
  tag: Scalars['String'],
};

export type TemplateRead = {
   __typename?: 'TemplateRead',
  id: Scalars['Int'],
  name: Scalars['String'],
  version: Scalars['String'],
  type: Scalars['String'],
};

export type TemplateView = {
   __typename?: 'TemplateView',
  id: Scalars['Int'],
  type: Scalars['String'],
  name: Scalars['String'],
  file_id: Scalars['Int'],
  version: Scalars['String'],
  tag_id?: Maybe<Scalars['UUID']>,
  date_created: Scalars['DateTime'],
  fields: Scalars['String'],
  file: FileView,
};

export enum TodoItemStatusType {
  Completed = 'completed',
  Rescheduled = 'rescheduled',
  Upcoming = 'upcoming',
  Dismissed = 'dismissed',
  Expired = 'expired',
  Live = 'live'
}

export type TodoItemView = {
   __typename?: 'TodoItemView',
  id: Scalars['UUID'],
  meta: Scalars['Json'],
  type: Scalars['String'],
  live_at: Scalars['DateTime'],
  lifespan?: Maybe<Scalars['Duration']>,
  completed_at?: Maybe<Scalars['DateTime']>,
  priority: Scalars['Int'],
  completed_by?: Maybe<Scalars['Int']>,
  status: TodoItemStatusType,
  finished_by?: Maybe<UserView>,
  dismissed_at?: Maybe<Scalars['DateTime']>,
};

export enum TokenType {
  Account = 'account',
  Issuer = 'issuer',
  TradeIntent = 'trade_intent',
  Opportunity = 'opportunity'
}

export enum TosppStatus {
  Unsigned = 'Unsigned',
  Signed = 'Signed',
  Expired = 'Expired'
}

export type TradeIntentFilterInput = {
  types: Array<Scalars['String']>,
  entity_ids?: Maybe<Array<Scalars['Int']>>,
  company_ids?: Maybe<Array<Scalars['Int']>>,
  statuses?: Maybe<Array<TradeIntentStatusType>>,
};

export type TradeIntentRead = {
   __typename?: 'TradeIntentRead',
  id: Scalars['UUID'],
  entity_id?: Maybe<Scalars['Int']>,
  holding_id?: Maybe<Scalars['Int']>,
  status: Scalars['String'],
  share_price?: Maybe<Scalars['BigDecimal']>,
  min_dollar_amount?: Maybe<Scalars['BigDecimal']>,
  max_dollar_amount?: Maybe<Scalars['BigDecimal']>,
  min_num_shares?: Maybe<Scalars['Long']>,
  max_num_shares?: Maybe<Scalars['Long']>,
  company_id: Scalars['Int'],
  pricing_type?: Maybe<Scalars['String']>,
  asset_type?: Maybe<Scalars['String']>,
  acceptable_structures: Array<Scalars['String']>,
  valuation?: Maybe<Scalars['BigDecimal']>,
  expired_at?: Maybe<Scalars['DateTime']>,
  offering_id?: Maybe<Scalars['UUID']>,
  loi_contract_id?: Maybe<Scalars['Int']>,
  date_created: Scalars['DateTime'],
  type: TradeIntentType,
  num_shares?: Maybe<Scalars['Long']>,
  dollar_amount?: Maybe<Scalars['BigDecimal']>,
  entity?: Maybe<EntityRead>,
  company: CompanyRead,
  is_expired: Scalars['Boolean'],
  structure?: Maybe<Scalars['String']>,
  offering?: Maybe<OfferingRead>,
  letter_of_intent?: Maybe<ContractRead>,
  is_loi_signed: Scalars['Boolean'],
  holding?: Maybe<HoldingRead>,
  orders: Array<OrderRead>,
  net_share_price?: Maybe<Scalars['BigDecimal']>,
  net_dollar_amount?: Maybe<Scalars['BigDecimal']>,
  is_cancellable: Scalars['Boolean'],
};

export enum TradeIntentSizeType {
  Dollars = 'dollars',
  Shares = 'shares'
}

export enum TradeIntentStatusType {
  PrePipeline = 'pre_pipeline',
  Pipeline = 'pipeline',
  Deleted = 'deleted',
  Closed = 'closed',
  Qualified = 'qualified',
  Cancelled = 'cancelled',
  Settlement = 'settlement',
  PreClosings = 'pre_closings',
  Closings = 'closings'
}

export enum TradeIntentType {
  Bid = 'bid',
  Ask = 'ask'
}

export type TradeIntentView = {
   __typename?: 'TradeIntentView',
  id: Scalars['UUID'],
  entity_id?: Maybe<Scalars['Int']>,
  type: TradeIntentType,
  status: TradeIntentStatusType,
  min_dollar_amount?: Maybe<Scalars['BigDecimal']>,
  max_dollar_amount?: Maybe<Scalars['BigDecimal']>,
  min_num_shares?: Maybe<Scalars['Long']>,
  max_num_shares?: Maybe<Scalars['Long']>,
  share_price?: Maybe<Scalars['BigDecimal']>,
  company_id: Scalars['Int'],
  pricing_type?: Maybe<Scalars['String']>,
  valuation?: Maybe<Scalars['BigDecimal']>,
  asset_type?: Maybe<Scalars['String']>,
  is_visible: Scalars['Boolean'],
  creator_id: Scalars['Int'],
  expired_at?: Maybe<Scalars['DateTime']>,
  renewed_at?: Maybe<Scalars['DateTime']>,
  certainty?: Maybe<Scalars['String']>,
  date_created: Scalars['DateTime'],
  date_updated?: Maybe<Scalars['DateTime']>,
  admin_note?: Maybe<Scalars['String']>,
  loi_contract_id?: Maybe<Scalars['Int']>,
  acceptable_structures: Array<ListingStructureType>,
  include_in_order_book: Scalars['Boolean'],
  include_in_brightpool: Scalars['Boolean'],
  expiration_confirmed: Scalars['Boolean'],
  offering_id?: Maybe<Scalars['UUID']>,
  is_trade_restricted: Scalars['Boolean'],
  additional_diligence_notes?: Maybe<Scalars['String']>,
  has_time_constraints?: Maybe<Scalars['Boolean']>,
  time_constraint_notes?: Maybe<Scalars['String']>,
  has_flexibility?: Maybe<Scalars['Boolean']>,
  flexibility_notes?: Maybe<Scalars['String']>,
  fee?: Maybe<Scalars['BigDecimal']>,
  share_type_description?: Maybe<Scalars['String']>,
  holding_id?: Maybe<Scalars['Int']>,
  size_type?: Maybe<TradeIntentSizeType>,
  share_price_recorded_as: SharePriceRecordedAsType,
  account_id: Scalars['UUID'],
  ownable_id?: Maybe<Scalars['UUID']>,
  source: Scalars['String'],
  interaction_log_id?: Maybe<Scalars['UUID']>,
  latest_activity?: Maybe<Scalars['String']>,
  notes?: Maybe<Scalars['String']>,
  deal_blockers: Array<Scalars['String']>,
  META: Meta,
  active_deals: Array<DealView>,
  dollar_amount?: Maybe<Scalars['BigDecimal']>,
  num_shares?: Maybe<Scalars['Long']>,
  entity?: Maybe<EntityView>,
  company: CompanyView,
  order_id?: Maybe<Scalars['Int']>,
  order?: Maybe<OrderView>,
  creator: UserView,
  is_expired: Scalars['Boolean'],
  primary_contacts: Array<UserView>,
  is_admin_created: Scalars['Boolean'],
  offering?: Maybe<OfferingView>,
  is_loi_signed: Scalars['Boolean'],
  loi?: Maybe<ContractView>,
  latest_price_change?: Maybe<FieldChangeView>,
  opportunity: OpportunityView,
  account: AccountView,
  holding?: Maybe<HoldingView>,
  owners: Array<OwnerView>,
  created_by: Scalars['Int'],
  created_at: Scalars['DateTime'],
  updated_at?: Maybe<Scalars['DateTime']>,
  last_refreshed_at: Scalars['DateTime'],
  stakeholders: Array<AccountRelationshipView>,
  interactions: Array<InteractionView>,
};


export type TradeIntentViewInteractionsArgs = {
  groupFilter?: Maybe<InteractionFilter>
};

export type TradesTabDealRead = {
   __typename?: 'TradesTabDealRead',
  id: Scalars['Int'],
  status: DealStatusType,
  date_created: Scalars['DateTime'],
  status_last_updated_at: Scalars['DateTime'],
  company_id: Scalars['Int'],
  orders: Array<TradesTabOrderRead>,
  is_buy_anchor: Scalars['Boolean'],
  trades: Array<TradesTabTradeRead>,
};

export type TradesTabOrderRead = {
   __typename?: 'TradesTabOrderRead',
  holding_share_class: Scalars['String'],
  type: TradeIntentType,
  account_name: Scalars['String'],
  order: OrderRead,
  entity: EntityRead,
  trade_intent: TradeIntentRead,
};

export type TradesTabTradeRead = {
   __typename?: 'TradesTabTradeRead',
  buy_order: TradesTabOrderRead,
  sell_order: TradesTabOrderRead,
  is_buy_anchor: Scalars['Boolean'],
  trade_status: DealTradeStatus,
};

export type TradeStructureRead = {
   __typename?: 'TradeStructureRead',
  id: Scalars['UUID'],
  company_id: Scalars['Int'],
  trade_type?: Maybe<Scalars['String']>,
  structure: Scalars['String'],
  is_default: Scalars['Boolean'],
  created_at: Scalars['DateTime'],
};

export type TransactionSummaryView = {
   __typename?: 'TransactionSummaryView',
  company_id: Scalars['Int'],
  trade_asset_types: Scalars['String'],
  avg_trade_share_price: Scalars['BigDecimal'],
  avg_trade_amount: Scalars['BigDecimal'],
  total_trade_volume: Scalars['BigDecimal'],
  total_trades: Scalars['Int'],
  latest_trade_date: Scalars['DateTime'],
};

export type TrustEntityDetails = {
   __typename?: 'TrustEntityDetails',
  birth_year?: Maybe<Scalars['Int']>,
  birth_month?: Maybe<Scalars['Int']>,
  birth_day?: Maybe<Scalars['Int']>,
  gender?: Maybe<Scalars['String']>,
  marital_status?: Maybe<Scalars['String']>,
  birth_date?: Maybe<Scalars['InvariantDate']>,
};

export type UnauthorizedView = {
   __typename?: 'UnauthorizedView',
  requiredCapabilities: Array<Scalars['String']>,
};

export type UpdateInteractionInput = {
  id: Scalars['UUID'],
  notes: Scalars['String'],
  contact_method: InteractionType,
  rollup_to_id?: Maybe<Scalars['UUID']>,
  rollup_from_id: Scalars['UUID'],
  tagged_value?: Maybe<Scalars['String']>,
  tokens: Array<InteractionTokenInput>,
};

export type UpdateInvestorPreferencesFormInput = {
  investment_structure_comfort: Array<Scalars['String']>,
  target_check_size?: Maybe<Scalars['String']>,
  target_regions: Array<Scalars['String']>,
  has_cash_on_hand?: Maybe<Scalars['Boolean']>,
  minimum_company_valuation?: Maybe<Scalars['Long']>,
  minimum_company_revenue?: Maybe<Scalars['Long']>,
  minimum_growth_rate?: Maybe<Scalars['BigDecimal']>,
  company_stages: Array<Scalars['String']>,
  only_profitable_companies?: Maybe<Scalars['Boolean']>,
  opportunities_of_interest: Array<Scalars['String']>,
  sectors_interested: Array<Scalars['String']>,
  sectors_avoid: Array<Scalars['String']>,
};

export type UpdateOpportunityDetailsFormInput = {
  id: Scalars['UUID'],
  ownerIds: Array<Scalars['Int']>,
  certainty?: Maybe<Scalars['String']>,
  deal_blockers: Array<Scalars['String']>,
  trade_intent: OpportunityTradeIntentFormInput,
};

export type UpdatePublishedOfferingFormInput = {
  id: Scalars['UUID'],
  available_to: Scalars['DateTime'],
  num_available_shares?: Maybe<Scalars['Long']>,
};

export type UserFlowMutations = {
   __typename?: 'UserFlowMutations',
  id: Scalars['UUID'],
  updateStatus: Scalars['Int'],
};


export type UserFlowMutationsUpdateStatusArgs = {
  newStatus: Scalars['String']
};

export type UserFlowRead = {
   __typename?: 'UserFlowRead',
  id: Scalars['UUID'],
  flow_id: Scalars['UUID'],
  status: Scalars['String'],
  flow: FlowRead,
  flow_holdings: Array<HoldingRead>,
  mutations: UserFlowMutations,
};

export type UserInfo = {
   __typename?: 'UserInfo',
  id: Scalars['Int'],
  first_name: Scalars['String'],
  last_name: Scalars['String'],
  email: Scalars['String'],
  phone_country_code: Scalars['Int'],
  phone_number: Scalars['String'],
  title: Scalars['String'],
  permission: Scalars['String'],
  onboardingEmailSent: Scalars['Boolean'],
};

export type UserInfoInput = {
  id: Scalars['Int'],
  first_name: Scalars['String'],
  last_name: Scalars['String'],
  email: Scalars['String'],
  phone_country_code: Scalars['Int'],
  phone_number: Scalars['String'],
  title: Scalars['String'],
  permission: Scalars['String'],
  onboardingEmailSent: Scalars['Boolean'],
};

export type UserMutations = {
   __typename?: 'UserMutations',
  placeholder: Scalars['String'],
};

export type UserPreferencesRead = {
   __typename?: 'UserPreferencesRead',
  id: Scalars['UUID'],
  acceptable_structures: Array<Scalars['String']>,
  minimum_block_size?: Maybe<Scalars['BigDecimal']>,
  is_structure_agnostic: Scalars['Boolean'],
};

export type UserPub = {
   __typename?: 'UserPub',
  id: Scalars['Int'],
  first_name: Scalars['String'],
  last_name: Scalars['String'],
  email: Scalars['String'],
  profile_picture?: Maybe<Scalars['String']>,
  personal_entity_id: Scalars['Int'],
  is_ghost_user: Scalars['Boolean'],
  is_identity_verified: Scalars['Boolean'],
  identification_doc?: Maybe<IdentificationDocumentRead>,
  legal_first_name: Scalars['String'],
  legal_last_name: Scalars['String'],
};

export type UserRead = {
   __typename?: 'UserRead',
  id: Scalars['Int'],
  email: Scalars['String'],
  first_name?: Maybe<Scalars['String']>,
  last_name?: Maybe<Scalars['String']>,
  profile_picture?: Maybe<Scalars['String']>,
  email_verified: Scalars['Boolean'],
  pin?: Maybe<Scalars['String']>,
  phone_number?: Maybe<Scalars['String']>,
  phone_country_code?: Maybe<Scalars['Int']>,
  phone_verification_code?: Maybe<Scalars['String']>,
  is_phone_number_verified: Scalars['Boolean'],
  linkedin_id?: Maybe<Scalars['String']>,
  angellist_id?: Maybe<Scalars['Int']>,
  personal_entity_id: Scalars['Int'],
  authy_id?: Maybe<Scalars['Int']>,
  is_2fa_enabled: Scalars['Boolean'],
  preferences_id: Scalars['UUID'],
  mailing_address_street_1?: Maybe<Scalars['String']>,
  mailing_address_street_2?: Maybe<Scalars['String']>,
  mailing_address_city?: Maybe<Scalars['String']>,
  mailing_address_postal_code?: Maybe<Scalars['String']>,
  mailing_address_state?: Maybe<Scalars['String']>,
  mailing_address_country_code?: Maybe<Scalars['String']>,
  last_feedback_request_at?: Maybe<Scalars['DateTime']>,
  self_accreditation?: Maybe<SelfAccreditationType>,
  date_created: Scalars['DateTime'],
  personal_entity: EntityRead,
  legal_full_name: Scalars['String'],
  location_constraints: Array<Scalars['String']>,
  is_ghost_user: Scalars['Boolean'],
  two_factor_enabled: Scalars['Boolean'],
  is_accredited: Scalars['Boolean'],
  is_refresh_target: Scalars['Boolean'],
  is_self_accredited?: Maybe<Scalars['Boolean']>,
  is_identity_verified: Scalars['Boolean'],
  marketplace_disclaimer_accepted: Scalars['Boolean'],
  id_doc_status?: Maybe<Scalars['String']>,
  balance: Scalars['BigDecimal'],
  tospp_status: TosppStatus,
  capabilities: Array<Scalars['String']>,
  user_type: Array<UserType>,
  ghost_admin?: Maybe<UserPub>,
  has_offerings: Scalars['Boolean'],
  preferences: Array<UserPreferencesRead>,
  user_ab_tests: Array<AbTestVariant>,
  flows: Array<UserFlowRead>,
  flow: UserFlowRead,
  formatted_phone_number?: Maybe<Scalars['String']>,
  participating_event?: Maybe<LiquidityEventShareholderRead>,
};


export type UserReadTospp_StatusArgs = {
  type: Scalars['String']
};


export type UserReadFlowsArgs = {
  activeOnly: Scalars['Boolean']
};


export type UserReadFlowArgs = {
  id: Scalars['UUID']
};

export enum UserType {
  RetailUser = 'RetailUser',
  EquityAdmin = 'EquityAdmin',
  FcsParticipant = 'FCSParticipant',
  InstitutionalUser = 'InstitutionalUser'
}

export type UserView = {
   __typename?: 'UserView',
  id: Scalars['Int'],
  email: Scalars['String'],
  first_name?: Maybe<Scalars['String']>,
  last_name?: Maybe<Scalars['String']>,
  email_verified: Scalars['Boolean'],
  phone_country_code?: Maybe<Scalars['Int']>,
  phone_number?: Maybe<Scalars['String']>,
  is_phone_number_verified: Scalars['Boolean'],
  is_autopilot_enabled: Scalars['Boolean'],
  is_blocked: Scalars['Boolean'],
  is_disabled: Scalars['Boolean'],
  personal_entity_id: Scalars['Int'],
  profile_picture?: Maybe<Scalars['String']>,
  mailing_address_street_1?: Maybe<Scalars['String']>,
  mailing_address_street_2?: Maybe<Scalars['String']>,
  mailing_address_city?: Maybe<Scalars['String']>,
  mailing_address_postal_code?: Maybe<Scalars['String']>,
  mailing_address_state?: Maybe<Scalars['String']>,
  mailing_address_country_code?: Maybe<Scalars['String']>,
  mailing_address_confirmed_at?: Maybe<Scalars['DateTime']>,
  crm_account_id: Scalars['UUID'],
  date_created: Scalars['DateTime'],
  META: Meta,
  location_constraints: Array<Scalars['String']>,
  personal_entity: EntityView,
  name: Scalars['String'],
  legal_full_name: Scalars['String'],
  is_ghost_user: Scalars['Boolean'],
  two_factor_enabled: Scalars['Boolean'],
  is_accredited: Scalars['Boolean'],
  is_refresh_target: Scalars['Boolean'],
  is_identity_verified: Scalars['Boolean'],
  balance: Scalars['BigDecimal'],
  tospp_status: TosppStatus,
  identification_doc?: Maybe<IdentificationDocumentView>,
  roles: Array<RoleView>,
  follows: Array<FollowView>,
  auth_codes: Array<AuthCodeView>,
  linkedin_url?: Maybe<Scalars['String']>,
  role?: Maybe<Scalars['String']>,
  trigger_clearbit_enrichment: Scalars['Boolean'],
  is_brightpool_user: Scalars['Boolean'],
  crm_account: AccountView,
  formatted_phone_number?: Maybe<Scalars['String']>,
  mutations: UserMutations,
};


export type UserViewTospp_StatusArgs = {
  type: Scalars['String']
};


export enum ValuationType {
  Primary = 'primary',
  CapTable = 'cap_table',
  CustomShareCount = 'custom_share_count',
  CustomText = 'custom_text'
}

export type TradeIntentSortPriceFragment = (
  { __typename?: 'OpportunityView' }
  & Pick<OpportunityView, 'id' | 'share_price' | 'valuation' | 'pricing_type'>
  & { company: (
    { __typename?: 'CompanyView' }
    & Pick<CompanyView, 'id' | 'last_round_estimated_number_of_shares'>
  ) }
);

export type DealOpportunityRowFragment = (
  { __typename?: 'OpportunityView' }
  & Pick<OpportunityView, 'id' | 'account_id' | 'certainty' | 'company_id' | 'created_at' | 'dollar_amount' | 'entity_id' | 'fee' | 'last_refreshed_at' | 'max_dollar_amount' | 'max_num_shares' | 'min_dollar_amount' | 'min_num_shares' | 'num_shares' | 'pricing_type' | 'share_price' | 'share_price_recorded_as' | 'size_type' | 'source' | 'status' | 'type' | 'valuation'>
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
  ), company: (
    { __typename?: 'CompanyView' }
    & Pick<CompanyView, 'id' | 'last_round_estimated_number_of_shares'>
  ), owners: Array<(
    { __typename?: 'OwnerView' }
    & Pick<OwnerView, 'id' | 'owner_id' | 'first_name' | 'last_name' | 'name'>
  )>, creator: (
    { __typename?: 'UserView' }
    & Pick<UserView, 'name'>
  ) }
);

export type AddOpportunityPanel_AddMutationVariables = {
  dealId: Scalars['Int'],
  tradeIntentId: Scalars['UUID']
};


export type AddOpportunityPanel_AddMutation = (
  { __typename?: 'Mutation' }
  & { addTradeIntentToDeal: (
    { __typename?: 'DealView' }
    & Pick<DealView, 'id'>
    & DealDetailsWrapperFragment
  ) }
);

export type AddOpportunityPanel_OpportunityViewFragment = (
  { __typename?: 'OpportunityView' }
  & Pick<OpportunityView, 'id' | 'type' | 'last_refreshed_at'>
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name' | 'email'>
  ), owners: Array<(
    { __typename?: 'OwnerView' }
    & Pick<OwnerView, 'id' | 'owner_id' | 'name'>
  )> }
  & TradeIntentSortPriceFragment
  & DealOpportunityRowFragment
);

export type AddOpportunityPanel_OpportunitiesQueryVariables = {
  companyId?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>
};


export type AddOpportunityPanel_OpportunitiesQuery = (
  { __typename?: 'Query' }
  & { opportunities: (
    { __typename?: 'PaginatedView_schema_admin_types_crm_opportunities_OpportunityView' }
    & { data: Array<(
      { __typename?: 'OpportunityView' }
      & AddOpportunityPanel_OpportunityViewFragment
    )> }
  ) }
);

export type BankAccountCardBankAccountViewFragment = (
  { __typename?: 'BankAccountView' }
  & Pick<BankAccountView, 'id' | 'type' | 'bank_name' | 'routing_number' | 'account_number' | 'brokerage_name' | 'ffc_name' | 'ffc_account_number' | 'country_code'>
);

export type BankAccountCardEntityViewFragment = (
  { __typename?: 'EntityView' }
  & Pick<EntityView, 'name' | 'phone_number'>
  & { address: (
    { __typename?: 'Address' }
    & Pick<Address, 'address_street_1' | 'address_street_2' | 'address_city' | 'address_state' | 'address_postal_code' | 'address_country_code'>
  ) }
);

export type BrokerProfilesQueryVariables = {
  offset: Scalars['Int'],
  limit: Scalars['Int']
};


export type BrokerProfilesQuery = (
  { __typename?: 'Query' }
  & { allBrokersProfiles: (
    { __typename?: 'PaginatedView_schema_admin_types_BrokerProfileView' }
    & { data: Array<(
      { __typename?: 'BrokerProfileView' }
      & Pick<BrokerProfileView, 'broker_entity_id' | 'informal_name' | 'name'>
    )> }
  ) }
);

export type BrokerOfRecordDropdownMutationVariables = {
  orderId: Scalars['Int'],
  entityId: Scalars['Int']
};


export type BrokerOfRecordDropdownMutation = (
  { __typename?: 'Mutation' }
  & { setOrderBrokerOfRecord: (
    { __typename?: 'OrderView' }
    & Pick<OrderView, 'id'>
    & { broker_of_record: Maybe<(
      { __typename?: 'BrokerProfileView' }
      & Pick<BrokerProfileView, 'broker_entity_id' | 'informal_name' | 'name'>
    )> }
  ) }
);

export type RemoveTradeFromDealMutationVariables = {
  dealId: Scalars['Int'],
  orderId: Scalars['Int']
};


export type RemoveTradeFromDealMutation = (
  { __typename?: 'Mutation' }
  & { removeTradeFromDeal: (
    { __typename?: 'DealView' }
    & Pick<DealView, 'id'>
    & DealDetailsWrapperFragment
  ) }
);

export type CreateOpportunityPanelMutationVariables = {
  form: DealTradeFormInput
};


export type CreateOpportunityPanelMutation = (
  { __typename?: 'Mutation' }
  & { createDealTrade: (
    { __typename?: 'DealView' }
    & Pick<DealView, 'id'>
    & DealDetailsWrapperFragment
  ) }
);

export type DealBoardQueryVariables = {};


export type DealBoardQuery = (
  { __typename?: 'Query' }
  & { activeDeals: Array<(
    { __typename?: 'DealView' }
    & Pick<DealView, 'id' | 'probability_to_close'>
    & { trades: Array<(
      { __typename?: 'DealTradeView' }
      & Pick<DealTradeView, 'is_anchor'>
      & { order: (
        { __typename?: 'OrderView' }
        & Pick<OrderView, 'dollar_amount' | 'commission'>
      ) }
    )> }
    & DealColumnFragment
    & DealDetailsWrapperFragment
  )> }
);

export type MiniTradeListFragment = (
  { __typename?: 'DealTradeView' }
  & Pick<DealTradeView, 'is_anchor'>
  & { order: (
    { __typename?: 'OrderView' }
    & Pick<OrderView, 'id' | 'dollar_amount'>
  ), account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
  ) }
);

export type DealCardFragment = (
  { __typename?: 'DealView' }
  & Pick<DealView, 'id' | 'probability_to_close' | 'status_last_updated_at' | 'volume_bids' | 'volume_asks'>
  & { trades: Array<(
    { __typename?: 'DealTradeView' }
    & Pick<DealTradeView, 'is_anchor' | 'type' | 'trade_intent_status_matches_deal'>
    & { order: (
      { __typename?: 'OrderView' }
      & Pick<OrderView, 'id' | 'dollar_amount' | 'commission'>
    ), trade_intent: (
      { __typename?: 'TradeIntentView' }
      & Pick<TradeIntentView, 'id' | 'status'>
    ) }
    & MiniTradeListFragment
  )>, owners: Array<(
    { __typename?: 'OwnerView' }
    & Pick<OwnerView, 'name'>
    & OwnerAvatarOwnerViewFragment
  )>, issuer: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
  ) }
);

export type DealColumnContentFragment = (
  { __typename?: 'DealView' }
  & Pick<DealView, 'id'>
  & DealCardFragment
);

export type DealColumnFragment = (
  { __typename?: 'DealView' }
  & Pick<DealView, 'active_deal_status' | 'status_last_updated_at' | 'volume_bids' | 'volume_asks' | 'probability_to_close'>
  & { trades: Array<(
    { __typename?: 'DealTradeView' }
    & Pick<DealTradeView, 'is_anchor' | 'type'>
    & { order: (
      { __typename?: 'OrderView' }
      & Pick<OrderView, 'dollar_amount' | 'commission'>
    ) }
  )> }
  & DealColumnContentFragment
);

export type DealDetailsFragment = (
  { __typename?: 'DealView' }
  & Pick<DealView, 'id' | 'volume_bids' | 'volume_asks' | 'company_id' | 'probability_to_close'>
  & { issuer: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
  ), trades: Array<(
    { __typename?: 'DealTradeView' }
    & Pick<DealTradeView, 'is_anchor' | 'type'>
    & { order: (
      { __typename?: 'OrderView' }
      & Pick<OrderView, 'dollar_amount' | 'share_price' | 'commission'>
      & { owners: Array<(
        { __typename?: 'UserView' }
        & Pick<UserView, 'id'>
      )> }
    ), trade_intent: (
      { __typename?: 'TradeIntentView' }
      & Pick<TradeIntentView, 'id'>
      & { owners: Array<(
        { __typename?: 'OwnerView' }
        & { id: OwnerView['owner_id'] }
      )> }
    ) }
    & DealDetailsColumnDealTradeFragment
  )> }
);

export type DealDetailsWrapperFragment = (
  { __typename?: 'DealView' }
  & Pick<DealView, 'id' | 'volume_bids' | 'volume_asks'>
  & { issuer: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
  ), trades: Array<(
    { __typename?: 'DealTradeView' }
    & Pick<DealTradeView, 'is_anchor' | 'type'>
  )> }
  & DealSidebarFragment
  & DealDetailsFragment
  & TradeDetailsWrapperFragment
);

export type DealDetailsWrapperQueryVariables = {
  id: Scalars['Int']
};


export type DealDetailsWrapperQuery = (
  { __typename?: 'Query' }
  & { deal: (
    { __typename?: 'DealView' }
    & DealDetailsWrapperFragment
  ) }
);

export type DealDetailsColumnDealFragment = (
  { __typename?: 'DealView' }
  & Pick<DealView, 'id'>
  & TradeListDealViewFragment
);

export type DealDetailsColumnDealTradeFragment = (
  { __typename?: 'DealTradeView' }
  & Pick<DealTradeView, 'type'>
  & TradeListDealTradeViewFragment
);

export type DealDetailsColumnOwnerViewFragment = (
  { __typename?: 'OwnerView' }
  & TradeListSummaryOwnerViewFragment
);

export type DealDetailsColumnUserViewFragment = (
  { __typename?: 'UserView' }
  & TradeListSummaryUserViewFragment
);

export type DeleteDealTemplateMutationVariables = {
  dealId: Scalars['Int'],
  templateId: Scalars['Int']
};


export type DeleteDealTemplateMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteDealTemplate'>
);

export type DocumentsSidebarFragment = (
  { __typename?: 'DealView' }
  & Pick<DealView, 'id'>
  & { trades: Array<(
    { __typename?: 'DealTradeView' }
    & Pick<DealTradeView, 'type'>
  )>, templates: Array<(
    { __typename?: 'TemplateView' }
    & Pick<TemplateView, 'id' | 'name' | 'tag_id'>
    & { file: (
      { __typename?: 'FileView' }
      & Pick<FileView, 'id' | 'filename'>
    ) }
  )> }
);

export type DealDetailsSidebarFragment = (
  { __typename?: 'DealView' }
  & Pick<DealView, 'id' | 'active_deal_status' | 'status_last_updated_at' | 'date_created' | 'probability_to_close'>
  & { trades: Array<(
    { __typename?: 'DealTradeView' }
    & Pick<DealTradeView, 'type'>
  )>, owners: Array<(
    { __typename?: 'OwnerView' }
    & { id: OwnerView['owner_id'] }
    & OwnerMultiSelectFragment
  )> }
);

export type DealDetailsSidebarCancelDealMutationVariables = {
  dealId: Scalars['Int']
};


export type DealDetailsSidebarCancelDealMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'cancelDeal'>
);

export type UpdateDealProbabilityToCloseMutationVariables = {
  dealId: Scalars['Int'],
  newProbability: Scalars['BigDecimal']
};


export type UpdateDealProbabilityToCloseMutation = (
  { __typename?: 'Mutation' }
  & { updateDealProbabilityToClose: (
    { __typename?: 'DealView' }
    & Pick<DealView, 'id' | 'probability_to_close'>
  ) }
);

export type DealSidebarFragment = (
  { __typename?: 'DealView' }
  & Pick<DealView, 'id'>
  & DealDetailsSidebarFragment
  & DocumentsSidebarFragment
);

export type EntityDropdownMutationVariables = {
  orderId: Scalars['Int'],
  entityId: Scalars['Int']
};


export type EntityDropdownMutation = (
  { __typename?: 'Mutation' }
  & { setOrderEntity: (
    { __typename?: 'OrderView' }
    & Pick<OrderView, 'id'>
    & { entity: (
      { __typename?: 'EntityView' }
      & Pick<EntityView, 'id' | 'type' | 'name'>
    ) }
  ) }
);

export type OrderDetailsPanelOrderViewFragment = (
  { __typename?: 'OrderView' }
  & Pick<OrderView, 'id' | 'type' | 'status' | 'is_modifiable' | 'share_price' | 'num_shares' | 'dollar_amount' | 'commission' | 'transaction_fee'>
  & { entity: (
    { __typename?: 'EntityView' }
    & Pick<EntityView, 'id' | 'type' | 'name'>
  ), company: (
    { __typename?: 'CompanyView' }
    & Pick<CompanyView, 'id' | 'name'>
  ), owners: Array<(
    { __typename?: 'UserView' }
    & Pick<UserView, 'id'>
    & OwnerAvatarUserViewFragment
  )>, broker_of_record: Maybe<(
    { __typename?: 'BrokerProfileView' }
    & Pick<BrokerProfileView, 'broker_entity_id' | 'name' | 'informal_name'>
  )> }
);

export type OrderDetailsPanelDealViewFragment = (
  { __typename?: 'DealView' }
  & Pick<DealView, 'id' | 'probability_to_close'>
);

export type OrderDetailsPanelMoneyFieldsFragment = (
  { __typename?: 'OrderView' }
  & Pick<OrderView, 'dollar_amount' | 'share_price' | 'num_shares' | 'commission' | 'transaction_fee'>
);

export type SetOrderDollarAmountMutationVariables = {
  orderId: Scalars['Int'],
  amount: Scalars['BigDecimal']
};


export type SetOrderDollarAmountMutation = (
  { __typename?: 'Mutation' }
  & { setOrderDollarAmount: (
    { __typename?: 'OrderView' }
    & Pick<OrderView, 'id'>
    & OrderDetailsPanelMoneyFieldsFragment
  ) }
);

export type SetOrderSharePriceMutationVariables = {
  orderId: Scalars['Int'],
  price: Scalars['BigDecimal']
};


export type SetOrderSharePriceMutation = (
  { __typename?: 'Mutation' }
  & { setOrderSharePrice: (
    { __typename?: 'OrderView' }
    & Pick<OrderView, 'id'>
    & OrderDetailsPanelMoneyFieldsFragment
  ) }
);

export type SetOrderNumSharesMutationVariables = {
  orderId: Scalars['Int'],
  numShares: Scalars['Long']
};


export type SetOrderNumSharesMutation = (
  { __typename?: 'Mutation' }
  & { setOrderNumShares: (
    { __typename?: 'OrderView' }
    & Pick<OrderView, 'id'>
    & OrderDetailsPanelMoneyFieldsFragment
  ) }
);

export type SetOrderCommissionMutationVariables = {
  orderId: Scalars['Int'],
  commission: Scalars['BigDecimal']
};


export type SetOrderCommissionMutation = (
  { __typename?: 'Mutation' }
  & { setOrderCommission: (
    { __typename?: 'OrderView' }
    & Pick<OrderView, 'id'>
    & OrderDetailsPanelMoneyFieldsFragment
  ) }
);

export type OwnerAvatarOwnerViewFragment = (
  { __typename?: 'OwnerView' }
  & Pick<OwnerView, 'name' | 'first_name' | 'last_name'>
  & { id: OwnerView['owner_id'] }
);

export type OwnerAvatarUserViewFragment = (
  { __typename?: 'UserView' }
  & Pick<UserView, 'id' | 'name' | 'first_name' | 'last_name'>
);

export type OwnerChipOwnerViewFragment = (
  { __typename?: 'OwnerView' }
  & Pick<OwnerView, 'name'>
  & OwnerAvatarOwnerViewFragment
);

export type OwnerChipUserViewFragment = (
  { __typename?: 'UserView' }
  & Pick<UserView, 'name'>
  & OwnerAvatarUserViewFragment
);

export type OwnerMultiSelectFragment = (
  { __typename?: 'OwnerView' }
  & Pick<OwnerView, 'name' | 'first_name' | 'last_name'>
  & { id: OwnerView['owner_id'] }
);

export type OwnerMultiSelectMutationVariables = {
  dealId: Scalars['Int'],
  ownerIds: Array<Scalars['Int']>
};


export type OwnerMultiSelectMutation = (
  { __typename?: 'Mutation' }
  & { setDealOwners: (
    { __typename?: 'DealView' }
    & Pick<DealView, 'id'>
    & { owners: Array<(
      { __typename?: 'OwnerView' }
      & OwnerMultiSelectFragment
    )> }
  ) }
);

export type CreateDealTemplateMutationVariables = {
  from: NewTemplateInput,
  dealId: Scalars['Int'],
  orderType?: Maybe<OrderType>
};


export type CreateDealTemplateMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'createDealTemplate'>
);

export type TradeCardFragment = (
  { __typename?: 'DealTradeView' }
  & Pick<DealTradeView, 'is_anchor' | 'trade_intent_status_matches_deal'>
  & { order: (
    { __typename?: 'OrderView' }
    & Pick<OrderView, 'id' | 'status' | 'dollar_amount' | 'share_price' | 'num_shares' | 'commission' | 'transaction_fee' | 'is_modifiable'>
    & { company: (
      { __typename?: 'CompanyView' }
      & Pick<CompanyView, 'id' | 'name'>
    ), owners: Array<(
      { __typename?: 'UserView' }
      & Pick<UserView, 'id'>
      & OwnerAvatarUserViewFragment
    )>, entity: (
      { __typename?: 'EntityView' }
      & Pick<EntityView, 'id' | 'name' | 'type'>
    ) }
  ), trade_intent: (
    { __typename?: 'TradeIntentView' }
    & Pick<TradeIntentView, 'id' | 'status'>
    & { owners: Array<(
      { __typename?: 'OwnerView' }
      & OwnerAvatarOwnerViewFragment
    )> }
  ), account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
    & { owners: Array<(
      { __typename?: 'OwnerView' }
      & OwnerAvatarOwnerViewFragment
    )> }
  ) }
);

export type TradeDetailsDealViewFragment = (
  { __typename?: 'DealView' }
  & Pick<DealView, 'id'>
  & OrderDetailsPanelDealViewFragment
);

export type TradeDetailsDealTradeViewFragment = (
  { __typename?: 'DealTradeView' }
  & Pick<DealTradeView, 'is_anchor'>
  & { order: (
    { __typename?: 'OrderView' }
    & Pick<OrderView, 'id' | 'type' | 'dollar_amount'>
    & { bank_account: Maybe<(
      { __typename?: 'BankAccountView' }
      & Pick<BankAccountView, 'id'>
    )>, company: (
      { __typename?: 'CompanyView' }
      & Pick<CompanyView, 'name'>
    ), entity: (
      { __typename?: 'EntityView' }
      & Pick<EntityView, 'id'>
    ) }
    & OrderDetailsPanelOrderViewFragment
  ), trade_intent: (
    { __typename?: 'TradeIntentView' }
    & Pick<TradeIntentView, 'id'>
    & TradeIntentDetailsPanelTradeIntentViewFragment
  ), account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
    & TradeIntentDetailsPanelAccountViewFragment
  ) }
);

export type TradeDetailsBankAccountsQueryVariables = {
  id: Scalars['Int']
};


export type TradeDetailsBankAccountsQuery = (
  { __typename?: 'Query' }
  & { entity: (
    { __typename?: 'EntityView' }
    & Pick<EntityView, 'id'>
    & { protected_bank_account_collection: (
      { __typename: 'UnauthorizedView' }
      & Pick<UnauthorizedView, 'requiredCapabilities'>
    ) | (
      { __typename: 'AuthorizedBankAccountCollectionView' }
      & { value: (
        { __typename?: 'CollectionOfBankAccountView' }
        & { nodes: Array<(
          { __typename?: 'BankAccountView' }
          & Pick<BankAccountView, 'id'>
          & BankAccountCardBankAccountViewFragment
        )> }
      ) }
    ) }
    & BankAccountCardEntityViewFragment
  ) }
);

export type TradeDetailsWrapperFragment = (
  { __typename?: 'DealView' }
  & Pick<DealView, 'id'>
  & { trades: Array<(
    { __typename?: 'DealTradeView' }
    & { order: (
      { __typename?: 'OrderView' }
      & Pick<OrderView, 'id' | 'type' | 'dollar_amount'>
    ), account: (
      { __typename?: 'AccountView' }
      & Pick<AccountView, 'id' | 'name'>
    ) }
    & TradeDetailsDealTradeViewFragment
  )> }
  & TradeDetailsDealViewFragment
);

export type TradeIntentDetailsPanelTradeIntentViewFragment = (
  { __typename?: 'TradeIntentView' }
  & Pick<TradeIntentView, 'id' | 'type' | 'status' | 'size_type' | 'pricing_type' | 'fee' | 'share_price' | 'valuation' | 'min_dollar_amount' | 'max_dollar_amount' | 'min_num_shares' | 'max_num_shares' | 'share_price_recorded_as' | 'renewed_at' | 'last_refreshed_at'>
  & { company: (
    { __typename?: 'CompanyView' }
    & Pick<CompanyView, 'id' | 'name' | 'last_round_estimated_number_of_shares'>
  ), owners: Array<(
    { __typename?: 'OwnerView' }
    & { id: OwnerView['owner_id'] }
    & OwnerAvatarOwnerViewFragment
  )> }
);

export type TradeIntentDetailsPanelAccountViewFragment = (
  { __typename?: 'AccountView' }
  & Pick<AccountView, 'id' | 'name'>
);

export type TradeListDealTradeViewFragment = (
  { __typename?: 'DealTradeView' }
  & Pick<DealTradeView, 'is_anchor'>
  & { order: (
    { __typename?: 'OrderView' }
    & Pick<OrderView, 'id'>
  ) }
  & TradeCardFragment
);

export type TradeListDealViewFragment = (
  { __typename?: 'DealView' }
  & Pick<DealView, 'id' | 'probability_to_close'>
);

export type TradeListSummaryOwnerViewFragment = (
  { __typename?: 'OwnerView' }
  & OwnerChipOwnerViewFragment
);

export type TradeListSummaryUserViewFragment = (
  { __typename?: 'UserView' }
  & OwnerChipUserViewFragment
);

export type CreateDealButtonMutationVariables = {
  tradeIntentId: Scalars['UUID']
};


export type CreateDealButtonMutation = (
  { __typename?: 'Mutation' }
  & { createDealFromTradeIntent: (
    { __typename?: 'DealView' }
    & Pick<DealView, 'id'>
    & DealDetailsWrapperFragment
  ) }
);

export type AccountSuggestionsQueryVariables = {
  offset: Scalars['Int'],
  limit: Scalars['Int']
};


export type AccountSuggestionsQuery = (
  { __typename?: 'Query' }
  & { accountCreationSuggestions: (
    { __typename?: 'PaginatedView_schema_admin_types_crm_accounts_AccountSuggestionView' }
    & Pick<PaginatedView_Schema_Admin_Types_Crm_Accounts_AccountSuggestionView, 'count'>
    & { data: Array<(
      { __typename?: 'AccountSuggestionView' }
      & Pick<AccountSuggestionView, 'id' | 'created_at'>
      & { front_contact: (
        { __typename?: 'FrontContactView' }
        & Pick<FrontContactView, 'id' | 'name' | 'email'>
      ), recent_messages: Array<(
        { __typename?: 'FrontMessageGroupView' }
        & Pick<FrontMessageGroupView, 'id' | 'subject' | 'content' | 'created_at' | 'front_created_at'>
        & { message_contacts: Array<(
          { __typename?: 'FrontMessageContactView' }
          & Pick<FrontMessageContactView, 'id' | 'role' | 'email'>
        )>, front_message: (
          { __typename?: 'FrontMessageView' }
          & Pick<FrontMessageView, 'id' | 'front_msg_id'>
        ) }
      )> }
    )> }
  ) }
);

export type IgnoreSuggestionMutationVariables = {
  id: Scalars['UUID']
};


export type IgnoreSuggestionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'rejectAccountSuggestion'>
);

export type AccountsTableFragment = (
  { __typename?: 'AccountView' }
  & Pick<AccountView, 'id' | 'name' | 'is_investor' | 'is_shareholder' | 'type' | 'client_type' | 'email' | 'phone_number' | 'formatted_phone_number' | 'do_not_contact_reasons' | 'transacted_as' | 'participates_in_secondaries' | 'has_done_primaries_before' | 'net_worth' | 'aum' | 'aum_secondaries' | 'region' | 'avg_order_size' | 'last_order_created_date' | 'last_order_closed_date' | 'num_active_deals' | 'num_closed_deals' | 'num_introductions' | 'order_structures' | 'account_level' | 'business_development_tier'>
  & { derived_location: (
    { __typename?: 'DerivedLocationView' }
    & AccountLocationFragment
  ), intermediary: Maybe<(
    { __typename?: 'AccountRelationshipView' }
    & ParentOrChildRelationshipFragment
  )>, relationships: Array<(
    { __typename?: 'AccountRelationshipView' }
    & ChildRelationshipFragment
  )>, purchased_companies: Array<(
    { __typename?: 'CompanyView' }
    & Pick<CompanyView, 'id' | 'name'>
  )>, companies_of_interest: Array<(
    { __typename?: 'CompanyView' }
    & Pick<CompanyView, 'id' | 'name'>
  )>, investor_preferences: Maybe<(
    { __typename?: 'InvestorPreferencesView' }
    & Pick<InvestorPreferencesView, 'id' | 'target_check_size' | 'investment_structure_comfort' | 'sectors_interested' | 'minimum_company_valuation' | 'minimum_company_revenue' | 'minimum_growth_rate' | 'only_profitable_companies' | 'opportunities_of_interest' | 'target_regions' | 'has_cash_on_hand'>
  )>, holdings: Array<(
    { __typename?: 'HoldingView' }
    & Pick<HoldingView, 'id'>
    & { company: (
      { __typename?: 'CompanyView' }
      & Pick<CompanyView, 'id' | 'name'>
    ) }
  )>, owners: Array<(
    { __typename?: 'OwnerView' }
    & Pick<OwnerView, 'id' | 'admin_id' | 'first_name' | 'last_name' | 'ranking'>
  )> }
);

export type AccountsQueryVariables = {};


export type AccountsQuery = (
  { __typename?: 'Query' }
  & { accounts: Array<(
    { __typename?: 'AccountView' }
    & AccountsTableFragment
  )> }
);

export type GetAccountEntityOptionsQueryVariables = {
  id: Scalars['UUID']
};


export type GetAccountEntityOptionsQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
    & { entities: Array<(
      { __typename?: 'EntityView' }
      & Pick<EntityView, 'id' | 'name' | 'type'>
    )> }
  ) }
);

export type FilteredAccountsQueryVariables = {
  filters: Array<Scalars['UUID']>,
  params: Scalars['Json'],
  offset: Scalars['Int'],
  limit: Scalars['Int']
};


export type FilteredAccountsQuery = (
  { __typename?: 'Query' }
  & { dynamicAccountsQuery: (
    { __typename?: 'PaginatedView_schema_admin_types_crm_accounts_AccountView' }
    & Pick<PaginatedView_Schema_Admin_Types_Crm_Accounts_AccountView, 'count' | 'offset' | 'limit'>
    & { data: Array<(
      { __typename?: 'AccountView' }
      & AccountsTableFragment
    )> }
  ) }
);

export type DynamicallyFilteredAccountsQueryVariables = {
  filter: Scalars['Json'],
  offset: Scalars['Int'],
  limit: Scalars['Int']
};


export type DynamicallyFilteredAccountsQuery = (
  { __typename?: 'Query' }
  & { dynamicQuery: (
    { __typename?: 'PaginatedView_schema_admin_types_crm_accounts_AccountView' }
    & Pick<PaginatedView_Schema_Admin_Types_Crm_Accounts_AccountView, 'count' | 'offset' | 'limit'>
    & { data: Array<(
      { __typename?: 'AccountView' }
      & AccountsTableFragment
    )> }
  ) }
);

export type DynamicallyFilteredLeadsQueryVariables = {
  filter: Scalars['Json'],
  offset: Scalars['Int'],
  limit: Scalars['Int']
};


export type DynamicallyFilteredLeadsQuery = (
  { __typename?: 'Query' }
  & { dynamicQuery: (
    { __typename?: 'PaginatedView_schema_admin_types_crm_accounts_AccountView' }
    & Pick<PaginatedView_Schema_Admin_Types_Crm_Accounts_AccountView, 'count' | 'offset' | 'limit'>
    & { data: Array<(
      { __typename?: 'AccountView' }
      & Pick<AccountView, 'id' | 'name' | 'created_at' | 'email' | 'do_not_contact_reasons' | 'net_worth' | 'qualified' | 'leadStatus'>
      & { user: Maybe<(
        { __typename?: 'UserView' }
        & Pick<UserView, 'id' | 'email_verified'>
      )>, companies_of_interest: Array<(
        { __typename?: 'CompanyView' }
        & Pick<CompanyView, 'id' | 'name'>
      )>, investor_preferences: Maybe<(
        { __typename?: 'InvestorPreferencesView' }
        & Pick<InvestorPreferencesView, 'id' | 'target_check_size'>
      )>, entities: Array<(
        { __typename?: 'EntityView' }
        & Pick<EntityView, 'id' | 'type' | 'is_accredited' | 'is_qualified_purchaser' | 'domicile_country_code'>
        & { roles: Array<(
          { __typename?: 'RoleView' }
          & Pick<RoleView, 'id' | 'type' | 'title'>
        )> }
      )>, bid_companies: Array<(
        { __typename?: 'CompanyView' }
        & Pick<CompanyView, 'id' | 'name'>
      )>, ask_companies: Array<(
        { __typename?: 'CompanyView' }
        & Pick<CompanyView, 'id' | 'name'>
      )>, profilingAssignees: Array<Maybe<(
        { __typename?: 'UserView' }
        & Pick<UserView, 'id' | 'name'>
      )>>, last_outreach_by: Maybe<(
        { __typename?: 'UserView' }
        & Pick<UserView, 'name'>
      )> }
    )> }
  ) }
);

export type SectorsQueryVariables = {};


export type SectorsQuery = (
  { __typename?: 'Query' }
  & { sectors: Array<(
    { __typename?: 'SectorView' }
    & Pick<SectorView, 'id' | 'name'>
  )> }
);

export type AccountTagQueryVariables = {
  id: Scalars['UUID']
};


export type AccountTagQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
  ) }
);

export type AccountQueryVariables = {
  id: Scalars['UUID']
};


export type AccountQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name' | 'type' | 'is_investor' | 'is_shareholder' | 'client_type_id' | 'aum' | 'aum_secondaries' | 'net_worth' | 'state' | 'country' | 'city' | 'notes' | 'transacted_as' | 'investor_notes' | 'shareholder_notes' | 'participates_in_secondaries' | 'has_referrer' | 'referrer_id' | 'referrer_type' | 'referral_notes' | 'relationship_strength' | 'relationship_sensitivity' | 'relationship_notes' | 'partnerships_relationship_strength' | 'partnerships_relationship_sensitivity' | 'partnerships_relationship_notes' | 'partnerships_notes'>
    & { referrer: Maybe<(
      { __typename?: 'AccountView' }
      & Pick<AccountView, 'id' | 'name'>
      & { entities: Array<(
        { __typename?: 'EntityView' }
        & Pick<EntityView, 'id' | 'domicile_country_code'>
      )> }
    )>, owners: Array<(
      { __typename?: 'OwnerView' }
      & Pick<OwnerView, 'id' | 'name' | 'admin_id' | 'ranking'>
    )>, has_influence_with: Array<(
      { __typename?: 'AccountCompanyInfluenceView' }
      & Pick<AccountCompanyInfluenceView, 'id' | 'company_id' | 'company_name'>
    )>, investor_preferences: Maybe<(
      { __typename?: 'InvestorPreferencesView' }
      & Pick<InvestorPreferencesView, 'id' | 'investment_structure_comfort' | 'target_check_size' | 'target_regions' | 'has_cash_on_hand' | 'minimum_company_valuation' | 'minimum_company_revenue' | 'minimum_growth_rate' | 'only_profitable_companies' | 'opportunities_of_interest' | 'sectors_interested' | 'sectors_avoid'>
    )>, entities: Array<(
      { __typename?: 'EntityView' }
      & Pick<EntityView, 'id' | 'name' | 'type'>
    )> }
  ) }
);

export type InteractionDataFragment = (
  { __typename?: 'InteractionView' }
  & Pick<InteractionView, 'id' | 'type' | 'tagged_value' | 'notes' | 'created_at'>
  & { recorder: Maybe<(
    { __typename?: 'UserView' }
    & Pick<UserView, 'id' | 'first_name' | 'last_name'>
  )>, rollup_to_account: Maybe<(
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
  )>, rollup_from_account: Maybe<(
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
  )>, source: Maybe<(
    { __typename?: 'AccountSource' }
    & { account: (
      { __typename?: 'AccountView' }
      & Pick<AccountView, 'id' | 'name' | 'type'>
    ) }
  ) | (
    { __typename?: 'OpportunitySource' }
    & { opportunity: (
      { __typename?: 'OpportunityView' }
      & Pick<OpportunityView, 'id'>
      & { trade_intent: (
        { __typename?: 'TradeIntentView' }
        & Pick<TradeIntentView, 'id' | 'type' | 'dollar_amount'>
      ), company: (
        { __typename?: 'CompanyView' }
        & Pick<CompanyView, 'id' | 'name'>
      ) }
    ) }
  )>, front_message_group: Maybe<(
    { __typename?: 'FrontMessageGroupView' }
    & Pick<FrontMessageGroupView, 'id' | 'subject' | 'content' | 'has_attachments' | 'is_inbound' | 'front_created_at'>
    & { front_message: (
      { __typename?: 'FrontMessageView' }
      & Pick<FrontMessageView, 'id' | 'front_msg_id' | 'front_conversation_id'>
    ), message_contacts: Array<(
      { __typename?: 'FrontMessageContactView' }
      & Pick<FrontMessageContactView, 'id' | 'role' | 'email'>
      & { account: Maybe<(
        { __typename?: 'AccountView' }
        & Pick<AccountView, 'id' | 'name'>
      )> }
    )> }
  )> }
);

export type InteractionWithRollupsDataFragment = (
  { __typename?: 'InteractionView' }
  & { rolled_up_from_child_accounts: Array<(
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
  )>, rolled_up_to_parent_accounts: Array<(
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
  )> }
  & InteractionDataFragment
);

export type AccountInteractionsQueryVariables = {
  id: Scalars['UUID'],
  groupFilter?: Maybe<InteractionFilter>
};


export type AccountInteractionsQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
    & { interactions: Array<(
      { __typename?: 'InteractionView' }
      & InteractionWithRollupsDataFragment
    )> }
  ) }
);

export type RelatedAccountFragment = (
  { __typename?: 'AccountView' }
  & Pick<AccountView, 'id' | 'name' | 'first_name' | 'last_name' | 'country' | 'state' | 'city' | 'relationship_strength' | 'relationship_sensitivity' | 'relationship_notes' | 'notes'>
  & { contact_methods: Array<(
    { __typename?: 'ContactMethodView' }
    & Pick<ContactMethodView, 'id' | 'channel' | 'is_primary' | 'channel_value'>
  )>, owners: Array<(
    { __typename?: 'OwnerView' }
    & Pick<OwnerView, 'id' | 'name' | 'admin_id'>
  )>, has_influence_with: Array<(
    { __typename?: 'AccountCompanyInfluenceView' }
    & Pick<AccountCompanyInfluenceView, 'id' | 'company_id' | 'company_name'>
  )> }
);

export type AccountRelationshipDataFragment = (
  { __typename?: 'AccountRelationshipView' }
  & Pick<AccountRelationshipView, 'id' | 'child_ranking' | 'parent_account_id' | 'child_account_id' | 'is_point_of_contact' | 'title'>
  & { child_account: (
    { __typename?: 'AccountView' }
    & RelatedAccountFragment
  ), parent_account: (
    { __typename?: 'AccountView' }
    & RelatedAccountFragment
  ) }
);

export type AccountContactsQueryVariables = {
  id: Scalars['UUID']
};


export type AccountContactsQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
    & { relationships: Array<(
      { __typename?: 'AccountRelationshipView' }
      & AccountRelationshipDataFragment
    )> }
  ) }
);

export type AccountRelationshipsQueryVariables = {
  id: Scalars['UUID']
};


export type AccountRelationshipsQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'type' | 'name'>
    & { relationships: Array<(
      { __typename?: 'AccountRelationshipView' }
      & AccountRelationshipDataFragment
    )>, parents: Array<(
      { __typename?: 'AccountRelationshipView' }
      & AccountRelationshipDataFragment
    )> }
  ) }
);

export type CreateOrUpdateAccountRelationshipMutationVariables = {
  form: AccountRelationshipFormInput
};


export type CreateOrUpdateAccountRelationshipMutation = (
  { __typename?: 'Mutation' }
  & { createOrUpdateAccountRelationship: (
    { __typename?: 'AccountRelationshipView' }
    & AccountRelationshipDataFragment
  ) }
);

export type DeleteRelationshipMutationVariables = {
  relationshipId: Scalars['UUID']
};


export type DeleteRelationshipMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteAccountRelationship'>
);

export type AccountsTypeaheadQueryVariables = {
  query: Scalars['String']
};


export type AccountsTypeaheadQuery = (
  { __typename?: 'Query' }
  & { accountsTypeahead: Array<(
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'type' | 'name' | 'email' | 'client_type'>
  )> }
);

export type IssuersTypeaheadQueryVariables = {
  query: Scalars['String']
};


export type IssuersTypeaheadQuery = (
  { __typename?: 'Query' }
  & { accountsTypeahead: Array<(
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
    & { issuer_account: Maybe<(
      { __typename?: 'IssuerAccountView' }
      & Pick<IssuerAccountView, 'id'>
      & { company: (
        { __typename?: 'CompanyView' }
        & Pick<CompanyView, 'id' | 'domain'>
      ) }
    )> }
  )> }
);

export type AccountWithTypeFragment = (
  { __typename?: 'AccountView' }
  & Pick<AccountView, 'id' | 'name' | 'type' | 'email' | 'client_type'>
);

export type AccountsTypeaheadWithTypesQueryVariables = {
  query: Scalars['String']
};


export type AccountsTypeaheadWithTypesQuery = (
  { __typename?: 'Query' }
  & { accountsTypeahead: Array<(
    { __typename?: 'AccountView' }
    & AccountWithTypeFragment
  )> }
);

export type IndividualAccountsTypeaheadQueryVariables = {
  query: Scalars['String']
};


export type IndividualAccountsTypeaheadQuery = (
  { __typename?: 'Query' }
  & { accountsTypeahead: Array<(
    { __typename?: 'AccountView' }
    & RelatedAccountFragment
  )> }
);

export type CompanyTypeAheadQueryVariables = {
  query: Scalars['String']
};


export type CompanyTypeAheadQuery = (
  { __typename?: 'Query' }
  & { companyTypeahead: Array<(
    { __typename?: 'CompanyView' }
    & Pick<CompanyView, 'id' | 'name' | 'domain'>
  )> }
);

export type AdminTypeAheadQueryVariables = {
  query: Scalars['String']
};


export type AdminTypeAheadQuery = (
  { __typename?: 'Query' }
  & { adminTypeAhead: Array<(
    { __typename?: 'UserView' }
    & Pick<UserView, 'id' | 'first_name' | 'last_name' | 'name'>
  )> }
);

export type AccountNameQueryVariables = {
  id: Scalars['UUID']
};


export type AccountNameQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
  ) }
);

export type OwnerFragment = (
  { __typename?: 'OwnerView' }
  & Pick<OwnerView, 'id' | 'name' | 'first_name' | 'last_name' | 'owner_group' | 'owner_id'>
  & { user: (
    { __typename?: 'UserView' }
    & Pick<UserView, 'id' | 'profile_picture'>
  ) }
);

export type TransactionSummaryFragment = (
  { __typename?: 'TransactionSummaryView' }
  & Pick<TransactionSummaryView, 'company_id' | 'trade_asset_types' | 'avg_trade_share_price' | 'avg_trade_amount' | 'total_trade_volume' | 'total_trades' | 'latest_trade_date'>
);

export type IssuerFragment = (
  { __typename?: 'AccountView' }
  & Pick<AccountView, 'id' | 'name' | 'type' | 'client_type_id' | 'state' | 'country' | 'city' | 'notes'>
  & { issuer_account: Maybe<(
    { __typename?: 'IssuerAccountView' }
    & Pick<IssuerAccountView, 'id' | 'has_transacted' | 'is_actionable' | 'forge_on_cap_table' | 'sensitivity' | 'sensitivity_notes' | 'company_id'>
    & { company: (
      { __typename?: 'CompanyView' }
      & Pick<CompanyView, 'id' | 'name' | 'domain' | 'logo_url'>
    ) }
  )>, owners: Array<(
    { __typename?: 'OwnerView' }
    & OwnerFragment
  )> }
);

export type IssuerQueryVariables = {
  id: Scalars['UUID']
};


export type IssuerQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & IssuerFragment
  ) }
);

export type IssuerDealFragment = (
  { __typename?: 'IssuerDeal' }
  & Pick<IssuerDeal, 'id' | 'issuerId' | 'totalVolume' | 'dateClosed' | 'netRevenue' | 'totalShares' | 'averageTakeRate' | 'grossPricePerShare' | 'numParticipants'>
);

export type IssuerTradeSummaryQueryVariables = {
  id: Scalars['UUID']
};


export type IssuerTradeSummaryQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
    & { issuer_account: Maybe<(
      { __typename?: 'IssuerAccountView' }
      & Pick<IssuerAccountView, 'id'>
      & { transaction_summary: Maybe<(
        { __typename?: 'TransactionSummaryView' }
        & TransactionSummaryFragment
      )>, deals: Array<(
        { __typename?: 'IssuerDeal' }
        & IssuerDealFragment
      )> }
    )> }
  ) }
);

export type AccountLocationFragment = (
  { __typename?: 'DerivedLocationView' }
  & Pick<DerivedLocationView, 'city' | 'state' | 'countryCode' | 'source'>
);

export type AccountHeaderFragment = (
  { __typename?: 'AccountView' }
  & Pick<AccountView, 'id' | 'name' | 'type' | 'email' | 'client_type' | 'client_type_id' | 'is_investor' | 'is_shareholder' | 'has_done_primaries_before' | 'is_account_of_interest' | 'account_of_interest_reason' | 'is_forge_declined' | 'forge_declined_reason' | 'account_level' | 'last_outreach_by_anyone' | 'last_order_closed_date'>
  & { derived_location: (
    { __typename?: 'DerivedLocationView' }
    & AccountLocationFragment
  ), account_of_interest_set_by_admin: Maybe<(
    { __typename?: 'UserView' }
    & Pick<UserView, 'id' | 'name'>
  )>, forge_declined_set_by_admin: Maybe<(
    { __typename?: 'UserView' }
    & Pick<UserView, 'id' | 'name'>
  )>, last_outreach_by_anyone_admin: Maybe<(
    { __typename?: 'UserView' }
    & Pick<UserView, 'id' | 'first_name' | 'last_name'>
  )>, linkedin_job: Maybe<(
    { __typename?: 'LinkedinJobView' }
    & LinkedinJobFragment
  )>, introducedByRelationships: Array<(
    { __typename?: 'AccountRelationshipView' }
    & Pick<AccountRelationshipView, 'id'>
    & { introduction: Maybe<(
      { __typename?: 'IntroductionView' }
      & { parent_broker_account: Maybe<(
        { __typename?: 'AccountView' }
        & Pick<AccountView, 'id' | 'name'>
      )> }
    )>, parent_account: (
      { __typename?: 'AccountView' }
      & Pick<AccountView, 'id' | 'name'>
    ) }
  )> }
);

export type LinkedinJobFragment = (
  { __typename?: 'LinkedinJobView' }
  & Pick<LinkedinJobView, 'employment_name' | 'employment_title' | 'employment_domain' | 'employment_role'>
);

export type CreateAccountMutationVariables = {
  form: CreateAccountFormInput
};


export type CreateAccountMutation = (
  { __typename?: 'Mutation' }
  & { createAccount: (
    { __typename?: 'AccountView' }
    & AccountHeaderFragment
  ) }
);

export type AccountHeaderQueryVariables = {
  id: Scalars['UUID']
};


export type AccountHeaderQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & AccountHeaderFragment
  ) }
);

export type ContactMethodFragment = (
  { __typename?: 'ContactMethodView' }
  & Pick<ContactMethodView, 'id' | 'channel' | 'is_primary' | 'channel_value' | 'formatted_channel_value' | 'account_id'>
  & { email_preferences: Maybe<(
    { __typename?: 'AdminEmailPreferences' }
    & Pick<AdminEmailPreferences, 'opt_in_newsletter_emails' | 'opt_in_opportunity_emails' | 'opt_in_general_marketing_emails'>
  )> }
);

export type ClientDetailsFragment = (
  { __typename?: 'AccountView' }
  & Pick<AccountView, 'id' | 'name' | 'relationship_notes' | 'relationship_strength' | 'relationship_sensitivity' | 'notes' | 'last_outreach_at' | 'business_development_tier' | 'outreach_schedule'>
  & { owners: Array<(
    { __typename?: 'OwnerView' }
    & OwnerFragment
  )>, has_influence_with: Array<(
    { __typename?: 'AccountCompanyInfluenceView' }
    & Pick<AccountCompanyInfluenceView, 'id' | 'company_id' | 'company_name'>
  )>, deals: Array<(
    { __typename?: 'AccountDealView' }
    & AccountDealFragment
  )> }
);

export type ClientDetailsDataQueryVariables = {
  id: Scalars['UUID']
};


export type ClientDetailsDataQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & ClientDetailsFragment
  ) }
);

export type InvestorDetailsFragment = (
  { __typename?: 'AccountView' }
  & Pick<AccountView, 'id' | 'type' | 'aum' | 'aum_secondaries' | 'net_worth' | 'investor_notes'>
  & { investor_preferences: Maybe<(
    { __typename?: 'InvestorPreferencesView' }
    & Pick<InvestorPreferencesView, 'id' | 'target_regions' | 'target_check_size' | 'investment_structure_comfort' | 'sectors_interested' | 'sectors_avoid' | 'minimum_company_valuation' | 'minimum_company_revenue' | 'minimum_growth_rate' | 'only_profitable_companies' | 'has_cash_on_hand' | 'opportunities_of_interest' | 'company_stages'>
  )> }
);

export type InvestorDetailsDataQueryVariables = {
  id: Scalars['UUID']
};


export type InvestorDetailsDataQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & InvestorDetailsFragment
  ) }
);

export type ShareholderDetailsFragment = (
  { __typename?: 'AccountView' }
  & Pick<AccountView, 'id' | 'shareholder_notes' | 'participates_in_secondaries'>
);

export type ShareholderDetailsDataQueryVariables = {
  id: Scalars['UUID']
};


export type ShareholderDetailsDataQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & ShareholderDetailsFragment
  ) }
);

export type BaseAccountQueryVariables = {
  id: Scalars['UUID']
};


export type BaseAccountQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'type' | 'is_shareholder' | 'is_investor'>
    & { opportunities: Array<(
      { __typename?: 'OpportunityView' }
      & Pick<OpportunityView, 'id'>
    )> }
  ) }
);

export type AccountReferralsQueryVariables = {
  id: Scalars['UUID']
};


export type AccountReferralsQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'referrer_type' | 'referral_notes'>
    & { referrer: Maybe<(
      { __typename?: 'AccountView' }
      & Pick<AccountView, 'id' | 'name'>
    )> }
  ) }
);

export type MinimalRelationshipAccountFragment = (
  { __typename?: 'AccountView' }
  & Pick<AccountView, 'id' | 'name' | 'type' | 'email' | 'formatted_phone_number'>
  & { intermediary: Maybe<(
    { __typename?: 'AccountRelationshipView' }
    & Pick<AccountRelationshipView, 'id'>
  )>, issuer_account: Maybe<(
    { __typename?: 'IssuerAccountView' }
    & Pick<IssuerAccountView, 'id'>
    & { company: (
      { __typename?: 'CompanyView' }
      & Pick<CompanyView, 'id' | 'logo_url'>
    ) }
  )> }
);

export type ChildRelationshipFragment = (
  { __typename?: 'AccountRelationshipView' }
  & Pick<AccountRelationshipView, 'id' | 'title' | 'start_date' | 'parent_to_child_relationship' | 'is_point_of_contact'>
  & { child_account: (
    { __typename?: 'AccountView' }
    & MinimalRelationshipAccountFragment
  ) }
);

export type ParentRelationshipFragment = (
  { __typename?: 'AccountRelationshipView' }
  & Pick<AccountRelationshipView, 'id' | 'title' | 'start_date' | 'parent_to_child_relationship'>
  & { parent_account: (
    { __typename?: 'AccountView' }
    & MinimalRelationshipAccountFragment
  ) }
);

export type ParentOrChildRelationshipFragment = (
  { __typename?: 'AccountRelationshipView' }
  & Pick<AccountRelationshipView, 'id' | 'title' | 'start_date' | 'parent_to_child_relationship' | 'is_point_of_contact'>
  & { parent_account: (
    { __typename?: 'AccountView' }
    & MinimalRelationshipAccountFragment
  ), child_account: (
    { __typename?: 'AccountView' }
    & MinimalRelationshipAccountFragment
  ) }
);

export type IntroductionFragment = (
  { __typename?: 'AccountRelationshipView' }
  & { introduction: Maybe<(
    { __typename?: 'IntroductionView' }
    & { parent_broker_account: Maybe<(
      { __typename?: 'AccountView' }
      & MinimalRelationshipAccountFragment
    )>, child_broker_account: Maybe<(
      { __typename?: 'AccountView' }
      & MinimalRelationshipAccountFragment
    )> }
  )> }
);

export type MinimalAccountRelationshipsQueryVariables = {
  id: Scalars['UUID']
};


export type MinimalAccountRelationshipsQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name' | 'type'>
    & { intermediary: Maybe<(
      { __typename?: 'AccountRelationshipView' }
      & Pick<AccountRelationshipView, 'id'>
    )>, introducedRelationships: Array<(
      { __typename?: 'AccountRelationshipView' }
      & ParentOrChildRelationshipFragment
      & IntroductionFragment
    )>, introducedByRelationships: Array<(
      { __typename?: 'AccountRelationshipView' }
      & ParentOrChildRelationshipFragment
      & IntroductionFragment
    )>, relationships: Array<(
      { __typename?: 'AccountRelationshipView' }
      & ChildRelationshipFragment
    )>, parents: Array<(
      { __typename?: 'AccountRelationshipView' }
      & ParentRelationshipFragment
    )> }
  ) }
);

export type EmailExistsQueryVariables = {
  email: Scalars['String']
};


export type EmailExistsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'emailExists'>
);

export type AccountEntitiesQueryVariables = {
  id: Scalars['UUID']
};


export type AccountEntitiesQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
    & { entities: Array<(
      { __typename?: 'EntityView' }
      & Pick<EntityView, 'id' | 'type' | 'name'>
    )> }
  ) }
);

export type AccountContactPrefsFragment = (
  { __typename?: 'AccountView' }
  & Pick<AccountView, 'id' | 'name' | 'type' | 'do_not_contact_reasons'>
  & { owners: Array<(
    { __typename?: 'OwnerView' }
    & OwnerFragment
  )>, intermediary: Maybe<(
    { __typename?: 'AccountRelationshipView' }
    & ParentOrChildRelationshipFragment
    & IntroductionFragment
  )>, relationships: Array<(
    { __typename?: 'AccountRelationshipView' }
    & ChildRelationshipFragment
  )>, parents: Array<(
    { __typename?: 'AccountRelationshipView' }
    & ParentRelationshipFragment
  )> }
);

export type AccountContactPreferencesQueryVariables = {
  id: Scalars['UUID']
};


export type AccountContactPreferencesQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & AccountContactPrefsFragment
  ) }
);

export type AccountWithRelationshipsAndContactMethodsFragment = (
  { __typename?: 'AccountView' }
  & Pick<AccountView, 'id' | 'name' | 'type'>
  & { intermediary: Maybe<(
    { __typename?: 'AccountRelationshipView' }
    & ParentOrChildRelationshipFragment
    & IntroductionFragment
  )>, relationships: Array<(
    { __typename?: 'AccountRelationshipView' }
    & ChildRelationshipFragment
  )>, contact_methods: Array<(
    { __typename?: 'ContactMethodView' }
    & ContactMethodFragment
  )> }
);

export type AccountContactMethodsQueryVariables = {
  id: Scalars['UUID']
};


export type AccountContactMethodsQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & AccountWithRelationshipsAndContactMethodsFragment
  ) }
);

export type CreateOrUpdateContactMethodMutationVariables = {
  form: ContactMethodFormInput
};


export type CreateOrUpdateContactMethodMutation = (
  { __typename?: 'Mutation' }
  & { createOrUpdateContactMethod: (
    { __typename?: 'ContactMethodView' }
    & ContactMethodFragment
  ) }
);

export type DeleteContactMethodMutationVariables = {
  id: Scalars['UUID']
};


export type DeleteContactMethodMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteContactMethod'>
);

export type AccountParentsQueryVariables = {
  accountId: Scalars['UUID']
};


export type AccountParentsQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
    & { parents: Array<(
      { __typename?: 'AccountRelationshipView' }
      & Pick<AccountRelationshipView, 'id'>
      & { parent_account: (
        { __typename?: 'AccountView' }
        & Pick<AccountView, 'id' | 'name' | 'type' | 'client_type'>
      ) }
    )> }
  ) }
);

export type AccountChildrenQueryVariables = {
  accountId: Scalars['UUID']
};


export type AccountChildrenQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
    & { relationships: Array<(
      { __typename?: 'AccountRelationshipView' }
      & Pick<AccountRelationshipView, 'id' | 'parent_to_child_relationship'>
      & { child_account: (
        { __typename?: 'AccountView' }
        & Pick<AccountView, 'id' | 'name' | 'type' | 'client_type'>
      ) }
    )> }
  ) }
);

export type FileFragment = (
  { __typename?: 'FileView' }
  & Pick<FileView, 'id' | 'filename' | 'serial' | 'date_created' | 'url'>
  & { tags: Array<(
    { __typename?: 'TagView' }
    & Pick<TagView, 'id' | 'tag'>
  )> }
);

export type GetDocumentsByAccountQueryVariables = {
  accountId: Scalars['UUID']
};


export type GetDocumentsByAccountQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
    & { files: Array<(
      { __typename?: 'FileView' }
      & FileFragment
    )>, parents: Array<(
      { __typename?: 'AccountRelationshipView' }
      & Pick<AccountRelationshipView, 'id'>
      & { parent_account: (
        { __typename?: 'AccountView' }
        & Pick<AccountView, 'id' | 'name'>
        & { files: Array<(
          { __typename?: 'FileView' }
          & FileFragment
        )> }
      ) }
    )>, introducer_accounts: Array<(
      { __typename?: 'AccountView' }
      & Pick<AccountView, 'id' | 'name'>
      & { files: Array<(
        { __typename?: 'FileView' }
        & FileFragment
      )> }
    )> }
  ) }
);

export type AssociateFileWithAccountMutationVariables = {
  accountId: Scalars['UUID'],
  fileSerial: Scalars['String'],
  tags: Array<Scalars['UUID']>
};


export type AssociateFileWithAccountMutation = (
  { __typename?: 'Mutation' }
  & { uploadAccountFile: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
    & { files: Array<(
      { __typename?: 'FileView' }
      & FileFragment
    )> }
  ) }
);

export type GetAllDocumentTagsQueryVariables = {};


export type GetAllDocumentTagsQuery = (
  { __typename?: 'Query' }
  & { allTags: Array<(
    { __typename?: 'TagView' }
    & Pick<TagView, 'id' | 'tag'>
  )> }
);

export type DeleteFileMutationVariables = {
  fileId: Scalars['Int']
};


export type DeleteFileMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteFile'>
);

export type AccountCardFragment = (
  { __typename?: 'AccountView' }
  & Pick<AccountView, 'id' | 'name' | 'account_level' | 'is_account_of_interest' | 'last_outreach_by_anyone' | 'outreach_schedule'>
  & { owners: Array<(
    { __typename?: 'OwnerView' }
    & Pick<OwnerView, 'id' | 'name'>
  )>, opportunities: Array<(
    { __typename?: 'OpportunityView' }
    & Pick<OpportunityView, 'id'>
  )>, interactions: Array<(
    { __typename?: 'InteractionView' }
    & Pick<InteractionView, 'id'>
  )> }
);

export type GetPaginatedAccountsByOwnersQueryVariables = {
  owners: Array<Scalars['Int']>,
  offset: Scalars['Int'],
  limit: Scalars['Int']
};


export type GetPaginatedAccountsByOwnersQuery = (
  { __typename?: 'Query' }
  & { getAccountsByOwners: (
    { __typename?: 'PaginatedView_schema_admin_types_crm_accounts_AccountView' }
    & Pick<PaginatedView_Schema_Admin_Types_Crm_Accounts_AccountView, 'count' | 'offset' | 'limit'>
    & { data: Array<(
      { __typename?: 'AccountView' }
      & AccountCardFragment
    )> }
  ) }
);

export type IssuerTradeHistoryQueryVariables = {
  accountId: Scalars['UUID']
};


export type IssuerTradeHistoryQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
    & { issuer_account: Maybe<(
      { __typename?: 'IssuerAccountView' }
      & Pick<IssuerAccountView, 'id'>
      & { deals: Array<(
        { __typename?: 'IssuerDeal' }
        & Pick<IssuerDeal, 'id' | 'issuerId' | 'totalVolume' | 'dateClosed' | 'netRevenue' | 'totalShares' | 'averageTakeRate' | 'grossPricePerShare' | 'numParticipants'>
      )> }
    )> }
  ) }
);

export type BaseIssuerAccountQueryVariables = {
  issuerId: Scalars['UUID']
};


export type BaseIssuerAccountQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
    & { issuer_account: Maybe<(
      { __typename?: 'IssuerAccountView' }
      & Pick<IssuerAccountView, 'id'>
      & { company: (
        { __typename?: 'CompanyView' }
        & Pick<CompanyView, 'id' | 'name'>
      ) }
    )> }
  ) }
);

export type IssuerLastRoundQueryVariables = {
  issuerId: Scalars['UUID']
};


export type IssuerLastRoundQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
    & { issuer_account: Maybe<(
      { __typename?: 'IssuerAccountView' }
      & Pick<IssuerAccountView, 'id'>
      & { company: (
        { __typename?: 'CompanyView' }
        & Pick<CompanyView, 'id'>
        & { last_round: Maybe<(
          { __typename?: 'FundingRound' }
          & FundingRoundFragment
        )> }
      ) }
    )> }
  ) }
);

export type IssuerLinksQueryVariables = {
  issuerId: Scalars['UUID']
};


export type IssuerLinksQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
    & { issuer_account: Maybe<(
      { __typename?: 'IssuerAccountView' }
      & Pick<IssuerAccountView, 'id'>
      & { company: (
        { __typename?: 'CompanyView' }
        & Pick<CompanyView, 'id' | 'token' | 'crunchbase_handle'>
      ) }
    )> }
  ) }
);

export type IssuerPlatformSettingsFragment = (
  { __typename?: 'CompanyView' }
  & Pick<CompanyView, 'id' | 'featured' | 'is_available' | 'show_pricing_data' | 'default_share_price_investor' | 'default_share_price_shareholder' | 'weight' | 'min_transaction_size_investor' | 'share_price_variance'>
);

export type IssuerPlatformSettingsQueryVariables = {
  issuerId: Scalars['UUID']
};


export type IssuerPlatformSettingsQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
    & { issuer_account: Maybe<(
      { __typename?: 'IssuerAccountView' }
      & Pick<IssuerAccountView, 'id'>
      & { company: (
        { __typename?: 'CompanyView' }
        & IssuerPlatformSettingsFragment
      ) }
    )> }
  ) }
);

export type UpdateIssuerPlatformSettingsMutationVariables = {
  companyPlatformSettings: CompanyPlatformSettingsInput
};


export type UpdateIssuerPlatformSettingsMutation = (
  { __typename?: 'Mutation' }
  & { updateCompanyPlatformSettings: (
    { __typename?: 'CompanyView' }
    & IssuerPlatformSettingsFragment
  ) }
);

export type UpdateIssuerMarketplaceSettingsMutationVariables = {
  form: IssuerMarketplaceSettingsFormInput
};


export type UpdateIssuerMarketplaceSettingsMutation = (
  { __typename?: 'Mutation' }
  & { updateIssuerMarketplaceSettings: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
    & { issuer_account: Maybe<(
      { __typename?: 'IssuerAccountView' }
      & Pick<IssuerAccountView, 'id'>
      & { company: (
        { __typename?: 'CompanyView' }
        & IssuerPlatformSettingsFragment
      ) }
    )> }
  ) }
);

export type IssuerOwnersFragment = (
  { __typename?: 'AccountView' }
  & Pick<AccountView, 'id' | 'relationship_notes' | 'relationship_strength' | 'relationship_sensitivity' | 'marketplace_notes' | 'partnerships_relationship_strength' | 'partnerships_relationship_sensitivity' | 'partnerships_relationship_notes' | 'partnerships_notes'>
  & { owners: Array<(
    { __typename?: 'OwnerView' }
    & OwnerFragment
  )> }
);

export type IssuerOwnersQueryVariables = {
  issuerId: Scalars['UUID']
};


export type IssuerOwnersQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & IssuerOwnersFragment
  ) }
);

export type UpdateIssuerMarketplaceCoverageMutationVariables = {
  form: IssuerMarketplaceCoverageFormInput
};


export type UpdateIssuerMarketplaceCoverageMutation = (
  { __typename?: 'Mutation' }
  & { updateIssuerMarketplaceCoverage: (
    { __typename?: 'AccountView' }
    & IssuerOwnersFragment
  ) }
);

export type UpdateIssuerPartnershipsCoverageMutationVariables = {
  form: IssuerPartnershipsCoverageFormInput
};


export type UpdateIssuerPartnershipsCoverageMutation = (
  { __typename?: 'Mutation' }
  & { updateIssuerPartnershipsCoverage: (
    { __typename?: 'AccountView' }
    & IssuerOwnersFragment
  ) }
);

export type GetPricedIssuersQueryVariables = {
  limit: Scalars['Int'],
  offset: Scalars['Int'],
  sortBy?: Maybe<IssuerSortColumn>,
  sortingDirection?: Maybe<SortDirection>
};


export type GetPricedIssuersQuery = (
  { __typename?: 'Query' }
  & { pricedIssuers: (
    { __typename?: 'PaginatedView_schema_admin_types_crm_accounts_AccountView' }
    & Pick<PaginatedView_Schema_Admin_Types_Crm_Accounts_AccountView, 'count' | 'limit' | 'offset'>
    & { data: Array<(
      { __typename?: 'AccountView' }
      & PricedIssuerFragment
    )> }
  ) }
);

export type PricedIssuerFragment = (
  { __typename?: 'AccountView' }
  & Pick<AccountView, 'id' | 'name'>
  & { owners: Array<(
    { __typename?: 'OwnerView' }
    & Pick<OwnerView, 'id' | 'name' | 'owner_id'>
  )>, issuer_account: Maybe<(
    { __typename?: 'IssuerAccountView' }
    & Pick<IssuerAccountView, 'id'>
    & { company: (
      { __typename?: 'CompanyView' }
      & Pick<CompanyView, 'id' | 'logo_url' | 'featured' | 'weight' | 'min_transaction_size_investor' | 'default_share_price_investor' | 'default_share_price_shareholder' | 'show_pricing_data' | 'share_price_variance' | 'is_available'>
    ) }
  )> }
);

export type IssuerHeaderFragment = (
  { __typename?: 'AccountView' }
  & Pick<AccountView, 'id' | 'name' | 'country' | 'state' | 'city' | 'notes'>
  & { issuer_account: Maybe<(
    { __typename?: 'IssuerAccountView' }
    & Pick<IssuerAccountView, 'id' | 'is_actionable'>
    & { company: (
      { __typename?: 'CompanyView' }
      & Pick<CompanyView, 'id' | 'logo_url'>
      & { last_round: Maybe<(
        { __typename?: 'FundingRound' }
        & Pick<FundingRound, 'id' | 'round_date' | 'valuation'>
      )> }
    ) }
  )> }
);

export type IssuerHeaderQueryVariables = {
  issuerId: Scalars['UUID']
};


export type IssuerHeaderQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & IssuerHeaderFragment
  ) }
);

export type UpdateIssuerHeaderMutationVariables = {
  form: IssuerHeaderFormInput
};


export type UpdateIssuerHeaderMutation = (
  { __typename?: 'Mutation' }
  & { updateIssuerHeader: (
    { __typename?: 'AccountView' }
    & IssuerHeaderFragment
  ) }
);

export type CompanyNameQueryVariables = {
  companyId: Scalars['Int']
};


export type CompanyNameQuery = (
  { __typename?: 'Query' }
  & { company: (
    { __typename?: 'CompanyView' }
    & Pick<CompanyView, 'id' | 'name'>
  ) }
);

export type OrderBookBlockFragment = (
  { __typename?: 'OrderBookBlockRead' }
  & Pick<OrderBookBlockRead, 'volume' | 'price_bucket_low' | 'price_bucket_high'>
);

export type IssuerGraphQueryVariables = {
  issuerId: Scalars['UUID']
};


export type IssuerGraphQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
    & { issuer_account: Maybe<(
      { __typename?: 'IssuerAccountView' }
      & Pick<IssuerAccountView, 'id'>
      & { company: (
        { __typename?: 'CompanyView' }
        & Pick<CompanyView, 'id'>
        & { order_book_bid_blocks: Array<(
          { __typename?: 'OrderBookBlockRead' }
          & OrderBookBlockFragment
        )>, order_book_ask_blocks: Array<(
          { __typename?: 'OrderBookBlockRead' }
          & OrderBookBlockFragment
        )> }
      ) }
    )> }
  ) }
);

export type OrderBookCompanyFragment = (
  { __typename?: 'CompanyView' }
  & Pick<CompanyView, 'id' | 'name' | 'logo_url'>
  & { last_round: Maybe<(
    { __typename?: 'FundingRound' }
    & Pick<FundingRound, 'id' | 'valuation' | 'round_date'>
  )>, bid_ask_summary: (
    { __typename?: 'BidAskSummaryView' }
    & Pick<BidAskSummaryView, 'bid_volume' | 'bid_structures' | 'bid_actionable' | 'ask_volume' | 'ask_structures' | 'ask_actionable'>
  ) }
);

export type OrderBookQueryVariables = {
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>,
  filter?: Maybe<OrderBookFilterInput>,
  sort?: Maybe<SortInput>
};


export type OrderBookQuery = (
  { __typename?: 'Query' }
  & { orderBookCompanies: (
    { __typename?: 'PaginatedView_schema_admin_types_CompanyView' }
    & Pick<PaginatedView_Schema_Admin_Types_CompanyView, 'count' | 'offset' | 'limit'>
    & { data: Array<(
      { __typename?: 'CompanyView' }
      & OrderBookCompanyFragment
    )> }
  ) }
);

export type OrderBookOpportunityFragment = (
  { __typename?: 'OpportunityView' }
  & Pick<OpportunityView, 'id' | 'status' | 'type'>
  & { trade_intent: (
    { __typename?: 'TradeIntentView' }
    & Pick<TradeIntentView, 'dollar_amount' | 'share_price' | 'acceptable_structures' | 'date_created' | 'date_updated'>
  ), account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name' | 'email'>
  ), owners: Array<(
    { __typename?: 'OwnerView' }
    & Pick<OwnerView, 'id' | 'name'>
    & { user: (
      { __typename?: 'UserView' }
      & Pick<UserView, 'id' | 'profile_picture'>
    ) }
  )> }
);

export type OrderBookBidAskDetailQueryVariables = {
  limit: Scalars['Int'],
  offset: Scalars['Int'],
  companyId: Scalars['Int'],
  filter: OpportunityFilterInput
};


export type OrderBookBidAskDetailQuery = (
  { __typename?: 'Query' }
  & { company: (
    { __typename?: 'CompanyView' }
    & Pick<CompanyView, 'id' | 'name' | 'logo_url'>
  ), opportunities: (
    { __typename?: 'PaginatedView_schema_admin_types_crm_opportunities_OpportunityView' }
    & Pick<PaginatedView_Schema_Admin_Types_Crm_Opportunities_OpportunityView, 'count' | 'offset' | 'limit'>
    & { data: Array<(
      { __typename?: 'OpportunityView' }
      & OrderBookOpportunityFragment
    )> }
  ) }
);

export type LastOrderInfoFragment = (
  { __typename?: 'OrderView' }
  & Pick<OrderView, 'id' | 'share_price' | 'date_fully_accrued' | 'dollar_amount'>
);

export type OrderBookCompanyDetailsFragment = (
  { __typename?: 'CompanyView' }
  & Pick<CompanyView, 'id' | 'active_asks_count' | 'active_bids_count' | 'total_bid_volume' | 'total_ask_volume'>
  & { order_book_bid_blocks: Array<(
    { __typename?: 'OrderBookBlockRead' }
    & OrderBookBlockFragment
  )>, order_book_ask_blocks: Array<(
    { __typename?: 'OrderBookBlockRead' }
    & OrderBookBlockFragment
  )>, last_buy_order: Maybe<(
    { __typename?: 'OrderView' }
    & LastOrderInfoFragment
  )>, crm_account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
  ) }
);

export type OrderBookDetailsQueryVariables = {
  companyId: Scalars['Int'],
  qualifiedOnly: Scalars['Boolean'],
  structures?: Maybe<Array<ListingStructureType>>
};


export type OrderBookDetailsQuery = (
  { __typename?: 'Query' }
  & { company: (
    { __typename?: 'CompanyView' }
    & OrderBookCompanyDetailsFragment
  ) }
);

export type QueriedAccountsQueryVariables = {
  query: Scalars['String'],
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type QueriedAccountsQuery = (
  { __typename?: 'Query' }
  & { filterAccounts: (
    { __typename?: 'PaginatedView_schema_admin_types_crm_accounts_AccountView' }
    & Pick<PaginatedView_Schema_Admin_Types_Crm_Accounts_AccountView, 'count' | 'limit' | 'offset'>
    & { data: Array<(
      { __typename?: 'AccountView' }
      & Pick<AccountView, 'id' | 'email' | 'name' | 'type' | 'last_order_closed_date'>
      & { parents: Array<(
        { __typename?: 'AccountRelationshipView' }
        & Pick<AccountRelationshipView, 'id' | 'parent_to_child_relationship' | 'is_point_of_contact'>
        & { parent_account: (
          { __typename?: 'AccountView' }
          & Pick<AccountView, 'id' | 'type' | 'name'>
          & { intermediary: Maybe<(
            { __typename?: 'AccountRelationshipView' }
            & Pick<AccountRelationshipView, 'id'>
          )> }
        ) }
      )> }
    )> }
  ) }
);

export type FilterAccountsCountOnlyQueryVariables = {
  query: Scalars['String']
};


export type FilterAccountsCountOnlyQuery = (
  { __typename?: 'Query' }
  & { filterAccounts: (
    { __typename?: 'PaginatedView_schema_admin_types_crm_accounts_AccountView' }
    & Pick<PaginatedView_Schema_Admin_Types_Crm_Accounts_AccountView, 'count'>
  ) }
);

export type TransactionHistoryQueryVariables = {
  accountId: Scalars['UUID']
};


export type TransactionHistoryQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
    & { deals: Array<(
      { __typename?: 'AccountDealView' }
      & Pick<AccountDealView, 'totalBuySideVolume' | 'totalSellSideVolume' | 'totalBuySideRevenue' | 'totalSellSideRevenue' | 'orderType' | 'dateFullyAccrued' | 'avgSharePrice' | 'orderCount' | 'totalNumShares'>
      & { company: (
        { __typename?: 'CompanyView' }
        & Pick<CompanyView, 'id' | 'name' | 'logo_url'>
      ) }
    )> }
  ) }
);

export type UpdateAccountMutationVariables = {
  form: AccountDetailsFormInput
};


export type UpdateAccountMutation = (
  { __typename?: 'Mutation' }
  & { updateAccount: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name' | 'type' | 'is_investor' | 'is_shareholder' | 'client_type_id' | 'aum' | 'aum_secondaries' | 'net_worth' | 'state' | 'country' | 'city' | 'notes' | 'investor_notes' | 'shareholder_notes' | 'participates_in_secondaries'>
    & { investor_preferences: Maybe<(
      { __typename?: 'InvestorPreferencesView' }
      & Pick<InvestorPreferencesView, 'id' | 'investment_structure_comfort' | 'target_check_size' | 'target_regions' | 'has_cash_on_hand' | 'minimum_company_valuation' | 'minimum_company_revenue' | 'minimum_growth_rate' | 'only_profitable_companies' | 'opportunities_of_interest' | 'sectors_interested' | 'sectors_avoid'>
    )> }
  ) }
);

export type UpdateAccountRelationshipMutationVariables = {
  form: AccountRelationshipFormInput
};


export type UpdateAccountRelationshipMutation = (
  { __typename?: 'Mutation' }
  & { createOrUpdateAccountRelationship: (
    { __typename?: 'AccountRelationshipView' }
    & AccountRelationshipDataFragment
  ) }
);

export type CreateSectorMutationVariables = {
  name: Scalars['String']
};


export type CreateSectorMutation = (
  { __typename?: 'Mutation' }
  & { createSector: (
    { __typename?: 'SectorView' }
    & Pick<SectorView, 'id' | 'name'>
  ) }
);

export type UpdateAccountHeaderMutationVariables = {
  form: AccountHeaderFormInput
};


export type UpdateAccountHeaderMutation = (
  { __typename?: 'Mutation' }
  & { updateAccountHeader: (
    { __typename?: 'AccountView' }
    & AccountHeaderFragment
  ) }
);

export type UpdateClientDetailsMutationVariables = {
  form: ClientDetailsFormInput
};


export type UpdateClientDetailsMutation = (
  { __typename?: 'Mutation' }
  & { updateClientDetails: (
    { __typename?: 'AccountView' }
    & ClientDetailsFragment
  ) }
);

export type UpdateInvestorDetailsMutationVariables = {
  form: InvestorDetailsFormInput
};


export type UpdateInvestorDetailsMutation = (
  { __typename?: 'Mutation' }
  & { updateInvestorDetails: (
    { __typename?: 'AccountView' }
    & InvestorDetailsFragment
  ) }
);

export type UpdateShareholderDetailsMutationVariables = {
  form: ShareholderDetailsFormInput
};


export type UpdateShareholderDetailsMutation = (
  { __typename?: 'Mutation' }
  & { updateShareholderDetails: (
    { __typename?: 'AccountView' }
    & ShareholderDetailsFragment
  ) }
);

export type SetIntermediaryMutationVariables = {
  form: SetIntermediaryFormInput
};


export type SetIntermediaryMutation = (
  { __typename?: 'Mutation' }
  & { setIntermediaryAccount: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
    & { intermediary: Maybe<(
      { __typename?: 'AccountRelationshipView' }
      & ParentOrChildRelationshipFragment
    )> }
  ) }
);

export type SetPocMutationVariables = {
  relationshipId: Scalars['UUID'],
  isPointOfContact: Scalars['Boolean']
};


export type SetPocMutation = (
  { __typename?: 'Mutation' }
  & { setPointOfContact: (
    { __typename?: 'AccountRelationshipView' }
    & Pick<AccountRelationshipView, 'id' | 'is_point_of_contact'>
  ) }
);

export type CurrentAdminFragment = (
  { __typename?: 'UserView' }
  & Pick<UserView, 'id' | 'email' | 'first_name' | 'last_name' | 'name' | 'profile_picture'>
);

export type AppDataQueryVariables = {};


export type AppDataQuery = (
  { __typename?: 'Query' }
  & { currentAdmin: (
    { __typename?: 'UserView' }
    & CurrentAdminFragment
  ) }
);

export type CreateModalStateQueryVariables = {};


export type CreateModalStateQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'is_create_modal_open'>
  & { create_modal_data: Maybe<(
    { __typename?: 'CreateModalData' }
    & Pick<CreateModalData, 'type' | 'accountId' | 'accountName' | 'companyId' | 'companyName'>
  )> }
);

export type OpenCreateModalMutationVariables = {
  data: CreateModalDataInput
};


export type OpenCreateModalMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'openCreateModal'>
);

export type CloseCreateModalMutationVariables = {
  id?: Maybe<Scalars['String']>
};


export type CloseCreateModalMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'closeCreateModal'>
);

export type AccountResultFragment = (
  { __typename?: 'AccountView' }
  & Pick<AccountView, 'id' | 'type' | 'name' | 'first_name' | 'last_name' | 'client_type'>
  & { contact_methods: Array<(
    { __typename?: 'ContactMethodView' }
    & Pick<ContactMethodView, 'id' | 'channel' | 'is_primary' | 'channel_value'>
  )>, issuer_account: Maybe<(
    { __typename?: 'IssuerAccountView' }
    & Pick<IssuerAccountView, 'id'>
    & { company: (
      { __typename?: 'CompanyView' }
      & Pick<CompanyView, 'id' | 'name' | 'domain' | 'legal_name' | 'logo_url'>
    ) }
  )>, parents: Array<(
    { __typename?: 'AccountRelationshipView' }
    & Pick<AccountRelationshipView, 'id'>
    & { parent_account: (
      { __typename?: 'AccountView' }
      & Pick<AccountView, 'id' | 'name'>
    ) }
  )> }
);

export type OmnisearchQueryVariables = {
  query: Scalars['String'],
  limit: Scalars['Int']
};


export type OmnisearchQuery = (
  { __typename?: 'Query' }
  & { accountSearch: (
    { __typename?: 'AccountSearchView' }
    & { individual_accounts: Array<(
      { __typename?: 'AccountView' }
      & AccountResultFragment
    )>, organization_accounts: Array<(
      { __typename?: 'AccountView' }
      & AccountResultFragment
    )>, issuer_accounts: Array<(
      { __typename?: 'AccountView' }
      & AccountResultFragment
    )> }
  ) }
);

export type OfferingFileFragment = (
  { __typename?: 'FileView' }
  & Pick<FileView, 'id' | 'url' | 'serial' | 'filename' | 'date_created'>
  & { tags: Array<(
    { __typename?: 'TagView' }
    & Pick<TagView, 'id' | 'tag'>
  )> }
);

export type GenericOfferingFragment = (
  { __typename?: 'OfferingView' }
  & Pick<OfferingView, 'id' | 'name' | 'offering_type' | 'num_available_shares' | 'min_shares_to_close' | 'starting_share_price' | 'dollar_amount_at_starting_price_gross' | 'dollar_amount_paid' | 'dollar_amount_fees_paid' | 'is_block_fully_committed' | 'total_listing_volume_gross' | 'available_from' | 'available_to' | 'status' | 'min_direct_size' | 'num_participants' | 'possible_structures' | 'dollar_amount_allocated_gross' | 'token'>
  & { company: (
    { __typename?: 'CompanyView' }
    & Pick<CompanyView, 'id' | 'name' | 'logo_url'>
  ) }
);

export type SpecificOfferingFragment = (
  { __typename?: 'OfferingView' }
  & Pick<OfferingView, 'id' | 'name' | 'offering_type' | 'num_available_shares' | 'num_shares_remaining' | 'min_shares_to_close' | 'starting_share_price' | 'est_num_company_shares' | 'block_type' | 'equifund_id' | 'dollar_amount_at_starting_price_gross' | 'dollar_amount_paid' | 'dollar_amount_fees_paid' | 'is_block_fully_committed' | 'total_listing_volume_gross' | 'available_from' | 'available_to' | 'status' | 'commission' | 'company_description' | 'min_listing_size' | 'min_direct_size' | 'possible_structures' | 'num_participants' | 'num_invites_sent' | 'num_invites_clicked' | 'num_invites_opened' | 'num_ndas_signed' | 'num_bids_placed' | 'num_orders_signed' | 'num_payments_received' | 'dollar_amount_allocated_gross' | 'token' | 'auto_reminder_email_at' | 'auto_order_reminder_email_at' | 'auto_feedback_email_at' | 'previous_invitation_email_at' | 'previous_reminder_email_at' | 'previous_order_reminder_email_at' | 'previous_feedback_email_at' | 'valuation_type' | 'custom_disclaimer_updated_at' | 'custom_valuation_disclaimer' | 'custom_closing_timeline' | 'custom_contact_message' | 'custom_consideration' | 'custom_transaction_timeline' | 'custom_transaction_structure' | 'custom_fund_structure' | 'custom_offering_process' | 'custom_offering_process_details'>
  & { company: (
    { __typename?: 'CompanyView' }
    & Pick<CompanyView, 'id' | 'name' | 'logo_url'>
    & { last_round: Maybe<(
      { __typename?: 'FundingRound' }
      & Pick<FundingRound, 'id' | 'round_date' | 'stage' | 'valuation' | 'est_num_shares' | 'price_per_share'>
    )> }
  ), files: Array<(
    { __typename?: 'FileView' }
    & OfferingFileFragment
  )>, primary_contacts: Array<(
    { __typename?: 'UserView' }
    & Pick<UserView, 'id' | 'first_name' | 'last_name' | 'name'>
  )>, custom_contact: Maybe<(
    { __typename?: 'UserView' }
    & Pick<UserView, 'id' | 'name'>
  )> }
);

export type GetAllOfferingsQueryVariables = {};


export type GetAllOfferingsQuery = (
  { __typename?: 'Query' }
  & { allOfferings: (
    { __typename?: 'PaginatedView_schema_admin_types_offerings_OfferingView' }
    & { data: Array<(
      { __typename?: 'OfferingView' }
      & GenericOfferingFragment
    )> }
  ) }
);

export type OfferingDateDataFragment = (
  { __typename?: 'OfferingView' }
  & Pick<OfferingView, 'id' | 'name' | 'available_from' | 'auto_reminder_email_at'>
);

export type AllOfferingDatesQueryVariables = {};


export type AllOfferingDatesQuery = (
  { __typename?: 'Query' }
  & { allOfferings: (
    { __typename?: 'PaginatedView_schema_admin_types_offerings_OfferingView' }
    & { data: Array<(
      { __typename?: 'OfferingView' }
      & OfferingDateDataFragment
    )> }
  ) }
);

export type GetOfferingQueryVariables = {
  id: Scalars['UUID']
};


export type GetOfferingQuery = (
  { __typename?: 'Query' }
  & { offering: (
    { __typename?: 'OfferingView' }
    & SpecificOfferingFragment
  ) }
);

export type CreateOfferingMutationVariables = {
  form: CreateOfferingFormInput
};


export type CreateOfferingMutation = (
  { __typename?: 'Mutation' }
  & { createOffering: (
    { __typename?: 'OfferingView' }
    & Pick<OfferingView, 'id'>
  ) }
);

export type DeleteOfferingMutationVariables = {
  offeringId: Scalars['UUID']
};


export type DeleteOfferingMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteOffering'>
);

export type UnpublishOfferingMutationVariables = {
  offeringId: Scalars['UUID']
};


export type UnpublishOfferingMutation = (
  { __typename?: 'Mutation' }
  & { unpublishOffering: (
    { __typename?: 'OfferingView' }
    & Pick<OfferingView, 'id' | 'status'>
  ) }
);

export type UpdateOfferingMutationVariables = {
  form: OfferingDetailsFormInput
};


export type UpdateOfferingMutation = (
  { __typename?: 'Mutation' }
  & { updateOffering: (
    { __typename?: 'OfferingView' }
    & SpecificOfferingFragment
  ) }
);

export type UpdatePublishedOfferingMutationVariables = {
  form: UpdatePublishedOfferingFormInput
};


export type UpdatePublishedOfferingMutation = (
  { __typename?: 'Mutation' }
  & { updatePublishedOffering: (
    { __typename?: 'OfferingView' }
    & SpecificOfferingFragment
  ) }
);

export type UpdateOfferingEmailReminderMutationVariables = {
  offeringId: Scalars['UUID'],
  emailType: OfferingEmailType,
  sendReminderAt?: Maybe<Scalars['DateTime']>
};


export type UpdateOfferingEmailReminderMutation = (
  { __typename?: 'Mutation' }
  & { updateOfferingEmailReminder: (
    { __typename?: 'OfferingView' }
    & Pick<OfferingView, 'id' | 'auto_reminder_email_at' | 'auto_order_reminder_email_at' | 'auto_feedback_email_at'>
  ) }
);

export type BasicFundInfoFragment = (
  { __typename?: 'EquifundView' }
  & Pick<EquifundView, 'id' | 'name' | 'company_id'>
);

export type GetAllEquifundsQueryVariables = {};


export type GetAllEquifundsQuery = (
  { __typename?: 'Query' }
  & { allEquifunds: (
    { __typename?: 'PaginatedView_schema_admin_types_EquifundView' }
    & { data: Array<(
      { __typename?: 'EquifundView' }
      & BasicFundInfoFragment
    )> }
  ) }
);

export type UploadOfferingFilesMutationVariables = {
  fileSerials: Array<Scalars['String']>,
  offeringId: Scalars['UUID']
};


export type UploadOfferingFilesMutation = (
  { __typename?: 'Mutation' }
  & { uploadOfferingDataRoomFiles: (
    { __typename?: 'OfferingView' }
    & Pick<OfferingView, 'id'>
    & { files: Array<(
      { __typename?: 'FileView' }
      & OfferingFileFragment
    )> }
  ) }
);

export type OfferingFilesFragment = (
  { __typename?: 'OfferingView' }
  & Pick<OfferingView, 'id' | 'num_participants'>
  & { files: Array<(
    { __typename?: 'FileView' }
    & OfferingFileFragment
  )> }
);

export type UploadOfferingParticipantsMutationVariables = {
  fileSerials: Array<Scalars['String']>,
  offeringId: Scalars['UUID']
};


export type UploadOfferingParticipantsMutation = (
  { __typename?: 'Mutation' }
  & { uploadInvitationCSVs: (
    { __typename?: 'OfferingView' }
    & OfferingFilesFragment
  ) }
);

export type DeleteOfferingDataroomFileMutationVariables = {
  offeringId: Scalars['UUID'],
  fileId: Scalars['Int']
};


export type DeleteOfferingDataroomFileMutation = (
  { __typename?: 'Mutation' }
  & { deleteDataroomFile: (
    { __typename?: 'OfferingView' }
    & Pick<OfferingView, 'id'>
    & { files: Array<(
      { __typename?: 'FileView' }
      & OfferingFileFragment
    )> }
  ) }
);

export type SendDummyEmailMutationVariables = {
  offeringId: Scalars['UUID'],
  emailType: OfferingEmailType
};


export type SendDummyEmailMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'sendDummyOfferingEmails'>
);

export type SendOfferingEmailsMutationVariables = {
  offeringId: Scalars['UUID'],
  emailType: OfferingEmailType
};


export type SendOfferingEmailsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'sendOfferingEmails'>
);

export type GetOfferingFilesQueryVariables = {
  offeringId: Scalars['UUID']
};


export type GetOfferingFilesQuery = (
  { __typename?: 'Query' }
  & { offering: (
    { __typename?: 'OfferingView' }
    & OfferingFilesFragment
  ) }
);

export type ParticipantFragment = (
  { __typename?: 'OfferingParticipationView' }
  & Pick<OfferingParticipationView, 'id' | 'status'>
  & { user: (
    { __typename?: 'UserView' }
    & Pick<UserView, 'id' | 'name' | 'email'>
    & { crm_account: (
      { __typename?: 'AccountView' }
      & Pick<AccountView, 'id'>
    ) }
  ) }
);

export type GetOfferingParticipantsQueryVariables = {
  id: Scalars['UUID'],
  offset: Scalars['Int'],
  limit: Scalars['Int']
};


export type GetOfferingParticipantsQuery = (
  { __typename?: 'Query' }
  & { offering: (
    { __typename?: 'OfferingView' }
    & Pick<OfferingView, 'id'>
    & { paginatedParticipants: (
      { __typename?: 'PaginatedView_schema_admin_types_offerings_OfferingParticipationView' }
      & Pick<PaginatedView_Schema_Admin_Types_Offerings_OfferingParticipationView, 'count' | 'offset' | 'limit'>
      & { data: Array<(
        { __typename?: 'OfferingParticipationView' }
        & ParticipantFragment
      )> }
    ) }
  ) }
);

export type BidDetailFragment = (
  { __typename?: 'TradeIntentView' }
  & Pick<TradeIntentView, 'id' | 'dollar_amount' | 'status' | 'is_loi_signed'>
  & { opportunity: (
    { __typename?: 'OpportunityView' }
    & OpportunityFragment
  ), order: Maybe<(
    { __typename?: 'OrderView' }
    & Pick<OrderView, 'id' | 'status' | 'client_signed' | 'wire_info_sent' | 'date_created'>
    & { entity: (
      { __typename?: 'EntityView' }
      & Pick<EntityView, 'new_client_form_signed'>
      & { crm_account: Maybe<(
        { __typename?: 'AccountView' }
        & Pick<AccountView, 'id' | 'name'>
      )> }
    ) }
  )> }
);

export type GetBidsByOfferingQueryVariables = {
  id: Scalars['UUID']
};


export type GetBidsByOfferingQuery = (
  { __typename?: 'Query' }
  & { offering: (
    { __typename?: 'OfferingView' }
    & Pick<OfferingView, 'id' | 'name'>
    & { bids: Array<(
      { __typename?: 'TradeIntentView' }
      & BidDetailFragment
    )> }
  ) }
);

export type ClientTypesQueryVariables = {
  accountType?: Maybe<Scalars['String']>
};


export type ClientTypesQuery = (
  { __typename?: 'Query' }
  & { client_types: Array<(
    { __typename?: 'ClientTypeView' }
    & Pick<ClientTypeView, 'id' | 'name' | 'account_type'>
  )> }
);

export type CrmMetadataQueryVariables = {};


export type CrmMetadataQuery = (
  { __typename?: 'Query' }
  & { client_types: Array<(
    { __typename?: 'ClientTypeView' }
    & Pick<ClientTypeView, 'id' | 'name' | 'account_type'>
  )>, sectors: Array<(
    { __typename?: 'SectorView' }
    & Pick<SectorView, 'id' | 'name'>
  )>, issuers: Array<(
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
    & { issuer_account: Maybe<(
      { __typename?: 'IssuerAccountView' }
      & Pick<IssuerAccountView, 'id'>
      & { company: (
        { __typename?: 'CompanyView' }
        & Pick<CompanyView, 'id' | 'name'>
      ) }
    )> }
  )>, adminsWithAccountCoverage: Array<(
    { __typename?: 'UserView' }
    & Pick<UserView, 'id' | 'first_name' | 'last_name'>
  )> }
);

export type AccountDealOrderFragment = (
  { __typename?: 'AccountDealOrderView' }
  & Pick<AccountDealOrderView, 'companyId' | 'orderType' | 'isClosed' | 'dateFullyAccrued' | 'volume' | 'revenue'>
);

export type AccountDealFragment = (
  { __typename?: 'AccountDealView' }
  & Pick<AccountDealView, 'orderType' | 'isClosed' | 'dateFullyAccrued' | 'totalSellSideVolume' | 'totalSellSideRevenue' | 'totalBuySideVolume' | 'totalBuySideRevenue'>
  & { company: (
    { __typename?: 'CompanyView' }
    & Pick<CompanyView, 'id' | 'name'>
  ) }
);

export type UpdateDealStatusMutationVariables = {
  dealId: Scalars['Int'],
  status: DealStatusType
};


export type UpdateDealStatusMutation = (
  { __typename?: 'Mutation' }
  & { updateDealStatus: (
    { __typename?: 'DealView' }
    & Pick<DealView, 'id' | 'active_deal_status' | 'status_last_updated_at' | 'probability_to_close'>
  ) }
);

export type AppendErrorMutationVariables = {
  errorMsg: Scalars['String']
};


export type AppendErrorMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'appendError'>
);

export type ClearErrorsMutationVariables = {
  errorMsg?: Maybe<Scalars['String']>
};


export type ClearErrorsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'clearErrors'>
);

export type ErrorsQueryVariables = {};


export type ErrorsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'errors'>
);

export type AccountHoldingsQueryVariables = {
  accountId: Scalars['UUID']
};


export type AccountHoldingsQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
    & { holdings: Array<(
      { __typename?: 'HoldingView' }
      & AccountHoldingFragment
    )> }
  ) }
);

export type CreateHoldingMutationVariables = {
  form: NewHoldingInput
};


export type CreateHoldingMutation = (
  { __typename?: 'Mutation' }
  & { createHolding: (
    { __typename?: 'HoldingView' }
    & Pick<HoldingView, 'id' | 'estimated_num_shares' | 'confirmed_num_shares' | 'share_dollar_amt_est' | 'current_value' | 'share_class' | 'updated_at'>
    & { company: (
      { __typename?: 'CompanyView' }
      & Pick<CompanyView, 'id' | 'name'>
      & { crm_account: (
        { __typename?: 'AccountView' }
        & Pick<AccountView, 'id'>
      ) }
    ) }
  ) }
);

export type AccountHoldingFragment = (
  { __typename?: 'HoldingView' }
  & Pick<HoldingView, 'id' | 'type' | 'is_deleted' | 'share_dollar_amt_est' | 'estimated_num_shares' | 'confirmed_num_shares' | 'share_class' | 'current_value'>
  & { company: (
    { __typename?: 'CompanyView' }
    & Pick<CompanyView, 'id' | 'name' | 'logo_url'>
    & { crm_account: (
      { __typename?: 'AccountView' }
      & Pick<AccountView, 'id'>
    ) }
  ), account: Maybe<(
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name' | 'email'>
  )> }
);

export type HoldingQueryVariables = {
  id: Scalars['Int']
};


export type HoldingQuery = (
  { __typename?: 'Query' }
  & { holding: (
    { __typename?: 'HoldingView' }
    & AccountHoldingFragment
  ) }
);

export type CreateInteractionMutationVariables = {
  form: NewInteractionInput
};


export type CreateInteractionMutation = (
  { __typename?: 'Mutation' }
  & { createInteraction: (
    { __typename?: 'InteractionView' }
    & InteractionDataFragment
  ) }
);

export type UpdateInteractionMutationVariables = {
  form: UpdateInteractionInput
};


export type UpdateInteractionMutation = (
  { __typename?: 'Mutation' }
  & { updateInteraction: (
    { __typename?: 'InteractionView' }
    & InteractionDataFragment
  ) }
);

export type DeleteInteractionMutationVariables = {
  id: Scalars['UUID']
};


export type DeleteInteractionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteInteraction'>
);

export type OpportunityAccountQueryVariables = {
  opportunityId: Scalars['UUID']
};


export type OpportunityAccountQuery = (
  { __typename?: 'Query' }
  & { opportunity: (
    { __typename?: 'OpportunityView' }
    & Pick<OpportunityView, 'id'>
    & { trade_intent: (
      { __typename?: 'TradeIntentView' }
      & Pick<TradeIntentView, 'id' | 'type'>
    ), account: (
      { __typename?: 'AccountView' }
      & Pick<AccountView, 'id' | 'name' | 'phone_number' | 'formatted_phone_number' | 'email'>
      & { parents: Array<(
        { __typename?: 'AccountRelationshipView' }
        & Pick<AccountRelationshipView, 'id' | 'title'>
        & { parent_account: (
          { __typename?: 'AccountView' }
          & Pick<AccountView, 'id' | 'name'>
        ) }
      )> }
    ) }
  ) }
);

export type ClientContextQueryVariables = {
  opportunityId: Scalars['UUID']
};


export type ClientContextQuery = (
  { __typename?: 'Query' }
  & { opportunity: (
    { __typename?: 'OpportunityView' }
    & Pick<OpportunityView, 'id'>
    & { trade_intent: (
      { __typename?: 'TradeIntentView' }
      & Pick<TradeIntentView, 'id' | 'type'>
    ), account: (
      { __typename?: 'AccountView' }
      & Pick<AccountView, 'id' | 'relationship_strength' | 'relationship_sensitivity' | 'relationship_notes' | 'notes'>
      & { owners: Array<(
        { __typename?: 'OwnerView' }
        & OwnerFragment
      )>, deals: Array<(
        { __typename?: 'AccountDealView' }
        & AccountDealFragment
      )> }
    ) }
  ) }
);

export type OpportunityDetailsFragment = (
  { __typename?: 'OpportunityView' }
  & Pick<OpportunityView, 'id' | 'certainty' | 'deal_blockers' | 'status' | 'expired_at'>
  & { company: (
    { __typename?: 'CompanyView' }
    & Pick<CompanyView, 'id' | 'last_round_estimated_number_of_shares'>
  ), trade_intent: (
    { __typename?: 'TradeIntentView' }
    & Pick<TradeIntentView, 'id' | 'asset_type' | 'dollar_amount' | 'num_shares' | 'share_price' | 'certainty' | 'fee' | 'has_time_constraints' | 'time_constraint_notes' | 'has_flexibility' | 'flexibility_notes' | 'additional_diligence_notes' | 'share_type_description'>
    & { entity: Maybe<(
      { __typename?: 'EntityView' }
      & Pick<EntityView, 'id' | 'type' | 'name'>
    )> }
  ), owners: Array<(
    { __typename?: 'OwnerView' }
    & OwnerFragment
  )> }
);

export type OpportunityDetailsQueryVariables = {
  opportunityId: Scalars['UUID']
};


export type OpportunityDetailsQuery = (
  { __typename?: 'Query' }
  & { opportunity: (
    { __typename?: 'OpportunityView' }
    & OpportunityDetailsFragment
  ) }
);

export type CreateOrderRequestMutationVariables = {
  opportunityId: Scalars['UUID'],
  assigneeId?: Maybe<Scalars['Int']>,
  notes: Scalars['String']
};


export type CreateOrderRequestMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'requestOrderForOpportunity'>
);

export type OpportunityDataFragment = (
  { __typename?: 'OpportunityView' }
  & Pick<OpportunityView, 'id' | 'account_id' | 'notes' | 'status' | 'updated_at' | 'last_refreshed_at' | 'latest_activity'>
  & { trade_intent: (
    { __typename?: 'TradeIntentView' }
    & Pick<TradeIntentView, 'id' | 'type' | 'acceptable_structures' | 'dollar_amount' | 'share_price' | 'status'>
    & { entity: Maybe<(
      { __typename?: 'EntityView' }
      & Pick<EntityView, 'id' | 'type' | 'name'>
    )> }
  ), company: (
    { __typename?: 'CompanyView' }
    & Pick<CompanyView, 'id' | 'name'>
  ), owners: Array<(
    { __typename?: 'OwnerView' }
    & Pick<OwnerView, 'id' | 'first_name' | 'last_name'>
  )>, account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
  ) }
);

export type TableOpportunityDataFragment = (
  { __typename?: 'OpportunityView' }
  & Pick<OpportunityView, 'id' | 'status' | 'updated_at'>
  & { trade_intent: (
    { __typename?: 'TradeIntentView' }
    & Pick<TradeIntentView, 'id' | 'share_price' | 'dollar_amount'>
    & { entity: Maybe<(
      { __typename?: 'EntityView' }
      & Pick<EntityView, 'id' | 'type' | 'name'>
    )>, latest_price_change: Maybe<(
      { __typename?: 'FieldChangeView' }
      & Pick<FieldChangeView, 'id' | 'field_name' | 'user_name' | 'changed_at' | 'old_value'>
    )> }
  ) }
);

export type CreateOrUpdateOpportunityMutationVariables = {
  form: OpportunityFormInput
};


export type CreateOrUpdateOpportunityMutation = (
  { __typename?: 'Mutation' }
  & { createOrUpdateOpportunity: (
    { __typename?: 'OpportunityView' }
    & OpportunityDataFragment
    & OpportunityFragment
  ) }
);

export type AccountOpportunitiesQueryVariables = {
  id: Scalars['UUID']
};


export type AccountOpportunitiesQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
    & { opportunities: Array<(
      { __typename?: 'OpportunityView' }
      & OpportunityDataFragment
    )> }
  ) }
);

export type BrokersTypeaheadQueryVariables = {
  query: Scalars['String']
};


export type BrokersTypeaheadQuery = (
  { __typename?: 'Query' }
  & { brokersTypeahead: Array<(
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
  )> }
);

export type OpportunitiesTypeaheadQueryVariables = {
  accountId: Scalars['UUID'],
  query: Scalars['String']
};


export type OpportunitiesTypeaheadQuery = (
  { __typename?: 'Query' }
  & { opportunitiesTypeahead: Array<(
    { __typename?: 'OpportunityView' }
    & Pick<OpportunityView, 'id'>
    & { trade_intent: (
      { __typename?: 'TradeIntentView' }
      & Pick<TradeIntentView, 'id' | 'type' | 'dollar_amount' | 'share_price' | 'num_shares'>
    ), company: (
      { __typename?: 'CompanyView' }
      & Pick<CompanyView, 'id' | 'name'>
    ) }
  )> }
);

export type OpportunityTagQueryVariables = {
  id: Scalars['UUID']
};


export type OpportunityTagQuery = (
  { __typename?: 'Query' }
  & { opportunity: (
    { __typename?: 'OpportunityView' }
    & Pick<OpportunityView, 'id'>
    & { company: (
      { __typename?: 'CompanyView' }
      & Pick<CompanyView, 'id' | 'name'>
    ), trade_intent: (
      { __typename?: 'TradeIntentView' }
      & Pick<TradeIntentView, 'id' | 'type'>
    ) }
  ) }
);

export type OpportunityQueryVariables = {
  id: Scalars['UUID']
};


export type OpportunityQuery = (
  { __typename?: 'Query' }
  & { opportunity: (
    { __typename?: 'OpportunityView' }
    & Pick<OpportunityView, 'id' | 'type' | 'notes' | 'latest_activity' | 'account_id' | 'status' | 'updated_at' | 'expired_at' | 'source' | 'certainty'>
    & { company: (
      { __typename?: 'CompanyView' }
      & Pick<CompanyView, 'id' | 'name' | 'logo_url'>
      & { crm_account: (
        { __typename?: 'AccountView' }
        & Pick<AccountView, 'id'>
      ) }
    ), account: (
      { __typename?: 'AccountView' }
      & Pick<AccountView, 'id' | 'name'>
    ), trade_intent: (
      { __typename?: 'TradeIntentView' }
      & Pick<TradeIntentView, 'id' | 'type' | 'acceptable_structures' | 'share_price' | 'dollar_amount' | 'expired_at' | 'fee'>
      & { holding: Maybe<(
        { __typename?: 'HoldingView' }
        & Pick<HoldingView, 'id'>
      )>, entity: Maybe<(
        { __typename?: 'EntityView' }
        & Pick<EntityView, 'id' | 'type' | 'name'>
      )>, active_deals: Array<(
        { __typename?: 'DealView' }
        & Pick<DealView, 'id' | 'active_deal_status' | 'date_created'>
      )> }
    ) }
  ) }
);

export type OpportunityStatusFragmentFragment = (
  { __typename?: 'OpportunityView' }
  & Pick<OpportunityView, 'id' | 'status' | 'expired_at' | 'latest_activity' | 'certainty'>
  & { company: (
    { __typename?: 'CompanyView' }
    & Pick<CompanyView, 'id' | 'name'>
  ), account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
  ), owners: Array<(
    { __typename?: 'OwnerView' }
    & Pick<OwnerView, 'id' | 'owner_id' | 'first_name' | 'last_name'>
  )> }
);

export type TradeIntentFragmentFragment = (
  { __typename?: 'TradeIntentView' }
  & Pick<TradeIntentView, 'id' | 'share_price' | 'share_type_description' | 'asset_type' | 'num_shares' | 'fee' | 'acceptable_structures' | 'dollar_amount' | 'additional_diligence_notes' | 'has_time_constraints' | 'time_constraint_notes' | 'has_flexibility' | 'flexibility_notes'>
  & { latest_price_change: Maybe<(
    { __typename?: 'FieldChangeView' }
    & Pick<FieldChangeView, 'id' | 'field_name' | 'user_name' | 'changed_at' | 'old_value'>
  )> }
);

export type OpportunityStatusViewQueryVariables = {
  id: Scalars['UUID']
};


export type OpportunityStatusViewQuery = (
  { __typename?: 'Query' }
  & { opportunity: (
    { __typename?: 'OpportunityView' }
    & OpportunityStatusFragmentFragment
  ) }
);

export type OpportunityStakeholdersQueryVariables = {
  id: Scalars['UUID']
};


export type OpportunityStakeholdersQuery = (
  { __typename?: 'Query' }
  & { opportunity: (
    { __typename?: 'OpportunityView' }
    & Pick<OpportunityView, 'id' | 'account_id'>
    & { stakeholders: Array<(
      { __typename?: 'AccountRelationshipView' }
      & AccountRelationshipDataFragment
    )> }
  ) }
);

export type OpportunityPricingQueryVariables = {
  id: Scalars['UUID']
};


export type OpportunityPricingQuery = (
  { __typename?: 'Query' }
  & { opportunity: (
    { __typename?: 'OpportunityView' }
    & Pick<OpportunityView, 'id'>
    & { company: (
      { __typename?: 'CompanyView' }
      & Pick<CompanyView, 'id' | 'last_round_estimated_number_of_shares'>
    ), trade_intent: (
      { __typename?: 'TradeIntentView' }
      & TradeIntentFragmentFragment
    ) }
  ) }
);

export type AccountRelationshipsTypeaheadQueryVariables = {
  query: Scalars['String'],
  accountId: Scalars['UUID']
};


export type AccountRelationshipsTypeaheadQuery = (
  { __typename?: 'Query' }
  & { accountRelationshipsTypeahead: Array<(
    { __typename?: 'AccountRelationshipView' }
    & AccountRelationshipDataFragment
  )> }
);

export type OpportunityInteractionsQueryVariables = {
  id: Scalars['UUID'],
  groupFilter?: Maybe<InteractionFilter>
};


export type OpportunityInteractionsQuery = (
  { __typename?: 'Query' }
  & { opportunity: (
    { __typename?: 'OpportunityView' }
    & Pick<OpportunityView, 'id' | 'account_id'>
    & { interactions: Array<(
      { __typename?: 'InteractionView' }
      & InteractionWithRollupsDataFragment
    )> }
  ) }
);

export type MinimalOpportunitiesQueryVariables = {
  accountId: Scalars['UUID']
};


export type MinimalOpportunitiesQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
    & { opportunities: Array<(
      { __typename?: 'OpportunityView' }
      & Pick<OpportunityView, 'id' | 'created_at' | 'status'>
      & { trade_intent: (
        { __typename?: 'TradeIntentView' }
        & Pick<TradeIntentView, 'id' | 'type' | 'share_price' | 'dollar_amount'>
      ), account: (
        { __typename?: 'AccountView' }
        & Pick<AccountView, 'id' | 'email' | 'name'>
      ), company: (
        { __typename?: 'CompanyView' }
        & Pick<CompanyView, 'id' | 'name' | 'logo_url'>
      ) }
    )> }
  ) }
);

export type OpportunityFragment = (
  { __typename?: 'OpportunityView' }
  & Pick<OpportunityView, 'id' | 'created_at' | 'updated_at' | 'expired_at' | 'account_id' | 'last_refreshed_at' | 'status' | 'source' | 'type' | 'certainty' | 'pricing_type' | 'min_dollar_amount' | 'dollar_amount' | 'min_num_shares' | 'num_shares' | 'share_price' | 'valuation' | 'entity_id'>
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
    & { entities: Array<(
      { __typename?: 'EntityView' }
      & Pick<EntityView, 'id' | 'type' | 'name'>
    )> }
  ), owners: Array<(
    { __typename?: 'OwnerView' }
    & Pick<OwnerView, 'id' | 'name' | 'first_name' | 'last_name' | 'owner_id'>
  )>, liquidity_event: Maybe<(
    { __typename?: 'LiquidityEventRead' }
    & Pick<LiquidityEventRead, 'id'>
  )>, trade_intent: (
    { __typename?: 'TradeIntentView' }
    & Pick<TradeIntentView, 'id' | 'fee' | 'type' | 'min_dollar_amount' | 'max_dollar_amount' | 'min_num_shares' | 'max_num_shares' | 'valuation' | 'share_price' | 'num_shares' | 'dollar_amount' | 'size_type' | 'pricing_type' | 'acceptable_structures' | 'share_price_recorded_as'>
    & { entity: Maybe<(
      { __typename?: 'EntityView' }
      & Pick<EntityView, 'id' | 'type' | 'name'>
    )>, creator: (
      { __typename?: 'UserView' }
      & Pick<UserView, 'id' | 'first_name' | 'last_name' | 'name'>
    ), holding: Maybe<(
      { __typename?: 'HoldingView' }
      & Pick<HoldingView, 'id'>
      & { cap_table_entry: Array<(
        { __typename?: 'CapTableEntryView' }
        & Pick<CapTableEntryView, 'id'>
      )> }
    )>, active_deals: Array<(
      { __typename?: 'DealView' }
      & Pick<DealView, 'id' | 'active_deal_status' | 'date_created'>
    )> }
  ), company: (
    { __typename?: 'CompanyView' }
    & Pick<CompanyView, 'id' | 'name' | 'last_round_estimated_number_of_shares'>
    & { crm_account: (
      { __typename?: 'AccountView' }
      & Pick<AccountView, 'id'>
    ) }
  ) }
);

export type GetAllOpportunitiesQueryVariables = {
  accountId: Scalars['UUID']
};


export type GetAllOpportunitiesQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
    & { opportunities: Array<(
      { __typename?: 'OpportunityView' }
      & OpportunityFragment
    )> }
  ) }
);

export type GetFilteredOpportunitiesQueryVariables = {
  limit: Scalars['Int'],
  offset: Scalars['Int'],
  filter: OpportunityFilterInput
};


export type GetFilteredOpportunitiesQuery = (
  { __typename?: 'Query' }
  & { opportunities: (
    { __typename?: 'PaginatedView_schema_admin_types_crm_opportunities_OpportunityView' }
    & Pick<PaginatedView_Schema_Admin_Types_Crm_Opportunities_OpportunityView, 'count' | 'offset' | 'limit'>
    & { data: Array<(
      { __typename?: 'OpportunityView' }
      & OpportunityFragment
    )> }
  ) }
);

export type EntityOptionFragment = (
  { __typename?: 'EntityView' }
  & Pick<EntityView, 'id' | 'name' | 'type'>
);

export type OpportunityHeaderQueryVariables = {
  opportunityId: Scalars['UUID']
};


export type OpportunityHeaderQuery = (
  { __typename?: 'Query' }
  & { opportunity: (
    { __typename?: 'OpportunityView' }
    & Pick<OpportunityView, 'id' | 'type' | 'created_at' | 'latest_activity' | 'status' | 'certainty' | 'source'>
    & { company: (
      { __typename?: 'CompanyView' }
      & Pick<CompanyView, 'id' | 'name' | 'logo_url'>
      & { crm_account: (
        { __typename?: 'AccountView' }
        & Pick<AccountView, 'id'>
      ) }
    ), trade_intent: (
      { __typename?: 'TradeIntentView' }
      & Pick<TradeIntentView, 'id' | 'type' | 'share_price' | 'max_dollar_amount' | 'min_dollar_amount' | 'min_num_shares' | 'max_num_shares' | 'valuation' | 'size_type' | 'acceptable_structures' | 'fee'>
    ), account: (
      { __typename?: 'AccountView' }
      & Pick<AccountView, 'id' | 'name' | 'email'>
    ) }
  ) }
);

export type UpdateOpportunityDetailsMutationVariables = {
  form: UpdateOpportunityDetailsFormInput
};


export type UpdateOpportunityDetailsMutation = (
  { __typename?: 'Mutation' }
  & { updateOpportunityDetails: (
    { __typename?: 'OpportunityView' }
    & OpportunityDetailsFragment
  ) }
);

export type ApplyOpportunityActionMutationVariables = {
  form: OpportunityActionInput
};


export type ApplyOpportunityActionMutation = (
  { __typename?: 'Mutation' }
  & { applyOpportunityAction: (
    { __typename?: 'OpportunityView' }
    & OpportunityDetailsFragment
  ) }
);

export type ExpireOpportunityMutationVariables = {
  id: Scalars['UUID']
};


export type ExpireOpportunityMutation = (
  { __typename?: 'Mutation' }
  & { applyOpportunityAction: (
    { __typename?: 'OpportunityView' }
    & OpportunityDetailsFragment
  ) }
);

export type CancelOpportunityMutationVariables = {
  id: Scalars['UUID'],
  cancellationForm: OpportunityCancellationFormInput
};


export type CancelOpportunityMutation = (
  { __typename?: 'Mutation' }
  & { applyOpportunityAction: (
    { __typename?: 'OpportunityView' }
    & OpportunityDetailsFragment
  ) }
);

export type FundingRoundFragment = (
  { __typename?: 'FundingRound' }
  & Pick<FundingRound, 'id' | 'round_date' | 'stage' | 'est_num_shares' | 'price_per_share' | 'valuation'>
);

export type OpportunityCompanyFinancingQueryVariables = {
  opportunityId: Scalars['UUID']
};


export type OpportunityCompanyFinancingQuery = (
  { __typename?: 'Query' }
  & { opportunity: (
    { __typename?: 'OpportunityView' }
    & Pick<OpportunityView, 'id'>
    & { company: (
      { __typename?: 'CompanyView' }
      & Pick<CompanyView, 'id'>
      & { last_round: Maybe<(
        { __typename?: 'FundingRound' }
        & FundingRoundFragment
      )> }
    ) }
  ) }
);

export type AccountTableSchemaQueryVariables = {};


export type AccountTableSchemaQuery = (
  { __typename?: 'Query' }
  & { accountsTableSchema: (
    { __typename?: 'TableDefinition' }
    & Pick<TableDefinition, 'fields'>
  ) }
);

export type FilteredAccountsTableQueryVariables = {
  query: Scalars['String'],
  limit: Scalars['Int'],
  offset: Scalars['Int']
};


export type FilteredAccountsTableQuery = (
  { __typename?: 'Query' }
  & { filterAccounts: (
    { __typename?: 'PaginatedView_schema_admin_types_crm_accounts_AccountView' }
    & Pick<PaginatedView_Schema_Admin_Types_Crm_Accounts_AccountView, 'count'>
  ) }
);

export type SegmentQueryFragment = (
  { __typename?: 'SegmentQueryView' }
  & Pick<SegmentQueryView, 'id' | 'name' | 'last_run_at' | 'last_run_count' | 'last_changed_at' | 'query' | 'created_at'>
  & { last_changed_by: (
    { __typename?: 'UserView' }
    & Pick<UserView, 'id' | 'name'>
  ), created_by: (
    { __typename?: 'UserView' }
    & Pick<UserView, 'id' | 'name'>
  ) }
);

export type CreateOrUpdateSegmentMutationVariables = {
  form: CreateOrUpdateSegmentFormInput
};


export type CreateOrUpdateSegmentMutation = (
  { __typename?: 'Mutation' }
  & { createOrUpdateSegment: (
    { __typename?: 'SegmentQueryView' }
    & SegmentQueryFragment
  ) }
);

export type SegmentQueriesQueryVariables = {};


export type SegmentQueriesQuery = (
  { __typename?: 'Query' }
  & { segmentQueries: Array<(
    { __typename?: 'SegmentQueryView' }
    & SegmentQueryFragment
  )> }
);

export type SegmentQueryVariables = {
  id: Scalars['UUID']
};


export type SegmentQuery = (
  { __typename?: 'Query' }
  & { segmentQuery: (
    { __typename?: 'SegmentQueryView' }
    & Pick<SegmentQueryView, 'id' | 'name' | 'query'>
  ) }
);

export type DownloadQueryMutationVariables = {
  query: Scalars['String']
};


export type DownloadQueryMutation = (
  { __typename?: 'Mutation' }
  & { exportAccountsQueryToCsv: (
    { __typename?: 'FileView' }
    & Pick<FileView, 'id' | 'url'>
  ) }
);

export type TodoFragment = (
  { __typename?: 'TodoItemView' }
  & Pick<TodoItemView, 'id' | 'meta' | 'type' | 'live_at' | 'lifespan' | 'status' | 'completed_at' | 'priority' | 'dismissed_at'>
  & { finished_by: Maybe<(
    { __typename?: 'UserView' }
    & Pick<UserView, 'id' | 'first_name' | 'last_name'>
  )> }
);

export type AllTodosQueryVariables = {};


export type AllTodosQuery = (
  { __typename?: 'Query' }
  & { allTodos: Array<(
    { __typename?: 'TodoItemView' }
    & TodoFragment
  )> }
);

export type ClaimAccountRollupFragment = (
  { __typename?: 'AccountView' }
  & Pick<AccountView, 'id' | 'name' | 'account_level' | 'img' | 'email' | 'is_account_of_interest' | 'account_of_interest_reason' | 'source' | 'created_at'>
  & { owners: Array<(
    { __typename?: 'OwnerView' }
    & Pick<OwnerView, 'id' | 'admin_id' | 'name'>
  )>, account_of_interest_set_by_admin: Maybe<(
    { __typename?: 'UserView' }
    & Pick<UserView, 'id' | 'name'>
  )>, admin_created_by: Maybe<(
    { __typename?: 'UserView' }
    & Pick<UserView, 'id' | 'name'>
  )> }
);

export type ClaimAccountRollupQueryVariables = {
  accountId: Scalars['UUID']
};


export type ClaimAccountRollupQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & ClaimAccountRollupFragment
  ), currentAdmin: (
    { __typename?: 'UserView' }
    & Pick<UserView, 'id'>
  ) }
);

export type AccountOutreachRollupFragment = (
  { __typename?: 'AccountView' }
  & Pick<AccountView, 'id' | 'name' | 'account_level' | 'last_outreach_at' | 'outreach_schedule' | 'email' | 'formatted_phone_number' | 'img' | 'last_front_message_id' | 'is_account_of_interest' | 'account_of_interest_reason'>
  & { last_outreach_by: Maybe<(
    { __typename?: 'UserView' }
    & Pick<UserView, 'id' | 'first_name' | 'last_name'>
  )>, account_of_interest_set_by_admin: Maybe<(
    { __typename?: 'UserView' }
    & Pick<UserView, 'id' | 'name'>
  )> }
);

export type AccountOutreachRollupQueryVariables = {
  accountId: Scalars['UUID']
};


export type AccountOutreachRollupQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'AccountView' }
    & AccountOutreachRollupFragment
  ), currentAdmin: (
    { __typename?: 'UserView' }
    & Pick<UserView, 'id'>
  ) }
);

export type DismissReminderMutationVariables = {
  reminderId: Scalars['UUID']
};


export type DismissReminderMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'dismissTodo'>
);

export type RestoreReminderMutationVariables = {
  reminderId: Scalars['UUID']
};


export type RestoreReminderMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'restoreTodo'>
);

export type SetOutreachScheduleMutationVariables = {
  accountId: Scalars['UUID'],
  schedule?: Maybe<Scalars['Duration']>
};


export type SetOutreachScheduleMutation = (
  { __typename?: 'Mutation' }
  & { setOutreachSchedule: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'outreach_schedule'>
  ) }
);

export type ResetOutreachScheduleMutationVariables = {
  accountId: Scalars['UUID']
};


export type ResetOutreachScheduleMutation = (
  { __typename?: 'Mutation' }
  & { resetOutreachSchedule: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'outreach_schedule'>
  ) }
);

export type QuickAssignFirstOwnerMutationVariables = {
  accountId: Scalars['UUID'],
  ownerId: Scalars['Int']
};


export type QuickAssignFirstOwnerMutation = (
  { __typename?: 'Mutation' }
  & { quickAssignFirstOwner: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id'>
    & { owners: Array<(
      { __typename?: 'OwnerView' }
      & OwnerFragment
    )> }
  ) }
);

export type AddProfileAccountTodoMutationVariables = {
  assigneeId: Scalars['Int'],
  accountId: Scalars['UUID']
};


export type AddProfileAccountTodoMutation = (
  { __typename?: 'Mutation' }
  & { addProfileAccountTodo: Maybe<(
    { __typename?: 'TodoItemView' }
    & Pick<TodoItemView, 'id' | 'meta'>
  )> }
);

export type AddLeadMutationVariables = {
  accountId: Scalars['UUID']
};


export type AddLeadMutation = (
  { __typename?: 'Mutation' }
  & { addLead: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
  ) }
);

export type DismissLeadMutationVariables = {
  accountId: Scalars['UUID']
};


export type DismissLeadMutation = (
  { __typename?: 'Mutation' }
  & { dismissLead: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
  ) }
);

export type ProfileLeadMutationVariables = {
  accountId: Scalars['UUID'],
  qualified: Scalars['Boolean']
};


export type ProfileLeadMutation = (
  { __typename?: 'Mutation' }
  & { profileLead: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name' | 'qualified'>
  ) }
);

export type AssignLeadMutationVariables = {
  accountId: Scalars['UUID'],
  assigneeId: Scalars['Int']
};


export type AssignLeadMutation = (
  { __typename?: 'Mutation' }
  & { assignLead: (
    { __typename?: 'AccountView' }
    & Pick<AccountView, 'id' | 'name'>
    & { profilingAssignees: Array<Maybe<(
      { __typename?: 'UserView' }
      & Pick<UserView, 'name'>
    )>> }
  ) }
);

export type AllSalesUsersQueryVariables = {};


export type AllSalesUsersQuery = (
  { __typename?: 'Query' }
  & { allUsersByCapability: Array<(
    { __typename?: 'UserView' }
    & Pick<UserView, 'id' | 'name'>
  )> }
);

export const TradeIntentSortPriceFragmentDoc = gql`
    fragment TradeIntentSortPrice on OpportunityView {
  id
  share_price
  valuation
  pricing_type
  company {
    id
    last_round_estimated_number_of_shares
  }
}
    `;
export const DealOpportunityRowFragmentDoc = gql`
    fragment DealOpportunityRow on OpportunityView {
  id
  account {
    id
    name
  }
  company {
    id
    last_round_estimated_number_of_shares
  }
  owners {
    id
    owner_id
    first_name
    last_name
    name
  }
  creator {
    name
  }
  account_id
  certainty
  company_id
  created_at
  dollar_amount
  entity_id
  fee
  last_refreshed_at
  max_dollar_amount
  max_num_shares
  min_dollar_amount
  min_num_shares
  num_shares
  pricing_type
  share_price
  share_price_recorded_as
  size_type
  source
  status
  type
  valuation
}
    `;
export const AddOpportunityPanel_OpportunityViewFragmentDoc = gql`
    fragment AddOpportunityPanel_OpportunityView on OpportunityView {
  id
  type
  last_refreshed_at
  account {
    id
    name
    email
  }
  owners {
    id
    owner_id
    name
  }
  ...TradeIntentSortPrice
  ...DealOpportunityRow
}
    ${TradeIntentSortPriceFragmentDoc}
${DealOpportunityRowFragmentDoc}`;
export const BankAccountCardBankAccountViewFragmentDoc = gql`
    fragment BankAccountCardBankAccountView on BankAccountView {
  id
  type
  bank_name
  routing_number
  account_number
  brokerage_name
  ffc_name
  ffc_account_number
  country_code
}
    `;
export const BankAccountCardEntityViewFragmentDoc = gql`
    fragment BankAccountCardEntityView on EntityView {
  name
  address {
    address_street_1
    address_street_2
    address_city
    address_state
    address_postal_code
    address_country_code
  }
  phone_number
}
    `;
export const MiniTradeListFragmentDoc = gql`
    fragment MiniTradeList on DealTradeView {
  is_anchor
  order {
    id
    dollar_amount
  }
  account {
    id
    name
  }
}
    `;
export const OwnerAvatarOwnerViewFragmentDoc = gql`
    fragment OwnerAvatarOwnerView on OwnerView {
  id: owner_id
  name
  first_name
  last_name
}
    `;
export const DealCardFragmentDoc = gql`
    fragment DealCard on DealView {
  id
  probability_to_close
  status_last_updated_at
  volume_bids
  volume_asks
  trades {
    is_anchor
    type
    order {
      id
      dollar_amount
      commission
    }
    trade_intent_status_matches_deal
    trade_intent {
      id
      status
    }
    ...MiniTradeList
  }
  owners {
    name
    ...OwnerAvatarOwnerView
  }
  issuer {
    id
    name
  }
}
    ${MiniTradeListFragmentDoc}
${OwnerAvatarOwnerViewFragmentDoc}`;
export const DealColumnContentFragmentDoc = gql`
    fragment DealColumnContent on DealView {
  id
  ...DealCard
}
    ${DealCardFragmentDoc}`;
export const DealColumnFragmentDoc = gql`
    fragment DealColumn on DealView {
  active_deal_status
  status_last_updated_at
  volume_bids
  volume_asks
  probability_to_close
  trades {
    is_anchor
    type
    order {
      dollar_amount
      commission
    }
  }
  ...DealColumnContent
}
    ${DealColumnContentFragmentDoc}`;
export const OwnerMultiSelectFragmentDoc = gql`
    fragment OwnerMultiSelect on OwnerView {
  id: owner_id
  name
  first_name
  last_name
}
    `;
export const DealDetailsSidebarFragmentDoc = gql`
    fragment DealDetailsSidebar on DealView {
  id
  active_deal_status
  status_last_updated_at
  date_created
  probability_to_close
  trades {
    type
  }
  owners {
    id: owner_id
    ...OwnerMultiSelect
  }
}
    ${OwnerMultiSelectFragmentDoc}`;
export const DocumentsSidebarFragmentDoc = gql`
    fragment DocumentsSidebar on DealView {
  id
  trades {
    type
  }
  templates {
    id
    name
    tag_id
    file {
      id
      filename
    }
  }
}
    `;
export const DealSidebarFragmentDoc = gql`
    fragment DealSidebar on DealView {
  id
  ...DealDetailsSidebar
  ...DocumentsSidebar
}
    ${DealDetailsSidebarFragmentDoc}
${DocumentsSidebarFragmentDoc}`;
export const OwnerAvatarUserViewFragmentDoc = gql`
    fragment OwnerAvatarUserView on UserView {
  id
  name
  first_name
  last_name
}
    `;
export const TradeCardFragmentDoc = gql`
    fragment TradeCard on DealTradeView {
  is_anchor
  trade_intent_status_matches_deal
  order {
    id
    status
    dollar_amount
    share_price
    num_shares
    commission
    transaction_fee
    is_modifiable
    company {
      id
      name
    }
    owners {
      id
      ...OwnerAvatarUserView
    }
    entity {
      id
      name
      type
    }
  }
  trade_intent {
    id
    status
    owners {
      ...OwnerAvatarOwnerView
    }
  }
  account {
    id
    name
    owners {
      ...OwnerAvatarOwnerView
    }
  }
}
    ${OwnerAvatarUserViewFragmentDoc}
${OwnerAvatarOwnerViewFragmentDoc}`;
export const TradeListDealTradeViewFragmentDoc = gql`
    fragment TradeListDealTradeView on DealTradeView {
  is_anchor
  order {
    id
  }
  ...TradeCard
}
    ${TradeCardFragmentDoc}`;
export const DealDetailsColumnDealTradeFragmentDoc = gql`
    fragment DealDetailsColumnDealTrade on DealTradeView {
  type
  ...TradeListDealTradeView
}
    ${TradeListDealTradeViewFragmentDoc}`;
export const DealDetailsFragmentDoc = gql`
    fragment DealDetails on DealView {
  id
  volume_bids
  volume_asks
  company_id
  probability_to_close
  issuer {
    id
    name
  }
  trades {
    is_anchor
    type
    order {
      dollar_amount
      share_price
      commission
      owners {
        id
      }
    }
    trade_intent {
      id
      owners {
        id: owner_id
      }
    }
    ...DealDetailsColumnDealTrade
  }
}
    ${DealDetailsColumnDealTradeFragmentDoc}`;
export const OrderDetailsPanelOrderViewFragmentDoc = gql`
    fragment OrderDetailsPanelOrderView on OrderView {
  id
  type
  status
  is_modifiable
  share_price
  num_shares
  dollar_amount
  commission
  transaction_fee
  entity {
    id
    type
    name
  }
  company {
    id
    name
  }
  owners {
    id
    ...OwnerAvatarUserView
  }
  broker_of_record {
    broker_entity_id
    name
    informal_name
  }
}
    ${OwnerAvatarUserViewFragmentDoc}`;
export const TradeIntentDetailsPanelTradeIntentViewFragmentDoc = gql`
    fragment TradeIntentDetailsPanelTradeIntentView on TradeIntentView {
  id
  type
  status
  size_type
  pricing_type
  fee
  share_price
  valuation
  min_dollar_amount
  max_dollar_amount
  min_num_shares
  max_num_shares
  share_price_recorded_as
  renewed_at
  last_refreshed_at
  company {
    id
    name
    last_round_estimated_number_of_shares
  }
  owners {
    id: owner_id
    ...OwnerAvatarOwnerView
  }
}
    ${OwnerAvatarOwnerViewFragmentDoc}`;
export const TradeIntentDetailsPanelAccountViewFragmentDoc = gql`
    fragment TradeIntentDetailsPanelAccountView on AccountView {
  id
  name
}
    `;
export const TradeDetailsDealTradeViewFragmentDoc = gql`
    fragment TradeDetailsDealTradeView on DealTradeView {
  is_anchor
  order {
    id
    type
    dollar_amount
    bank_account {
      id
    }
    company {
      name
    }
    entity {
      id
    }
    ...OrderDetailsPanelOrderView
  }
  trade_intent {
    id
    ...TradeIntentDetailsPanelTradeIntentView
  }
  account {
    id
    name
    ...TradeIntentDetailsPanelAccountView
  }
}
    ${OrderDetailsPanelOrderViewFragmentDoc}
${TradeIntentDetailsPanelTradeIntentViewFragmentDoc}
${TradeIntentDetailsPanelAccountViewFragmentDoc}`;
export const OrderDetailsPanelDealViewFragmentDoc = gql`
    fragment OrderDetailsPanelDealView on DealView {
  id
  probability_to_close
}
    `;
export const TradeDetailsDealViewFragmentDoc = gql`
    fragment TradeDetailsDealView on DealView {
  id
  ...OrderDetailsPanelDealView
}
    ${OrderDetailsPanelDealViewFragmentDoc}`;
export const TradeDetailsWrapperFragmentDoc = gql`
    fragment TradeDetailsWrapper on DealView {
  id
  trades {
    order {
      id
      type
      dollar_amount
    }
    account {
      id
      name
    }
    ...TradeDetailsDealTradeView
  }
  ...TradeDetailsDealView
}
    ${TradeDetailsDealTradeViewFragmentDoc}
${TradeDetailsDealViewFragmentDoc}`;
export const DealDetailsWrapperFragmentDoc = gql`
    fragment DealDetailsWrapper on DealView {
  id
  volume_bids
  volume_asks
  issuer {
    id
    name
  }
  trades {
    is_anchor
    type
  }
  ...DealSidebar
  ...DealDetails
  ...TradeDetailsWrapper
}
    ${DealSidebarFragmentDoc}
${DealDetailsFragmentDoc}
${TradeDetailsWrapperFragmentDoc}`;
export const TradeListDealViewFragmentDoc = gql`
    fragment TradeListDealView on DealView {
  id
  probability_to_close
}
    `;
export const DealDetailsColumnDealFragmentDoc = gql`
    fragment DealDetailsColumnDeal on DealView {
  id
  ...TradeListDealView
}
    ${TradeListDealViewFragmentDoc}`;
export const OwnerChipOwnerViewFragmentDoc = gql`
    fragment OwnerChipOwnerView on OwnerView {
  name
  ...OwnerAvatarOwnerView
}
    ${OwnerAvatarOwnerViewFragmentDoc}`;
export const TradeListSummaryOwnerViewFragmentDoc = gql`
    fragment TradeListSummaryOwnerView on OwnerView {
  ...OwnerChipOwnerView
}
    ${OwnerChipOwnerViewFragmentDoc}`;
export const DealDetailsColumnOwnerViewFragmentDoc = gql`
    fragment DealDetailsColumnOwnerView on OwnerView {
  ...TradeListSummaryOwnerView
}
    ${TradeListSummaryOwnerViewFragmentDoc}`;
export const OwnerChipUserViewFragmentDoc = gql`
    fragment OwnerChipUserView on UserView {
  name
  ...OwnerAvatarUserView
}
    ${OwnerAvatarUserViewFragmentDoc}`;
export const TradeListSummaryUserViewFragmentDoc = gql`
    fragment TradeListSummaryUserView on UserView {
  ...OwnerChipUserView
}
    ${OwnerChipUserViewFragmentDoc}`;
export const DealDetailsColumnUserViewFragmentDoc = gql`
    fragment DealDetailsColumnUserView on UserView {
  ...TradeListSummaryUserView
}
    ${TradeListSummaryUserViewFragmentDoc}`;
export const OrderDetailsPanelMoneyFieldsFragmentDoc = gql`
    fragment OrderDetailsPanelMoneyFields on OrderView {
  dollar_amount
  share_price
  num_shares
  commission
  transaction_fee
}
    `;
export const AccountLocationFragmentDoc = gql`
    fragment AccountLocation on DerivedLocationView {
  city
  state
  countryCode
  source
}
    `;
export const MinimalRelationshipAccountFragmentDoc = gql`
    fragment MinimalRelationshipAccount on AccountView {
  id
  name
  type
  email
  formatted_phone_number
  intermediary {
    id
  }
  issuer_account {
    id
    company {
      id
      logo_url
    }
  }
}
    `;
export const ParentOrChildRelationshipFragmentDoc = gql`
    fragment ParentOrChildRelationship on AccountRelationshipView {
  id
  title
  start_date
  parent_to_child_relationship
  is_point_of_contact
  parent_account {
    ...MinimalRelationshipAccount
  }
  child_account {
    ...MinimalRelationshipAccount
  }
}
    ${MinimalRelationshipAccountFragmentDoc}`;
export const ChildRelationshipFragmentDoc = gql`
    fragment ChildRelationship on AccountRelationshipView {
  id
  title
  start_date
  parent_to_child_relationship
  is_point_of_contact
  child_account {
    ...MinimalRelationshipAccount
  }
}
    ${MinimalRelationshipAccountFragmentDoc}`;
export const AccountsTableFragmentDoc = gql`
    fragment AccountsTable on AccountView {
  id
  name
  is_investor
  is_shareholder
  type
  client_type
  email
  phone_number
  formatted_phone_number
  do_not_contact_reasons
  transacted_as
  participates_in_secondaries
  has_done_primaries_before
  net_worth
  aum
  aum_secondaries
  derived_location {
    ...AccountLocation
  }
  region
  avg_order_size
  last_order_created_date
  last_order_closed_date
  num_active_deals
  num_closed_deals
  num_introductions
  order_structures
  account_level
  business_development_tier
  intermediary {
    ...ParentOrChildRelationship
  }
  relationships {
    ...ChildRelationship
  }
  purchased_companies {
    id
    name
  }
  companies_of_interest {
    id
    name
  }
  investor_preferences {
    id
    target_check_size
    investment_structure_comfort
    sectors_interested
    minimum_company_valuation
    minimum_company_revenue
    minimum_growth_rate
    only_profitable_companies
    opportunities_of_interest
    target_regions
    target_check_size
    has_cash_on_hand
  }
  holdings {
    id
    company {
      id
      name
    }
  }
  owners {
    id
    admin_id
    first_name
    last_name
    ranking
  }
}
    ${AccountLocationFragmentDoc}
${ParentOrChildRelationshipFragmentDoc}
${ChildRelationshipFragmentDoc}`;
export const InteractionDataFragmentDoc = gql`
    fragment InteractionData on InteractionView {
  id
  type
  tagged_value
  notes
  recorder {
    id
    first_name
    last_name
  }
  created_at
  rollup_to_account {
    id
    name
  }
  rollup_from_account {
    id
    name
  }
  source {
    ... on AccountSource {
      account {
        id
        name
        type
      }
    }
    ... on OpportunitySource {
      opportunity {
        id
        trade_intent {
          id
          type
          dollar_amount
        }
        company {
          id
          name
        }
      }
    }
  }
  front_message_group {
    id
    subject
    content
    has_attachments
    is_inbound
    front_created_at
    front_message {
      id
      front_msg_id
      front_conversation_id
    }
    message_contacts {
      id
      role
      email
      account {
        id
        name
      }
    }
  }
}
    `;
export const InteractionWithRollupsDataFragmentDoc = gql`
    fragment InteractionWithRollupsData on InteractionView {
  ...InteractionData
  rolled_up_from_child_accounts(accountId: $id) {
    id
    name
  }
  rolled_up_to_parent_accounts(accountId: $id) {
    id
    name
  }
}
    ${InteractionDataFragmentDoc}`;
export const RelatedAccountFragmentDoc = gql`
    fragment RelatedAccount on AccountView {
  id
  name
  first_name
  last_name
  country
  state
  city
  contact_methods {
    id
    channel
    is_primary
    channel_value
  }
  owners {
    id
    name
    admin_id
  }
  relationship_strength
  relationship_sensitivity
  relationship_notes
  has_influence_with {
    id
    company_id
    company_name
  }
  notes
}
    `;
export const AccountRelationshipDataFragmentDoc = gql`
    fragment AccountRelationshipData on AccountRelationshipView {
  id
  child_ranking
  parent_account_id
  child_account_id
  is_point_of_contact
  title
  child_account {
    ...RelatedAccount
  }
  parent_account {
    ...RelatedAccount
  }
}
    ${RelatedAccountFragmentDoc}`;
export const AccountWithTypeFragmentDoc = gql`
    fragment AccountWithType on AccountView {
  id
  name
  type
  email
  client_type
}
    `;
export const TransactionSummaryFragmentDoc = gql`
    fragment TransactionSummary on TransactionSummaryView {
  company_id
  trade_asset_types
  avg_trade_share_price
  avg_trade_amount
  total_trade_volume
  total_trades
  latest_trade_date
}
    `;
export const OwnerFragmentDoc = gql`
    fragment Owner on OwnerView {
  id
  name
  first_name
  last_name
  owner_group
  owner_id
  user {
    id
    profile_picture
  }
}
    `;
export const IssuerFragmentDoc = gql`
    fragment Issuer on AccountView {
  id
  name
  type
  client_type_id
  state
  country
  city
  notes
  issuer_account {
    id
    company {
      id
      name
      domain
      logo_url
    }
    has_transacted
    is_actionable
    forge_on_cap_table
    sensitivity
    sensitivity_notes
    company_id
  }
  owners {
    ...Owner
  }
}
    ${OwnerFragmentDoc}`;
export const IssuerDealFragmentDoc = gql`
    fragment issuerDeal on IssuerDeal {
  id
  issuerId
  totalVolume
  dateClosed
  netRevenue
  totalShares
  averageTakeRate
  grossPricePerShare
  numParticipants
}
    `;
export const LinkedinJobFragmentDoc = gql`
    fragment LinkedinJob on LinkedinJobView {
  employment_name
  employment_title
  employment_domain
  employment_role
}
    `;
export const AccountHeaderFragmentDoc = gql`
    fragment AccountHeader on AccountView {
  id
  name
  type
  email
  client_type
  client_type_id
  derived_location {
    ...AccountLocation
  }
  is_investor
  is_shareholder
  has_done_primaries_before
  is_account_of_interest
  account_of_interest_reason
  account_of_interest_set_by_admin {
    id
    name
  }
  is_forge_declined
  forge_declined_reason
  forge_declined_set_by_admin {
    id
    name
  }
  account_level
  last_outreach_by_anyone
  last_outreach_by_anyone_admin {
    id
    first_name
    last_name
  }
  last_order_closed_date
  linkedin_job {
    ...LinkedinJob
  }
  introducedByRelationships {
    id
    introduction {
      parent_broker_account {
        id
        name
      }
    }
    parent_account {
      id
      name
    }
  }
}
    ${AccountLocationFragmentDoc}
${LinkedinJobFragmentDoc}`;
export const AccountDealFragmentDoc = gql`
    fragment AccountDeal on AccountDealView {
  orderType
  isClosed
  dateFullyAccrued
  totalSellSideVolume
  totalSellSideRevenue
  totalBuySideVolume
  totalBuySideRevenue
  company {
    id
    name
  }
}
    `;
export const ClientDetailsFragmentDoc = gql`
    fragment ClientDetails on AccountView {
  id
  name
  relationship_notes
  relationship_strength
  relationship_sensitivity
  notes
  last_outreach_at
  business_development_tier
  outreach_schedule
  owners {
    ...Owner
  }
  has_influence_with {
    id
    company_id
    company_name
  }
  deals(onlyClosed: true) {
    ...AccountDeal
  }
}
    ${OwnerFragmentDoc}
${AccountDealFragmentDoc}`;
export const InvestorDetailsFragmentDoc = gql`
    fragment InvestorDetails on AccountView {
  id
  type
  aum
  aum_secondaries
  net_worth
  investor_notes
  investor_preferences {
    id
    target_regions
    target_check_size
    investment_structure_comfort
    sectors_interested
    sectors_avoid
    minimum_company_valuation
    minimum_company_revenue
    minimum_growth_rate
    only_profitable_companies
    has_cash_on_hand
    opportunities_of_interest
    company_stages
  }
}
    `;
export const ShareholderDetailsFragmentDoc = gql`
    fragment ShareholderDetails on AccountView {
  id
  shareholder_notes
  participates_in_secondaries
}
    `;
export const IntroductionFragmentDoc = gql`
    fragment Introduction on AccountRelationshipView {
  introduction {
    parent_broker_account {
      ...MinimalRelationshipAccount
    }
    child_broker_account {
      ...MinimalRelationshipAccount
    }
  }
}
    ${MinimalRelationshipAccountFragmentDoc}`;
export const ParentRelationshipFragmentDoc = gql`
    fragment ParentRelationship on AccountRelationshipView {
  id
  title
  start_date
  parent_to_child_relationship
  parent_account {
    ...MinimalRelationshipAccount
  }
}
    ${MinimalRelationshipAccountFragmentDoc}`;
export const AccountContactPrefsFragmentDoc = gql`
    fragment AccountContactPrefs on AccountView {
  id
  name
  type
  do_not_contact_reasons
  owners {
    ...Owner
  }
  intermediary {
    ...ParentOrChildRelationship
    ...Introduction
  }
  relationships {
    ...ChildRelationship
  }
  parents {
    ...ParentRelationship
  }
}
    ${OwnerFragmentDoc}
${ParentOrChildRelationshipFragmentDoc}
${IntroductionFragmentDoc}
${ChildRelationshipFragmentDoc}
${ParentRelationshipFragmentDoc}`;
export const ContactMethodFragmentDoc = gql`
    fragment ContactMethod on ContactMethodView {
  id
  channel
  is_primary
  channel_value
  formatted_channel_value
  account_id
  email_preferences {
    opt_in_newsletter_emails
    opt_in_opportunity_emails
    opt_in_general_marketing_emails
  }
}
    `;
export const AccountWithRelationshipsAndContactMethodsFragmentDoc = gql`
    fragment AccountWithRelationshipsAndContactMethods on AccountView {
  id
  name
  type
  intermediary {
    ...ParentOrChildRelationship
    ...Introduction
  }
  relationships {
    ...ChildRelationship
  }
  contact_methods {
    ...ContactMethod
  }
}
    ${ParentOrChildRelationshipFragmentDoc}
${IntroductionFragmentDoc}
${ChildRelationshipFragmentDoc}
${ContactMethodFragmentDoc}`;
export const FileFragmentDoc = gql`
    fragment File on FileView {
  id
  filename
  serial
  date_created
  url
  tags {
    id
    tag
  }
}
    `;
export const AccountCardFragmentDoc = gql`
    fragment AccountCard on AccountView {
  id
  name
  account_level
  is_account_of_interest
  owners {
    id
    name
  }
  opportunities {
    id
  }
  last_outreach_by_anyone
  outreach_schedule
  interactions {
    id
  }
}
    `;
export const IssuerPlatformSettingsFragmentDoc = gql`
    fragment IssuerPlatformSettings on CompanyView {
  id
  featured
  is_available
  show_pricing_data
  default_share_price_investor
  default_share_price_shareholder
  weight
  min_transaction_size_investor
  share_price_variance
}
    `;
export const IssuerOwnersFragmentDoc = gql`
    fragment IssuerOwners on AccountView {
  id
  relationship_notes
  relationship_strength
  relationship_sensitivity
  marketplace_notes
  partnerships_relationship_strength
  partnerships_relationship_sensitivity
  partnerships_relationship_notes
  partnerships_notes
  owners {
    ...Owner
  }
}
    ${OwnerFragmentDoc}`;
export const PricedIssuerFragmentDoc = gql`
    fragment PricedIssuer on AccountView {
  id
  name
  owners {
    id
    name
    owner_id
  }
  issuer_account {
    id
    company {
      id
      logo_url
      featured
      weight
      min_transaction_size_investor
      default_share_price_investor
      default_share_price_shareholder
      show_pricing_data
      share_price_variance
      is_available
    }
  }
}
    `;
export const IssuerHeaderFragmentDoc = gql`
    fragment IssuerHeader on AccountView {
  id
  name
  country
  state
  city
  notes
  issuer_account {
    id
    is_actionable
    company {
      id
      logo_url
      last_round {
        id
        round_date
        valuation
      }
    }
  }
}
    `;
export const OrderBookCompanyFragmentDoc = gql`
    fragment orderBookCompany on CompanyView {
  id
  name
  logo_url
  last_round {
    id
    valuation
    round_date
  }
  bid_ask_summary {
    bid_volume
    bid_structures
    bid_actionable
    ask_volume
    ask_structures
    ask_actionable
  }
}
    `;
export const OrderBookOpportunityFragmentDoc = gql`
    fragment OrderBookOpportunity on OpportunityView {
  id
  status
  type
  trade_intent {
    dollar_amount
    share_price
    acceptable_structures
    date_created
    date_updated
  }
  account {
    id
    name
    email
  }
  owners {
    id
    name
    user {
      id
      profile_picture
    }
  }
}
    `;
export const OrderBookBlockFragmentDoc = gql`
    fragment OrderBookBlock on OrderBookBlockRead {
  volume
  price_bucket_low
  price_bucket_high
}
    `;
export const LastOrderInfoFragmentDoc = gql`
    fragment lastOrderInfo on OrderView {
  id
  share_price
  date_fully_accrued
  dollar_amount
}
    `;
export const OrderBookCompanyDetailsFragmentDoc = gql`
    fragment orderBookCompanyDetails on CompanyView {
  id
  order_book_bid_blocks(structures: $structures, qualifiedOnly: $qualifiedOnly) {
    ...OrderBookBlock
  }
  order_book_ask_blocks(structures: $structures, qualifiedOnly: $qualifiedOnly) {
    ...OrderBookBlock
  }
  active_asks_count(qualifiedOnly: $qualifiedOnly, structures: $structures)
  active_bids_count(qualifiedOnly: $qualifiedOnly, structures: $structures)
  total_bid_volume(qualifiedOnly: $qualifiedOnly, structures: $structures)
  total_ask_volume(qualifiedOnly: $qualifiedOnly, structures: $structures)
  last_buy_order {
    ...lastOrderInfo
  }
  crm_account {
    id
  }
}
    ${OrderBookBlockFragmentDoc}
${LastOrderInfoFragmentDoc}`;
export const CurrentAdminFragmentDoc = gql`
    fragment currentAdmin on UserView {
  id
  email
  first_name
  last_name
  name
  profile_picture
}
    `;
export const AccountResultFragmentDoc = gql`
    fragment AccountResult on AccountView {
  id
  type
  name
  first_name
  last_name
  client_type
  contact_methods {
    id
    channel
    is_primary
    channel_value
  }
  issuer_account {
    id
    company {
      id
      name
      domain
      legal_name
      logo_url
    }
  }
  parents {
    id
    parent_account {
      id
      name
    }
  }
}
    `;
export const GenericOfferingFragmentDoc = gql`
    fragment GenericOffering on OfferingView {
  id
  name
  offering_type
  num_available_shares
  min_shares_to_close
  starting_share_price
  dollar_amount_at_starting_price_gross
  dollar_amount_paid
  dollar_amount_fees_paid
  is_block_fully_committed
  total_listing_volume_gross
  available_from
  available_to
  status
  min_direct_size
  num_participants
  possible_structures
  dollar_amount_allocated_gross
  token
  company {
    id
    name
    logo_url
  }
}
    `;
export const OfferingFileFragmentDoc = gql`
    fragment OfferingFile on FileView {
  id
  url
  serial
  filename
  date_created
  tags {
    id
    tag
  }
}
    `;
export const SpecificOfferingFragmentDoc = gql`
    fragment SpecificOffering on OfferingView {
  id
  name
  offering_type
  num_available_shares
  num_shares_remaining
  min_shares_to_close
  starting_share_price
  est_num_company_shares
  block_type
  equifund_id
  dollar_amount_at_starting_price_gross
  dollar_amount_paid
  dollar_amount_fees_paid
  is_block_fully_committed
  total_listing_volume_gross
  available_from
  available_to
  status
  commission
  company_description
  min_listing_size
  min_direct_size
  min_listing_size
  equifund_id
  possible_structures
  num_participants
  num_invites_sent
  num_invites_clicked
  num_invites_opened
  num_ndas_signed
  num_bids_placed
  num_orders_signed
  num_payments_received
  dollar_amount_allocated_gross
  token
  auto_reminder_email_at
  auto_order_reminder_email_at
  auto_feedback_email_at
  previous_invitation_email_at
  previous_reminder_email_at
  previous_order_reminder_email_at
  previous_feedback_email_at
  valuation_type
  custom_disclaimer_updated_at
  custom_valuation_disclaimer
  custom_closing_timeline
  custom_contact_message
  custom_consideration
  custom_transaction_timeline
  custom_transaction_structure
  custom_fund_structure
  custom_offering_process
  custom_offering_process_details
  company {
    id
    name
    logo_url
    last_round {
      id
      round_date
      stage
      valuation
      est_num_shares
      price_per_share
    }
  }
  files {
    ...OfferingFile
  }
  primary_contacts {
    id
    first_name
    last_name
    name
  }
  custom_contact {
    id
    name
  }
}
    ${OfferingFileFragmentDoc}`;
export const OfferingDateDataFragmentDoc = gql`
    fragment OfferingDateData on OfferingView {
  id
  name
  available_from
  auto_reminder_email_at
}
    `;
export const BasicFundInfoFragmentDoc = gql`
    fragment BasicFundInfo on EquifundView {
  id
  name
  company_id
}
    `;
export const OfferingFilesFragmentDoc = gql`
    fragment OfferingFiles on OfferingView {
  id
  num_participants
  files {
    ...OfferingFile
  }
}
    ${OfferingFileFragmentDoc}`;
export const ParticipantFragmentDoc = gql`
    fragment Participant on OfferingParticipationView {
  id
  user {
    id
    name
    email
    crm_account {
      id
    }
  }
  status
}
    `;
export const OpportunityFragmentDoc = gql`
    fragment Opportunity on OpportunityView {
  id
  created_at
  updated_at
  expired_at
  account_id
  account {
    id
    name
    entities {
      id
      type
      name
    }
  }
  last_refreshed_at
  status
  source
  type
  certainty
  owners {
    id
    name
    first_name
    last_name
    owner_id
  }
  liquidity_event {
    id
  }
  pricing_type
  min_dollar_amount
  dollar_amount
  min_num_shares
  num_shares
  share_price
  valuation
  entity_id
  trade_intent {
    id
    fee
    type
    min_dollar_amount
    max_dollar_amount
    min_num_shares
    max_num_shares
    valuation
    share_price
    num_shares
    dollar_amount
    size_type
    pricing_type
    acceptable_structures
    share_price_recorded_as
    entity {
      id
      type
      name
    }
    creator {
      id
      first_name
      last_name
      name
    }
    holding {
      id
      cap_table_entry {
        id
      }
    }
    active_deals {
      id
      active_deal_status
      date_created
    }
  }
  company {
    id
    name
    last_round_estimated_number_of_shares
    crm_account {
      id
    }
  }
}
    `;
export const BidDetailFragmentDoc = gql`
    fragment BidDetail on TradeIntentView {
  id
  dollar_amount
  status
  is_loi_signed
  opportunity {
    ...Opportunity
  }
  order {
    id
    status
    client_signed
    entity {
      new_client_form_signed
      crm_account {
        id
        name
      }
    }
    wire_info_sent
    date_created
  }
}
    ${OpportunityFragmentDoc}`;
export const AccountDealOrderFragmentDoc = gql`
    fragment AccountDealOrder on AccountDealOrderView {
  companyId
  orderType
  isClosed
  dateFullyAccrued
  volume
  revenue
}
    `;
export const AccountHoldingFragmentDoc = gql`
    fragment AccountHolding on HoldingView {
  id
  type
  company {
    id
    name
    logo_url
    crm_account {
      id
    }
  }
  account {
    id
    name
    email
  }
  is_deleted
  share_dollar_amt_est
  estimated_num_shares
  confirmed_num_shares
  share_class
  current_value
}
    `;
export const OpportunityDetailsFragmentDoc = gql`
    fragment OpportunityDetails on OpportunityView {
  id
  certainty
  deal_blockers
  status
  expired_at
  company {
    id
    last_round_estimated_number_of_shares
  }
  trade_intent {
    id
    asset_type
    dollar_amount
    num_shares
    share_price
    certainty
    fee
    entity {
      id
      type
      name
    }
    has_time_constraints
    time_constraint_notes
    has_flexibility
    flexibility_notes
    additional_diligence_notes
    share_type_description
  }
  owners {
    ...Owner
  }
}
    ${OwnerFragmentDoc}`;
export const OpportunityDataFragmentDoc = gql`
    fragment OpportunityData on OpportunityView {
  id
  account_id
  notes
  status
  updated_at
  last_refreshed_at
  latest_activity
  trade_intent {
    id
    type
    acceptable_structures
    dollar_amount
    share_price
    status
    entity {
      id
      type
      name
    }
  }
  company {
    id
    name
  }
  owners {
    id
    first_name
    last_name
  }
  account {
    id
    name
  }
}
    `;
export const TableOpportunityDataFragmentDoc = gql`
    fragment TableOpportunityData on OpportunityView {
  id
  status
  updated_at
  trade_intent {
    id
    share_price
    dollar_amount
    entity {
      id
      type
      name
    }
    latest_price_change {
      id
      field_name
      user_name
      changed_at
      old_value
    }
  }
}
    `;
export const OpportunityStatusFragmentFragmentDoc = gql`
    fragment OpportunityStatusFragment on OpportunityView {
  id
  status
  expired_at
  latest_activity
  certainty
  company {
    id
    name
  }
  account {
    id
    name
  }
  owners {
    id
    owner_id
    first_name
    last_name
  }
}
    `;
export const TradeIntentFragmentFragmentDoc = gql`
    fragment TradeIntentFragment on TradeIntentView {
  id
  share_price
  share_type_description
  asset_type
  num_shares
  fee
  acceptable_structures
  dollar_amount
  additional_diligence_notes
  has_time_constraints
  time_constraint_notes
  has_flexibility
  flexibility_notes
  latest_price_change {
    id
    field_name
    user_name
    changed_at
    old_value
  }
}
    `;
export const EntityOptionFragmentDoc = gql`
    fragment EntityOption on EntityView {
  id
  name
  type
}
    `;
export const FundingRoundFragmentDoc = gql`
    fragment FundingRound on FundingRound {
  id
  round_date
  stage
  est_num_shares
  price_per_share
  valuation
}
    `;
export const SegmentQueryFragmentDoc = gql`
    fragment SegmentQuery on SegmentQueryView {
  id
  name
  last_run_at
  last_run_count
  last_changed_by {
    id
    name
  }
  last_changed_at
  query
  created_at
  created_by {
    id
    name
  }
}
    `;
export const TodoFragmentDoc = gql`
    fragment Todo on TodoItemView {
  id
  meta
  type
  live_at
  lifespan
  status
  completed_at
  priority
  finished_by {
    id
    first_name
    last_name
  }
  dismissed_at
}
    `;
export const ClaimAccountRollupFragmentDoc = gql`
    fragment ClaimAccountRollup on AccountView {
  id
  name
  account_level
  img
  email
  owners {
    id
    admin_id
    name
  }
  is_account_of_interest
  account_of_interest_reason
  account_of_interest_set_by_admin {
    id
    name
  }
  source
  created_at
  admin_created_by {
    id
    name
  }
}
    `;
export const AccountOutreachRollupFragmentDoc = gql`
    fragment AccountOutreachRollup on AccountView {
  id
  name
  account_level
  last_outreach_at
  outreach_schedule
  last_outreach_by {
    id
    first_name
    last_name
  }
  email
  formatted_phone_number
  img
  last_front_message_id
  is_account_of_interest
  account_of_interest_reason
  account_of_interest_set_by_admin {
    id
    name
  }
}
    `;
export const AddOpportunityPanel_AddDocument = gql`
    mutation AddOpportunityPanel_Add($dealId: Int!, $tradeIntentId: UUID!) {
  addTradeIntentToDeal(dealId: $dealId, tradeIntentId: $tradeIntentId) {
    id
    ...DealDetailsWrapper
  }
}
    ${DealDetailsWrapperFragmentDoc}`;
export type AddOpportunityPanel_AddMutationFn = ApolloReactCommon.MutationFunction<AddOpportunityPanel_AddMutation, AddOpportunityPanel_AddMutationVariables>;
export type AddOpportunityPanel_AddComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddOpportunityPanel_AddMutation, AddOpportunityPanel_AddMutationVariables>, 'mutation'>;

    export const AddOpportunityPanel_AddComponent = (props: AddOpportunityPanel_AddComponentProps) => (
      <ApolloReactComponents.Mutation<AddOpportunityPanel_AddMutation, AddOpportunityPanel_AddMutationVariables> mutation={AddOpportunityPanel_AddDocument} {...props} />
    );
    
export type AddOpportunityPanel_AddProps<TChildProps = {}> = ApolloReactHoc.MutateProps<AddOpportunityPanel_AddMutation, AddOpportunityPanel_AddMutationVariables> & TChildProps;
export function withAddOpportunityPanel_Add<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddOpportunityPanel_AddMutation,
  AddOpportunityPanel_AddMutationVariables,
  AddOpportunityPanel_AddProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, AddOpportunityPanel_AddMutation, AddOpportunityPanel_AddMutationVariables, AddOpportunityPanel_AddProps<TChildProps>>(AddOpportunityPanel_AddDocument, {
      alias: 'addOpportunityPanelAdd',
      ...operationOptions
    });
};

/**
 * __useAddOpportunityPanel_AddMutation__
 *
 * To run a mutation, you first call `useAddOpportunityPanel_AddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOpportunityPanel_AddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOpportunityPanelAddMutation, { data, loading, error }] = useAddOpportunityPanel_AddMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      tradeIntentId: // value for 'tradeIntentId'
 *   },
 * });
 */
export function useAddOpportunityPanel_AddMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddOpportunityPanel_AddMutation, AddOpportunityPanel_AddMutationVariables>) {
        return ApolloReactHooks.useMutation<AddOpportunityPanel_AddMutation, AddOpportunityPanel_AddMutationVariables>(AddOpportunityPanel_AddDocument, baseOptions);
      }
export type AddOpportunityPanel_AddMutationHookResult = ReturnType<typeof useAddOpportunityPanel_AddMutation>;
export type AddOpportunityPanel_AddMutationResult = ApolloReactCommon.MutationResult<AddOpportunityPanel_AddMutation>;
export type AddOpportunityPanel_AddMutationOptions = ApolloReactCommon.BaseMutationOptions<AddOpportunityPanel_AddMutation, AddOpportunityPanel_AddMutationVariables>;
export const AddOpportunityPanel_OpportunitiesDocument = gql`
    query AddOpportunityPanel_Opportunities($companyId: Int, $limit: Int = 10000, $offset: Int = 0) {
  opportunities(limit: $limit, offset: $offset, filter: {companyId: $companyId, status: "pre_pipeline", expired: false}) {
    data {
      ...AddOpportunityPanel_OpportunityView
    }
  }
}
    ${AddOpportunityPanel_OpportunityViewFragmentDoc}`;
export type AddOpportunityPanel_OpportunitiesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AddOpportunityPanel_OpportunitiesQuery, AddOpportunityPanel_OpportunitiesQueryVariables>, 'query'>;

    export const AddOpportunityPanel_OpportunitiesComponent = (props: AddOpportunityPanel_OpportunitiesComponentProps) => (
      <ApolloReactComponents.Query<AddOpportunityPanel_OpportunitiesQuery, AddOpportunityPanel_OpportunitiesQueryVariables> query={AddOpportunityPanel_OpportunitiesDocument} {...props} />
    );
    
export type AddOpportunityPanel_OpportunitiesProps<TChildProps = {}> = ApolloReactHoc.DataProps<AddOpportunityPanel_OpportunitiesQuery, AddOpportunityPanel_OpportunitiesQueryVariables> & TChildProps;
export function withAddOpportunityPanel_Opportunities<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddOpportunityPanel_OpportunitiesQuery,
  AddOpportunityPanel_OpportunitiesQueryVariables,
  AddOpportunityPanel_OpportunitiesProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AddOpportunityPanel_OpportunitiesQuery, AddOpportunityPanel_OpportunitiesQueryVariables, AddOpportunityPanel_OpportunitiesProps<TChildProps>>(AddOpportunityPanel_OpportunitiesDocument, {
      alias: 'addOpportunityPanelOpportunities',
      ...operationOptions
    });
};

/**
 * __useAddOpportunityPanel_OpportunitiesQuery__
 *
 * To run a query within a React component, call `useAddOpportunityPanel_OpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddOpportunityPanel_OpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddOpportunityPanel_OpportunitiesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAddOpportunityPanel_OpportunitiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AddOpportunityPanel_OpportunitiesQuery, AddOpportunityPanel_OpportunitiesQueryVariables>) {
        return ApolloReactHooks.useQuery<AddOpportunityPanel_OpportunitiesQuery, AddOpportunityPanel_OpportunitiesQueryVariables>(AddOpportunityPanel_OpportunitiesDocument, baseOptions);
      }
export function useAddOpportunityPanel_OpportunitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddOpportunityPanel_OpportunitiesQuery, AddOpportunityPanel_OpportunitiesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AddOpportunityPanel_OpportunitiesQuery, AddOpportunityPanel_OpportunitiesQueryVariables>(AddOpportunityPanel_OpportunitiesDocument, baseOptions);
        }
export type AddOpportunityPanel_OpportunitiesQueryHookResult = ReturnType<typeof useAddOpportunityPanel_OpportunitiesQuery>;
export type AddOpportunityPanel_OpportunitiesLazyQueryHookResult = ReturnType<typeof useAddOpportunityPanel_OpportunitiesLazyQuery>;
export type AddOpportunityPanel_OpportunitiesQueryResult = ApolloReactCommon.QueryResult<AddOpportunityPanel_OpportunitiesQuery, AddOpportunityPanel_OpportunitiesQueryVariables>;
export const BrokerProfilesDocument = gql`
    query BrokerProfiles($offset: Int!, $limit: Int!) {
  allBrokersProfiles(offset: $offset, limit: $limit) {
    data {
      broker_entity_id
      informal_name
      name
    }
  }
}
    `;
export type BrokerProfilesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BrokerProfilesQuery, BrokerProfilesQueryVariables>, 'query'> & ({ variables: BrokerProfilesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BrokerProfilesComponent = (props: BrokerProfilesComponentProps) => (
      <ApolloReactComponents.Query<BrokerProfilesQuery, BrokerProfilesQueryVariables> query={BrokerProfilesDocument} {...props} />
    );
    
export type BrokerProfilesProps<TChildProps = {}> = ApolloReactHoc.DataProps<BrokerProfilesQuery, BrokerProfilesQueryVariables> & TChildProps;
export function withBrokerProfiles<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BrokerProfilesQuery,
  BrokerProfilesQueryVariables,
  BrokerProfilesProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, BrokerProfilesQuery, BrokerProfilesQueryVariables, BrokerProfilesProps<TChildProps>>(BrokerProfilesDocument, {
      alias: 'brokerProfiles',
      ...operationOptions
    });
};

/**
 * __useBrokerProfilesQuery__
 *
 * To run a query within a React component, call `useBrokerProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrokerProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrokerProfilesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBrokerProfilesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BrokerProfilesQuery, BrokerProfilesQueryVariables>) {
        return ApolloReactHooks.useQuery<BrokerProfilesQuery, BrokerProfilesQueryVariables>(BrokerProfilesDocument, baseOptions);
      }
export function useBrokerProfilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BrokerProfilesQuery, BrokerProfilesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BrokerProfilesQuery, BrokerProfilesQueryVariables>(BrokerProfilesDocument, baseOptions);
        }
export type BrokerProfilesQueryHookResult = ReturnType<typeof useBrokerProfilesQuery>;
export type BrokerProfilesLazyQueryHookResult = ReturnType<typeof useBrokerProfilesLazyQuery>;
export type BrokerProfilesQueryResult = ApolloReactCommon.QueryResult<BrokerProfilesQuery, BrokerProfilesQueryVariables>;
export const BrokerOfRecordDropdownDocument = gql`
    mutation BrokerOfRecordDropdown($orderId: Int!, $entityId: Int!) {
  setOrderBrokerOfRecord(orderId: $orderId, entityId: $entityId) {
    id
    broker_of_record {
      broker_entity_id
      informal_name
      name
    }
  }
}
    `;
export type BrokerOfRecordDropdownMutationFn = ApolloReactCommon.MutationFunction<BrokerOfRecordDropdownMutation, BrokerOfRecordDropdownMutationVariables>;
export type BrokerOfRecordDropdownComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<BrokerOfRecordDropdownMutation, BrokerOfRecordDropdownMutationVariables>, 'mutation'>;

    export const BrokerOfRecordDropdownComponent = (props: BrokerOfRecordDropdownComponentProps) => (
      <ApolloReactComponents.Mutation<BrokerOfRecordDropdownMutation, BrokerOfRecordDropdownMutationVariables> mutation={BrokerOfRecordDropdownDocument} {...props} />
    );
    
export type BrokerOfRecordDropdownProps<TChildProps = {}> = ApolloReactHoc.MutateProps<BrokerOfRecordDropdownMutation, BrokerOfRecordDropdownMutationVariables> & TChildProps;
export function withBrokerOfRecordDropdown<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BrokerOfRecordDropdownMutation,
  BrokerOfRecordDropdownMutationVariables,
  BrokerOfRecordDropdownProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, BrokerOfRecordDropdownMutation, BrokerOfRecordDropdownMutationVariables, BrokerOfRecordDropdownProps<TChildProps>>(BrokerOfRecordDropdownDocument, {
      alias: 'brokerOfRecordDropdown',
      ...operationOptions
    });
};

/**
 * __useBrokerOfRecordDropdownMutation__
 *
 * To run a mutation, you first call `useBrokerOfRecordDropdownMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrokerOfRecordDropdownMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brokerOfRecordDropdownMutation, { data, loading, error }] = useBrokerOfRecordDropdownMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useBrokerOfRecordDropdownMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BrokerOfRecordDropdownMutation, BrokerOfRecordDropdownMutationVariables>) {
        return ApolloReactHooks.useMutation<BrokerOfRecordDropdownMutation, BrokerOfRecordDropdownMutationVariables>(BrokerOfRecordDropdownDocument, baseOptions);
      }
export type BrokerOfRecordDropdownMutationHookResult = ReturnType<typeof useBrokerOfRecordDropdownMutation>;
export type BrokerOfRecordDropdownMutationResult = ApolloReactCommon.MutationResult<BrokerOfRecordDropdownMutation>;
export type BrokerOfRecordDropdownMutationOptions = ApolloReactCommon.BaseMutationOptions<BrokerOfRecordDropdownMutation, BrokerOfRecordDropdownMutationVariables>;
export const RemoveTradeFromDealDocument = gql`
    mutation RemoveTradeFromDeal($dealId: Int!, $orderId: Int!) {
  removeTradeFromDeal(dealId: $dealId, orderId: $orderId) {
    id
    ...DealDetailsWrapper
  }
}
    ${DealDetailsWrapperFragmentDoc}`;
export type RemoveTradeFromDealMutationFn = ApolloReactCommon.MutationFunction<RemoveTradeFromDealMutation, RemoveTradeFromDealMutationVariables>;
export type RemoveTradeFromDealComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RemoveTradeFromDealMutation, RemoveTradeFromDealMutationVariables>, 'mutation'>;

    export const RemoveTradeFromDealComponent = (props: RemoveTradeFromDealComponentProps) => (
      <ApolloReactComponents.Mutation<RemoveTradeFromDealMutation, RemoveTradeFromDealMutationVariables> mutation={RemoveTradeFromDealDocument} {...props} />
    );
    
export type RemoveTradeFromDealProps<TChildProps = {}> = ApolloReactHoc.MutateProps<RemoveTradeFromDealMutation, RemoveTradeFromDealMutationVariables> & TChildProps;
export function withRemoveTradeFromDeal<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveTradeFromDealMutation,
  RemoveTradeFromDealMutationVariables,
  RemoveTradeFromDealProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveTradeFromDealMutation, RemoveTradeFromDealMutationVariables, RemoveTradeFromDealProps<TChildProps>>(RemoveTradeFromDealDocument, {
      alias: 'removeTradeFromDeal',
      ...operationOptions
    });
};

/**
 * __useRemoveTradeFromDealMutation__
 *
 * To run a mutation, you first call `useRemoveTradeFromDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTradeFromDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTradeFromDealMutation, { data, loading, error }] = useRemoveTradeFromDealMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useRemoveTradeFromDealMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveTradeFromDealMutation, RemoveTradeFromDealMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveTradeFromDealMutation, RemoveTradeFromDealMutationVariables>(RemoveTradeFromDealDocument, baseOptions);
      }
export type RemoveTradeFromDealMutationHookResult = ReturnType<typeof useRemoveTradeFromDealMutation>;
export type RemoveTradeFromDealMutationResult = ApolloReactCommon.MutationResult<RemoveTradeFromDealMutation>;
export type RemoveTradeFromDealMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveTradeFromDealMutation, RemoveTradeFromDealMutationVariables>;
export const CreateOpportunityPanelDocument = gql`
    mutation CreateOpportunityPanel($form: DealTradeFormInput!) {
  createDealTrade(form: $form) {
    id
    ...DealDetailsWrapper
  }
}
    ${DealDetailsWrapperFragmentDoc}`;
export type CreateOpportunityPanelMutationFn = ApolloReactCommon.MutationFunction<CreateOpportunityPanelMutation, CreateOpportunityPanelMutationVariables>;
export type CreateOpportunityPanelComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateOpportunityPanelMutation, CreateOpportunityPanelMutationVariables>, 'mutation'>;

    export const CreateOpportunityPanelComponent = (props: CreateOpportunityPanelComponentProps) => (
      <ApolloReactComponents.Mutation<CreateOpportunityPanelMutation, CreateOpportunityPanelMutationVariables> mutation={CreateOpportunityPanelDocument} {...props} />
    );
    
export type CreateOpportunityPanelProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CreateOpportunityPanelMutation, CreateOpportunityPanelMutationVariables> & TChildProps;
export function withCreateOpportunityPanel<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateOpportunityPanelMutation,
  CreateOpportunityPanelMutationVariables,
  CreateOpportunityPanelProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CreateOpportunityPanelMutation, CreateOpportunityPanelMutationVariables, CreateOpportunityPanelProps<TChildProps>>(CreateOpportunityPanelDocument, {
      alias: 'createOpportunityPanel',
      ...operationOptions
    });
};

/**
 * __useCreateOpportunityPanelMutation__
 *
 * To run a mutation, you first call `useCreateOpportunityPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOpportunityPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOpportunityPanelMutation, { data, loading, error }] = useCreateOpportunityPanelMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useCreateOpportunityPanelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOpportunityPanelMutation, CreateOpportunityPanelMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateOpportunityPanelMutation, CreateOpportunityPanelMutationVariables>(CreateOpportunityPanelDocument, baseOptions);
      }
export type CreateOpportunityPanelMutationHookResult = ReturnType<typeof useCreateOpportunityPanelMutation>;
export type CreateOpportunityPanelMutationResult = ApolloReactCommon.MutationResult<CreateOpportunityPanelMutation>;
export type CreateOpportunityPanelMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOpportunityPanelMutation, CreateOpportunityPanelMutationVariables>;
export const DealBoardDocument = gql`
    query DealBoard {
  activeDeals: allActiveDeals {
    id
    trades {
      is_anchor
      order {
        dollar_amount
        commission
      }
    }
    probability_to_close
    ...DealColumn
    ...DealDetailsWrapper
  }
}
    ${DealColumnFragmentDoc}
${DealDetailsWrapperFragmentDoc}`;
export type DealBoardComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DealBoardQuery, DealBoardQueryVariables>, 'query'>;

    export const DealBoardComponent = (props: DealBoardComponentProps) => (
      <ApolloReactComponents.Query<DealBoardQuery, DealBoardQueryVariables> query={DealBoardDocument} {...props} />
    );
    
export type DealBoardProps<TChildProps = {}> = ApolloReactHoc.DataProps<DealBoardQuery, DealBoardQueryVariables> & TChildProps;
export function withDealBoard<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DealBoardQuery,
  DealBoardQueryVariables,
  DealBoardProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, DealBoardQuery, DealBoardQueryVariables, DealBoardProps<TChildProps>>(DealBoardDocument, {
      alias: 'dealBoard',
      ...operationOptions
    });
};

/**
 * __useDealBoardQuery__
 *
 * To run a query within a React component, call `useDealBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealBoardQuery({
 *   variables: {
 *   },
 * });
 */
export function useDealBoardQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DealBoardQuery, DealBoardQueryVariables>) {
        return ApolloReactHooks.useQuery<DealBoardQuery, DealBoardQueryVariables>(DealBoardDocument, baseOptions);
      }
export function useDealBoardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DealBoardQuery, DealBoardQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DealBoardQuery, DealBoardQueryVariables>(DealBoardDocument, baseOptions);
        }
export type DealBoardQueryHookResult = ReturnType<typeof useDealBoardQuery>;
export type DealBoardLazyQueryHookResult = ReturnType<typeof useDealBoardLazyQuery>;
export type DealBoardQueryResult = ApolloReactCommon.QueryResult<DealBoardQuery, DealBoardQueryVariables>;
export const DealDetailsWrapperDocument = gql`
    query DealDetailsWrapper($id: Int!) {
  deal(id: $id) {
    ...DealDetailsWrapper
  }
}
    ${DealDetailsWrapperFragmentDoc}`;
export type DealDetailsWrapperComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DealDetailsWrapperQuery, DealDetailsWrapperQueryVariables>, 'query'> & ({ variables: DealDetailsWrapperQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DealDetailsWrapperComponent = (props: DealDetailsWrapperComponentProps) => (
      <ApolloReactComponents.Query<DealDetailsWrapperQuery, DealDetailsWrapperQueryVariables> query={DealDetailsWrapperDocument} {...props} />
    );
    
export type DealDetailsWrapperProps<TChildProps = {}> = ApolloReactHoc.DataProps<DealDetailsWrapperQuery, DealDetailsWrapperQueryVariables> & TChildProps;
export function withDealDetailsWrapper<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DealDetailsWrapperQuery,
  DealDetailsWrapperQueryVariables,
  DealDetailsWrapperProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, DealDetailsWrapperQuery, DealDetailsWrapperQueryVariables, DealDetailsWrapperProps<TChildProps>>(DealDetailsWrapperDocument, {
      alias: 'dealDetailsWrapper',
      ...operationOptions
    });
};

/**
 * __useDealDetailsWrapperQuery__
 *
 * To run a query within a React component, call `useDealDetailsWrapperQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealDetailsWrapperQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealDetailsWrapperQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDealDetailsWrapperQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DealDetailsWrapperQuery, DealDetailsWrapperQueryVariables>) {
        return ApolloReactHooks.useQuery<DealDetailsWrapperQuery, DealDetailsWrapperQueryVariables>(DealDetailsWrapperDocument, baseOptions);
      }
export function useDealDetailsWrapperLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DealDetailsWrapperQuery, DealDetailsWrapperQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DealDetailsWrapperQuery, DealDetailsWrapperQueryVariables>(DealDetailsWrapperDocument, baseOptions);
        }
export type DealDetailsWrapperQueryHookResult = ReturnType<typeof useDealDetailsWrapperQuery>;
export type DealDetailsWrapperLazyQueryHookResult = ReturnType<typeof useDealDetailsWrapperLazyQuery>;
export type DealDetailsWrapperQueryResult = ApolloReactCommon.QueryResult<DealDetailsWrapperQuery, DealDetailsWrapperQueryVariables>;
export const DeleteDealTemplateDocument = gql`
    mutation DeleteDealTemplate($dealId: Int!, $templateId: Int!) {
  deleteDealTemplate(deal_id: $dealId, template_id: $templateId)
}
    `;
export type DeleteDealTemplateMutationFn = ApolloReactCommon.MutationFunction<DeleteDealTemplateMutation, DeleteDealTemplateMutationVariables>;
export type DeleteDealTemplateComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteDealTemplateMutation, DeleteDealTemplateMutationVariables>, 'mutation'>;

    export const DeleteDealTemplateComponent = (props: DeleteDealTemplateComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteDealTemplateMutation, DeleteDealTemplateMutationVariables> mutation={DeleteDealTemplateDocument} {...props} />
    );
    
export type DeleteDealTemplateProps<TChildProps = {}> = ApolloReactHoc.MutateProps<DeleteDealTemplateMutation, DeleteDealTemplateMutationVariables> & TChildProps;
export function withDeleteDealTemplate<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteDealTemplateMutation,
  DeleteDealTemplateMutationVariables,
  DeleteDealTemplateProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteDealTemplateMutation, DeleteDealTemplateMutationVariables, DeleteDealTemplateProps<TChildProps>>(DeleteDealTemplateDocument, {
      alias: 'deleteDealTemplate',
      ...operationOptions
    });
};

/**
 * __useDeleteDealTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteDealTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDealTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDealTemplateMutation, { data, loading, error }] = useDeleteDealTemplateMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useDeleteDealTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDealTemplateMutation, DeleteDealTemplateMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteDealTemplateMutation, DeleteDealTemplateMutationVariables>(DeleteDealTemplateDocument, baseOptions);
      }
export type DeleteDealTemplateMutationHookResult = ReturnType<typeof useDeleteDealTemplateMutation>;
export type DeleteDealTemplateMutationResult = ApolloReactCommon.MutationResult<DeleteDealTemplateMutation>;
export type DeleteDealTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteDealTemplateMutation, DeleteDealTemplateMutationVariables>;
export const DealDetailsSidebarCancelDealDocument = gql`
    mutation DealDetailsSidebarCancelDeal($dealId: Int!) {
  cancelDeal(dealId: $dealId)
}
    `;
export type DealDetailsSidebarCancelDealMutationFn = ApolloReactCommon.MutationFunction<DealDetailsSidebarCancelDealMutation, DealDetailsSidebarCancelDealMutationVariables>;
export type DealDetailsSidebarCancelDealComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DealDetailsSidebarCancelDealMutation, DealDetailsSidebarCancelDealMutationVariables>, 'mutation'>;

    export const DealDetailsSidebarCancelDealComponent = (props: DealDetailsSidebarCancelDealComponentProps) => (
      <ApolloReactComponents.Mutation<DealDetailsSidebarCancelDealMutation, DealDetailsSidebarCancelDealMutationVariables> mutation={DealDetailsSidebarCancelDealDocument} {...props} />
    );
    
export type DealDetailsSidebarCancelDealProps<TChildProps = {}> = ApolloReactHoc.MutateProps<DealDetailsSidebarCancelDealMutation, DealDetailsSidebarCancelDealMutationVariables> & TChildProps;
export function withDealDetailsSidebarCancelDeal<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DealDetailsSidebarCancelDealMutation,
  DealDetailsSidebarCancelDealMutationVariables,
  DealDetailsSidebarCancelDealProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, DealDetailsSidebarCancelDealMutation, DealDetailsSidebarCancelDealMutationVariables, DealDetailsSidebarCancelDealProps<TChildProps>>(DealDetailsSidebarCancelDealDocument, {
      alias: 'dealDetailsSidebarCancelDeal',
      ...operationOptions
    });
};

/**
 * __useDealDetailsSidebarCancelDealMutation__
 *
 * To run a mutation, you first call `useDealDetailsSidebarCancelDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDealDetailsSidebarCancelDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dealDetailsSidebarCancelDealMutation, { data, loading, error }] = useDealDetailsSidebarCancelDealMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useDealDetailsSidebarCancelDealMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DealDetailsSidebarCancelDealMutation, DealDetailsSidebarCancelDealMutationVariables>) {
        return ApolloReactHooks.useMutation<DealDetailsSidebarCancelDealMutation, DealDetailsSidebarCancelDealMutationVariables>(DealDetailsSidebarCancelDealDocument, baseOptions);
      }
export type DealDetailsSidebarCancelDealMutationHookResult = ReturnType<typeof useDealDetailsSidebarCancelDealMutation>;
export type DealDetailsSidebarCancelDealMutationResult = ApolloReactCommon.MutationResult<DealDetailsSidebarCancelDealMutation>;
export type DealDetailsSidebarCancelDealMutationOptions = ApolloReactCommon.BaseMutationOptions<DealDetailsSidebarCancelDealMutation, DealDetailsSidebarCancelDealMutationVariables>;
export const UpdateDealProbabilityToCloseDocument = gql`
    mutation updateDealProbabilityToClose($dealId: Int!, $newProbability: BigDecimal!) {
  updateDealProbabilityToClose(dealId: $dealId, newProbability: $newProbability) {
    id
    probability_to_close
  }
}
    `;
export type UpdateDealProbabilityToCloseMutationFn = ApolloReactCommon.MutationFunction<UpdateDealProbabilityToCloseMutation, UpdateDealProbabilityToCloseMutationVariables>;
export type UpdateDealProbabilityToCloseComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateDealProbabilityToCloseMutation, UpdateDealProbabilityToCloseMutationVariables>, 'mutation'>;

    export const UpdateDealProbabilityToCloseComponent = (props: UpdateDealProbabilityToCloseComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateDealProbabilityToCloseMutation, UpdateDealProbabilityToCloseMutationVariables> mutation={UpdateDealProbabilityToCloseDocument} {...props} />
    );
    
export type UpdateDealProbabilityToCloseProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateDealProbabilityToCloseMutation, UpdateDealProbabilityToCloseMutationVariables> & TChildProps;
export function withUpdateDealProbabilityToClose<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateDealProbabilityToCloseMutation,
  UpdateDealProbabilityToCloseMutationVariables,
  UpdateDealProbabilityToCloseProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateDealProbabilityToCloseMutation, UpdateDealProbabilityToCloseMutationVariables, UpdateDealProbabilityToCloseProps<TChildProps>>(UpdateDealProbabilityToCloseDocument, {
      alias: 'updateDealProbabilityToClose',
      ...operationOptions
    });
};

/**
 * __useUpdateDealProbabilityToCloseMutation__
 *
 * To run a mutation, you first call `useUpdateDealProbabilityToCloseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDealProbabilityToCloseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDealProbabilityToCloseMutation, { data, loading, error }] = useUpdateDealProbabilityToCloseMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      newProbability: // value for 'newProbability'
 *   },
 * });
 */
export function useUpdateDealProbabilityToCloseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDealProbabilityToCloseMutation, UpdateDealProbabilityToCloseMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateDealProbabilityToCloseMutation, UpdateDealProbabilityToCloseMutationVariables>(UpdateDealProbabilityToCloseDocument, baseOptions);
      }
export type UpdateDealProbabilityToCloseMutationHookResult = ReturnType<typeof useUpdateDealProbabilityToCloseMutation>;
export type UpdateDealProbabilityToCloseMutationResult = ApolloReactCommon.MutationResult<UpdateDealProbabilityToCloseMutation>;
export type UpdateDealProbabilityToCloseMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDealProbabilityToCloseMutation, UpdateDealProbabilityToCloseMutationVariables>;
export const EntityDropdownDocument = gql`
    mutation EntityDropdown($orderId: Int!, $entityId: Int!) {
  setOrderEntity(id: $orderId, entityId: $entityId) {
    id
    entity {
      id
      type
      name
    }
  }
}
    `;
export type EntityDropdownMutationFn = ApolloReactCommon.MutationFunction<EntityDropdownMutation, EntityDropdownMutationVariables>;
export type EntityDropdownComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<EntityDropdownMutation, EntityDropdownMutationVariables>, 'mutation'>;

    export const EntityDropdownComponent = (props: EntityDropdownComponentProps) => (
      <ApolloReactComponents.Mutation<EntityDropdownMutation, EntityDropdownMutationVariables> mutation={EntityDropdownDocument} {...props} />
    );
    
export type EntityDropdownProps<TChildProps = {}> = ApolloReactHoc.MutateProps<EntityDropdownMutation, EntityDropdownMutationVariables> & TChildProps;
export function withEntityDropdown<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityDropdownMutation,
  EntityDropdownMutationVariables,
  EntityDropdownProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, EntityDropdownMutation, EntityDropdownMutationVariables, EntityDropdownProps<TChildProps>>(EntityDropdownDocument, {
      alias: 'entityDropdown',
      ...operationOptions
    });
};

/**
 * __useEntityDropdownMutation__
 *
 * To run a mutation, you first call `useEntityDropdownMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEntityDropdownMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [entityDropdownMutation, { data, loading, error }] = useEntityDropdownMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useEntityDropdownMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EntityDropdownMutation, EntityDropdownMutationVariables>) {
        return ApolloReactHooks.useMutation<EntityDropdownMutation, EntityDropdownMutationVariables>(EntityDropdownDocument, baseOptions);
      }
export type EntityDropdownMutationHookResult = ReturnType<typeof useEntityDropdownMutation>;
export type EntityDropdownMutationResult = ApolloReactCommon.MutationResult<EntityDropdownMutation>;
export type EntityDropdownMutationOptions = ApolloReactCommon.BaseMutationOptions<EntityDropdownMutation, EntityDropdownMutationVariables>;
export const SetOrderDollarAmountDocument = gql`
    mutation SetOrderDollarAmount($orderId: Int!, $amount: BigDecimal!) {
  setOrderDollarAmount(id: $orderId, amount: $amount) {
    id
    ...OrderDetailsPanelMoneyFields
  }
}
    ${OrderDetailsPanelMoneyFieldsFragmentDoc}`;
export type SetOrderDollarAmountMutationFn = ApolloReactCommon.MutationFunction<SetOrderDollarAmountMutation, SetOrderDollarAmountMutationVariables>;
export type SetOrderDollarAmountComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SetOrderDollarAmountMutation, SetOrderDollarAmountMutationVariables>, 'mutation'>;

    export const SetOrderDollarAmountComponent = (props: SetOrderDollarAmountComponentProps) => (
      <ApolloReactComponents.Mutation<SetOrderDollarAmountMutation, SetOrderDollarAmountMutationVariables> mutation={SetOrderDollarAmountDocument} {...props} />
    );
    
export type SetOrderDollarAmountProps<TChildProps = {}> = ApolloReactHoc.MutateProps<SetOrderDollarAmountMutation, SetOrderDollarAmountMutationVariables> & TChildProps;
export function withSetOrderDollarAmount<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SetOrderDollarAmountMutation,
  SetOrderDollarAmountMutationVariables,
  SetOrderDollarAmountProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, SetOrderDollarAmountMutation, SetOrderDollarAmountMutationVariables, SetOrderDollarAmountProps<TChildProps>>(SetOrderDollarAmountDocument, {
      alias: 'setOrderDollarAmount',
      ...operationOptions
    });
};

/**
 * __useSetOrderDollarAmountMutation__
 *
 * To run a mutation, you first call `useSetOrderDollarAmountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrderDollarAmountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrderDollarAmountMutation, { data, loading, error }] = useSetOrderDollarAmountMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useSetOrderDollarAmountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetOrderDollarAmountMutation, SetOrderDollarAmountMutationVariables>) {
        return ApolloReactHooks.useMutation<SetOrderDollarAmountMutation, SetOrderDollarAmountMutationVariables>(SetOrderDollarAmountDocument, baseOptions);
      }
export type SetOrderDollarAmountMutationHookResult = ReturnType<typeof useSetOrderDollarAmountMutation>;
export type SetOrderDollarAmountMutationResult = ApolloReactCommon.MutationResult<SetOrderDollarAmountMutation>;
export type SetOrderDollarAmountMutationOptions = ApolloReactCommon.BaseMutationOptions<SetOrderDollarAmountMutation, SetOrderDollarAmountMutationVariables>;
export const SetOrderSharePriceDocument = gql`
    mutation SetOrderSharePrice($orderId: Int!, $price: BigDecimal!) {
  setOrderSharePrice(id: $orderId, price: $price) {
    id
    ...OrderDetailsPanelMoneyFields
  }
}
    ${OrderDetailsPanelMoneyFieldsFragmentDoc}`;
export type SetOrderSharePriceMutationFn = ApolloReactCommon.MutationFunction<SetOrderSharePriceMutation, SetOrderSharePriceMutationVariables>;
export type SetOrderSharePriceComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SetOrderSharePriceMutation, SetOrderSharePriceMutationVariables>, 'mutation'>;

    export const SetOrderSharePriceComponent = (props: SetOrderSharePriceComponentProps) => (
      <ApolloReactComponents.Mutation<SetOrderSharePriceMutation, SetOrderSharePriceMutationVariables> mutation={SetOrderSharePriceDocument} {...props} />
    );
    
export type SetOrderSharePriceProps<TChildProps = {}> = ApolloReactHoc.MutateProps<SetOrderSharePriceMutation, SetOrderSharePriceMutationVariables> & TChildProps;
export function withSetOrderSharePrice<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SetOrderSharePriceMutation,
  SetOrderSharePriceMutationVariables,
  SetOrderSharePriceProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, SetOrderSharePriceMutation, SetOrderSharePriceMutationVariables, SetOrderSharePriceProps<TChildProps>>(SetOrderSharePriceDocument, {
      alias: 'setOrderSharePrice',
      ...operationOptions
    });
};

/**
 * __useSetOrderSharePriceMutation__
 *
 * To run a mutation, you first call `useSetOrderSharePriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrderSharePriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrderSharePriceMutation, { data, loading, error }] = useSetOrderSharePriceMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      price: // value for 'price'
 *   },
 * });
 */
export function useSetOrderSharePriceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetOrderSharePriceMutation, SetOrderSharePriceMutationVariables>) {
        return ApolloReactHooks.useMutation<SetOrderSharePriceMutation, SetOrderSharePriceMutationVariables>(SetOrderSharePriceDocument, baseOptions);
      }
export type SetOrderSharePriceMutationHookResult = ReturnType<typeof useSetOrderSharePriceMutation>;
export type SetOrderSharePriceMutationResult = ApolloReactCommon.MutationResult<SetOrderSharePriceMutation>;
export type SetOrderSharePriceMutationOptions = ApolloReactCommon.BaseMutationOptions<SetOrderSharePriceMutation, SetOrderSharePriceMutationVariables>;
export const SetOrderNumSharesDocument = gql`
    mutation SetOrderNumShares($orderId: Int!, $numShares: Long!) {
  setOrderNumShares(id: $orderId, numShares: $numShares) {
    id
    ...OrderDetailsPanelMoneyFields
  }
}
    ${OrderDetailsPanelMoneyFieldsFragmentDoc}`;
export type SetOrderNumSharesMutationFn = ApolloReactCommon.MutationFunction<SetOrderNumSharesMutation, SetOrderNumSharesMutationVariables>;
export type SetOrderNumSharesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SetOrderNumSharesMutation, SetOrderNumSharesMutationVariables>, 'mutation'>;

    export const SetOrderNumSharesComponent = (props: SetOrderNumSharesComponentProps) => (
      <ApolloReactComponents.Mutation<SetOrderNumSharesMutation, SetOrderNumSharesMutationVariables> mutation={SetOrderNumSharesDocument} {...props} />
    );
    
export type SetOrderNumSharesProps<TChildProps = {}> = ApolloReactHoc.MutateProps<SetOrderNumSharesMutation, SetOrderNumSharesMutationVariables> & TChildProps;
export function withSetOrderNumShares<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SetOrderNumSharesMutation,
  SetOrderNumSharesMutationVariables,
  SetOrderNumSharesProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, SetOrderNumSharesMutation, SetOrderNumSharesMutationVariables, SetOrderNumSharesProps<TChildProps>>(SetOrderNumSharesDocument, {
      alias: 'setOrderNumShares',
      ...operationOptions
    });
};

/**
 * __useSetOrderNumSharesMutation__
 *
 * To run a mutation, you first call `useSetOrderNumSharesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrderNumSharesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrderNumSharesMutation, { data, loading, error }] = useSetOrderNumSharesMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      numShares: // value for 'numShares'
 *   },
 * });
 */
export function useSetOrderNumSharesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetOrderNumSharesMutation, SetOrderNumSharesMutationVariables>) {
        return ApolloReactHooks.useMutation<SetOrderNumSharesMutation, SetOrderNumSharesMutationVariables>(SetOrderNumSharesDocument, baseOptions);
      }
export type SetOrderNumSharesMutationHookResult = ReturnType<typeof useSetOrderNumSharesMutation>;
export type SetOrderNumSharesMutationResult = ApolloReactCommon.MutationResult<SetOrderNumSharesMutation>;
export type SetOrderNumSharesMutationOptions = ApolloReactCommon.BaseMutationOptions<SetOrderNumSharesMutation, SetOrderNumSharesMutationVariables>;
export const SetOrderCommissionDocument = gql`
    mutation SetOrderCommission($orderId: Int!, $commission: BigDecimal!) {
  setOrderCommission(id: $orderId, commission: $commission) {
    id
    ...OrderDetailsPanelMoneyFields
  }
}
    ${OrderDetailsPanelMoneyFieldsFragmentDoc}`;
export type SetOrderCommissionMutationFn = ApolloReactCommon.MutationFunction<SetOrderCommissionMutation, SetOrderCommissionMutationVariables>;
export type SetOrderCommissionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SetOrderCommissionMutation, SetOrderCommissionMutationVariables>, 'mutation'>;

    export const SetOrderCommissionComponent = (props: SetOrderCommissionComponentProps) => (
      <ApolloReactComponents.Mutation<SetOrderCommissionMutation, SetOrderCommissionMutationVariables> mutation={SetOrderCommissionDocument} {...props} />
    );
    
export type SetOrderCommissionProps<TChildProps = {}> = ApolloReactHoc.MutateProps<SetOrderCommissionMutation, SetOrderCommissionMutationVariables> & TChildProps;
export function withSetOrderCommission<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SetOrderCommissionMutation,
  SetOrderCommissionMutationVariables,
  SetOrderCommissionProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, SetOrderCommissionMutation, SetOrderCommissionMutationVariables, SetOrderCommissionProps<TChildProps>>(SetOrderCommissionDocument, {
      alias: 'setOrderCommission',
      ...operationOptions
    });
};

/**
 * __useSetOrderCommissionMutation__
 *
 * To run a mutation, you first call `useSetOrderCommissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrderCommissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrderCommissionMutation, { data, loading, error }] = useSetOrderCommissionMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      commission: // value for 'commission'
 *   },
 * });
 */
export function useSetOrderCommissionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetOrderCommissionMutation, SetOrderCommissionMutationVariables>) {
        return ApolloReactHooks.useMutation<SetOrderCommissionMutation, SetOrderCommissionMutationVariables>(SetOrderCommissionDocument, baseOptions);
      }
export type SetOrderCommissionMutationHookResult = ReturnType<typeof useSetOrderCommissionMutation>;
export type SetOrderCommissionMutationResult = ApolloReactCommon.MutationResult<SetOrderCommissionMutation>;
export type SetOrderCommissionMutationOptions = ApolloReactCommon.BaseMutationOptions<SetOrderCommissionMutation, SetOrderCommissionMutationVariables>;
export const OwnerMultiSelectDocument = gql`
    mutation OwnerMultiSelect($dealId: Int!, $ownerIds: [Int!]!) {
  setDealOwners(dealId: $dealId, ownerIds: $ownerIds) {
    id
    owners {
      ...OwnerMultiSelect
    }
  }
}
    ${OwnerMultiSelectFragmentDoc}`;
export type OwnerMultiSelectMutationFn = ApolloReactCommon.MutationFunction<OwnerMultiSelectMutation, OwnerMultiSelectMutationVariables>;
export type OwnerMultiSelectComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<OwnerMultiSelectMutation, OwnerMultiSelectMutationVariables>, 'mutation'>;

    export const OwnerMultiSelectComponent = (props: OwnerMultiSelectComponentProps) => (
      <ApolloReactComponents.Mutation<OwnerMultiSelectMutation, OwnerMultiSelectMutationVariables> mutation={OwnerMultiSelectDocument} {...props} />
    );
    
export type OwnerMultiSelectProps<TChildProps = {}> = ApolloReactHoc.MutateProps<OwnerMultiSelectMutation, OwnerMultiSelectMutationVariables> & TChildProps;
export function withOwnerMultiSelect<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OwnerMultiSelectMutation,
  OwnerMultiSelectMutationVariables,
  OwnerMultiSelectProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, OwnerMultiSelectMutation, OwnerMultiSelectMutationVariables, OwnerMultiSelectProps<TChildProps>>(OwnerMultiSelectDocument, {
      alias: 'ownerMultiSelect',
      ...operationOptions
    });
};

/**
 * __useOwnerMultiSelectMutation__
 *
 * To run a mutation, you first call `useOwnerMultiSelectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOwnerMultiSelectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ownerMultiSelectMutation, { data, loading, error }] = useOwnerMultiSelectMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      ownerIds: // value for 'ownerIds'
 *   },
 * });
 */
export function useOwnerMultiSelectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OwnerMultiSelectMutation, OwnerMultiSelectMutationVariables>) {
        return ApolloReactHooks.useMutation<OwnerMultiSelectMutation, OwnerMultiSelectMutationVariables>(OwnerMultiSelectDocument, baseOptions);
      }
export type OwnerMultiSelectMutationHookResult = ReturnType<typeof useOwnerMultiSelectMutation>;
export type OwnerMultiSelectMutationResult = ApolloReactCommon.MutationResult<OwnerMultiSelectMutation>;
export type OwnerMultiSelectMutationOptions = ApolloReactCommon.BaseMutationOptions<OwnerMultiSelectMutation, OwnerMultiSelectMutationVariables>;
export const CreateDealTemplateDocument = gql`
    mutation createDealTemplate($from: NewTemplateInput!, $dealId: Int!, $orderType: OrderType) {
  createDealTemplate(from: $from, deal_id: $dealId, order_type: $orderType)
}
    `;
export type CreateDealTemplateMutationFn = ApolloReactCommon.MutationFunction<CreateDealTemplateMutation, CreateDealTemplateMutationVariables>;
export type CreateDealTemplateComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateDealTemplateMutation, CreateDealTemplateMutationVariables>, 'mutation'>;

    export const CreateDealTemplateComponent = (props: CreateDealTemplateComponentProps) => (
      <ApolloReactComponents.Mutation<CreateDealTemplateMutation, CreateDealTemplateMutationVariables> mutation={CreateDealTemplateDocument} {...props} />
    );
    
export type CreateDealTemplateProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CreateDealTemplateMutation, CreateDealTemplateMutationVariables> & TChildProps;
export function withCreateDealTemplate<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateDealTemplateMutation,
  CreateDealTemplateMutationVariables,
  CreateDealTemplateProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CreateDealTemplateMutation, CreateDealTemplateMutationVariables, CreateDealTemplateProps<TChildProps>>(CreateDealTemplateDocument, {
      alias: 'createDealTemplate',
      ...operationOptions
    });
};

/**
 * __useCreateDealTemplateMutation__
 *
 * To run a mutation, you first call `useCreateDealTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDealTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDealTemplateMutation, { data, loading, error }] = useCreateDealTemplateMutation({
 *   variables: {
 *      from: // value for 'from'
 *      dealId: // value for 'dealId'
 *      orderType: // value for 'orderType'
 *   },
 * });
 */
export function useCreateDealTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDealTemplateMutation, CreateDealTemplateMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateDealTemplateMutation, CreateDealTemplateMutationVariables>(CreateDealTemplateDocument, baseOptions);
      }
export type CreateDealTemplateMutationHookResult = ReturnType<typeof useCreateDealTemplateMutation>;
export type CreateDealTemplateMutationResult = ApolloReactCommon.MutationResult<CreateDealTemplateMutation>;
export type CreateDealTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDealTemplateMutation, CreateDealTemplateMutationVariables>;
export const TradeDetailsBankAccountsDocument = gql`
    query TradeDetailsBankAccounts($id: Int!) {
  entity(id: $id) {
    id
    ...BankAccountCardEntityView
    protected_bank_account_collection {
      __typename
      ... on UnauthorizedView {
        requiredCapabilities
      }
      ... on AuthorizedBankAccountCollectionView {
        value {
          nodes {
            id
            ...BankAccountCardBankAccountView
          }
        }
      }
    }
  }
}
    ${BankAccountCardEntityViewFragmentDoc}
${BankAccountCardBankAccountViewFragmentDoc}`;
export type TradeDetailsBankAccountsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TradeDetailsBankAccountsQuery, TradeDetailsBankAccountsQueryVariables>, 'query'> & ({ variables: TradeDetailsBankAccountsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TradeDetailsBankAccountsComponent = (props: TradeDetailsBankAccountsComponentProps) => (
      <ApolloReactComponents.Query<TradeDetailsBankAccountsQuery, TradeDetailsBankAccountsQueryVariables> query={TradeDetailsBankAccountsDocument} {...props} />
    );
    
export type TradeDetailsBankAccountsProps<TChildProps = {}> = ApolloReactHoc.DataProps<TradeDetailsBankAccountsQuery, TradeDetailsBankAccountsQueryVariables> & TChildProps;
export function withTradeDetailsBankAccounts<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TradeDetailsBankAccountsQuery,
  TradeDetailsBankAccountsQueryVariables,
  TradeDetailsBankAccountsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, TradeDetailsBankAccountsQuery, TradeDetailsBankAccountsQueryVariables, TradeDetailsBankAccountsProps<TChildProps>>(TradeDetailsBankAccountsDocument, {
      alias: 'tradeDetailsBankAccounts',
      ...operationOptions
    });
};

/**
 * __useTradeDetailsBankAccountsQuery__
 *
 * To run a query within a React component, call `useTradeDetailsBankAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradeDetailsBankAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradeDetailsBankAccountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTradeDetailsBankAccountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TradeDetailsBankAccountsQuery, TradeDetailsBankAccountsQueryVariables>) {
        return ApolloReactHooks.useQuery<TradeDetailsBankAccountsQuery, TradeDetailsBankAccountsQueryVariables>(TradeDetailsBankAccountsDocument, baseOptions);
      }
export function useTradeDetailsBankAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradeDetailsBankAccountsQuery, TradeDetailsBankAccountsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TradeDetailsBankAccountsQuery, TradeDetailsBankAccountsQueryVariables>(TradeDetailsBankAccountsDocument, baseOptions);
        }
export type TradeDetailsBankAccountsQueryHookResult = ReturnType<typeof useTradeDetailsBankAccountsQuery>;
export type TradeDetailsBankAccountsLazyQueryHookResult = ReturnType<typeof useTradeDetailsBankAccountsLazyQuery>;
export type TradeDetailsBankAccountsQueryResult = ApolloReactCommon.QueryResult<TradeDetailsBankAccountsQuery, TradeDetailsBankAccountsQueryVariables>;
export const CreateDealButtonDocument = gql`
    mutation CreateDealButton($tradeIntentId: UUID!) {
  createDealFromTradeIntent(tradeIntentId: $tradeIntentId) {
    id
    ...DealDetailsWrapper
  }
}
    ${DealDetailsWrapperFragmentDoc}`;
export type CreateDealButtonMutationFn = ApolloReactCommon.MutationFunction<CreateDealButtonMutation, CreateDealButtonMutationVariables>;
export type CreateDealButtonComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateDealButtonMutation, CreateDealButtonMutationVariables>, 'mutation'>;

    export const CreateDealButtonComponent = (props: CreateDealButtonComponentProps) => (
      <ApolloReactComponents.Mutation<CreateDealButtonMutation, CreateDealButtonMutationVariables> mutation={CreateDealButtonDocument} {...props} />
    );
    
export type CreateDealButtonProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CreateDealButtonMutation, CreateDealButtonMutationVariables> & TChildProps;
export function withCreateDealButton<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateDealButtonMutation,
  CreateDealButtonMutationVariables,
  CreateDealButtonProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CreateDealButtonMutation, CreateDealButtonMutationVariables, CreateDealButtonProps<TChildProps>>(CreateDealButtonDocument, {
      alias: 'createDealButton',
      ...operationOptions
    });
};

/**
 * __useCreateDealButtonMutation__
 *
 * To run a mutation, you first call `useCreateDealButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDealButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDealButtonMutation, { data, loading, error }] = useCreateDealButtonMutation({
 *   variables: {
 *      tradeIntentId: // value for 'tradeIntentId'
 *   },
 * });
 */
export function useCreateDealButtonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDealButtonMutation, CreateDealButtonMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateDealButtonMutation, CreateDealButtonMutationVariables>(CreateDealButtonDocument, baseOptions);
      }
export type CreateDealButtonMutationHookResult = ReturnType<typeof useCreateDealButtonMutation>;
export type CreateDealButtonMutationResult = ApolloReactCommon.MutationResult<CreateDealButtonMutation>;
export type CreateDealButtonMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDealButtonMutation, CreateDealButtonMutationVariables>;
export const AccountSuggestionsDocument = gql`
    query accountSuggestions($offset: Int!, $limit: Int!) {
  accountCreationSuggestions(offset: $offset, limit: $limit) {
    count
    data {
      id
      front_contact {
        id
        name
        email
      }
      recent_messages {
        id
        subject
        content
        message_contacts {
          id
          role
          email
        }
        created_at
        front_created_at
        front_message {
          id
          front_msg_id
        }
      }
      created_at
    }
  }
}
    `;
export type AccountSuggestionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountSuggestionsQuery, AccountSuggestionsQueryVariables>, 'query'> & ({ variables: AccountSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountSuggestionsComponent = (props: AccountSuggestionsComponentProps) => (
      <ApolloReactComponents.Query<AccountSuggestionsQuery, AccountSuggestionsQueryVariables> query={AccountSuggestionsDocument} {...props} />
    );
    
export type AccountSuggestionsProps<TChildProps = {}> = ApolloReactHoc.DataProps<AccountSuggestionsQuery, AccountSuggestionsQueryVariables> & TChildProps;
export function withAccountSuggestions<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountSuggestionsQuery,
  AccountSuggestionsQueryVariables,
  AccountSuggestionsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AccountSuggestionsQuery, AccountSuggestionsQueryVariables, AccountSuggestionsProps<TChildProps>>(AccountSuggestionsDocument, {
      alias: 'accountSuggestions',
      ...operationOptions
    });
};

/**
 * __useAccountSuggestionsQuery__
 *
 * To run a query within a React component, call `useAccountSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSuggestionsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAccountSuggestionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountSuggestionsQuery, AccountSuggestionsQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountSuggestionsQuery, AccountSuggestionsQueryVariables>(AccountSuggestionsDocument, baseOptions);
      }
export function useAccountSuggestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountSuggestionsQuery, AccountSuggestionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountSuggestionsQuery, AccountSuggestionsQueryVariables>(AccountSuggestionsDocument, baseOptions);
        }
export type AccountSuggestionsQueryHookResult = ReturnType<typeof useAccountSuggestionsQuery>;
export type AccountSuggestionsLazyQueryHookResult = ReturnType<typeof useAccountSuggestionsLazyQuery>;
export type AccountSuggestionsQueryResult = ApolloReactCommon.QueryResult<AccountSuggestionsQuery, AccountSuggestionsQueryVariables>;
export const IgnoreSuggestionDocument = gql`
    mutation ignoreSuggestion($id: UUID!) {
  rejectAccountSuggestion(id: $id)
}
    `;
export type IgnoreSuggestionMutationFn = ApolloReactCommon.MutationFunction<IgnoreSuggestionMutation, IgnoreSuggestionMutationVariables>;
export type IgnoreSuggestionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<IgnoreSuggestionMutation, IgnoreSuggestionMutationVariables>, 'mutation'>;

    export const IgnoreSuggestionComponent = (props: IgnoreSuggestionComponentProps) => (
      <ApolloReactComponents.Mutation<IgnoreSuggestionMutation, IgnoreSuggestionMutationVariables> mutation={IgnoreSuggestionDocument} {...props} />
    );
    
export type IgnoreSuggestionProps<TChildProps = {}> = ApolloReactHoc.MutateProps<IgnoreSuggestionMutation, IgnoreSuggestionMutationVariables> & TChildProps;
export function withIgnoreSuggestion<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IgnoreSuggestionMutation,
  IgnoreSuggestionMutationVariables,
  IgnoreSuggestionProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, IgnoreSuggestionMutation, IgnoreSuggestionMutationVariables, IgnoreSuggestionProps<TChildProps>>(IgnoreSuggestionDocument, {
      alias: 'ignoreSuggestion',
      ...operationOptions
    });
};

/**
 * __useIgnoreSuggestionMutation__
 *
 * To run a mutation, you first call `useIgnoreSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIgnoreSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ignoreSuggestionMutation, { data, loading, error }] = useIgnoreSuggestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIgnoreSuggestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IgnoreSuggestionMutation, IgnoreSuggestionMutationVariables>) {
        return ApolloReactHooks.useMutation<IgnoreSuggestionMutation, IgnoreSuggestionMutationVariables>(IgnoreSuggestionDocument, baseOptions);
      }
export type IgnoreSuggestionMutationHookResult = ReturnType<typeof useIgnoreSuggestionMutation>;
export type IgnoreSuggestionMutationResult = ApolloReactCommon.MutationResult<IgnoreSuggestionMutation>;
export type IgnoreSuggestionMutationOptions = ApolloReactCommon.BaseMutationOptions<IgnoreSuggestionMutation, IgnoreSuggestionMutationVariables>;
export const AccountsDocument = gql`
    query accounts {
  accounts {
    ...AccountsTable
  }
}
    ${AccountsTableFragmentDoc}`;
export type AccountsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountsQuery, AccountsQueryVariables>, 'query'>;

    export const AccountsComponent = (props: AccountsComponentProps) => (
      <ApolloReactComponents.Query<AccountsQuery, AccountsQueryVariables> query={AccountsDocument} {...props} />
    );
    
export type AccountsProps<TChildProps = {}> = ApolloReactHoc.DataProps<AccountsQuery, AccountsQueryVariables> & TChildProps;
export function withAccounts<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountsQuery,
  AccountsQueryVariables,
  AccountsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AccountsQuery, AccountsQueryVariables, AccountsProps<TChildProps>>(AccountsDocument, {
      alias: 'accounts',
      ...operationOptions
    });
};

/**
 * __useAccountsQuery__
 *
 * To run a query within a React component, call `useAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountsQuery, AccountsQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, baseOptions);
      }
export function useAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountsQuery, AccountsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, baseOptions);
        }
export type AccountsQueryHookResult = ReturnType<typeof useAccountsQuery>;
export type AccountsLazyQueryHookResult = ReturnType<typeof useAccountsLazyQuery>;
export type AccountsQueryResult = ApolloReactCommon.QueryResult<AccountsQuery, AccountsQueryVariables>;
export const GetAccountEntityOptionsDocument = gql`
    query getAccountEntityOptions($id: UUID!) {
  account(id: $id) {
    id
    entities {
      id
      name
      type
    }
  }
}
    `;
export type GetAccountEntityOptionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAccountEntityOptionsQuery, GetAccountEntityOptionsQueryVariables>, 'query'> & ({ variables: GetAccountEntityOptionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAccountEntityOptionsComponent = (props: GetAccountEntityOptionsComponentProps) => (
      <ApolloReactComponents.Query<GetAccountEntityOptionsQuery, GetAccountEntityOptionsQueryVariables> query={GetAccountEntityOptionsDocument} {...props} />
    );
    
export type GetAccountEntityOptionsProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetAccountEntityOptionsQuery, GetAccountEntityOptionsQueryVariables> & TChildProps;
export function withGetAccountEntityOptions<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAccountEntityOptionsQuery,
  GetAccountEntityOptionsQueryVariables,
  GetAccountEntityOptionsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetAccountEntityOptionsQuery, GetAccountEntityOptionsQueryVariables, GetAccountEntityOptionsProps<TChildProps>>(GetAccountEntityOptionsDocument, {
      alias: 'getAccountEntityOptions',
      ...operationOptions
    });
};

/**
 * __useGetAccountEntityOptionsQuery__
 *
 * To run a query within a React component, call `useGetAccountEntityOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountEntityOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountEntityOptionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountEntityOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAccountEntityOptionsQuery, GetAccountEntityOptionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAccountEntityOptionsQuery, GetAccountEntityOptionsQueryVariables>(GetAccountEntityOptionsDocument, baseOptions);
      }
export function useGetAccountEntityOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAccountEntityOptionsQuery, GetAccountEntityOptionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAccountEntityOptionsQuery, GetAccountEntityOptionsQueryVariables>(GetAccountEntityOptionsDocument, baseOptions);
        }
export type GetAccountEntityOptionsQueryHookResult = ReturnType<typeof useGetAccountEntityOptionsQuery>;
export type GetAccountEntityOptionsLazyQueryHookResult = ReturnType<typeof useGetAccountEntityOptionsLazyQuery>;
export type GetAccountEntityOptionsQueryResult = ApolloReactCommon.QueryResult<GetAccountEntityOptionsQuery, GetAccountEntityOptionsQueryVariables>;
export const FilteredAccountsDocument = gql`
    query filteredAccounts($filters: [UUID!]!, $params: Json!, $offset: Int!, $limit: Int!) {
  dynamicAccountsQuery(filters: $filters, params: $params, offset: $offset, limit: $limit) {
    count
    offset
    limit
    data {
      ...AccountsTable
    }
  }
}
    ${AccountsTableFragmentDoc}`;
export type FilteredAccountsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FilteredAccountsQuery, FilteredAccountsQueryVariables>, 'query'> & ({ variables: FilteredAccountsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FilteredAccountsComponent = (props: FilteredAccountsComponentProps) => (
      <ApolloReactComponents.Query<FilteredAccountsQuery, FilteredAccountsQueryVariables> query={FilteredAccountsDocument} {...props} />
    );
    
export type FilteredAccountsProps<TChildProps = {}> = ApolloReactHoc.DataProps<FilteredAccountsQuery, FilteredAccountsQueryVariables> & TChildProps;
export function withFilteredAccounts<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FilteredAccountsQuery,
  FilteredAccountsQueryVariables,
  FilteredAccountsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, FilteredAccountsQuery, FilteredAccountsQueryVariables, FilteredAccountsProps<TChildProps>>(FilteredAccountsDocument, {
      alias: 'filteredAccounts',
      ...operationOptions
    });
};

/**
 * __useFilteredAccountsQuery__
 *
 * To run a query within a React component, call `useFilteredAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredAccountsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      params: // value for 'params'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFilteredAccountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FilteredAccountsQuery, FilteredAccountsQueryVariables>) {
        return ApolloReactHooks.useQuery<FilteredAccountsQuery, FilteredAccountsQueryVariables>(FilteredAccountsDocument, baseOptions);
      }
export function useFilteredAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FilteredAccountsQuery, FilteredAccountsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FilteredAccountsQuery, FilteredAccountsQueryVariables>(FilteredAccountsDocument, baseOptions);
        }
export type FilteredAccountsQueryHookResult = ReturnType<typeof useFilteredAccountsQuery>;
export type FilteredAccountsLazyQueryHookResult = ReturnType<typeof useFilteredAccountsLazyQuery>;
export type FilteredAccountsQueryResult = ApolloReactCommon.QueryResult<FilteredAccountsQuery, FilteredAccountsQueryVariables>;
export const DynamicallyFilteredAccountsDocument = gql`
    query dynamicallyFilteredAccounts($filter: Json!, $offset: Int!, $limit: Int!) {
  dynamicQuery(filter: $filter, offset: $offset, limit: $limit) {
    count
    offset
    limit
    data {
      ...AccountsTable
    }
  }
}
    ${AccountsTableFragmentDoc}`;
export type DynamicallyFilteredAccountsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DynamicallyFilteredAccountsQuery, DynamicallyFilteredAccountsQueryVariables>, 'query'> & ({ variables: DynamicallyFilteredAccountsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DynamicallyFilteredAccountsComponent = (props: DynamicallyFilteredAccountsComponentProps) => (
      <ApolloReactComponents.Query<DynamicallyFilteredAccountsQuery, DynamicallyFilteredAccountsQueryVariables> query={DynamicallyFilteredAccountsDocument} {...props} />
    );
    
export type DynamicallyFilteredAccountsProps<TChildProps = {}> = ApolloReactHoc.DataProps<DynamicallyFilteredAccountsQuery, DynamicallyFilteredAccountsQueryVariables> & TChildProps;
export function withDynamicallyFilteredAccounts<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DynamicallyFilteredAccountsQuery,
  DynamicallyFilteredAccountsQueryVariables,
  DynamicallyFilteredAccountsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, DynamicallyFilteredAccountsQuery, DynamicallyFilteredAccountsQueryVariables, DynamicallyFilteredAccountsProps<TChildProps>>(DynamicallyFilteredAccountsDocument, {
      alias: 'dynamicallyFilteredAccounts',
      ...operationOptions
    });
};

/**
 * __useDynamicallyFilteredAccountsQuery__
 *
 * To run a query within a React component, call `useDynamicallyFilteredAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDynamicallyFilteredAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDynamicallyFilteredAccountsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDynamicallyFilteredAccountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DynamicallyFilteredAccountsQuery, DynamicallyFilteredAccountsQueryVariables>) {
        return ApolloReactHooks.useQuery<DynamicallyFilteredAccountsQuery, DynamicallyFilteredAccountsQueryVariables>(DynamicallyFilteredAccountsDocument, baseOptions);
      }
export function useDynamicallyFilteredAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DynamicallyFilteredAccountsQuery, DynamicallyFilteredAccountsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DynamicallyFilteredAccountsQuery, DynamicallyFilteredAccountsQueryVariables>(DynamicallyFilteredAccountsDocument, baseOptions);
        }
export type DynamicallyFilteredAccountsQueryHookResult = ReturnType<typeof useDynamicallyFilteredAccountsQuery>;
export type DynamicallyFilteredAccountsLazyQueryHookResult = ReturnType<typeof useDynamicallyFilteredAccountsLazyQuery>;
export type DynamicallyFilteredAccountsQueryResult = ApolloReactCommon.QueryResult<DynamicallyFilteredAccountsQuery, DynamicallyFilteredAccountsQueryVariables>;
export const DynamicallyFilteredLeadsDocument = gql`
    query dynamicallyFilteredLeads($filter: Json!, $offset: Int!, $limit: Int!) {
  dynamicQuery(filter: $filter, offset: $offset, limit: $limit) {
    count
    offset
    limit
    data {
      id
      name
      created_at
      email
      do_not_contact_reasons
      net_worth
      user {
        id
        email_verified
      }
      companies_of_interest {
        id
        name
      }
      investor_preferences {
        id
        target_check_size
        target_check_size
      }
      entities {
        id
        type
        is_accredited
        is_qualified_purchaser
        roles {
          id
          type
          title
        }
        domicile_country_code
      }
      bid_companies {
        id
        name
      }
      ask_companies {
        id
        name
      }
      profilingAssignees {
        id
        name
      }
      qualified
      leadStatus
      last_outreach_by {
        name
      }
    }
  }
}
    `;
export type DynamicallyFilteredLeadsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DynamicallyFilteredLeadsQuery, DynamicallyFilteredLeadsQueryVariables>, 'query'> & ({ variables: DynamicallyFilteredLeadsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DynamicallyFilteredLeadsComponent = (props: DynamicallyFilteredLeadsComponentProps) => (
      <ApolloReactComponents.Query<DynamicallyFilteredLeadsQuery, DynamicallyFilteredLeadsQueryVariables> query={DynamicallyFilteredLeadsDocument} {...props} />
    );
    
export type DynamicallyFilteredLeadsProps<TChildProps = {}> = ApolloReactHoc.DataProps<DynamicallyFilteredLeadsQuery, DynamicallyFilteredLeadsQueryVariables> & TChildProps;
export function withDynamicallyFilteredLeads<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DynamicallyFilteredLeadsQuery,
  DynamicallyFilteredLeadsQueryVariables,
  DynamicallyFilteredLeadsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, DynamicallyFilteredLeadsQuery, DynamicallyFilteredLeadsQueryVariables, DynamicallyFilteredLeadsProps<TChildProps>>(DynamicallyFilteredLeadsDocument, {
      alias: 'dynamicallyFilteredLeads',
      ...operationOptions
    });
};

/**
 * __useDynamicallyFilteredLeadsQuery__
 *
 * To run a query within a React component, call `useDynamicallyFilteredLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDynamicallyFilteredLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDynamicallyFilteredLeadsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDynamicallyFilteredLeadsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DynamicallyFilteredLeadsQuery, DynamicallyFilteredLeadsQueryVariables>) {
        return ApolloReactHooks.useQuery<DynamicallyFilteredLeadsQuery, DynamicallyFilteredLeadsQueryVariables>(DynamicallyFilteredLeadsDocument, baseOptions);
      }
export function useDynamicallyFilteredLeadsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DynamicallyFilteredLeadsQuery, DynamicallyFilteredLeadsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DynamicallyFilteredLeadsQuery, DynamicallyFilteredLeadsQueryVariables>(DynamicallyFilteredLeadsDocument, baseOptions);
        }
export type DynamicallyFilteredLeadsQueryHookResult = ReturnType<typeof useDynamicallyFilteredLeadsQuery>;
export type DynamicallyFilteredLeadsLazyQueryHookResult = ReturnType<typeof useDynamicallyFilteredLeadsLazyQuery>;
export type DynamicallyFilteredLeadsQueryResult = ApolloReactCommon.QueryResult<DynamicallyFilteredLeadsQuery, DynamicallyFilteredLeadsQueryVariables>;
export const SectorsDocument = gql`
    query sectors {
  sectors {
    id
    name
  }
}
    `;
export type SectorsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SectorsQuery, SectorsQueryVariables>, 'query'>;

    export const SectorsComponent = (props: SectorsComponentProps) => (
      <ApolloReactComponents.Query<SectorsQuery, SectorsQueryVariables> query={SectorsDocument} {...props} />
    );
    
export type SectorsProps<TChildProps = {}> = ApolloReactHoc.DataProps<SectorsQuery, SectorsQueryVariables> & TChildProps;
export function withSectors<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SectorsQuery,
  SectorsQueryVariables,
  SectorsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, SectorsQuery, SectorsQueryVariables, SectorsProps<TChildProps>>(SectorsDocument, {
      alias: 'sectors',
      ...operationOptions
    });
};

/**
 * __useSectorsQuery__
 *
 * To run a query within a React component, call `useSectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSectorsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SectorsQuery, SectorsQueryVariables>) {
        return ApolloReactHooks.useQuery<SectorsQuery, SectorsQueryVariables>(SectorsDocument, baseOptions);
      }
export function useSectorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SectorsQuery, SectorsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SectorsQuery, SectorsQueryVariables>(SectorsDocument, baseOptions);
        }
export type SectorsQueryHookResult = ReturnType<typeof useSectorsQuery>;
export type SectorsLazyQueryHookResult = ReturnType<typeof useSectorsLazyQuery>;
export type SectorsQueryResult = ApolloReactCommon.QueryResult<SectorsQuery, SectorsQueryVariables>;
export const AccountTagDocument = gql`
    query accountTag($id: UUID!) {
  account(id: $id) {
    id
    name
  }
}
    `;
export type AccountTagComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountTagQuery, AccountTagQueryVariables>, 'query'> & ({ variables: AccountTagQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountTagComponent = (props: AccountTagComponentProps) => (
      <ApolloReactComponents.Query<AccountTagQuery, AccountTagQueryVariables> query={AccountTagDocument} {...props} />
    );
    
export type AccountTagProps<TChildProps = {}> = ApolloReactHoc.DataProps<AccountTagQuery, AccountTagQueryVariables> & TChildProps;
export function withAccountTag<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountTagQuery,
  AccountTagQueryVariables,
  AccountTagProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AccountTagQuery, AccountTagQueryVariables, AccountTagProps<TChildProps>>(AccountTagDocument, {
      alias: 'accountTag',
      ...operationOptions
    });
};

/**
 * __useAccountTagQuery__
 *
 * To run a query within a React component, call `useAccountTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountTagQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountTagQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountTagQuery, AccountTagQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountTagQuery, AccountTagQueryVariables>(AccountTagDocument, baseOptions);
      }
export function useAccountTagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountTagQuery, AccountTagQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountTagQuery, AccountTagQueryVariables>(AccountTagDocument, baseOptions);
        }
export type AccountTagQueryHookResult = ReturnType<typeof useAccountTagQuery>;
export type AccountTagLazyQueryHookResult = ReturnType<typeof useAccountTagLazyQuery>;
export type AccountTagQueryResult = ApolloReactCommon.QueryResult<AccountTagQuery, AccountTagQueryVariables>;
export const AccountDocument = gql`
    query account($id: UUID!) {
  account(id: $id) {
    id
    name
    type
    is_investor
    is_shareholder
    client_type_id
    aum
    aum_secondaries
    net_worth
    state
    country
    city
    notes
    transacted_as
    investor_notes
    shareholder_notes
    participates_in_secondaries
    has_referrer
    referrer_id
    referrer_type
    referral_notes
    referrer {
      id
      name
      entities {
        id
        domicile_country_code
      }
    }
    owners {
      id
      name
      admin_id
      ranking
    }
    has_influence_with {
      id
      company_id
      company_name
    }
    relationship_strength
    relationship_sensitivity
    relationship_notes
    partnerships_relationship_strength
    partnerships_relationship_sensitivity
    partnerships_relationship_notes
    partnerships_notes
    investor_preferences {
      id
      investment_structure_comfort
      target_check_size
      target_regions
      has_cash_on_hand
      minimum_company_valuation
      minimum_company_revenue
      minimum_growth_rate
      only_profitable_companies
      opportunities_of_interest
      sectors_interested
      sectors_avoid
    }
    entities {
      id
      name
      type
    }
  }
}
    `;
export type AccountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountQuery, AccountQueryVariables>, 'query'> & ({ variables: AccountQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountComponent = (props: AccountComponentProps) => (
      <ApolloReactComponents.Query<AccountQuery, AccountQueryVariables> query={AccountDocument} {...props} />
    );
    
export type AccountProps<TChildProps = {}> = ApolloReactHoc.DataProps<AccountQuery, AccountQueryVariables> & TChildProps;
export function withAccount<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountQuery,
  AccountQueryVariables,
  AccountProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AccountQuery, AccountQueryVariables, AccountProps<TChildProps>>(AccountDocument, {
      alias: 'account',
      ...operationOptions
    });
};

/**
 * __useAccountQuery__
 *
 * To run a query within a React component, call `useAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountQuery, AccountQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountQuery, AccountQueryVariables>(AccountDocument, baseOptions);
      }
export function useAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountQuery, AccountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountQuery, AccountQueryVariables>(AccountDocument, baseOptions);
        }
export type AccountQueryHookResult = ReturnType<typeof useAccountQuery>;
export type AccountLazyQueryHookResult = ReturnType<typeof useAccountLazyQuery>;
export type AccountQueryResult = ApolloReactCommon.QueryResult<AccountQuery, AccountQueryVariables>;
export const AccountInteractionsDocument = gql`
    query accountInteractions($id: UUID!, $groupFilter: InteractionFilter) {
  account(id: $id) {
    id
    name
    interactions(groupFilter: $groupFilter) {
      ...InteractionWithRollupsData
    }
  }
}
    ${InteractionWithRollupsDataFragmentDoc}`;
export type AccountInteractionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountInteractionsQuery, AccountInteractionsQueryVariables>, 'query'> & ({ variables: AccountInteractionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountInteractionsComponent = (props: AccountInteractionsComponentProps) => (
      <ApolloReactComponents.Query<AccountInteractionsQuery, AccountInteractionsQueryVariables> query={AccountInteractionsDocument} {...props} />
    );
    
export type AccountInteractionsProps<TChildProps = {}> = ApolloReactHoc.DataProps<AccountInteractionsQuery, AccountInteractionsQueryVariables> & TChildProps;
export function withAccountInteractions<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountInteractionsQuery,
  AccountInteractionsQueryVariables,
  AccountInteractionsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AccountInteractionsQuery, AccountInteractionsQueryVariables, AccountInteractionsProps<TChildProps>>(AccountInteractionsDocument, {
      alias: 'accountInteractions',
      ...operationOptions
    });
};

/**
 * __useAccountInteractionsQuery__
 *
 * To run a query within a React component, call `useAccountInteractionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountInteractionsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountInteractionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      groupFilter: // value for 'groupFilter'
 *   },
 * });
 */
export function useAccountInteractionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountInteractionsQuery, AccountInteractionsQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountInteractionsQuery, AccountInteractionsQueryVariables>(AccountInteractionsDocument, baseOptions);
      }
export function useAccountInteractionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountInteractionsQuery, AccountInteractionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountInteractionsQuery, AccountInteractionsQueryVariables>(AccountInteractionsDocument, baseOptions);
        }
export type AccountInteractionsQueryHookResult = ReturnType<typeof useAccountInteractionsQuery>;
export type AccountInteractionsLazyQueryHookResult = ReturnType<typeof useAccountInteractionsLazyQuery>;
export type AccountInteractionsQueryResult = ApolloReactCommon.QueryResult<AccountInteractionsQuery, AccountInteractionsQueryVariables>;
export const AccountContactsDocument = gql`
    query accountContacts($id: UUID!) {
  account(id: $id) {
    id
    relationships {
      ...AccountRelationshipData
    }
  }
}
    ${AccountRelationshipDataFragmentDoc}`;
export type AccountContactsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountContactsQuery, AccountContactsQueryVariables>, 'query'> & ({ variables: AccountContactsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountContactsComponent = (props: AccountContactsComponentProps) => (
      <ApolloReactComponents.Query<AccountContactsQuery, AccountContactsQueryVariables> query={AccountContactsDocument} {...props} />
    );
    
export type AccountContactsProps<TChildProps = {}> = ApolloReactHoc.DataProps<AccountContactsQuery, AccountContactsQueryVariables> & TChildProps;
export function withAccountContacts<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountContactsQuery,
  AccountContactsQueryVariables,
  AccountContactsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AccountContactsQuery, AccountContactsQueryVariables, AccountContactsProps<TChildProps>>(AccountContactsDocument, {
      alias: 'accountContacts',
      ...operationOptions
    });
};

/**
 * __useAccountContactsQuery__
 *
 * To run a query within a React component, call `useAccountContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountContactsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountContactsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountContactsQuery, AccountContactsQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountContactsQuery, AccountContactsQueryVariables>(AccountContactsDocument, baseOptions);
      }
export function useAccountContactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountContactsQuery, AccountContactsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountContactsQuery, AccountContactsQueryVariables>(AccountContactsDocument, baseOptions);
        }
export type AccountContactsQueryHookResult = ReturnType<typeof useAccountContactsQuery>;
export type AccountContactsLazyQueryHookResult = ReturnType<typeof useAccountContactsLazyQuery>;
export type AccountContactsQueryResult = ApolloReactCommon.QueryResult<AccountContactsQuery, AccountContactsQueryVariables>;
export const AccountRelationshipsDocument = gql`
    query accountRelationships($id: UUID!) {
  account(id: $id) {
    id
    type
    name
    relationships {
      ...AccountRelationshipData
    }
    parents {
      ...AccountRelationshipData
    }
  }
}
    ${AccountRelationshipDataFragmentDoc}`;
export type AccountRelationshipsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountRelationshipsQuery, AccountRelationshipsQueryVariables>, 'query'> & ({ variables: AccountRelationshipsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountRelationshipsComponent = (props: AccountRelationshipsComponentProps) => (
      <ApolloReactComponents.Query<AccountRelationshipsQuery, AccountRelationshipsQueryVariables> query={AccountRelationshipsDocument} {...props} />
    );
    
export type AccountRelationshipsProps<TChildProps = {}> = ApolloReactHoc.DataProps<AccountRelationshipsQuery, AccountRelationshipsQueryVariables> & TChildProps;
export function withAccountRelationships<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountRelationshipsQuery,
  AccountRelationshipsQueryVariables,
  AccountRelationshipsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AccountRelationshipsQuery, AccountRelationshipsQueryVariables, AccountRelationshipsProps<TChildProps>>(AccountRelationshipsDocument, {
      alias: 'accountRelationships',
      ...operationOptions
    });
};

/**
 * __useAccountRelationshipsQuery__
 *
 * To run a query within a React component, call `useAccountRelationshipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountRelationshipsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountRelationshipsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountRelationshipsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountRelationshipsQuery, AccountRelationshipsQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountRelationshipsQuery, AccountRelationshipsQueryVariables>(AccountRelationshipsDocument, baseOptions);
      }
export function useAccountRelationshipsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountRelationshipsQuery, AccountRelationshipsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountRelationshipsQuery, AccountRelationshipsQueryVariables>(AccountRelationshipsDocument, baseOptions);
        }
export type AccountRelationshipsQueryHookResult = ReturnType<typeof useAccountRelationshipsQuery>;
export type AccountRelationshipsLazyQueryHookResult = ReturnType<typeof useAccountRelationshipsLazyQuery>;
export type AccountRelationshipsQueryResult = ApolloReactCommon.QueryResult<AccountRelationshipsQuery, AccountRelationshipsQueryVariables>;
export const CreateOrUpdateAccountRelationshipDocument = gql`
    mutation createOrUpdateAccountRelationship($form: AccountRelationshipFormInput!) {
  createOrUpdateAccountRelationship(form: $form) {
    ...AccountRelationshipData
  }
}
    ${AccountRelationshipDataFragmentDoc}`;
export type CreateOrUpdateAccountRelationshipMutationFn = ApolloReactCommon.MutationFunction<CreateOrUpdateAccountRelationshipMutation, CreateOrUpdateAccountRelationshipMutationVariables>;
export type CreateOrUpdateAccountRelationshipComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateOrUpdateAccountRelationshipMutation, CreateOrUpdateAccountRelationshipMutationVariables>, 'mutation'>;

    export const CreateOrUpdateAccountRelationshipComponent = (props: CreateOrUpdateAccountRelationshipComponentProps) => (
      <ApolloReactComponents.Mutation<CreateOrUpdateAccountRelationshipMutation, CreateOrUpdateAccountRelationshipMutationVariables> mutation={CreateOrUpdateAccountRelationshipDocument} {...props} />
    );
    
export type CreateOrUpdateAccountRelationshipProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CreateOrUpdateAccountRelationshipMutation, CreateOrUpdateAccountRelationshipMutationVariables> & TChildProps;
export function withCreateOrUpdateAccountRelationship<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateOrUpdateAccountRelationshipMutation,
  CreateOrUpdateAccountRelationshipMutationVariables,
  CreateOrUpdateAccountRelationshipProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CreateOrUpdateAccountRelationshipMutation, CreateOrUpdateAccountRelationshipMutationVariables, CreateOrUpdateAccountRelationshipProps<TChildProps>>(CreateOrUpdateAccountRelationshipDocument, {
      alias: 'createOrUpdateAccountRelationship',
      ...operationOptions
    });
};

/**
 * __useCreateOrUpdateAccountRelationshipMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateAccountRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateAccountRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateAccountRelationshipMutation, { data, loading, error }] = useCreateOrUpdateAccountRelationshipMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useCreateOrUpdateAccountRelationshipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrUpdateAccountRelationshipMutation, CreateOrUpdateAccountRelationshipMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateOrUpdateAccountRelationshipMutation, CreateOrUpdateAccountRelationshipMutationVariables>(CreateOrUpdateAccountRelationshipDocument, baseOptions);
      }
export type CreateOrUpdateAccountRelationshipMutationHookResult = ReturnType<typeof useCreateOrUpdateAccountRelationshipMutation>;
export type CreateOrUpdateAccountRelationshipMutationResult = ApolloReactCommon.MutationResult<CreateOrUpdateAccountRelationshipMutation>;
export type CreateOrUpdateAccountRelationshipMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOrUpdateAccountRelationshipMutation, CreateOrUpdateAccountRelationshipMutationVariables>;
export const DeleteRelationshipDocument = gql`
    mutation deleteRelationship($relationshipId: UUID!) {
  deleteAccountRelationship(relationshipId: $relationshipId)
}
    `;
export type DeleteRelationshipMutationFn = ApolloReactCommon.MutationFunction<DeleteRelationshipMutation, DeleteRelationshipMutationVariables>;
export type DeleteRelationshipComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteRelationshipMutation, DeleteRelationshipMutationVariables>, 'mutation'>;

    export const DeleteRelationshipComponent = (props: DeleteRelationshipComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteRelationshipMutation, DeleteRelationshipMutationVariables> mutation={DeleteRelationshipDocument} {...props} />
    );
    
export type DeleteRelationshipProps<TChildProps = {}> = ApolloReactHoc.MutateProps<DeleteRelationshipMutation, DeleteRelationshipMutationVariables> & TChildProps;
export function withDeleteRelationship<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteRelationshipMutation,
  DeleteRelationshipMutationVariables,
  DeleteRelationshipProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteRelationshipMutation, DeleteRelationshipMutationVariables, DeleteRelationshipProps<TChildProps>>(DeleteRelationshipDocument, {
      alias: 'deleteRelationship',
      ...operationOptions
    });
};

/**
 * __useDeleteRelationshipMutation__
 *
 * To run a mutation, you first call `useDeleteRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRelationshipMutation, { data, loading, error }] = useDeleteRelationshipMutation({
 *   variables: {
 *      relationshipId: // value for 'relationshipId'
 *   },
 * });
 */
export function useDeleteRelationshipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRelationshipMutation, DeleteRelationshipMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteRelationshipMutation, DeleteRelationshipMutationVariables>(DeleteRelationshipDocument, baseOptions);
      }
export type DeleteRelationshipMutationHookResult = ReturnType<typeof useDeleteRelationshipMutation>;
export type DeleteRelationshipMutationResult = ApolloReactCommon.MutationResult<DeleteRelationshipMutation>;
export type DeleteRelationshipMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteRelationshipMutation, DeleteRelationshipMutationVariables>;
export const AccountsTypeaheadDocument = gql`
    query accountsTypeahead($query: String!) {
  accountsTypeahead(query: $query, limit: 10, filter: {types: ["individual", "organization"]}) {
    id
    type
    name
    email
    client_type
  }
}
    `;
export type AccountsTypeaheadComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountsTypeaheadQuery, AccountsTypeaheadQueryVariables>, 'query'> & ({ variables: AccountsTypeaheadQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountsTypeaheadComponent = (props: AccountsTypeaheadComponentProps) => (
      <ApolloReactComponents.Query<AccountsTypeaheadQuery, AccountsTypeaheadQueryVariables> query={AccountsTypeaheadDocument} {...props} />
    );
    
export type AccountsTypeaheadProps<TChildProps = {}> = ApolloReactHoc.DataProps<AccountsTypeaheadQuery, AccountsTypeaheadQueryVariables> & TChildProps;
export function withAccountsTypeahead<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountsTypeaheadQuery,
  AccountsTypeaheadQueryVariables,
  AccountsTypeaheadProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AccountsTypeaheadQuery, AccountsTypeaheadQueryVariables, AccountsTypeaheadProps<TChildProps>>(AccountsTypeaheadDocument, {
      alias: 'accountsTypeahead',
      ...operationOptions
    });
};

/**
 * __useAccountsTypeaheadQuery__
 *
 * To run a query within a React component, call `useAccountsTypeaheadQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsTypeaheadQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsTypeaheadQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAccountsTypeaheadQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountsTypeaheadQuery, AccountsTypeaheadQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountsTypeaheadQuery, AccountsTypeaheadQueryVariables>(AccountsTypeaheadDocument, baseOptions);
      }
export function useAccountsTypeaheadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountsTypeaheadQuery, AccountsTypeaheadQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountsTypeaheadQuery, AccountsTypeaheadQueryVariables>(AccountsTypeaheadDocument, baseOptions);
        }
export type AccountsTypeaheadQueryHookResult = ReturnType<typeof useAccountsTypeaheadQuery>;
export type AccountsTypeaheadLazyQueryHookResult = ReturnType<typeof useAccountsTypeaheadLazyQuery>;
export type AccountsTypeaheadQueryResult = ApolloReactCommon.QueryResult<AccountsTypeaheadQuery, AccountsTypeaheadQueryVariables>;
export const IssuersTypeaheadDocument = gql`
    query issuersTypeahead($query: String!) {
  accountsTypeahead(query: $query, limit: 10, filter: {types: ["issuer"]}) {
    id
    name
    issuer_account {
      id
      company {
        id
        domain
      }
    }
  }
}
    `;
export type IssuersTypeaheadComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<IssuersTypeaheadQuery, IssuersTypeaheadQueryVariables>, 'query'> & ({ variables: IssuersTypeaheadQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const IssuersTypeaheadComponent = (props: IssuersTypeaheadComponentProps) => (
      <ApolloReactComponents.Query<IssuersTypeaheadQuery, IssuersTypeaheadQueryVariables> query={IssuersTypeaheadDocument} {...props} />
    );
    
export type IssuersTypeaheadProps<TChildProps = {}> = ApolloReactHoc.DataProps<IssuersTypeaheadQuery, IssuersTypeaheadQueryVariables> & TChildProps;
export function withIssuersTypeahead<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IssuersTypeaheadQuery,
  IssuersTypeaheadQueryVariables,
  IssuersTypeaheadProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, IssuersTypeaheadQuery, IssuersTypeaheadQueryVariables, IssuersTypeaheadProps<TChildProps>>(IssuersTypeaheadDocument, {
      alias: 'issuersTypeahead',
      ...operationOptions
    });
};

/**
 * __useIssuersTypeaheadQuery__
 *
 * To run a query within a React component, call `useIssuersTypeaheadQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssuersTypeaheadQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssuersTypeaheadQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useIssuersTypeaheadQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IssuersTypeaheadQuery, IssuersTypeaheadQueryVariables>) {
        return ApolloReactHooks.useQuery<IssuersTypeaheadQuery, IssuersTypeaheadQueryVariables>(IssuersTypeaheadDocument, baseOptions);
      }
export function useIssuersTypeaheadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IssuersTypeaheadQuery, IssuersTypeaheadQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IssuersTypeaheadQuery, IssuersTypeaheadQueryVariables>(IssuersTypeaheadDocument, baseOptions);
        }
export type IssuersTypeaheadQueryHookResult = ReturnType<typeof useIssuersTypeaheadQuery>;
export type IssuersTypeaheadLazyQueryHookResult = ReturnType<typeof useIssuersTypeaheadLazyQuery>;
export type IssuersTypeaheadQueryResult = ApolloReactCommon.QueryResult<IssuersTypeaheadQuery, IssuersTypeaheadQueryVariables>;
export const AccountsTypeaheadWithTypesDocument = gql`
    query accountsTypeaheadWithTypes($query: String!) {
  accountsTypeahead(query: $query, limit: 10, filter: {types: ["individual", "organization"]}) {
    ...AccountWithType
  }
}
    ${AccountWithTypeFragmentDoc}`;
export type AccountsTypeaheadWithTypesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountsTypeaheadWithTypesQuery, AccountsTypeaheadWithTypesQueryVariables>, 'query'> & ({ variables: AccountsTypeaheadWithTypesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountsTypeaheadWithTypesComponent = (props: AccountsTypeaheadWithTypesComponentProps) => (
      <ApolloReactComponents.Query<AccountsTypeaheadWithTypesQuery, AccountsTypeaheadWithTypesQueryVariables> query={AccountsTypeaheadWithTypesDocument} {...props} />
    );
    
export type AccountsTypeaheadWithTypesProps<TChildProps = {}> = ApolloReactHoc.DataProps<AccountsTypeaheadWithTypesQuery, AccountsTypeaheadWithTypesQueryVariables> & TChildProps;
export function withAccountsTypeaheadWithTypes<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountsTypeaheadWithTypesQuery,
  AccountsTypeaheadWithTypesQueryVariables,
  AccountsTypeaheadWithTypesProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AccountsTypeaheadWithTypesQuery, AccountsTypeaheadWithTypesQueryVariables, AccountsTypeaheadWithTypesProps<TChildProps>>(AccountsTypeaheadWithTypesDocument, {
      alias: 'accountsTypeaheadWithTypes',
      ...operationOptions
    });
};

/**
 * __useAccountsTypeaheadWithTypesQuery__
 *
 * To run a query within a React component, call `useAccountsTypeaheadWithTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsTypeaheadWithTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsTypeaheadWithTypesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAccountsTypeaheadWithTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountsTypeaheadWithTypesQuery, AccountsTypeaheadWithTypesQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountsTypeaheadWithTypesQuery, AccountsTypeaheadWithTypesQueryVariables>(AccountsTypeaheadWithTypesDocument, baseOptions);
      }
export function useAccountsTypeaheadWithTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountsTypeaheadWithTypesQuery, AccountsTypeaheadWithTypesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountsTypeaheadWithTypesQuery, AccountsTypeaheadWithTypesQueryVariables>(AccountsTypeaheadWithTypesDocument, baseOptions);
        }
export type AccountsTypeaheadWithTypesQueryHookResult = ReturnType<typeof useAccountsTypeaheadWithTypesQuery>;
export type AccountsTypeaheadWithTypesLazyQueryHookResult = ReturnType<typeof useAccountsTypeaheadWithTypesLazyQuery>;
export type AccountsTypeaheadWithTypesQueryResult = ApolloReactCommon.QueryResult<AccountsTypeaheadWithTypesQuery, AccountsTypeaheadWithTypesQueryVariables>;
export const IndividualAccountsTypeaheadDocument = gql`
    query individualAccountsTypeahead($query: String!) {
  accountsTypeahead(query: $query, limit: 10, filter: {types: ["individual"]}) {
    ...RelatedAccount
  }
}
    ${RelatedAccountFragmentDoc}`;
export type IndividualAccountsTypeaheadComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<IndividualAccountsTypeaheadQuery, IndividualAccountsTypeaheadQueryVariables>, 'query'> & ({ variables: IndividualAccountsTypeaheadQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const IndividualAccountsTypeaheadComponent = (props: IndividualAccountsTypeaheadComponentProps) => (
      <ApolloReactComponents.Query<IndividualAccountsTypeaheadQuery, IndividualAccountsTypeaheadQueryVariables> query={IndividualAccountsTypeaheadDocument} {...props} />
    );
    
export type IndividualAccountsTypeaheadProps<TChildProps = {}> = ApolloReactHoc.DataProps<IndividualAccountsTypeaheadQuery, IndividualAccountsTypeaheadQueryVariables> & TChildProps;
export function withIndividualAccountsTypeahead<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IndividualAccountsTypeaheadQuery,
  IndividualAccountsTypeaheadQueryVariables,
  IndividualAccountsTypeaheadProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, IndividualAccountsTypeaheadQuery, IndividualAccountsTypeaheadQueryVariables, IndividualAccountsTypeaheadProps<TChildProps>>(IndividualAccountsTypeaheadDocument, {
      alias: 'individualAccountsTypeahead',
      ...operationOptions
    });
};

/**
 * __useIndividualAccountsTypeaheadQuery__
 *
 * To run a query within a React component, call `useIndividualAccountsTypeaheadQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndividualAccountsTypeaheadQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndividualAccountsTypeaheadQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useIndividualAccountsTypeaheadQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IndividualAccountsTypeaheadQuery, IndividualAccountsTypeaheadQueryVariables>) {
        return ApolloReactHooks.useQuery<IndividualAccountsTypeaheadQuery, IndividualAccountsTypeaheadQueryVariables>(IndividualAccountsTypeaheadDocument, baseOptions);
      }
export function useIndividualAccountsTypeaheadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IndividualAccountsTypeaheadQuery, IndividualAccountsTypeaheadQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IndividualAccountsTypeaheadQuery, IndividualAccountsTypeaheadQueryVariables>(IndividualAccountsTypeaheadDocument, baseOptions);
        }
export type IndividualAccountsTypeaheadQueryHookResult = ReturnType<typeof useIndividualAccountsTypeaheadQuery>;
export type IndividualAccountsTypeaheadLazyQueryHookResult = ReturnType<typeof useIndividualAccountsTypeaheadLazyQuery>;
export type IndividualAccountsTypeaheadQueryResult = ApolloReactCommon.QueryResult<IndividualAccountsTypeaheadQuery, IndividualAccountsTypeaheadQueryVariables>;
export const CompanyTypeAheadDocument = gql`
    query companyTypeAhead($query: String!) {
  companyTypeahead(query: $query, limit: 10) {
    id
    name
    domain
  }
}
    `;
export type CompanyTypeAheadComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CompanyTypeAheadQuery, CompanyTypeAheadQueryVariables>, 'query'> & ({ variables: CompanyTypeAheadQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CompanyTypeAheadComponent = (props: CompanyTypeAheadComponentProps) => (
      <ApolloReactComponents.Query<CompanyTypeAheadQuery, CompanyTypeAheadQueryVariables> query={CompanyTypeAheadDocument} {...props} />
    );
    
export type CompanyTypeAheadProps<TChildProps = {}> = ApolloReactHoc.DataProps<CompanyTypeAheadQuery, CompanyTypeAheadQueryVariables> & TChildProps;
export function withCompanyTypeAhead<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CompanyTypeAheadQuery,
  CompanyTypeAheadQueryVariables,
  CompanyTypeAheadProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, CompanyTypeAheadQuery, CompanyTypeAheadQueryVariables, CompanyTypeAheadProps<TChildProps>>(CompanyTypeAheadDocument, {
      alias: 'companyTypeAhead',
      ...operationOptions
    });
};

/**
 * __useCompanyTypeAheadQuery__
 *
 * To run a query within a React component, call `useCompanyTypeAheadQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyTypeAheadQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyTypeAheadQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useCompanyTypeAheadQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CompanyTypeAheadQuery, CompanyTypeAheadQueryVariables>) {
        return ApolloReactHooks.useQuery<CompanyTypeAheadQuery, CompanyTypeAheadQueryVariables>(CompanyTypeAheadDocument, baseOptions);
      }
export function useCompanyTypeAheadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyTypeAheadQuery, CompanyTypeAheadQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CompanyTypeAheadQuery, CompanyTypeAheadQueryVariables>(CompanyTypeAheadDocument, baseOptions);
        }
export type CompanyTypeAheadQueryHookResult = ReturnType<typeof useCompanyTypeAheadQuery>;
export type CompanyTypeAheadLazyQueryHookResult = ReturnType<typeof useCompanyTypeAheadLazyQuery>;
export type CompanyTypeAheadQueryResult = ApolloReactCommon.QueryResult<CompanyTypeAheadQuery, CompanyTypeAheadQueryVariables>;
export const AdminTypeAheadDocument = gql`
    query adminTypeAhead($query: String!) {
  adminTypeAhead(query: $query, limit: 10) {
    id
    first_name
    last_name
    name
  }
}
    `;
export type AdminTypeAheadComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AdminTypeAheadQuery, AdminTypeAheadQueryVariables>, 'query'> & ({ variables: AdminTypeAheadQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AdminTypeAheadComponent = (props: AdminTypeAheadComponentProps) => (
      <ApolloReactComponents.Query<AdminTypeAheadQuery, AdminTypeAheadQueryVariables> query={AdminTypeAheadDocument} {...props} />
    );
    
export type AdminTypeAheadProps<TChildProps = {}> = ApolloReactHoc.DataProps<AdminTypeAheadQuery, AdminTypeAheadQueryVariables> & TChildProps;
export function withAdminTypeAhead<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AdminTypeAheadQuery,
  AdminTypeAheadQueryVariables,
  AdminTypeAheadProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AdminTypeAheadQuery, AdminTypeAheadQueryVariables, AdminTypeAheadProps<TChildProps>>(AdminTypeAheadDocument, {
      alias: 'adminTypeAhead',
      ...operationOptions
    });
};

/**
 * __useAdminTypeAheadQuery__
 *
 * To run a query within a React component, call `useAdminTypeAheadQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminTypeAheadQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminTypeAheadQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAdminTypeAheadQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminTypeAheadQuery, AdminTypeAheadQueryVariables>) {
        return ApolloReactHooks.useQuery<AdminTypeAheadQuery, AdminTypeAheadQueryVariables>(AdminTypeAheadDocument, baseOptions);
      }
export function useAdminTypeAheadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminTypeAheadQuery, AdminTypeAheadQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AdminTypeAheadQuery, AdminTypeAheadQueryVariables>(AdminTypeAheadDocument, baseOptions);
        }
export type AdminTypeAheadQueryHookResult = ReturnType<typeof useAdminTypeAheadQuery>;
export type AdminTypeAheadLazyQueryHookResult = ReturnType<typeof useAdminTypeAheadLazyQuery>;
export type AdminTypeAheadQueryResult = ApolloReactCommon.QueryResult<AdminTypeAheadQuery, AdminTypeAheadQueryVariables>;
export const AccountNameDocument = gql`
    query accountName($id: UUID!) {
  account(id: $id) {
    id
    name
  }
}
    `;
export type AccountNameComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountNameQuery, AccountNameQueryVariables>, 'query'> & ({ variables: AccountNameQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountNameComponent = (props: AccountNameComponentProps) => (
      <ApolloReactComponents.Query<AccountNameQuery, AccountNameQueryVariables> query={AccountNameDocument} {...props} />
    );
    
export type AccountNameProps<TChildProps = {}> = ApolloReactHoc.DataProps<AccountNameQuery, AccountNameQueryVariables> & TChildProps;
export function withAccountName<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountNameQuery,
  AccountNameQueryVariables,
  AccountNameProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AccountNameQuery, AccountNameQueryVariables, AccountNameProps<TChildProps>>(AccountNameDocument, {
      alias: 'accountName',
      ...operationOptions
    });
};

/**
 * __useAccountNameQuery__
 *
 * To run a query within a React component, call `useAccountNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountNameQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountNameQuery, AccountNameQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountNameQuery, AccountNameQueryVariables>(AccountNameDocument, baseOptions);
      }
export function useAccountNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountNameQuery, AccountNameQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountNameQuery, AccountNameQueryVariables>(AccountNameDocument, baseOptions);
        }
export type AccountNameQueryHookResult = ReturnType<typeof useAccountNameQuery>;
export type AccountNameLazyQueryHookResult = ReturnType<typeof useAccountNameLazyQuery>;
export type AccountNameQueryResult = ApolloReactCommon.QueryResult<AccountNameQuery, AccountNameQueryVariables>;
export const IssuerDocument = gql`
    query issuer($id: UUID!) {
  account(id: $id) {
    ...Issuer
  }
}
    ${IssuerFragmentDoc}`;
export type IssuerComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<IssuerQuery, IssuerQueryVariables>, 'query'> & ({ variables: IssuerQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const IssuerComponent = (props: IssuerComponentProps) => (
      <ApolloReactComponents.Query<IssuerQuery, IssuerQueryVariables> query={IssuerDocument} {...props} />
    );
    
export type IssuerProps<TChildProps = {}> = ApolloReactHoc.DataProps<IssuerQuery, IssuerQueryVariables> & TChildProps;
export function withIssuer<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IssuerQuery,
  IssuerQueryVariables,
  IssuerProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, IssuerQuery, IssuerQueryVariables, IssuerProps<TChildProps>>(IssuerDocument, {
      alias: 'issuer',
      ...operationOptions
    });
};

/**
 * __useIssuerQuery__
 *
 * To run a query within a React component, call `useIssuerQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssuerQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssuerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIssuerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IssuerQuery, IssuerQueryVariables>) {
        return ApolloReactHooks.useQuery<IssuerQuery, IssuerQueryVariables>(IssuerDocument, baseOptions);
      }
export function useIssuerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IssuerQuery, IssuerQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IssuerQuery, IssuerQueryVariables>(IssuerDocument, baseOptions);
        }
export type IssuerQueryHookResult = ReturnType<typeof useIssuerQuery>;
export type IssuerLazyQueryHookResult = ReturnType<typeof useIssuerLazyQuery>;
export type IssuerQueryResult = ApolloReactCommon.QueryResult<IssuerQuery, IssuerQueryVariables>;
export const IssuerTradeSummaryDocument = gql`
    query issuerTradeSummary($id: UUID!) {
  account(id: $id) {
    id
    issuer_account {
      id
      transaction_summary {
        ...TransactionSummary
      }
      deals {
        ...issuerDeal
      }
    }
  }
}
    ${TransactionSummaryFragmentDoc}
${IssuerDealFragmentDoc}`;
export type IssuerTradeSummaryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<IssuerTradeSummaryQuery, IssuerTradeSummaryQueryVariables>, 'query'> & ({ variables: IssuerTradeSummaryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const IssuerTradeSummaryComponent = (props: IssuerTradeSummaryComponentProps) => (
      <ApolloReactComponents.Query<IssuerTradeSummaryQuery, IssuerTradeSummaryQueryVariables> query={IssuerTradeSummaryDocument} {...props} />
    );
    
export type IssuerTradeSummaryProps<TChildProps = {}> = ApolloReactHoc.DataProps<IssuerTradeSummaryQuery, IssuerTradeSummaryQueryVariables> & TChildProps;
export function withIssuerTradeSummary<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IssuerTradeSummaryQuery,
  IssuerTradeSummaryQueryVariables,
  IssuerTradeSummaryProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, IssuerTradeSummaryQuery, IssuerTradeSummaryQueryVariables, IssuerTradeSummaryProps<TChildProps>>(IssuerTradeSummaryDocument, {
      alias: 'issuerTradeSummary',
      ...operationOptions
    });
};

/**
 * __useIssuerTradeSummaryQuery__
 *
 * To run a query within a React component, call `useIssuerTradeSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssuerTradeSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssuerTradeSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIssuerTradeSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IssuerTradeSummaryQuery, IssuerTradeSummaryQueryVariables>) {
        return ApolloReactHooks.useQuery<IssuerTradeSummaryQuery, IssuerTradeSummaryQueryVariables>(IssuerTradeSummaryDocument, baseOptions);
      }
export function useIssuerTradeSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IssuerTradeSummaryQuery, IssuerTradeSummaryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IssuerTradeSummaryQuery, IssuerTradeSummaryQueryVariables>(IssuerTradeSummaryDocument, baseOptions);
        }
export type IssuerTradeSummaryQueryHookResult = ReturnType<typeof useIssuerTradeSummaryQuery>;
export type IssuerTradeSummaryLazyQueryHookResult = ReturnType<typeof useIssuerTradeSummaryLazyQuery>;
export type IssuerTradeSummaryQueryResult = ApolloReactCommon.QueryResult<IssuerTradeSummaryQuery, IssuerTradeSummaryQueryVariables>;
export const CreateAccountDocument = gql`
    mutation createAccount($form: CreateAccountFormInput!) {
  createAccount(form: $form) {
    ...AccountHeader
  }
}
    ${AccountHeaderFragmentDoc}`;
export type CreateAccountMutationFn = ApolloReactCommon.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;
export type CreateAccountComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateAccountMutation, CreateAccountMutationVariables>, 'mutation'>;

    export const CreateAccountComponent = (props: CreateAccountComponentProps) => (
      <ApolloReactComponents.Mutation<CreateAccountMutation, CreateAccountMutationVariables> mutation={CreateAccountDocument} {...props} />
    );
    
export type CreateAccountProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CreateAccountMutation, CreateAccountMutationVariables> & TChildProps;
export function withCreateAccount<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateAccountMutation,
  CreateAccountMutationVariables,
  CreateAccountProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CreateAccountMutation, CreateAccountMutationVariables, CreateAccountProps<TChildProps>>(CreateAccountDocument, {
      alias: 'createAccount',
      ...operationOptions
    });
};

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, baseOptions);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = ApolloReactCommon.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const AccountHeaderDocument = gql`
    query accountHeader($id: UUID!) {
  account(id: $id) {
    ...AccountHeader
  }
}
    ${AccountHeaderFragmentDoc}`;
export type AccountHeaderComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountHeaderQuery, AccountHeaderQueryVariables>, 'query'> & ({ variables: AccountHeaderQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountHeaderComponent = (props: AccountHeaderComponentProps) => (
      <ApolloReactComponents.Query<AccountHeaderQuery, AccountHeaderQueryVariables> query={AccountHeaderDocument} {...props} />
    );
    
export type AccountHeaderProps<TChildProps = {}> = ApolloReactHoc.DataProps<AccountHeaderQuery, AccountHeaderQueryVariables> & TChildProps;
export function withAccountHeader<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountHeaderQuery,
  AccountHeaderQueryVariables,
  AccountHeaderProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AccountHeaderQuery, AccountHeaderQueryVariables, AccountHeaderProps<TChildProps>>(AccountHeaderDocument, {
      alias: 'accountHeader',
      ...operationOptions
    });
};

/**
 * __useAccountHeaderQuery__
 *
 * To run a query within a React component, call `useAccountHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountHeaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountHeaderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountHeaderQuery, AccountHeaderQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountHeaderQuery, AccountHeaderQueryVariables>(AccountHeaderDocument, baseOptions);
      }
export function useAccountHeaderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountHeaderQuery, AccountHeaderQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountHeaderQuery, AccountHeaderQueryVariables>(AccountHeaderDocument, baseOptions);
        }
export type AccountHeaderQueryHookResult = ReturnType<typeof useAccountHeaderQuery>;
export type AccountHeaderLazyQueryHookResult = ReturnType<typeof useAccountHeaderLazyQuery>;
export type AccountHeaderQueryResult = ApolloReactCommon.QueryResult<AccountHeaderQuery, AccountHeaderQueryVariables>;
export const ClientDetailsDataDocument = gql`
    query ClientDetailsData($id: UUID!) {
  account(id: $id) {
    ...ClientDetails
  }
}
    ${ClientDetailsFragmentDoc}`;
export type ClientDetailsDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ClientDetailsDataQuery, ClientDetailsDataQueryVariables>, 'query'> & ({ variables: ClientDetailsDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ClientDetailsDataComponent = (props: ClientDetailsDataComponentProps) => (
      <ApolloReactComponents.Query<ClientDetailsDataQuery, ClientDetailsDataQueryVariables> query={ClientDetailsDataDocument} {...props} />
    );
    
export type ClientDetailsDataProps<TChildProps = {}> = ApolloReactHoc.DataProps<ClientDetailsDataQuery, ClientDetailsDataQueryVariables> & TChildProps;
export function withClientDetailsData<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ClientDetailsDataQuery,
  ClientDetailsDataQueryVariables,
  ClientDetailsDataProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, ClientDetailsDataQuery, ClientDetailsDataQueryVariables, ClientDetailsDataProps<TChildProps>>(ClientDetailsDataDocument, {
      alias: 'clientDetailsData',
      ...operationOptions
    });
};

/**
 * __useClientDetailsDataQuery__
 *
 * To run a query within a React component, call `useClientDetailsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientDetailsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientDetailsDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientDetailsDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ClientDetailsDataQuery, ClientDetailsDataQueryVariables>) {
        return ApolloReactHooks.useQuery<ClientDetailsDataQuery, ClientDetailsDataQueryVariables>(ClientDetailsDataDocument, baseOptions);
      }
export function useClientDetailsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClientDetailsDataQuery, ClientDetailsDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ClientDetailsDataQuery, ClientDetailsDataQueryVariables>(ClientDetailsDataDocument, baseOptions);
        }
export type ClientDetailsDataQueryHookResult = ReturnType<typeof useClientDetailsDataQuery>;
export type ClientDetailsDataLazyQueryHookResult = ReturnType<typeof useClientDetailsDataLazyQuery>;
export type ClientDetailsDataQueryResult = ApolloReactCommon.QueryResult<ClientDetailsDataQuery, ClientDetailsDataQueryVariables>;
export const InvestorDetailsDataDocument = gql`
    query InvestorDetailsData($id: UUID!) {
  account(id: $id) {
    ...InvestorDetails
  }
}
    ${InvestorDetailsFragmentDoc}`;
export type InvestorDetailsDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<InvestorDetailsDataQuery, InvestorDetailsDataQueryVariables>, 'query'> & ({ variables: InvestorDetailsDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const InvestorDetailsDataComponent = (props: InvestorDetailsDataComponentProps) => (
      <ApolloReactComponents.Query<InvestorDetailsDataQuery, InvestorDetailsDataQueryVariables> query={InvestorDetailsDataDocument} {...props} />
    );
    
export type InvestorDetailsDataProps<TChildProps = {}> = ApolloReactHoc.DataProps<InvestorDetailsDataQuery, InvestorDetailsDataQueryVariables> & TChildProps;
export function withInvestorDetailsData<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InvestorDetailsDataQuery,
  InvestorDetailsDataQueryVariables,
  InvestorDetailsDataProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, InvestorDetailsDataQuery, InvestorDetailsDataQueryVariables, InvestorDetailsDataProps<TChildProps>>(InvestorDetailsDataDocument, {
      alias: 'investorDetailsData',
      ...operationOptions
    });
};

/**
 * __useInvestorDetailsDataQuery__
 *
 * To run a query within a React component, call `useInvestorDetailsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorDetailsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorDetailsDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvestorDetailsDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InvestorDetailsDataQuery, InvestorDetailsDataQueryVariables>) {
        return ApolloReactHooks.useQuery<InvestorDetailsDataQuery, InvestorDetailsDataQueryVariables>(InvestorDetailsDataDocument, baseOptions);
      }
export function useInvestorDetailsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InvestorDetailsDataQuery, InvestorDetailsDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<InvestorDetailsDataQuery, InvestorDetailsDataQueryVariables>(InvestorDetailsDataDocument, baseOptions);
        }
export type InvestorDetailsDataQueryHookResult = ReturnType<typeof useInvestorDetailsDataQuery>;
export type InvestorDetailsDataLazyQueryHookResult = ReturnType<typeof useInvestorDetailsDataLazyQuery>;
export type InvestorDetailsDataQueryResult = ApolloReactCommon.QueryResult<InvestorDetailsDataQuery, InvestorDetailsDataQueryVariables>;
export const ShareholderDetailsDataDocument = gql`
    query ShareholderDetailsData($id: UUID!) {
  account(id: $id) {
    ...ShareholderDetails
  }
}
    ${ShareholderDetailsFragmentDoc}`;
export type ShareholderDetailsDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShareholderDetailsDataQuery, ShareholderDetailsDataQueryVariables>, 'query'> & ({ variables: ShareholderDetailsDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShareholderDetailsDataComponent = (props: ShareholderDetailsDataComponentProps) => (
      <ApolloReactComponents.Query<ShareholderDetailsDataQuery, ShareholderDetailsDataQueryVariables> query={ShareholderDetailsDataDocument} {...props} />
    );
    
export type ShareholderDetailsDataProps<TChildProps = {}> = ApolloReactHoc.DataProps<ShareholderDetailsDataQuery, ShareholderDetailsDataQueryVariables> & TChildProps;
export function withShareholderDetailsData<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ShareholderDetailsDataQuery,
  ShareholderDetailsDataQueryVariables,
  ShareholderDetailsDataProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, ShareholderDetailsDataQuery, ShareholderDetailsDataQueryVariables, ShareholderDetailsDataProps<TChildProps>>(ShareholderDetailsDataDocument, {
      alias: 'shareholderDetailsData',
      ...operationOptions
    });
};

/**
 * __useShareholderDetailsDataQuery__
 *
 * To run a query within a React component, call `useShareholderDetailsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareholderDetailsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareholderDetailsDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useShareholderDetailsDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ShareholderDetailsDataQuery, ShareholderDetailsDataQueryVariables>) {
        return ApolloReactHooks.useQuery<ShareholderDetailsDataQuery, ShareholderDetailsDataQueryVariables>(ShareholderDetailsDataDocument, baseOptions);
      }
export function useShareholderDetailsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShareholderDetailsDataQuery, ShareholderDetailsDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ShareholderDetailsDataQuery, ShareholderDetailsDataQueryVariables>(ShareholderDetailsDataDocument, baseOptions);
        }
export type ShareholderDetailsDataQueryHookResult = ReturnType<typeof useShareholderDetailsDataQuery>;
export type ShareholderDetailsDataLazyQueryHookResult = ReturnType<typeof useShareholderDetailsDataLazyQuery>;
export type ShareholderDetailsDataQueryResult = ApolloReactCommon.QueryResult<ShareholderDetailsDataQuery, ShareholderDetailsDataQueryVariables>;
export const BaseAccountDocument = gql`
    query BaseAccount($id: UUID!) {
  account(id: $id) {
    id
    type
    is_shareholder
    is_investor
    opportunities {
      id
    }
  }
}
    `;
export type BaseAccountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BaseAccountQuery, BaseAccountQueryVariables>, 'query'> & ({ variables: BaseAccountQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BaseAccountComponent = (props: BaseAccountComponentProps) => (
      <ApolloReactComponents.Query<BaseAccountQuery, BaseAccountQueryVariables> query={BaseAccountDocument} {...props} />
    );
    
export type BaseAccountProps<TChildProps = {}> = ApolloReactHoc.DataProps<BaseAccountQuery, BaseAccountQueryVariables> & TChildProps;
export function withBaseAccount<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BaseAccountQuery,
  BaseAccountQueryVariables,
  BaseAccountProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, BaseAccountQuery, BaseAccountQueryVariables, BaseAccountProps<TChildProps>>(BaseAccountDocument, {
      alias: 'baseAccount',
      ...operationOptions
    });
};

/**
 * __useBaseAccountQuery__
 *
 * To run a query within a React component, call `useBaseAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useBaseAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBaseAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBaseAccountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BaseAccountQuery, BaseAccountQueryVariables>) {
        return ApolloReactHooks.useQuery<BaseAccountQuery, BaseAccountQueryVariables>(BaseAccountDocument, baseOptions);
      }
export function useBaseAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BaseAccountQuery, BaseAccountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BaseAccountQuery, BaseAccountQueryVariables>(BaseAccountDocument, baseOptions);
        }
export type BaseAccountQueryHookResult = ReturnType<typeof useBaseAccountQuery>;
export type BaseAccountLazyQueryHookResult = ReturnType<typeof useBaseAccountLazyQuery>;
export type BaseAccountQueryResult = ApolloReactCommon.QueryResult<BaseAccountQuery, BaseAccountQueryVariables>;
export const AccountReferralsDocument = gql`
    query accountReferrals($id: UUID!) {
  account(id: $id) {
    id
    referrer_type
    referral_notes
    referrer {
      id
      name
    }
  }
}
    `;
export type AccountReferralsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountReferralsQuery, AccountReferralsQueryVariables>, 'query'> & ({ variables: AccountReferralsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountReferralsComponent = (props: AccountReferralsComponentProps) => (
      <ApolloReactComponents.Query<AccountReferralsQuery, AccountReferralsQueryVariables> query={AccountReferralsDocument} {...props} />
    );
    
export type AccountReferralsProps<TChildProps = {}> = ApolloReactHoc.DataProps<AccountReferralsQuery, AccountReferralsQueryVariables> & TChildProps;
export function withAccountReferrals<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountReferralsQuery,
  AccountReferralsQueryVariables,
  AccountReferralsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AccountReferralsQuery, AccountReferralsQueryVariables, AccountReferralsProps<TChildProps>>(AccountReferralsDocument, {
      alias: 'accountReferrals',
      ...operationOptions
    });
};

/**
 * __useAccountReferralsQuery__
 *
 * To run a query within a React component, call `useAccountReferralsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountReferralsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountReferralsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountReferralsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountReferralsQuery, AccountReferralsQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountReferralsQuery, AccountReferralsQueryVariables>(AccountReferralsDocument, baseOptions);
      }
export function useAccountReferralsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountReferralsQuery, AccountReferralsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountReferralsQuery, AccountReferralsQueryVariables>(AccountReferralsDocument, baseOptions);
        }
export type AccountReferralsQueryHookResult = ReturnType<typeof useAccountReferralsQuery>;
export type AccountReferralsLazyQueryHookResult = ReturnType<typeof useAccountReferralsLazyQuery>;
export type AccountReferralsQueryResult = ApolloReactCommon.QueryResult<AccountReferralsQuery, AccountReferralsQueryVariables>;
export const MinimalAccountRelationshipsDocument = gql`
    query minimalAccountRelationships($id: UUID!) {
  account(id: $id) {
    id
    name
    intermediary {
      id
    }
    type
    introducedRelationships {
      ...ParentOrChildRelationship
      ...Introduction
    }
    introducedByRelationships {
      ...ParentOrChildRelationship
      ...Introduction
    }
    relationships {
      ...ChildRelationship
    }
    parents {
      ...ParentRelationship
    }
  }
}
    ${ParentOrChildRelationshipFragmentDoc}
${IntroductionFragmentDoc}
${ChildRelationshipFragmentDoc}
${ParentRelationshipFragmentDoc}`;
export type MinimalAccountRelationshipsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MinimalAccountRelationshipsQuery, MinimalAccountRelationshipsQueryVariables>, 'query'> & ({ variables: MinimalAccountRelationshipsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MinimalAccountRelationshipsComponent = (props: MinimalAccountRelationshipsComponentProps) => (
      <ApolloReactComponents.Query<MinimalAccountRelationshipsQuery, MinimalAccountRelationshipsQueryVariables> query={MinimalAccountRelationshipsDocument} {...props} />
    );
    
export type MinimalAccountRelationshipsProps<TChildProps = {}> = ApolloReactHoc.DataProps<MinimalAccountRelationshipsQuery, MinimalAccountRelationshipsQueryVariables> & TChildProps;
export function withMinimalAccountRelationships<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MinimalAccountRelationshipsQuery,
  MinimalAccountRelationshipsQueryVariables,
  MinimalAccountRelationshipsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, MinimalAccountRelationshipsQuery, MinimalAccountRelationshipsQueryVariables, MinimalAccountRelationshipsProps<TChildProps>>(MinimalAccountRelationshipsDocument, {
      alias: 'minimalAccountRelationships',
      ...operationOptions
    });
};

/**
 * __useMinimalAccountRelationshipsQuery__
 *
 * To run a query within a React component, call `useMinimalAccountRelationshipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMinimalAccountRelationshipsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMinimalAccountRelationshipsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMinimalAccountRelationshipsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MinimalAccountRelationshipsQuery, MinimalAccountRelationshipsQueryVariables>) {
        return ApolloReactHooks.useQuery<MinimalAccountRelationshipsQuery, MinimalAccountRelationshipsQueryVariables>(MinimalAccountRelationshipsDocument, baseOptions);
      }
export function useMinimalAccountRelationshipsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MinimalAccountRelationshipsQuery, MinimalAccountRelationshipsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MinimalAccountRelationshipsQuery, MinimalAccountRelationshipsQueryVariables>(MinimalAccountRelationshipsDocument, baseOptions);
        }
export type MinimalAccountRelationshipsQueryHookResult = ReturnType<typeof useMinimalAccountRelationshipsQuery>;
export type MinimalAccountRelationshipsLazyQueryHookResult = ReturnType<typeof useMinimalAccountRelationshipsLazyQuery>;
export type MinimalAccountRelationshipsQueryResult = ApolloReactCommon.QueryResult<MinimalAccountRelationshipsQuery, MinimalAccountRelationshipsQueryVariables>;
export const EmailExistsDocument = gql`
    query emailExists($email: String!) {
  emailExists(email: $email)
}
    `;
export type EmailExistsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EmailExistsQuery, EmailExistsQueryVariables>, 'query'> & ({ variables: EmailExistsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EmailExistsComponent = (props: EmailExistsComponentProps) => (
      <ApolloReactComponents.Query<EmailExistsQuery, EmailExistsQueryVariables> query={EmailExistsDocument} {...props} />
    );
    
export type EmailExistsProps<TChildProps = {}> = ApolloReactHoc.DataProps<EmailExistsQuery, EmailExistsQueryVariables> & TChildProps;
export function withEmailExists<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EmailExistsQuery,
  EmailExistsQueryVariables,
  EmailExistsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, EmailExistsQuery, EmailExistsQueryVariables, EmailExistsProps<TChildProps>>(EmailExistsDocument, {
      alias: 'emailExists',
      ...operationOptions
    });
};

/**
 * __useEmailExistsQuery__
 *
 * To run a query within a React component, call `useEmailExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailExistsQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useEmailExistsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EmailExistsQuery, EmailExistsQueryVariables>) {
        return ApolloReactHooks.useQuery<EmailExistsQuery, EmailExistsQueryVariables>(EmailExistsDocument, baseOptions);
      }
export function useEmailExistsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EmailExistsQuery, EmailExistsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EmailExistsQuery, EmailExistsQueryVariables>(EmailExistsDocument, baseOptions);
        }
export type EmailExistsQueryHookResult = ReturnType<typeof useEmailExistsQuery>;
export type EmailExistsLazyQueryHookResult = ReturnType<typeof useEmailExistsLazyQuery>;
export type EmailExistsQueryResult = ApolloReactCommon.QueryResult<EmailExistsQuery, EmailExistsQueryVariables>;
export const AccountEntitiesDocument = gql`
    query accountEntities($id: UUID!) {
  account(id: $id) {
    id
    entities {
      id
      type
      name
    }
  }
}
    `;
export type AccountEntitiesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountEntitiesQuery, AccountEntitiesQueryVariables>, 'query'> & ({ variables: AccountEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountEntitiesComponent = (props: AccountEntitiesComponentProps) => (
      <ApolloReactComponents.Query<AccountEntitiesQuery, AccountEntitiesQueryVariables> query={AccountEntitiesDocument} {...props} />
    );
    
export type AccountEntitiesProps<TChildProps = {}> = ApolloReactHoc.DataProps<AccountEntitiesQuery, AccountEntitiesQueryVariables> & TChildProps;
export function withAccountEntities<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountEntitiesQuery,
  AccountEntitiesQueryVariables,
  AccountEntitiesProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AccountEntitiesQuery, AccountEntitiesQueryVariables, AccountEntitiesProps<TChildProps>>(AccountEntitiesDocument, {
      alias: 'accountEntities',
      ...operationOptions
    });
};

/**
 * __useAccountEntitiesQuery__
 *
 * To run a query within a React component, call `useAccountEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountEntitiesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountEntitiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountEntitiesQuery, AccountEntitiesQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountEntitiesQuery, AccountEntitiesQueryVariables>(AccountEntitiesDocument, baseOptions);
      }
export function useAccountEntitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountEntitiesQuery, AccountEntitiesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountEntitiesQuery, AccountEntitiesQueryVariables>(AccountEntitiesDocument, baseOptions);
        }
export type AccountEntitiesQueryHookResult = ReturnType<typeof useAccountEntitiesQuery>;
export type AccountEntitiesLazyQueryHookResult = ReturnType<typeof useAccountEntitiesLazyQuery>;
export type AccountEntitiesQueryResult = ApolloReactCommon.QueryResult<AccountEntitiesQuery, AccountEntitiesQueryVariables>;
export const AccountContactPreferencesDocument = gql`
    query accountContactPreferences($id: UUID!) {
  account(id: $id) {
    ...AccountContactPrefs
  }
}
    ${AccountContactPrefsFragmentDoc}`;
export type AccountContactPreferencesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountContactPreferencesQuery, AccountContactPreferencesQueryVariables>, 'query'> & ({ variables: AccountContactPreferencesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountContactPreferencesComponent = (props: AccountContactPreferencesComponentProps) => (
      <ApolloReactComponents.Query<AccountContactPreferencesQuery, AccountContactPreferencesQueryVariables> query={AccountContactPreferencesDocument} {...props} />
    );
    
export type AccountContactPreferencesProps<TChildProps = {}> = ApolloReactHoc.DataProps<AccountContactPreferencesQuery, AccountContactPreferencesQueryVariables> & TChildProps;
export function withAccountContactPreferences<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountContactPreferencesQuery,
  AccountContactPreferencesQueryVariables,
  AccountContactPreferencesProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AccountContactPreferencesQuery, AccountContactPreferencesQueryVariables, AccountContactPreferencesProps<TChildProps>>(AccountContactPreferencesDocument, {
      alias: 'accountContactPreferences',
      ...operationOptions
    });
};

/**
 * __useAccountContactPreferencesQuery__
 *
 * To run a query within a React component, call `useAccountContactPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountContactPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountContactPreferencesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountContactPreferencesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountContactPreferencesQuery, AccountContactPreferencesQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountContactPreferencesQuery, AccountContactPreferencesQueryVariables>(AccountContactPreferencesDocument, baseOptions);
      }
export function useAccountContactPreferencesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountContactPreferencesQuery, AccountContactPreferencesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountContactPreferencesQuery, AccountContactPreferencesQueryVariables>(AccountContactPreferencesDocument, baseOptions);
        }
export type AccountContactPreferencesQueryHookResult = ReturnType<typeof useAccountContactPreferencesQuery>;
export type AccountContactPreferencesLazyQueryHookResult = ReturnType<typeof useAccountContactPreferencesLazyQuery>;
export type AccountContactPreferencesQueryResult = ApolloReactCommon.QueryResult<AccountContactPreferencesQuery, AccountContactPreferencesQueryVariables>;
export const AccountContactMethodsDocument = gql`
    query accountContactMethods($id: UUID!) {
  account(id: $id) {
    ...AccountWithRelationshipsAndContactMethods
  }
}
    ${AccountWithRelationshipsAndContactMethodsFragmentDoc}`;
export type AccountContactMethodsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountContactMethodsQuery, AccountContactMethodsQueryVariables>, 'query'> & ({ variables: AccountContactMethodsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountContactMethodsComponent = (props: AccountContactMethodsComponentProps) => (
      <ApolloReactComponents.Query<AccountContactMethodsQuery, AccountContactMethodsQueryVariables> query={AccountContactMethodsDocument} {...props} />
    );
    
export type AccountContactMethodsProps<TChildProps = {}> = ApolloReactHoc.DataProps<AccountContactMethodsQuery, AccountContactMethodsQueryVariables> & TChildProps;
export function withAccountContactMethods<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountContactMethodsQuery,
  AccountContactMethodsQueryVariables,
  AccountContactMethodsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AccountContactMethodsQuery, AccountContactMethodsQueryVariables, AccountContactMethodsProps<TChildProps>>(AccountContactMethodsDocument, {
      alias: 'accountContactMethods',
      ...operationOptions
    });
};

/**
 * __useAccountContactMethodsQuery__
 *
 * To run a query within a React component, call `useAccountContactMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountContactMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountContactMethodsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountContactMethodsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountContactMethodsQuery, AccountContactMethodsQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountContactMethodsQuery, AccountContactMethodsQueryVariables>(AccountContactMethodsDocument, baseOptions);
      }
export function useAccountContactMethodsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountContactMethodsQuery, AccountContactMethodsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountContactMethodsQuery, AccountContactMethodsQueryVariables>(AccountContactMethodsDocument, baseOptions);
        }
export type AccountContactMethodsQueryHookResult = ReturnType<typeof useAccountContactMethodsQuery>;
export type AccountContactMethodsLazyQueryHookResult = ReturnType<typeof useAccountContactMethodsLazyQuery>;
export type AccountContactMethodsQueryResult = ApolloReactCommon.QueryResult<AccountContactMethodsQuery, AccountContactMethodsQueryVariables>;
export const CreateOrUpdateContactMethodDocument = gql`
    mutation createOrUpdateContactMethod($form: ContactMethodFormInput!) {
  createOrUpdateContactMethod(form: $form) {
    ...ContactMethod
  }
}
    ${ContactMethodFragmentDoc}`;
export type CreateOrUpdateContactMethodMutationFn = ApolloReactCommon.MutationFunction<CreateOrUpdateContactMethodMutation, CreateOrUpdateContactMethodMutationVariables>;
export type CreateOrUpdateContactMethodComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateOrUpdateContactMethodMutation, CreateOrUpdateContactMethodMutationVariables>, 'mutation'>;

    export const CreateOrUpdateContactMethodComponent = (props: CreateOrUpdateContactMethodComponentProps) => (
      <ApolloReactComponents.Mutation<CreateOrUpdateContactMethodMutation, CreateOrUpdateContactMethodMutationVariables> mutation={CreateOrUpdateContactMethodDocument} {...props} />
    );
    
export type CreateOrUpdateContactMethodProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CreateOrUpdateContactMethodMutation, CreateOrUpdateContactMethodMutationVariables> & TChildProps;
export function withCreateOrUpdateContactMethod<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateOrUpdateContactMethodMutation,
  CreateOrUpdateContactMethodMutationVariables,
  CreateOrUpdateContactMethodProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CreateOrUpdateContactMethodMutation, CreateOrUpdateContactMethodMutationVariables, CreateOrUpdateContactMethodProps<TChildProps>>(CreateOrUpdateContactMethodDocument, {
      alias: 'createOrUpdateContactMethod',
      ...operationOptions
    });
};

/**
 * __useCreateOrUpdateContactMethodMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateContactMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateContactMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateContactMethodMutation, { data, loading, error }] = useCreateOrUpdateContactMethodMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useCreateOrUpdateContactMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrUpdateContactMethodMutation, CreateOrUpdateContactMethodMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateOrUpdateContactMethodMutation, CreateOrUpdateContactMethodMutationVariables>(CreateOrUpdateContactMethodDocument, baseOptions);
      }
export type CreateOrUpdateContactMethodMutationHookResult = ReturnType<typeof useCreateOrUpdateContactMethodMutation>;
export type CreateOrUpdateContactMethodMutationResult = ApolloReactCommon.MutationResult<CreateOrUpdateContactMethodMutation>;
export type CreateOrUpdateContactMethodMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOrUpdateContactMethodMutation, CreateOrUpdateContactMethodMutationVariables>;
export const DeleteContactMethodDocument = gql`
    mutation deleteContactMethod($id: UUID!) {
  deleteContactMethod(id: $id)
}
    `;
export type DeleteContactMethodMutationFn = ApolloReactCommon.MutationFunction<DeleteContactMethodMutation, DeleteContactMethodMutationVariables>;
export type DeleteContactMethodComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteContactMethodMutation, DeleteContactMethodMutationVariables>, 'mutation'>;

    export const DeleteContactMethodComponent = (props: DeleteContactMethodComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteContactMethodMutation, DeleteContactMethodMutationVariables> mutation={DeleteContactMethodDocument} {...props} />
    );
    
export type DeleteContactMethodProps<TChildProps = {}> = ApolloReactHoc.MutateProps<DeleteContactMethodMutation, DeleteContactMethodMutationVariables> & TChildProps;
export function withDeleteContactMethod<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteContactMethodMutation,
  DeleteContactMethodMutationVariables,
  DeleteContactMethodProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteContactMethodMutation, DeleteContactMethodMutationVariables, DeleteContactMethodProps<TChildProps>>(DeleteContactMethodDocument, {
      alias: 'deleteContactMethod',
      ...operationOptions
    });
};

/**
 * __useDeleteContactMethodMutation__
 *
 * To run a mutation, you first call `useDeleteContactMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactMethodMutation, { data, loading, error }] = useDeleteContactMethodMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContactMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteContactMethodMutation, DeleteContactMethodMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteContactMethodMutation, DeleteContactMethodMutationVariables>(DeleteContactMethodDocument, baseOptions);
      }
export type DeleteContactMethodMutationHookResult = ReturnType<typeof useDeleteContactMethodMutation>;
export type DeleteContactMethodMutationResult = ApolloReactCommon.MutationResult<DeleteContactMethodMutation>;
export type DeleteContactMethodMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteContactMethodMutation, DeleteContactMethodMutationVariables>;
export const AccountParentsDocument = gql`
    query accountParents($accountId: UUID!) {
  account(id: $accountId) {
    id
    parents {
      id
      parent_account {
        id
        name
        type
        client_type
      }
    }
  }
}
    `;
export type AccountParentsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountParentsQuery, AccountParentsQueryVariables>, 'query'> & ({ variables: AccountParentsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountParentsComponent = (props: AccountParentsComponentProps) => (
      <ApolloReactComponents.Query<AccountParentsQuery, AccountParentsQueryVariables> query={AccountParentsDocument} {...props} />
    );
    
export type AccountParentsProps<TChildProps = {}> = ApolloReactHoc.DataProps<AccountParentsQuery, AccountParentsQueryVariables> & TChildProps;
export function withAccountParents<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountParentsQuery,
  AccountParentsQueryVariables,
  AccountParentsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AccountParentsQuery, AccountParentsQueryVariables, AccountParentsProps<TChildProps>>(AccountParentsDocument, {
      alias: 'accountParents',
      ...operationOptions
    });
};

/**
 * __useAccountParentsQuery__
 *
 * To run a query within a React component, call `useAccountParentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountParentsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountParentsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountParentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountParentsQuery, AccountParentsQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountParentsQuery, AccountParentsQueryVariables>(AccountParentsDocument, baseOptions);
      }
export function useAccountParentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountParentsQuery, AccountParentsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountParentsQuery, AccountParentsQueryVariables>(AccountParentsDocument, baseOptions);
        }
export type AccountParentsQueryHookResult = ReturnType<typeof useAccountParentsQuery>;
export type AccountParentsLazyQueryHookResult = ReturnType<typeof useAccountParentsLazyQuery>;
export type AccountParentsQueryResult = ApolloReactCommon.QueryResult<AccountParentsQuery, AccountParentsQueryVariables>;
export const AccountChildrenDocument = gql`
    query accountChildren($accountId: UUID!) {
  account(id: $accountId) {
    id
    relationships {
      id
      parent_to_child_relationship
      child_account {
        id
        name
        type
        client_type
      }
    }
  }
}
    `;
export type AccountChildrenComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountChildrenQuery, AccountChildrenQueryVariables>, 'query'> & ({ variables: AccountChildrenQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountChildrenComponent = (props: AccountChildrenComponentProps) => (
      <ApolloReactComponents.Query<AccountChildrenQuery, AccountChildrenQueryVariables> query={AccountChildrenDocument} {...props} />
    );
    
export type AccountChildrenProps<TChildProps = {}> = ApolloReactHoc.DataProps<AccountChildrenQuery, AccountChildrenQueryVariables> & TChildProps;
export function withAccountChildren<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountChildrenQuery,
  AccountChildrenQueryVariables,
  AccountChildrenProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AccountChildrenQuery, AccountChildrenQueryVariables, AccountChildrenProps<TChildProps>>(AccountChildrenDocument, {
      alias: 'accountChildren',
      ...operationOptions
    });
};

/**
 * __useAccountChildrenQuery__
 *
 * To run a query within a React component, call `useAccountChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountChildrenQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountChildrenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountChildrenQuery, AccountChildrenQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountChildrenQuery, AccountChildrenQueryVariables>(AccountChildrenDocument, baseOptions);
      }
export function useAccountChildrenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountChildrenQuery, AccountChildrenQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountChildrenQuery, AccountChildrenQueryVariables>(AccountChildrenDocument, baseOptions);
        }
export type AccountChildrenQueryHookResult = ReturnType<typeof useAccountChildrenQuery>;
export type AccountChildrenLazyQueryHookResult = ReturnType<typeof useAccountChildrenLazyQuery>;
export type AccountChildrenQueryResult = ApolloReactCommon.QueryResult<AccountChildrenQuery, AccountChildrenQueryVariables>;
export const GetDocumentsByAccountDocument = gql`
    query getDocumentsByAccount($accountId: UUID!) {
  account(id: $accountId) {
    id
    files {
      ...File
    }
    parents {
      id
      parent_account {
        id
        name
        files {
          ...File
        }
      }
    }
    introducer_accounts {
      id
      name
      files {
        ...File
      }
    }
  }
}
    ${FileFragmentDoc}`;
export type GetDocumentsByAccountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetDocumentsByAccountQuery, GetDocumentsByAccountQueryVariables>, 'query'> & ({ variables: GetDocumentsByAccountQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetDocumentsByAccountComponent = (props: GetDocumentsByAccountComponentProps) => (
      <ApolloReactComponents.Query<GetDocumentsByAccountQuery, GetDocumentsByAccountQueryVariables> query={GetDocumentsByAccountDocument} {...props} />
    );
    
export type GetDocumentsByAccountProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetDocumentsByAccountQuery, GetDocumentsByAccountQueryVariables> & TChildProps;
export function withGetDocumentsByAccount<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetDocumentsByAccountQuery,
  GetDocumentsByAccountQueryVariables,
  GetDocumentsByAccountProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetDocumentsByAccountQuery, GetDocumentsByAccountQueryVariables, GetDocumentsByAccountProps<TChildProps>>(GetDocumentsByAccountDocument, {
      alias: 'getDocumentsByAccount',
      ...operationOptions
    });
};

/**
 * __useGetDocumentsByAccountQuery__
 *
 * To run a query within a React component, call `useGetDocumentsByAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsByAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsByAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetDocumentsByAccountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDocumentsByAccountQuery, GetDocumentsByAccountQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDocumentsByAccountQuery, GetDocumentsByAccountQueryVariables>(GetDocumentsByAccountDocument, baseOptions);
      }
export function useGetDocumentsByAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDocumentsByAccountQuery, GetDocumentsByAccountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDocumentsByAccountQuery, GetDocumentsByAccountQueryVariables>(GetDocumentsByAccountDocument, baseOptions);
        }
export type GetDocumentsByAccountQueryHookResult = ReturnType<typeof useGetDocumentsByAccountQuery>;
export type GetDocumentsByAccountLazyQueryHookResult = ReturnType<typeof useGetDocumentsByAccountLazyQuery>;
export type GetDocumentsByAccountQueryResult = ApolloReactCommon.QueryResult<GetDocumentsByAccountQuery, GetDocumentsByAccountQueryVariables>;
export const AssociateFileWithAccountDocument = gql`
    mutation associateFileWithAccount($accountId: UUID!, $fileSerial: String!, $tags: [UUID!]!) {
  uploadAccountFile(accountId: $accountId, fileSerial: $fileSerial, tags: $tags) {
    id
    files {
      ...File
    }
  }
}
    ${FileFragmentDoc}`;
export type AssociateFileWithAccountMutationFn = ApolloReactCommon.MutationFunction<AssociateFileWithAccountMutation, AssociateFileWithAccountMutationVariables>;
export type AssociateFileWithAccountComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AssociateFileWithAccountMutation, AssociateFileWithAccountMutationVariables>, 'mutation'>;

    export const AssociateFileWithAccountComponent = (props: AssociateFileWithAccountComponentProps) => (
      <ApolloReactComponents.Mutation<AssociateFileWithAccountMutation, AssociateFileWithAccountMutationVariables> mutation={AssociateFileWithAccountDocument} {...props} />
    );
    
export type AssociateFileWithAccountProps<TChildProps = {}> = ApolloReactHoc.MutateProps<AssociateFileWithAccountMutation, AssociateFileWithAccountMutationVariables> & TChildProps;
export function withAssociateFileWithAccount<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AssociateFileWithAccountMutation,
  AssociateFileWithAccountMutationVariables,
  AssociateFileWithAccountProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, AssociateFileWithAccountMutation, AssociateFileWithAccountMutationVariables, AssociateFileWithAccountProps<TChildProps>>(AssociateFileWithAccountDocument, {
      alias: 'associateFileWithAccount',
      ...operationOptions
    });
};

/**
 * __useAssociateFileWithAccountMutation__
 *
 * To run a mutation, you first call `useAssociateFileWithAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateFileWithAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateFileWithAccountMutation, { data, loading, error }] = useAssociateFileWithAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      fileSerial: // value for 'fileSerial'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useAssociateFileWithAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssociateFileWithAccountMutation, AssociateFileWithAccountMutationVariables>) {
        return ApolloReactHooks.useMutation<AssociateFileWithAccountMutation, AssociateFileWithAccountMutationVariables>(AssociateFileWithAccountDocument, baseOptions);
      }
export type AssociateFileWithAccountMutationHookResult = ReturnType<typeof useAssociateFileWithAccountMutation>;
export type AssociateFileWithAccountMutationResult = ApolloReactCommon.MutationResult<AssociateFileWithAccountMutation>;
export type AssociateFileWithAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<AssociateFileWithAccountMutation, AssociateFileWithAccountMutationVariables>;
export const GetAllDocumentTagsDocument = gql`
    query getAllDocumentTags {
  allTags {
    id
    tag
  }
}
    `;
export type GetAllDocumentTagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAllDocumentTagsQuery, GetAllDocumentTagsQueryVariables>, 'query'>;

    export const GetAllDocumentTagsComponent = (props: GetAllDocumentTagsComponentProps) => (
      <ApolloReactComponents.Query<GetAllDocumentTagsQuery, GetAllDocumentTagsQueryVariables> query={GetAllDocumentTagsDocument} {...props} />
    );
    
export type GetAllDocumentTagsProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetAllDocumentTagsQuery, GetAllDocumentTagsQueryVariables> & TChildProps;
export function withGetAllDocumentTags<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAllDocumentTagsQuery,
  GetAllDocumentTagsQueryVariables,
  GetAllDocumentTagsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetAllDocumentTagsQuery, GetAllDocumentTagsQueryVariables, GetAllDocumentTagsProps<TChildProps>>(GetAllDocumentTagsDocument, {
      alias: 'getAllDocumentTags',
      ...operationOptions
    });
};

/**
 * __useGetAllDocumentTagsQuery__
 *
 * To run a query within a React component, call `useGetAllDocumentTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDocumentTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDocumentTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllDocumentTagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllDocumentTagsQuery, GetAllDocumentTagsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllDocumentTagsQuery, GetAllDocumentTagsQueryVariables>(GetAllDocumentTagsDocument, baseOptions);
      }
export function useGetAllDocumentTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllDocumentTagsQuery, GetAllDocumentTagsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllDocumentTagsQuery, GetAllDocumentTagsQueryVariables>(GetAllDocumentTagsDocument, baseOptions);
        }
export type GetAllDocumentTagsQueryHookResult = ReturnType<typeof useGetAllDocumentTagsQuery>;
export type GetAllDocumentTagsLazyQueryHookResult = ReturnType<typeof useGetAllDocumentTagsLazyQuery>;
export type GetAllDocumentTagsQueryResult = ApolloReactCommon.QueryResult<GetAllDocumentTagsQuery, GetAllDocumentTagsQueryVariables>;
export const DeleteFileDocument = gql`
    mutation deleteFile($fileId: Int!) {
  deleteFile(fileId: $fileId)
}
    `;
export type DeleteFileMutationFn = ApolloReactCommon.MutationFunction<DeleteFileMutation, DeleteFileMutationVariables>;
export type DeleteFileComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteFileMutation, DeleteFileMutationVariables>, 'mutation'>;

    export const DeleteFileComponent = (props: DeleteFileComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteFileMutation, DeleteFileMutationVariables> mutation={DeleteFileDocument} {...props} />
    );
    
export type DeleteFileProps<TChildProps = {}> = ApolloReactHoc.MutateProps<DeleteFileMutation, DeleteFileMutationVariables> & TChildProps;
export function withDeleteFile<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteFileMutation,
  DeleteFileMutationVariables,
  DeleteFileProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteFileMutation, DeleteFileMutationVariables, DeleteFileProps<TChildProps>>(DeleteFileDocument, {
      alias: 'deleteFile',
      ...operationOptions
    });
};

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDeleteFileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFileMutation, DeleteFileMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument, baseOptions);
      }
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>;
export type DeleteFileMutationResult = ApolloReactCommon.MutationResult<DeleteFileMutation>;
export type DeleteFileMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteFileMutation, DeleteFileMutationVariables>;
export const GetPaginatedAccountsByOwnersDocument = gql`
    query getPaginatedAccountsByOwners($owners: [Int!]!, $offset: Int!, $limit: Int!) {
  getAccountsByOwners(owners: $owners, offset: $offset, limit: $limit) {
    count
    offset
    limit
    data {
      ...AccountCard
    }
  }
}
    ${AccountCardFragmentDoc}`;
export type GetPaginatedAccountsByOwnersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPaginatedAccountsByOwnersQuery, GetPaginatedAccountsByOwnersQueryVariables>, 'query'> & ({ variables: GetPaginatedAccountsByOwnersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetPaginatedAccountsByOwnersComponent = (props: GetPaginatedAccountsByOwnersComponentProps) => (
      <ApolloReactComponents.Query<GetPaginatedAccountsByOwnersQuery, GetPaginatedAccountsByOwnersQueryVariables> query={GetPaginatedAccountsByOwnersDocument} {...props} />
    );
    
export type GetPaginatedAccountsByOwnersProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetPaginatedAccountsByOwnersQuery, GetPaginatedAccountsByOwnersQueryVariables> & TChildProps;
export function withGetPaginatedAccountsByOwners<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetPaginatedAccountsByOwnersQuery,
  GetPaginatedAccountsByOwnersQueryVariables,
  GetPaginatedAccountsByOwnersProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetPaginatedAccountsByOwnersQuery, GetPaginatedAccountsByOwnersQueryVariables, GetPaginatedAccountsByOwnersProps<TChildProps>>(GetPaginatedAccountsByOwnersDocument, {
      alias: 'getPaginatedAccountsByOwners',
      ...operationOptions
    });
};

/**
 * __useGetPaginatedAccountsByOwnersQuery__
 *
 * To run a query within a React component, call `useGetPaginatedAccountsByOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedAccountsByOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedAccountsByOwnersQuery({
 *   variables: {
 *      owners: // value for 'owners'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPaginatedAccountsByOwnersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPaginatedAccountsByOwnersQuery, GetPaginatedAccountsByOwnersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPaginatedAccountsByOwnersQuery, GetPaginatedAccountsByOwnersQueryVariables>(GetPaginatedAccountsByOwnersDocument, baseOptions);
      }
export function useGetPaginatedAccountsByOwnersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPaginatedAccountsByOwnersQuery, GetPaginatedAccountsByOwnersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPaginatedAccountsByOwnersQuery, GetPaginatedAccountsByOwnersQueryVariables>(GetPaginatedAccountsByOwnersDocument, baseOptions);
        }
export type GetPaginatedAccountsByOwnersQueryHookResult = ReturnType<typeof useGetPaginatedAccountsByOwnersQuery>;
export type GetPaginatedAccountsByOwnersLazyQueryHookResult = ReturnType<typeof useGetPaginatedAccountsByOwnersLazyQuery>;
export type GetPaginatedAccountsByOwnersQueryResult = ApolloReactCommon.QueryResult<GetPaginatedAccountsByOwnersQuery, GetPaginatedAccountsByOwnersQueryVariables>;
export const IssuerTradeHistoryDocument = gql`
    query issuerTradeHistory($accountId: UUID!) {
  account(id: $accountId) {
    id
    issuer_account {
      id
      deals {
        id
        issuerId
        totalVolume
        dateClosed
        netRevenue
        totalShares
        averageTakeRate
        grossPricePerShare
        numParticipants
      }
    }
  }
}
    `;
export type IssuerTradeHistoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<IssuerTradeHistoryQuery, IssuerTradeHistoryQueryVariables>, 'query'> & ({ variables: IssuerTradeHistoryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const IssuerTradeHistoryComponent = (props: IssuerTradeHistoryComponentProps) => (
      <ApolloReactComponents.Query<IssuerTradeHistoryQuery, IssuerTradeHistoryQueryVariables> query={IssuerTradeHistoryDocument} {...props} />
    );
    
export type IssuerTradeHistoryProps<TChildProps = {}> = ApolloReactHoc.DataProps<IssuerTradeHistoryQuery, IssuerTradeHistoryQueryVariables> & TChildProps;
export function withIssuerTradeHistory<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IssuerTradeHistoryQuery,
  IssuerTradeHistoryQueryVariables,
  IssuerTradeHistoryProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, IssuerTradeHistoryQuery, IssuerTradeHistoryQueryVariables, IssuerTradeHistoryProps<TChildProps>>(IssuerTradeHistoryDocument, {
      alias: 'issuerTradeHistory',
      ...operationOptions
    });
};

/**
 * __useIssuerTradeHistoryQuery__
 *
 * To run a query within a React component, call `useIssuerTradeHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssuerTradeHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssuerTradeHistoryQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useIssuerTradeHistoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IssuerTradeHistoryQuery, IssuerTradeHistoryQueryVariables>) {
        return ApolloReactHooks.useQuery<IssuerTradeHistoryQuery, IssuerTradeHistoryQueryVariables>(IssuerTradeHistoryDocument, baseOptions);
      }
export function useIssuerTradeHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IssuerTradeHistoryQuery, IssuerTradeHistoryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IssuerTradeHistoryQuery, IssuerTradeHistoryQueryVariables>(IssuerTradeHistoryDocument, baseOptions);
        }
export type IssuerTradeHistoryQueryHookResult = ReturnType<typeof useIssuerTradeHistoryQuery>;
export type IssuerTradeHistoryLazyQueryHookResult = ReturnType<typeof useIssuerTradeHistoryLazyQuery>;
export type IssuerTradeHistoryQueryResult = ApolloReactCommon.QueryResult<IssuerTradeHistoryQuery, IssuerTradeHistoryQueryVariables>;
export const BaseIssuerAccountDocument = gql`
    query BaseIssuerAccount($issuerId: UUID!) {
  account(id: $issuerId) {
    id
    issuer_account {
      id
      company {
        id
        name
      }
    }
  }
}
    `;
export type BaseIssuerAccountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BaseIssuerAccountQuery, BaseIssuerAccountQueryVariables>, 'query'> & ({ variables: BaseIssuerAccountQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BaseIssuerAccountComponent = (props: BaseIssuerAccountComponentProps) => (
      <ApolloReactComponents.Query<BaseIssuerAccountQuery, BaseIssuerAccountQueryVariables> query={BaseIssuerAccountDocument} {...props} />
    );
    
export type BaseIssuerAccountProps<TChildProps = {}> = ApolloReactHoc.DataProps<BaseIssuerAccountQuery, BaseIssuerAccountQueryVariables> & TChildProps;
export function withBaseIssuerAccount<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BaseIssuerAccountQuery,
  BaseIssuerAccountQueryVariables,
  BaseIssuerAccountProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, BaseIssuerAccountQuery, BaseIssuerAccountQueryVariables, BaseIssuerAccountProps<TChildProps>>(BaseIssuerAccountDocument, {
      alias: 'baseIssuerAccount',
      ...operationOptions
    });
};

/**
 * __useBaseIssuerAccountQuery__
 *
 * To run a query within a React component, call `useBaseIssuerAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useBaseIssuerAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBaseIssuerAccountQuery({
 *   variables: {
 *      issuerId: // value for 'issuerId'
 *   },
 * });
 */
export function useBaseIssuerAccountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BaseIssuerAccountQuery, BaseIssuerAccountQueryVariables>) {
        return ApolloReactHooks.useQuery<BaseIssuerAccountQuery, BaseIssuerAccountQueryVariables>(BaseIssuerAccountDocument, baseOptions);
      }
export function useBaseIssuerAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BaseIssuerAccountQuery, BaseIssuerAccountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BaseIssuerAccountQuery, BaseIssuerAccountQueryVariables>(BaseIssuerAccountDocument, baseOptions);
        }
export type BaseIssuerAccountQueryHookResult = ReturnType<typeof useBaseIssuerAccountQuery>;
export type BaseIssuerAccountLazyQueryHookResult = ReturnType<typeof useBaseIssuerAccountLazyQuery>;
export type BaseIssuerAccountQueryResult = ApolloReactCommon.QueryResult<BaseIssuerAccountQuery, BaseIssuerAccountQueryVariables>;
export const IssuerLastRoundDocument = gql`
    query IssuerLastRound($issuerId: UUID!) {
  account(id: $issuerId) {
    id
    issuer_account {
      id
      company {
        id
        last_round {
          ...FundingRound
        }
      }
    }
  }
}
    ${FundingRoundFragmentDoc}`;
export type IssuerLastRoundComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<IssuerLastRoundQuery, IssuerLastRoundQueryVariables>, 'query'> & ({ variables: IssuerLastRoundQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const IssuerLastRoundComponent = (props: IssuerLastRoundComponentProps) => (
      <ApolloReactComponents.Query<IssuerLastRoundQuery, IssuerLastRoundQueryVariables> query={IssuerLastRoundDocument} {...props} />
    );
    
export type IssuerLastRoundProps<TChildProps = {}> = ApolloReactHoc.DataProps<IssuerLastRoundQuery, IssuerLastRoundQueryVariables> & TChildProps;
export function withIssuerLastRound<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IssuerLastRoundQuery,
  IssuerLastRoundQueryVariables,
  IssuerLastRoundProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, IssuerLastRoundQuery, IssuerLastRoundQueryVariables, IssuerLastRoundProps<TChildProps>>(IssuerLastRoundDocument, {
      alias: 'issuerLastRound',
      ...operationOptions
    });
};

/**
 * __useIssuerLastRoundQuery__
 *
 * To run a query within a React component, call `useIssuerLastRoundQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssuerLastRoundQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssuerLastRoundQuery({
 *   variables: {
 *      issuerId: // value for 'issuerId'
 *   },
 * });
 */
export function useIssuerLastRoundQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IssuerLastRoundQuery, IssuerLastRoundQueryVariables>) {
        return ApolloReactHooks.useQuery<IssuerLastRoundQuery, IssuerLastRoundQueryVariables>(IssuerLastRoundDocument, baseOptions);
      }
export function useIssuerLastRoundLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IssuerLastRoundQuery, IssuerLastRoundQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IssuerLastRoundQuery, IssuerLastRoundQueryVariables>(IssuerLastRoundDocument, baseOptions);
        }
export type IssuerLastRoundQueryHookResult = ReturnType<typeof useIssuerLastRoundQuery>;
export type IssuerLastRoundLazyQueryHookResult = ReturnType<typeof useIssuerLastRoundLazyQuery>;
export type IssuerLastRoundQueryResult = ApolloReactCommon.QueryResult<IssuerLastRoundQuery, IssuerLastRoundQueryVariables>;
export const IssuerLinksDocument = gql`
    query IssuerLinks($issuerId: UUID!) {
  account(id: $issuerId) {
    id
    issuer_account {
      id
      company {
        id
        token
        crunchbase_handle
      }
    }
  }
}
    `;
export type IssuerLinksComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<IssuerLinksQuery, IssuerLinksQueryVariables>, 'query'> & ({ variables: IssuerLinksQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const IssuerLinksComponent = (props: IssuerLinksComponentProps) => (
      <ApolloReactComponents.Query<IssuerLinksQuery, IssuerLinksQueryVariables> query={IssuerLinksDocument} {...props} />
    );
    
export type IssuerLinksProps<TChildProps = {}> = ApolloReactHoc.DataProps<IssuerLinksQuery, IssuerLinksQueryVariables> & TChildProps;
export function withIssuerLinks<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IssuerLinksQuery,
  IssuerLinksQueryVariables,
  IssuerLinksProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, IssuerLinksQuery, IssuerLinksQueryVariables, IssuerLinksProps<TChildProps>>(IssuerLinksDocument, {
      alias: 'issuerLinks',
      ...operationOptions
    });
};

/**
 * __useIssuerLinksQuery__
 *
 * To run a query within a React component, call `useIssuerLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssuerLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssuerLinksQuery({
 *   variables: {
 *      issuerId: // value for 'issuerId'
 *   },
 * });
 */
export function useIssuerLinksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IssuerLinksQuery, IssuerLinksQueryVariables>) {
        return ApolloReactHooks.useQuery<IssuerLinksQuery, IssuerLinksQueryVariables>(IssuerLinksDocument, baseOptions);
      }
export function useIssuerLinksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IssuerLinksQuery, IssuerLinksQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IssuerLinksQuery, IssuerLinksQueryVariables>(IssuerLinksDocument, baseOptions);
        }
export type IssuerLinksQueryHookResult = ReturnType<typeof useIssuerLinksQuery>;
export type IssuerLinksLazyQueryHookResult = ReturnType<typeof useIssuerLinksLazyQuery>;
export type IssuerLinksQueryResult = ApolloReactCommon.QueryResult<IssuerLinksQuery, IssuerLinksQueryVariables>;
export const IssuerPlatformSettingsDocument = gql`
    query IssuerPlatformSettings($issuerId: UUID!) {
  account(id: $issuerId) {
    id
    issuer_account {
      id
      company {
        ...IssuerPlatformSettings
      }
    }
  }
}
    ${IssuerPlatformSettingsFragmentDoc}`;
export type IssuerPlatformSettingsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<IssuerPlatformSettingsQuery, IssuerPlatformSettingsQueryVariables>, 'query'> & ({ variables: IssuerPlatformSettingsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const IssuerPlatformSettingsComponent = (props: IssuerPlatformSettingsComponentProps) => (
      <ApolloReactComponents.Query<IssuerPlatformSettingsQuery, IssuerPlatformSettingsQueryVariables> query={IssuerPlatformSettingsDocument} {...props} />
    );
    
export type IssuerPlatformSettingsProps<TChildProps = {}> = ApolloReactHoc.DataProps<IssuerPlatformSettingsQuery, IssuerPlatformSettingsQueryVariables> & TChildProps;
export function withIssuerPlatformSettings<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IssuerPlatformSettingsQuery,
  IssuerPlatformSettingsQueryVariables,
  IssuerPlatformSettingsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, IssuerPlatformSettingsQuery, IssuerPlatformSettingsQueryVariables, IssuerPlatformSettingsProps<TChildProps>>(IssuerPlatformSettingsDocument, {
      alias: 'issuerPlatformSettings',
      ...operationOptions
    });
};

/**
 * __useIssuerPlatformSettingsQuery__
 *
 * To run a query within a React component, call `useIssuerPlatformSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssuerPlatformSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssuerPlatformSettingsQuery({
 *   variables: {
 *      issuerId: // value for 'issuerId'
 *   },
 * });
 */
export function useIssuerPlatformSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IssuerPlatformSettingsQuery, IssuerPlatformSettingsQueryVariables>) {
        return ApolloReactHooks.useQuery<IssuerPlatformSettingsQuery, IssuerPlatformSettingsQueryVariables>(IssuerPlatformSettingsDocument, baseOptions);
      }
export function useIssuerPlatformSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IssuerPlatformSettingsQuery, IssuerPlatformSettingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IssuerPlatformSettingsQuery, IssuerPlatformSettingsQueryVariables>(IssuerPlatformSettingsDocument, baseOptions);
        }
export type IssuerPlatformSettingsQueryHookResult = ReturnType<typeof useIssuerPlatformSettingsQuery>;
export type IssuerPlatformSettingsLazyQueryHookResult = ReturnType<typeof useIssuerPlatformSettingsLazyQuery>;
export type IssuerPlatformSettingsQueryResult = ApolloReactCommon.QueryResult<IssuerPlatformSettingsQuery, IssuerPlatformSettingsQueryVariables>;
export const UpdateIssuerPlatformSettingsDocument = gql`
    mutation UpdateIssuerPlatformSettings($companyPlatformSettings: CompanyPlatformSettingsInput!) {
  updateCompanyPlatformSettings(companyPlatformSettings: $companyPlatformSettings) {
    ...IssuerPlatformSettings
  }
}
    ${IssuerPlatformSettingsFragmentDoc}`;
export type UpdateIssuerPlatformSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateIssuerPlatformSettingsMutation, UpdateIssuerPlatformSettingsMutationVariables>;
export type UpdateIssuerPlatformSettingsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateIssuerPlatformSettingsMutation, UpdateIssuerPlatformSettingsMutationVariables>, 'mutation'>;

    export const UpdateIssuerPlatformSettingsComponent = (props: UpdateIssuerPlatformSettingsComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateIssuerPlatformSettingsMutation, UpdateIssuerPlatformSettingsMutationVariables> mutation={UpdateIssuerPlatformSettingsDocument} {...props} />
    );
    
export type UpdateIssuerPlatformSettingsProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateIssuerPlatformSettingsMutation, UpdateIssuerPlatformSettingsMutationVariables> & TChildProps;
export function withUpdateIssuerPlatformSettings<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateIssuerPlatformSettingsMutation,
  UpdateIssuerPlatformSettingsMutationVariables,
  UpdateIssuerPlatformSettingsProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateIssuerPlatformSettingsMutation, UpdateIssuerPlatformSettingsMutationVariables, UpdateIssuerPlatformSettingsProps<TChildProps>>(UpdateIssuerPlatformSettingsDocument, {
      alias: 'updateIssuerPlatformSettings',
      ...operationOptions
    });
};

/**
 * __useUpdateIssuerPlatformSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateIssuerPlatformSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIssuerPlatformSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIssuerPlatformSettingsMutation, { data, loading, error }] = useUpdateIssuerPlatformSettingsMutation({
 *   variables: {
 *      companyPlatformSettings: // value for 'companyPlatformSettings'
 *   },
 * });
 */
export function useUpdateIssuerPlatformSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateIssuerPlatformSettingsMutation, UpdateIssuerPlatformSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateIssuerPlatformSettingsMutation, UpdateIssuerPlatformSettingsMutationVariables>(UpdateIssuerPlatformSettingsDocument, baseOptions);
      }
export type UpdateIssuerPlatformSettingsMutationHookResult = ReturnType<typeof useUpdateIssuerPlatformSettingsMutation>;
export type UpdateIssuerPlatformSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateIssuerPlatformSettingsMutation>;
export type UpdateIssuerPlatformSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateIssuerPlatformSettingsMutation, UpdateIssuerPlatformSettingsMutationVariables>;
export const UpdateIssuerMarketplaceSettingsDocument = gql`
    mutation updateIssuerMarketplaceSettings($form: IssuerMarketplaceSettingsFormInput!) {
  updateIssuerMarketplaceSettings(form: $form) {
    id
    issuer_account {
      id
      company {
        ...IssuerPlatformSettings
      }
    }
  }
}
    ${IssuerPlatformSettingsFragmentDoc}`;
export type UpdateIssuerMarketplaceSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateIssuerMarketplaceSettingsMutation, UpdateIssuerMarketplaceSettingsMutationVariables>;
export type UpdateIssuerMarketplaceSettingsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateIssuerMarketplaceSettingsMutation, UpdateIssuerMarketplaceSettingsMutationVariables>, 'mutation'>;

    export const UpdateIssuerMarketplaceSettingsComponent = (props: UpdateIssuerMarketplaceSettingsComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateIssuerMarketplaceSettingsMutation, UpdateIssuerMarketplaceSettingsMutationVariables> mutation={UpdateIssuerMarketplaceSettingsDocument} {...props} />
    );
    
export type UpdateIssuerMarketplaceSettingsProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateIssuerMarketplaceSettingsMutation, UpdateIssuerMarketplaceSettingsMutationVariables> & TChildProps;
export function withUpdateIssuerMarketplaceSettings<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateIssuerMarketplaceSettingsMutation,
  UpdateIssuerMarketplaceSettingsMutationVariables,
  UpdateIssuerMarketplaceSettingsProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateIssuerMarketplaceSettingsMutation, UpdateIssuerMarketplaceSettingsMutationVariables, UpdateIssuerMarketplaceSettingsProps<TChildProps>>(UpdateIssuerMarketplaceSettingsDocument, {
      alias: 'updateIssuerMarketplaceSettings',
      ...operationOptions
    });
};

/**
 * __useUpdateIssuerMarketplaceSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateIssuerMarketplaceSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIssuerMarketplaceSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIssuerMarketplaceSettingsMutation, { data, loading, error }] = useUpdateIssuerMarketplaceSettingsMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateIssuerMarketplaceSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateIssuerMarketplaceSettingsMutation, UpdateIssuerMarketplaceSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateIssuerMarketplaceSettingsMutation, UpdateIssuerMarketplaceSettingsMutationVariables>(UpdateIssuerMarketplaceSettingsDocument, baseOptions);
      }
export type UpdateIssuerMarketplaceSettingsMutationHookResult = ReturnType<typeof useUpdateIssuerMarketplaceSettingsMutation>;
export type UpdateIssuerMarketplaceSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateIssuerMarketplaceSettingsMutation>;
export type UpdateIssuerMarketplaceSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateIssuerMarketplaceSettingsMutation, UpdateIssuerMarketplaceSettingsMutationVariables>;
export const IssuerOwnersDocument = gql`
    query IssuerOwners($issuerId: UUID!) {
  account(id: $issuerId) {
    ...IssuerOwners
  }
}
    ${IssuerOwnersFragmentDoc}`;
export type IssuerOwnersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<IssuerOwnersQuery, IssuerOwnersQueryVariables>, 'query'> & ({ variables: IssuerOwnersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const IssuerOwnersComponent = (props: IssuerOwnersComponentProps) => (
      <ApolloReactComponents.Query<IssuerOwnersQuery, IssuerOwnersQueryVariables> query={IssuerOwnersDocument} {...props} />
    );
    
export type IssuerOwnersProps<TChildProps = {}> = ApolloReactHoc.DataProps<IssuerOwnersQuery, IssuerOwnersQueryVariables> & TChildProps;
export function withIssuerOwners<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IssuerOwnersQuery,
  IssuerOwnersQueryVariables,
  IssuerOwnersProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, IssuerOwnersQuery, IssuerOwnersQueryVariables, IssuerOwnersProps<TChildProps>>(IssuerOwnersDocument, {
      alias: 'issuerOwners',
      ...operationOptions
    });
};

/**
 * __useIssuerOwnersQuery__
 *
 * To run a query within a React component, call `useIssuerOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssuerOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssuerOwnersQuery({
 *   variables: {
 *      issuerId: // value for 'issuerId'
 *   },
 * });
 */
export function useIssuerOwnersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IssuerOwnersQuery, IssuerOwnersQueryVariables>) {
        return ApolloReactHooks.useQuery<IssuerOwnersQuery, IssuerOwnersQueryVariables>(IssuerOwnersDocument, baseOptions);
      }
export function useIssuerOwnersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IssuerOwnersQuery, IssuerOwnersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IssuerOwnersQuery, IssuerOwnersQueryVariables>(IssuerOwnersDocument, baseOptions);
        }
export type IssuerOwnersQueryHookResult = ReturnType<typeof useIssuerOwnersQuery>;
export type IssuerOwnersLazyQueryHookResult = ReturnType<typeof useIssuerOwnersLazyQuery>;
export type IssuerOwnersQueryResult = ApolloReactCommon.QueryResult<IssuerOwnersQuery, IssuerOwnersQueryVariables>;
export const UpdateIssuerMarketplaceCoverageDocument = gql`
    mutation updateIssuerMarketplaceCoverage($form: IssuerMarketplaceCoverageFormInput!) {
  updateIssuerMarketplaceCoverage(form: $form) {
    ...IssuerOwners
  }
}
    ${IssuerOwnersFragmentDoc}`;
export type UpdateIssuerMarketplaceCoverageMutationFn = ApolloReactCommon.MutationFunction<UpdateIssuerMarketplaceCoverageMutation, UpdateIssuerMarketplaceCoverageMutationVariables>;
export type UpdateIssuerMarketplaceCoverageComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateIssuerMarketplaceCoverageMutation, UpdateIssuerMarketplaceCoverageMutationVariables>, 'mutation'>;

    export const UpdateIssuerMarketplaceCoverageComponent = (props: UpdateIssuerMarketplaceCoverageComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateIssuerMarketplaceCoverageMutation, UpdateIssuerMarketplaceCoverageMutationVariables> mutation={UpdateIssuerMarketplaceCoverageDocument} {...props} />
    );
    
export type UpdateIssuerMarketplaceCoverageProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateIssuerMarketplaceCoverageMutation, UpdateIssuerMarketplaceCoverageMutationVariables> & TChildProps;
export function withUpdateIssuerMarketplaceCoverage<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateIssuerMarketplaceCoverageMutation,
  UpdateIssuerMarketplaceCoverageMutationVariables,
  UpdateIssuerMarketplaceCoverageProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateIssuerMarketplaceCoverageMutation, UpdateIssuerMarketplaceCoverageMutationVariables, UpdateIssuerMarketplaceCoverageProps<TChildProps>>(UpdateIssuerMarketplaceCoverageDocument, {
      alias: 'updateIssuerMarketplaceCoverage',
      ...operationOptions
    });
};

/**
 * __useUpdateIssuerMarketplaceCoverageMutation__
 *
 * To run a mutation, you first call `useUpdateIssuerMarketplaceCoverageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIssuerMarketplaceCoverageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIssuerMarketplaceCoverageMutation, { data, loading, error }] = useUpdateIssuerMarketplaceCoverageMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateIssuerMarketplaceCoverageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateIssuerMarketplaceCoverageMutation, UpdateIssuerMarketplaceCoverageMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateIssuerMarketplaceCoverageMutation, UpdateIssuerMarketplaceCoverageMutationVariables>(UpdateIssuerMarketplaceCoverageDocument, baseOptions);
      }
export type UpdateIssuerMarketplaceCoverageMutationHookResult = ReturnType<typeof useUpdateIssuerMarketplaceCoverageMutation>;
export type UpdateIssuerMarketplaceCoverageMutationResult = ApolloReactCommon.MutationResult<UpdateIssuerMarketplaceCoverageMutation>;
export type UpdateIssuerMarketplaceCoverageMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateIssuerMarketplaceCoverageMutation, UpdateIssuerMarketplaceCoverageMutationVariables>;
export const UpdateIssuerPartnershipsCoverageDocument = gql`
    mutation updateIssuerPartnershipsCoverage($form: IssuerPartnershipsCoverageFormInput!) {
  updateIssuerPartnershipsCoverage(form: $form) {
    ...IssuerOwners
  }
}
    ${IssuerOwnersFragmentDoc}`;
export type UpdateIssuerPartnershipsCoverageMutationFn = ApolloReactCommon.MutationFunction<UpdateIssuerPartnershipsCoverageMutation, UpdateIssuerPartnershipsCoverageMutationVariables>;
export type UpdateIssuerPartnershipsCoverageComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateIssuerPartnershipsCoverageMutation, UpdateIssuerPartnershipsCoverageMutationVariables>, 'mutation'>;

    export const UpdateIssuerPartnershipsCoverageComponent = (props: UpdateIssuerPartnershipsCoverageComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateIssuerPartnershipsCoverageMutation, UpdateIssuerPartnershipsCoverageMutationVariables> mutation={UpdateIssuerPartnershipsCoverageDocument} {...props} />
    );
    
export type UpdateIssuerPartnershipsCoverageProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateIssuerPartnershipsCoverageMutation, UpdateIssuerPartnershipsCoverageMutationVariables> & TChildProps;
export function withUpdateIssuerPartnershipsCoverage<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateIssuerPartnershipsCoverageMutation,
  UpdateIssuerPartnershipsCoverageMutationVariables,
  UpdateIssuerPartnershipsCoverageProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateIssuerPartnershipsCoverageMutation, UpdateIssuerPartnershipsCoverageMutationVariables, UpdateIssuerPartnershipsCoverageProps<TChildProps>>(UpdateIssuerPartnershipsCoverageDocument, {
      alias: 'updateIssuerPartnershipsCoverage',
      ...operationOptions
    });
};

/**
 * __useUpdateIssuerPartnershipsCoverageMutation__
 *
 * To run a mutation, you first call `useUpdateIssuerPartnershipsCoverageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIssuerPartnershipsCoverageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIssuerPartnershipsCoverageMutation, { data, loading, error }] = useUpdateIssuerPartnershipsCoverageMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateIssuerPartnershipsCoverageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateIssuerPartnershipsCoverageMutation, UpdateIssuerPartnershipsCoverageMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateIssuerPartnershipsCoverageMutation, UpdateIssuerPartnershipsCoverageMutationVariables>(UpdateIssuerPartnershipsCoverageDocument, baseOptions);
      }
export type UpdateIssuerPartnershipsCoverageMutationHookResult = ReturnType<typeof useUpdateIssuerPartnershipsCoverageMutation>;
export type UpdateIssuerPartnershipsCoverageMutationResult = ApolloReactCommon.MutationResult<UpdateIssuerPartnershipsCoverageMutation>;
export type UpdateIssuerPartnershipsCoverageMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateIssuerPartnershipsCoverageMutation, UpdateIssuerPartnershipsCoverageMutationVariables>;
export const GetPricedIssuersDocument = gql`
    query getPricedIssuers($limit: Int!, $offset: Int!, $sortBy: IssuerSortColumn, $sortingDirection: SortDirection) {
  pricedIssuers(limit: $limit, offset: $offset, sortBy: $sortBy, sortingDirection: $sortingDirection) {
    count
    limit
    offset
    data {
      ...PricedIssuer
    }
  }
}
    ${PricedIssuerFragmentDoc}`;
export type GetPricedIssuersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPricedIssuersQuery, GetPricedIssuersQueryVariables>, 'query'> & ({ variables: GetPricedIssuersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetPricedIssuersComponent = (props: GetPricedIssuersComponentProps) => (
      <ApolloReactComponents.Query<GetPricedIssuersQuery, GetPricedIssuersQueryVariables> query={GetPricedIssuersDocument} {...props} />
    );
    
export type GetPricedIssuersProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetPricedIssuersQuery, GetPricedIssuersQueryVariables> & TChildProps;
export function withGetPricedIssuers<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetPricedIssuersQuery,
  GetPricedIssuersQueryVariables,
  GetPricedIssuersProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetPricedIssuersQuery, GetPricedIssuersQueryVariables, GetPricedIssuersProps<TChildProps>>(GetPricedIssuersDocument, {
      alias: 'getPricedIssuers',
      ...operationOptions
    });
};

/**
 * __useGetPricedIssuersQuery__
 *
 * To run a query within a React component, call `useGetPricedIssuersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricedIssuersQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricedIssuersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sortBy: // value for 'sortBy'
 *      sortingDirection: // value for 'sortingDirection'
 *   },
 * });
 */
export function useGetPricedIssuersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPricedIssuersQuery, GetPricedIssuersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPricedIssuersQuery, GetPricedIssuersQueryVariables>(GetPricedIssuersDocument, baseOptions);
      }
export function useGetPricedIssuersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPricedIssuersQuery, GetPricedIssuersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPricedIssuersQuery, GetPricedIssuersQueryVariables>(GetPricedIssuersDocument, baseOptions);
        }
export type GetPricedIssuersQueryHookResult = ReturnType<typeof useGetPricedIssuersQuery>;
export type GetPricedIssuersLazyQueryHookResult = ReturnType<typeof useGetPricedIssuersLazyQuery>;
export type GetPricedIssuersQueryResult = ApolloReactCommon.QueryResult<GetPricedIssuersQuery, GetPricedIssuersQueryVariables>;
export const IssuerHeaderDocument = gql`
    query issuerHeader($issuerId: UUID!) {
  account(id: $issuerId) {
    ...IssuerHeader
  }
}
    ${IssuerHeaderFragmentDoc}`;
export type IssuerHeaderComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<IssuerHeaderQuery, IssuerHeaderQueryVariables>, 'query'> & ({ variables: IssuerHeaderQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const IssuerHeaderComponent = (props: IssuerHeaderComponentProps) => (
      <ApolloReactComponents.Query<IssuerHeaderQuery, IssuerHeaderQueryVariables> query={IssuerHeaderDocument} {...props} />
    );
    
export type IssuerHeaderProps<TChildProps = {}> = ApolloReactHoc.DataProps<IssuerHeaderQuery, IssuerHeaderQueryVariables> & TChildProps;
export function withIssuerHeader<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IssuerHeaderQuery,
  IssuerHeaderQueryVariables,
  IssuerHeaderProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, IssuerHeaderQuery, IssuerHeaderQueryVariables, IssuerHeaderProps<TChildProps>>(IssuerHeaderDocument, {
      alias: 'issuerHeader',
      ...operationOptions
    });
};

/**
 * __useIssuerHeaderQuery__
 *
 * To run a query within a React component, call `useIssuerHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssuerHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssuerHeaderQuery({
 *   variables: {
 *      issuerId: // value for 'issuerId'
 *   },
 * });
 */
export function useIssuerHeaderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IssuerHeaderQuery, IssuerHeaderQueryVariables>) {
        return ApolloReactHooks.useQuery<IssuerHeaderQuery, IssuerHeaderQueryVariables>(IssuerHeaderDocument, baseOptions);
      }
export function useIssuerHeaderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IssuerHeaderQuery, IssuerHeaderQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IssuerHeaderQuery, IssuerHeaderQueryVariables>(IssuerHeaderDocument, baseOptions);
        }
export type IssuerHeaderQueryHookResult = ReturnType<typeof useIssuerHeaderQuery>;
export type IssuerHeaderLazyQueryHookResult = ReturnType<typeof useIssuerHeaderLazyQuery>;
export type IssuerHeaderQueryResult = ApolloReactCommon.QueryResult<IssuerHeaderQuery, IssuerHeaderQueryVariables>;
export const UpdateIssuerHeaderDocument = gql`
    mutation updateIssuerHeader($form: IssuerHeaderFormInput!) {
  updateIssuerHeader(form: $form) {
    ...IssuerHeader
  }
}
    ${IssuerHeaderFragmentDoc}`;
export type UpdateIssuerHeaderMutationFn = ApolloReactCommon.MutationFunction<UpdateIssuerHeaderMutation, UpdateIssuerHeaderMutationVariables>;
export type UpdateIssuerHeaderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateIssuerHeaderMutation, UpdateIssuerHeaderMutationVariables>, 'mutation'>;

    export const UpdateIssuerHeaderComponent = (props: UpdateIssuerHeaderComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateIssuerHeaderMutation, UpdateIssuerHeaderMutationVariables> mutation={UpdateIssuerHeaderDocument} {...props} />
    );
    
export type UpdateIssuerHeaderProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateIssuerHeaderMutation, UpdateIssuerHeaderMutationVariables> & TChildProps;
export function withUpdateIssuerHeader<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateIssuerHeaderMutation,
  UpdateIssuerHeaderMutationVariables,
  UpdateIssuerHeaderProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateIssuerHeaderMutation, UpdateIssuerHeaderMutationVariables, UpdateIssuerHeaderProps<TChildProps>>(UpdateIssuerHeaderDocument, {
      alias: 'updateIssuerHeader',
      ...operationOptions
    });
};

/**
 * __useUpdateIssuerHeaderMutation__
 *
 * To run a mutation, you first call `useUpdateIssuerHeaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIssuerHeaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIssuerHeaderMutation, { data, loading, error }] = useUpdateIssuerHeaderMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateIssuerHeaderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateIssuerHeaderMutation, UpdateIssuerHeaderMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateIssuerHeaderMutation, UpdateIssuerHeaderMutationVariables>(UpdateIssuerHeaderDocument, baseOptions);
      }
export type UpdateIssuerHeaderMutationHookResult = ReturnType<typeof useUpdateIssuerHeaderMutation>;
export type UpdateIssuerHeaderMutationResult = ApolloReactCommon.MutationResult<UpdateIssuerHeaderMutation>;
export type UpdateIssuerHeaderMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateIssuerHeaderMutation, UpdateIssuerHeaderMutationVariables>;
export const CompanyNameDocument = gql`
    query companyName($companyId: Int!) {
  company(id: $companyId) {
    id
    name
  }
}
    `;
export type CompanyNameComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CompanyNameQuery, CompanyNameQueryVariables>, 'query'> & ({ variables: CompanyNameQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CompanyNameComponent = (props: CompanyNameComponentProps) => (
      <ApolloReactComponents.Query<CompanyNameQuery, CompanyNameQueryVariables> query={CompanyNameDocument} {...props} />
    );
    
export type CompanyNameProps<TChildProps = {}> = ApolloReactHoc.DataProps<CompanyNameQuery, CompanyNameQueryVariables> & TChildProps;
export function withCompanyName<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CompanyNameQuery,
  CompanyNameQueryVariables,
  CompanyNameProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, CompanyNameQuery, CompanyNameQueryVariables, CompanyNameProps<TChildProps>>(CompanyNameDocument, {
      alias: 'companyName',
      ...operationOptions
    });
};

/**
 * __useCompanyNameQuery__
 *
 * To run a query within a React component, call `useCompanyNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyNameQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyNameQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CompanyNameQuery, CompanyNameQueryVariables>) {
        return ApolloReactHooks.useQuery<CompanyNameQuery, CompanyNameQueryVariables>(CompanyNameDocument, baseOptions);
      }
export function useCompanyNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyNameQuery, CompanyNameQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CompanyNameQuery, CompanyNameQueryVariables>(CompanyNameDocument, baseOptions);
        }
export type CompanyNameQueryHookResult = ReturnType<typeof useCompanyNameQuery>;
export type CompanyNameLazyQueryHookResult = ReturnType<typeof useCompanyNameLazyQuery>;
export type CompanyNameQueryResult = ApolloReactCommon.QueryResult<CompanyNameQuery, CompanyNameQueryVariables>;
export const IssuerGraphDocument = gql`
    query issuerGraph($issuerId: UUID!) {
  account(id: $issuerId) {
    id
    issuer_account {
      id
      company {
        id
        order_book_bid_blocks(structures: []) {
          ...OrderBookBlock
        }
        order_book_ask_blocks(structures: []) {
          ...OrderBookBlock
        }
      }
    }
  }
}
    ${OrderBookBlockFragmentDoc}`;
export type IssuerGraphComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<IssuerGraphQuery, IssuerGraphQueryVariables>, 'query'> & ({ variables: IssuerGraphQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const IssuerGraphComponent = (props: IssuerGraphComponentProps) => (
      <ApolloReactComponents.Query<IssuerGraphQuery, IssuerGraphQueryVariables> query={IssuerGraphDocument} {...props} />
    );
    
export type IssuerGraphProps<TChildProps = {}> = ApolloReactHoc.DataProps<IssuerGraphQuery, IssuerGraphQueryVariables> & TChildProps;
export function withIssuerGraph<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IssuerGraphQuery,
  IssuerGraphQueryVariables,
  IssuerGraphProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, IssuerGraphQuery, IssuerGraphQueryVariables, IssuerGraphProps<TChildProps>>(IssuerGraphDocument, {
      alias: 'issuerGraph',
      ...operationOptions
    });
};

/**
 * __useIssuerGraphQuery__
 *
 * To run a query within a React component, call `useIssuerGraphQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssuerGraphQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssuerGraphQuery({
 *   variables: {
 *      issuerId: // value for 'issuerId'
 *   },
 * });
 */
export function useIssuerGraphQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IssuerGraphQuery, IssuerGraphQueryVariables>) {
        return ApolloReactHooks.useQuery<IssuerGraphQuery, IssuerGraphQueryVariables>(IssuerGraphDocument, baseOptions);
      }
export function useIssuerGraphLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IssuerGraphQuery, IssuerGraphQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IssuerGraphQuery, IssuerGraphQueryVariables>(IssuerGraphDocument, baseOptions);
        }
export type IssuerGraphQueryHookResult = ReturnType<typeof useIssuerGraphQuery>;
export type IssuerGraphLazyQueryHookResult = ReturnType<typeof useIssuerGraphLazyQuery>;
export type IssuerGraphQueryResult = ApolloReactCommon.QueryResult<IssuerGraphQuery, IssuerGraphQueryVariables>;
export const OrderBookDocument = gql`
    query orderBook($offset: Int, $limit: Int, $filter: OrderBookFilterInput, $sort: SortInput) {
  orderBookCompanies(offset: $offset, limit: $limit, filter: $filter, sort: $sort) {
    count
    offset
    limit
    data {
      ...orderBookCompany
    }
  }
}
    ${OrderBookCompanyFragmentDoc}`;
export type OrderBookComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrderBookQuery, OrderBookQueryVariables>, 'query'>;

    export const OrderBookComponent = (props: OrderBookComponentProps) => (
      <ApolloReactComponents.Query<OrderBookQuery, OrderBookQueryVariables> query={OrderBookDocument} {...props} />
    );
    
export type OrderBookProps<TChildProps = {}> = ApolloReactHoc.DataProps<OrderBookQuery, OrderBookQueryVariables> & TChildProps;
export function withOrderBook<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrderBookQuery,
  OrderBookQueryVariables,
  OrderBookProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, OrderBookQuery, OrderBookQueryVariables, OrderBookProps<TChildProps>>(OrderBookDocument, {
      alias: 'orderBook',
      ...operationOptions
    });
};

/**
 * __useOrderBookQuery__
 *
 * To run a query within a React component, call `useOrderBookQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderBookQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderBookQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useOrderBookQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrderBookQuery, OrderBookQueryVariables>) {
        return ApolloReactHooks.useQuery<OrderBookQuery, OrderBookQueryVariables>(OrderBookDocument, baseOptions);
      }
export function useOrderBookLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrderBookQuery, OrderBookQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OrderBookQuery, OrderBookQueryVariables>(OrderBookDocument, baseOptions);
        }
export type OrderBookQueryHookResult = ReturnType<typeof useOrderBookQuery>;
export type OrderBookLazyQueryHookResult = ReturnType<typeof useOrderBookLazyQuery>;
export type OrderBookQueryResult = ApolloReactCommon.QueryResult<OrderBookQuery, OrderBookQueryVariables>;
export const OrderBookBidAskDetailDocument = gql`
    query orderBookBidAskDetail($limit: Int!, $offset: Int!, $companyId: Int!, $filter: OpportunityFilterInput!) {
  company(id: $companyId) {
    id
    name
    logo_url
  }
  opportunities(limit: $limit, offset: $offset, filter: $filter) {
    count
    offset
    limit
    data {
      ...OrderBookOpportunity
    }
  }
}
    ${OrderBookOpportunityFragmentDoc}`;
export type OrderBookBidAskDetailComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrderBookBidAskDetailQuery, OrderBookBidAskDetailQueryVariables>, 'query'> & ({ variables: OrderBookBidAskDetailQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrderBookBidAskDetailComponent = (props: OrderBookBidAskDetailComponentProps) => (
      <ApolloReactComponents.Query<OrderBookBidAskDetailQuery, OrderBookBidAskDetailQueryVariables> query={OrderBookBidAskDetailDocument} {...props} />
    );
    
export type OrderBookBidAskDetailProps<TChildProps = {}> = ApolloReactHoc.DataProps<OrderBookBidAskDetailQuery, OrderBookBidAskDetailQueryVariables> & TChildProps;
export function withOrderBookBidAskDetail<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrderBookBidAskDetailQuery,
  OrderBookBidAskDetailQueryVariables,
  OrderBookBidAskDetailProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, OrderBookBidAskDetailQuery, OrderBookBidAskDetailQueryVariables, OrderBookBidAskDetailProps<TChildProps>>(OrderBookBidAskDetailDocument, {
      alias: 'orderBookBidAskDetail',
      ...operationOptions
    });
};

/**
 * __useOrderBookBidAskDetailQuery__
 *
 * To run a query within a React component, call `useOrderBookBidAskDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderBookBidAskDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderBookBidAskDetailQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      companyId: // value for 'companyId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrderBookBidAskDetailQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrderBookBidAskDetailQuery, OrderBookBidAskDetailQueryVariables>) {
        return ApolloReactHooks.useQuery<OrderBookBidAskDetailQuery, OrderBookBidAskDetailQueryVariables>(OrderBookBidAskDetailDocument, baseOptions);
      }
export function useOrderBookBidAskDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrderBookBidAskDetailQuery, OrderBookBidAskDetailQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OrderBookBidAskDetailQuery, OrderBookBidAskDetailQueryVariables>(OrderBookBidAskDetailDocument, baseOptions);
        }
export type OrderBookBidAskDetailQueryHookResult = ReturnType<typeof useOrderBookBidAskDetailQuery>;
export type OrderBookBidAskDetailLazyQueryHookResult = ReturnType<typeof useOrderBookBidAskDetailLazyQuery>;
export type OrderBookBidAskDetailQueryResult = ApolloReactCommon.QueryResult<OrderBookBidAskDetailQuery, OrderBookBidAskDetailQueryVariables>;
export const OrderBookDetailsDocument = gql`
    query OrderBookDetails($companyId: Int!, $qualifiedOnly: Boolean!, $structures: [ListingStructureType!]) {
  company(id: $companyId) {
    ...orderBookCompanyDetails
  }
}
    ${OrderBookCompanyDetailsFragmentDoc}`;
export type OrderBookDetailsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrderBookDetailsQuery, OrderBookDetailsQueryVariables>, 'query'> & ({ variables: OrderBookDetailsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrderBookDetailsComponent = (props: OrderBookDetailsComponentProps) => (
      <ApolloReactComponents.Query<OrderBookDetailsQuery, OrderBookDetailsQueryVariables> query={OrderBookDetailsDocument} {...props} />
    );
    
export type OrderBookDetailsProps<TChildProps = {}> = ApolloReactHoc.DataProps<OrderBookDetailsQuery, OrderBookDetailsQueryVariables> & TChildProps;
export function withOrderBookDetails<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrderBookDetailsQuery,
  OrderBookDetailsQueryVariables,
  OrderBookDetailsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, OrderBookDetailsQuery, OrderBookDetailsQueryVariables, OrderBookDetailsProps<TChildProps>>(OrderBookDetailsDocument, {
      alias: 'orderBookDetails',
      ...operationOptions
    });
};

/**
 * __useOrderBookDetailsQuery__
 *
 * To run a query within a React component, call `useOrderBookDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderBookDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderBookDetailsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      qualifiedOnly: // value for 'qualifiedOnly'
 *      structures: // value for 'structures'
 *   },
 * });
 */
export function useOrderBookDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrderBookDetailsQuery, OrderBookDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<OrderBookDetailsQuery, OrderBookDetailsQueryVariables>(OrderBookDetailsDocument, baseOptions);
      }
export function useOrderBookDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrderBookDetailsQuery, OrderBookDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OrderBookDetailsQuery, OrderBookDetailsQueryVariables>(OrderBookDetailsDocument, baseOptions);
        }
export type OrderBookDetailsQueryHookResult = ReturnType<typeof useOrderBookDetailsQuery>;
export type OrderBookDetailsLazyQueryHookResult = ReturnType<typeof useOrderBookDetailsLazyQuery>;
export type OrderBookDetailsQueryResult = ApolloReactCommon.QueryResult<OrderBookDetailsQuery, OrderBookDetailsQueryVariables>;
export const QueriedAccountsDocument = gql`
    query queriedAccounts($query: String!, $limit: Int!, $offset: Int!) {
  filterAccounts(query: $query, limit: $limit, offset: $offset, unroll: true) {
    count
    limit
    offset
    data {
      id
      email
      name
      type
      last_order_closed_date
      parents {
        id
        parent_to_child_relationship
        is_point_of_contact
        parent_account {
          id
          type
          name
          intermediary {
            id
          }
        }
      }
    }
  }
}
    `;
export type QueriedAccountsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<QueriedAccountsQuery, QueriedAccountsQueryVariables>, 'query'> & ({ variables: QueriedAccountsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const QueriedAccountsComponent = (props: QueriedAccountsComponentProps) => (
      <ApolloReactComponents.Query<QueriedAccountsQuery, QueriedAccountsQueryVariables> query={QueriedAccountsDocument} {...props} />
    );
    
export type QueriedAccountsProps<TChildProps = {}> = ApolloReactHoc.DataProps<QueriedAccountsQuery, QueriedAccountsQueryVariables> & TChildProps;
export function withQueriedAccounts<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  QueriedAccountsQuery,
  QueriedAccountsQueryVariables,
  QueriedAccountsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, QueriedAccountsQuery, QueriedAccountsQueryVariables, QueriedAccountsProps<TChildProps>>(QueriedAccountsDocument, {
      alias: 'queriedAccounts',
      ...operationOptions
    });
};

/**
 * __useQueriedAccountsQuery__
 *
 * To run a query within a React component, call `useQueriedAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueriedAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueriedAccountsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useQueriedAccountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<QueriedAccountsQuery, QueriedAccountsQueryVariables>) {
        return ApolloReactHooks.useQuery<QueriedAccountsQuery, QueriedAccountsQueryVariables>(QueriedAccountsDocument, baseOptions);
      }
export function useQueriedAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QueriedAccountsQuery, QueriedAccountsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<QueriedAccountsQuery, QueriedAccountsQueryVariables>(QueriedAccountsDocument, baseOptions);
        }
export type QueriedAccountsQueryHookResult = ReturnType<typeof useQueriedAccountsQuery>;
export type QueriedAccountsLazyQueryHookResult = ReturnType<typeof useQueriedAccountsLazyQuery>;
export type QueriedAccountsQueryResult = ApolloReactCommon.QueryResult<QueriedAccountsQuery, QueriedAccountsQueryVariables>;
export const FilterAccountsCountOnlyDocument = gql`
    query filterAccountsCountOnly($query: String!) {
  filterAccounts(query: $query, limit: 1, offset: 0) {
    count
  }
}
    `;
export type FilterAccountsCountOnlyComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FilterAccountsCountOnlyQuery, FilterAccountsCountOnlyQueryVariables>, 'query'> & ({ variables: FilterAccountsCountOnlyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FilterAccountsCountOnlyComponent = (props: FilterAccountsCountOnlyComponentProps) => (
      <ApolloReactComponents.Query<FilterAccountsCountOnlyQuery, FilterAccountsCountOnlyQueryVariables> query={FilterAccountsCountOnlyDocument} {...props} />
    );
    
export type FilterAccountsCountOnlyProps<TChildProps = {}> = ApolloReactHoc.DataProps<FilterAccountsCountOnlyQuery, FilterAccountsCountOnlyQueryVariables> & TChildProps;
export function withFilterAccountsCountOnly<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FilterAccountsCountOnlyQuery,
  FilterAccountsCountOnlyQueryVariables,
  FilterAccountsCountOnlyProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, FilterAccountsCountOnlyQuery, FilterAccountsCountOnlyQueryVariables, FilterAccountsCountOnlyProps<TChildProps>>(FilterAccountsCountOnlyDocument, {
      alias: 'filterAccountsCountOnly',
      ...operationOptions
    });
};

/**
 * __useFilterAccountsCountOnlyQuery__
 *
 * To run a query within a React component, call `useFilterAccountsCountOnlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterAccountsCountOnlyQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterAccountsCountOnlyQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFilterAccountsCountOnlyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FilterAccountsCountOnlyQuery, FilterAccountsCountOnlyQueryVariables>) {
        return ApolloReactHooks.useQuery<FilterAccountsCountOnlyQuery, FilterAccountsCountOnlyQueryVariables>(FilterAccountsCountOnlyDocument, baseOptions);
      }
export function useFilterAccountsCountOnlyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FilterAccountsCountOnlyQuery, FilterAccountsCountOnlyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FilterAccountsCountOnlyQuery, FilterAccountsCountOnlyQueryVariables>(FilterAccountsCountOnlyDocument, baseOptions);
        }
export type FilterAccountsCountOnlyQueryHookResult = ReturnType<typeof useFilterAccountsCountOnlyQuery>;
export type FilterAccountsCountOnlyLazyQueryHookResult = ReturnType<typeof useFilterAccountsCountOnlyLazyQuery>;
export type FilterAccountsCountOnlyQueryResult = ApolloReactCommon.QueryResult<FilterAccountsCountOnlyQuery, FilterAccountsCountOnlyQueryVariables>;
export const TransactionHistoryDocument = gql`
    query transactionHistory($accountId: UUID!) {
  account(id: $accountId) {
    id
    deals(onlyClosed: true) {
      company {
        id
        name
        logo_url
      }
      totalBuySideVolume
      totalSellSideVolume
      totalBuySideRevenue
      totalSellSideRevenue
      orderType
      dateFullyAccrued
      avgSharePrice
      orderCount
      totalNumShares
    }
  }
}
    `;
export type TransactionHistoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TransactionHistoryQuery, TransactionHistoryQueryVariables>, 'query'> & ({ variables: TransactionHistoryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TransactionHistoryComponent = (props: TransactionHistoryComponentProps) => (
      <ApolloReactComponents.Query<TransactionHistoryQuery, TransactionHistoryQueryVariables> query={TransactionHistoryDocument} {...props} />
    );
    
export type TransactionHistoryProps<TChildProps = {}> = ApolloReactHoc.DataProps<TransactionHistoryQuery, TransactionHistoryQueryVariables> & TChildProps;
export function withTransactionHistory<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TransactionHistoryQuery,
  TransactionHistoryQueryVariables,
  TransactionHistoryProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, TransactionHistoryQuery, TransactionHistoryQueryVariables, TransactionHistoryProps<TChildProps>>(TransactionHistoryDocument, {
      alias: 'transactionHistory',
      ...operationOptions
    });
};

/**
 * __useTransactionHistoryQuery__
 *
 * To run a query within a React component, call `useTransactionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionHistoryQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useTransactionHistoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TransactionHistoryQuery, TransactionHistoryQueryVariables>) {
        return ApolloReactHooks.useQuery<TransactionHistoryQuery, TransactionHistoryQueryVariables>(TransactionHistoryDocument, baseOptions);
      }
export function useTransactionHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TransactionHistoryQuery, TransactionHistoryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TransactionHistoryQuery, TransactionHistoryQueryVariables>(TransactionHistoryDocument, baseOptions);
        }
export type TransactionHistoryQueryHookResult = ReturnType<typeof useTransactionHistoryQuery>;
export type TransactionHistoryLazyQueryHookResult = ReturnType<typeof useTransactionHistoryLazyQuery>;
export type TransactionHistoryQueryResult = ApolloReactCommon.QueryResult<TransactionHistoryQuery, TransactionHistoryQueryVariables>;
export const UpdateAccountDocument = gql`
    mutation updateAccount($form: AccountDetailsFormInput!) {
  updateAccount(form: $form) {
    id
    name
    type
    is_investor
    is_shareholder
    client_type_id
    aum
    aum_secondaries
    net_worth
    state
    country
    city
    notes
    investor_notes
    shareholder_notes
    participates_in_secondaries
    investor_preferences {
      id
      investment_structure_comfort
      target_check_size
      target_regions
      has_cash_on_hand
      minimum_company_valuation
      minimum_company_revenue
      minimum_growth_rate
      only_profitable_companies
      opportunities_of_interest
      sectors_interested
      sectors_avoid
    }
  }
}
    `;
export type UpdateAccountMutationFn = ApolloReactCommon.MutationFunction<UpdateAccountMutation, UpdateAccountMutationVariables>;
export type UpdateAccountComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateAccountMutation, UpdateAccountMutationVariables>, 'mutation'>;

    export const UpdateAccountComponent = (props: UpdateAccountComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateAccountMutation, UpdateAccountMutationVariables> mutation={UpdateAccountDocument} {...props} />
    );
    
export type UpdateAccountProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateAccountMutation, UpdateAccountMutationVariables> & TChildProps;
export function withUpdateAccount<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateAccountMutation,
  UpdateAccountMutationVariables,
  UpdateAccountProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateAccountMutation, UpdateAccountMutationVariables, UpdateAccountProps<TChildProps>>(UpdateAccountDocument, {
      alias: 'updateAccount',
      ...operationOptions
    });
};

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, baseOptions);
      }
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = ApolloReactCommon.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const UpdateAccountRelationshipDocument = gql`
    mutation updateAccountRelationship($form: AccountRelationshipFormInput!) {
  createOrUpdateAccountRelationship(form: $form) {
    ...AccountRelationshipData
  }
}
    ${AccountRelationshipDataFragmentDoc}`;
export type UpdateAccountRelationshipMutationFn = ApolloReactCommon.MutationFunction<UpdateAccountRelationshipMutation, UpdateAccountRelationshipMutationVariables>;
export type UpdateAccountRelationshipComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateAccountRelationshipMutation, UpdateAccountRelationshipMutationVariables>, 'mutation'>;

    export const UpdateAccountRelationshipComponent = (props: UpdateAccountRelationshipComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateAccountRelationshipMutation, UpdateAccountRelationshipMutationVariables> mutation={UpdateAccountRelationshipDocument} {...props} />
    );
    
export type UpdateAccountRelationshipProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateAccountRelationshipMutation, UpdateAccountRelationshipMutationVariables> & TChildProps;
export function withUpdateAccountRelationship<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateAccountRelationshipMutation,
  UpdateAccountRelationshipMutationVariables,
  UpdateAccountRelationshipProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateAccountRelationshipMutation, UpdateAccountRelationshipMutationVariables, UpdateAccountRelationshipProps<TChildProps>>(UpdateAccountRelationshipDocument, {
      alias: 'updateAccountRelationship',
      ...operationOptions
    });
};

/**
 * __useUpdateAccountRelationshipMutation__
 *
 * To run a mutation, you first call `useUpdateAccountRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountRelationshipMutation, { data, loading, error }] = useUpdateAccountRelationshipMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateAccountRelationshipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAccountRelationshipMutation, UpdateAccountRelationshipMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateAccountRelationshipMutation, UpdateAccountRelationshipMutationVariables>(UpdateAccountRelationshipDocument, baseOptions);
      }
export type UpdateAccountRelationshipMutationHookResult = ReturnType<typeof useUpdateAccountRelationshipMutation>;
export type UpdateAccountRelationshipMutationResult = ApolloReactCommon.MutationResult<UpdateAccountRelationshipMutation>;
export type UpdateAccountRelationshipMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAccountRelationshipMutation, UpdateAccountRelationshipMutationVariables>;
export const CreateSectorDocument = gql`
    mutation createSector($name: String!) {
  createSector(name: $name) {
    id
    name
  }
}
    `;
export type CreateSectorMutationFn = ApolloReactCommon.MutationFunction<CreateSectorMutation, CreateSectorMutationVariables>;
export type CreateSectorComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateSectorMutation, CreateSectorMutationVariables>, 'mutation'>;

    export const CreateSectorComponent = (props: CreateSectorComponentProps) => (
      <ApolloReactComponents.Mutation<CreateSectorMutation, CreateSectorMutationVariables> mutation={CreateSectorDocument} {...props} />
    );
    
export type CreateSectorProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CreateSectorMutation, CreateSectorMutationVariables> & TChildProps;
export function withCreateSector<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateSectorMutation,
  CreateSectorMutationVariables,
  CreateSectorProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CreateSectorMutation, CreateSectorMutationVariables, CreateSectorProps<TChildProps>>(CreateSectorDocument, {
      alias: 'createSector',
      ...operationOptions
    });
};

/**
 * __useCreateSectorMutation__
 *
 * To run a mutation, you first call `useCreateSectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSectorMutation, { data, loading, error }] = useCreateSectorMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateSectorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSectorMutation, CreateSectorMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateSectorMutation, CreateSectorMutationVariables>(CreateSectorDocument, baseOptions);
      }
export type CreateSectorMutationHookResult = ReturnType<typeof useCreateSectorMutation>;
export type CreateSectorMutationResult = ApolloReactCommon.MutationResult<CreateSectorMutation>;
export type CreateSectorMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSectorMutation, CreateSectorMutationVariables>;
export const UpdateAccountHeaderDocument = gql`
    mutation updateAccountHeader($form: AccountHeaderFormInput!) {
  updateAccountHeader(form: $form) {
    ...AccountHeader
  }
}
    ${AccountHeaderFragmentDoc}`;
export type UpdateAccountHeaderMutationFn = ApolloReactCommon.MutationFunction<UpdateAccountHeaderMutation, UpdateAccountHeaderMutationVariables>;
export type UpdateAccountHeaderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateAccountHeaderMutation, UpdateAccountHeaderMutationVariables>, 'mutation'>;

    export const UpdateAccountHeaderComponent = (props: UpdateAccountHeaderComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateAccountHeaderMutation, UpdateAccountHeaderMutationVariables> mutation={UpdateAccountHeaderDocument} {...props} />
    );
    
export type UpdateAccountHeaderProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateAccountHeaderMutation, UpdateAccountHeaderMutationVariables> & TChildProps;
export function withUpdateAccountHeader<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateAccountHeaderMutation,
  UpdateAccountHeaderMutationVariables,
  UpdateAccountHeaderProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateAccountHeaderMutation, UpdateAccountHeaderMutationVariables, UpdateAccountHeaderProps<TChildProps>>(UpdateAccountHeaderDocument, {
      alias: 'updateAccountHeader',
      ...operationOptions
    });
};

/**
 * __useUpdateAccountHeaderMutation__
 *
 * To run a mutation, you first call `useUpdateAccountHeaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountHeaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountHeaderMutation, { data, loading, error }] = useUpdateAccountHeaderMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateAccountHeaderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAccountHeaderMutation, UpdateAccountHeaderMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateAccountHeaderMutation, UpdateAccountHeaderMutationVariables>(UpdateAccountHeaderDocument, baseOptions);
      }
export type UpdateAccountHeaderMutationHookResult = ReturnType<typeof useUpdateAccountHeaderMutation>;
export type UpdateAccountHeaderMutationResult = ApolloReactCommon.MutationResult<UpdateAccountHeaderMutation>;
export type UpdateAccountHeaderMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAccountHeaderMutation, UpdateAccountHeaderMutationVariables>;
export const UpdateClientDetailsDocument = gql`
    mutation updateClientDetails($form: ClientDetailsFormInput!) {
  updateClientDetails(form: $form) {
    ...ClientDetails
  }
}
    ${ClientDetailsFragmentDoc}`;
export type UpdateClientDetailsMutationFn = ApolloReactCommon.MutationFunction<UpdateClientDetailsMutation, UpdateClientDetailsMutationVariables>;
export type UpdateClientDetailsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateClientDetailsMutation, UpdateClientDetailsMutationVariables>, 'mutation'>;

    export const UpdateClientDetailsComponent = (props: UpdateClientDetailsComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateClientDetailsMutation, UpdateClientDetailsMutationVariables> mutation={UpdateClientDetailsDocument} {...props} />
    );
    
export type UpdateClientDetailsProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateClientDetailsMutation, UpdateClientDetailsMutationVariables> & TChildProps;
export function withUpdateClientDetails<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateClientDetailsMutation,
  UpdateClientDetailsMutationVariables,
  UpdateClientDetailsProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateClientDetailsMutation, UpdateClientDetailsMutationVariables, UpdateClientDetailsProps<TChildProps>>(UpdateClientDetailsDocument, {
      alias: 'updateClientDetails',
      ...operationOptions
    });
};

/**
 * __useUpdateClientDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateClientDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientDetailsMutation, { data, loading, error }] = useUpdateClientDetailsMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateClientDetailsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateClientDetailsMutation, UpdateClientDetailsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateClientDetailsMutation, UpdateClientDetailsMutationVariables>(UpdateClientDetailsDocument, baseOptions);
      }
export type UpdateClientDetailsMutationHookResult = ReturnType<typeof useUpdateClientDetailsMutation>;
export type UpdateClientDetailsMutationResult = ApolloReactCommon.MutationResult<UpdateClientDetailsMutation>;
export type UpdateClientDetailsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateClientDetailsMutation, UpdateClientDetailsMutationVariables>;
export const UpdateInvestorDetailsDocument = gql`
    mutation updateInvestorDetails($form: InvestorDetailsFormInput!) {
  updateInvestorDetails(form: $form) {
    ...InvestorDetails
  }
}
    ${InvestorDetailsFragmentDoc}`;
export type UpdateInvestorDetailsMutationFn = ApolloReactCommon.MutationFunction<UpdateInvestorDetailsMutation, UpdateInvestorDetailsMutationVariables>;
export type UpdateInvestorDetailsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateInvestorDetailsMutation, UpdateInvestorDetailsMutationVariables>, 'mutation'>;

    export const UpdateInvestorDetailsComponent = (props: UpdateInvestorDetailsComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateInvestorDetailsMutation, UpdateInvestorDetailsMutationVariables> mutation={UpdateInvestorDetailsDocument} {...props} />
    );
    
export type UpdateInvestorDetailsProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateInvestorDetailsMutation, UpdateInvestorDetailsMutationVariables> & TChildProps;
export function withUpdateInvestorDetails<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateInvestorDetailsMutation,
  UpdateInvestorDetailsMutationVariables,
  UpdateInvestorDetailsProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateInvestorDetailsMutation, UpdateInvestorDetailsMutationVariables, UpdateInvestorDetailsProps<TChildProps>>(UpdateInvestorDetailsDocument, {
      alias: 'updateInvestorDetails',
      ...operationOptions
    });
};

/**
 * __useUpdateInvestorDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateInvestorDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvestorDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvestorDetailsMutation, { data, loading, error }] = useUpdateInvestorDetailsMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateInvestorDetailsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateInvestorDetailsMutation, UpdateInvestorDetailsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateInvestorDetailsMutation, UpdateInvestorDetailsMutationVariables>(UpdateInvestorDetailsDocument, baseOptions);
      }
export type UpdateInvestorDetailsMutationHookResult = ReturnType<typeof useUpdateInvestorDetailsMutation>;
export type UpdateInvestorDetailsMutationResult = ApolloReactCommon.MutationResult<UpdateInvestorDetailsMutation>;
export type UpdateInvestorDetailsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateInvestorDetailsMutation, UpdateInvestorDetailsMutationVariables>;
export const UpdateShareholderDetailsDocument = gql`
    mutation updateShareholderDetails($form: ShareholderDetailsFormInput!) {
  updateShareholderDetails(form: $form) {
    ...ShareholderDetails
  }
}
    ${ShareholderDetailsFragmentDoc}`;
export type UpdateShareholderDetailsMutationFn = ApolloReactCommon.MutationFunction<UpdateShareholderDetailsMutation, UpdateShareholderDetailsMutationVariables>;
export type UpdateShareholderDetailsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateShareholderDetailsMutation, UpdateShareholderDetailsMutationVariables>, 'mutation'>;

    export const UpdateShareholderDetailsComponent = (props: UpdateShareholderDetailsComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateShareholderDetailsMutation, UpdateShareholderDetailsMutationVariables> mutation={UpdateShareholderDetailsDocument} {...props} />
    );
    
export type UpdateShareholderDetailsProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateShareholderDetailsMutation, UpdateShareholderDetailsMutationVariables> & TChildProps;
export function withUpdateShareholderDetails<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateShareholderDetailsMutation,
  UpdateShareholderDetailsMutationVariables,
  UpdateShareholderDetailsProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateShareholderDetailsMutation, UpdateShareholderDetailsMutationVariables, UpdateShareholderDetailsProps<TChildProps>>(UpdateShareholderDetailsDocument, {
      alias: 'updateShareholderDetails',
      ...operationOptions
    });
};

/**
 * __useUpdateShareholderDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateShareholderDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShareholderDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShareholderDetailsMutation, { data, loading, error }] = useUpdateShareholderDetailsMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateShareholderDetailsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateShareholderDetailsMutation, UpdateShareholderDetailsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateShareholderDetailsMutation, UpdateShareholderDetailsMutationVariables>(UpdateShareholderDetailsDocument, baseOptions);
      }
export type UpdateShareholderDetailsMutationHookResult = ReturnType<typeof useUpdateShareholderDetailsMutation>;
export type UpdateShareholderDetailsMutationResult = ApolloReactCommon.MutationResult<UpdateShareholderDetailsMutation>;
export type UpdateShareholderDetailsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateShareholderDetailsMutation, UpdateShareholderDetailsMutationVariables>;
export const SetIntermediaryDocument = gql`
    mutation setIntermediary($form: SetIntermediaryFormInput!) {
  setIntermediaryAccount(form: $form) {
    id
    intermediary {
      ...ParentOrChildRelationship
    }
  }
}
    ${ParentOrChildRelationshipFragmentDoc}`;
export type SetIntermediaryMutationFn = ApolloReactCommon.MutationFunction<SetIntermediaryMutation, SetIntermediaryMutationVariables>;
export type SetIntermediaryComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SetIntermediaryMutation, SetIntermediaryMutationVariables>, 'mutation'>;

    export const SetIntermediaryComponent = (props: SetIntermediaryComponentProps) => (
      <ApolloReactComponents.Mutation<SetIntermediaryMutation, SetIntermediaryMutationVariables> mutation={SetIntermediaryDocument} {...props} />
    );
    
export type SetIntermediaryProps<TChildProps = {}> = ApolloReactHoc.MutateProps<SetIntermediaryMutation, SetIntermediaryMutationVariables> & TChildProps;
export function withSetIntermediary<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SetIntermediaryMutation,
  SetIntermediaryMutationVariables,
  SetIntermediaryProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, SetIntermediaryMutation, SetIntermediaryMutationVariables, SetIntermediaryProps<TChildProps>>(SetIntermediaryDocument, {
      alias: 'setIntermediary',
      ...operationOptions
    });
};

/**
 * __useSetIntermediaryMutation__
 *
 * To run a mutation, you first call `useSetIntermediaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIntermediaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIntermediaryMutation, { data, loading, error }] = useSetIntermediaryMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useSetIntermediaryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetIntermediaryMutation, SetIntermediaryMutationVariables>) {
        return ApolloReactHooks.useMutation<SetIntermediaryMutation, SetIntermediaryMutationVariables>(SetIntermediaryDocument, baseOptions);
      }
export type SetIntermediaryMutationHookResult = ReturnType<typeof useSetIntermediaryMutation>;
export type SetIntermediaryMutationResult = ApolloReactCommon.MutationResult<SetIntermediaryMutation>;
export type SetIntermediaryMutationOptions = ApolloReactCommon.BaseMutationOptions<SetIntermediaryMutation, SetIntermediaryMutationVariables>;
export const SetPocDocument = gql`
    mutation setPOC($relationshipId: UUID!, $isPointOfContact: Boolean!) {
  setPointOfContact(relationshipId: $relationshipId, isPointOfContact: $isPointOfContact) {
    id
    is_point_of_contact
  }
}
    `;
export type SetPocMutationFn = ApolloReactCommon.MutationFunction<SetPocMutation, SetPocMutationVariables>;
export type SetPocComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SetPocMutation, SetPocMutationVariables>, 'mutation'>;

    export const SetPocComponent = (props: SetPocComponentProps) => (
      <ApolloReactComponents.Mutation<SetPocMutation, SetPocMutationVariables> mutation={SetPocDocument} {...props} />
    );
    
export type SetPocProps<TChildProps = {}> = ApolloReactHoc.MutateProps<SetPocMutation, SetPocMutationVariables> & TChildProps;
export function withSetPoc<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SetPocMutation,
  SetPocMutationVariables,
  SetPocProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, SetPocMutation, SetPocMutationVariables, SetPocProps<TChildProps>>(SetPocDocument, {
      alias: 'setPoc',
      ...operationOptions
    });
};

/**
 * __useSetPocMutation__
 *
 * To run a mutation, you first call `useSetPocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPocMutation, { data, loading, error }] = useSetPocMutation({
 *   variables: {
 *      relationshipId: // value for 'relationshipId'
 *      isPointOfContact: // value for 'isPointOfContact'
 *   },
 * });
 */
export function useSetPocMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetPocMutation, SetPocMutationVariables>) {
        return ApolloReactHooks.useMutation<SetPocMutation, SetPocMutationVariables>(SetPocDocument, baseOptions);
      }
export type SetPocMutationHookResult = ReturnType<typeof useSetPocMutation>;
export type SetPocMutationResult = ApolloReactCommon.MutationResult<SetPocMutation>;
export type SetPocMutationOptions = ApolloReactCommon.BaseMutationOptions<SetPocMutation, SetPocMutationVariables>;
export const AppDataDocument = gql`
    query appData {
  currentAdmin {
    ...currentAdmin
  }
}
    ${CurrentAdminFragmentDoc}`;
export type AppDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AppDataQuery, AppDataQueryVariables>, 'query'>;

    export const AppDataComponent = (props: AppDataComponentProps) => (
      <ApolloReactComponents.Query<AppDataQuery, AppDataQueryVariables> query={AppDataDocument} {...props} />
    );
    
export type AppDataProps<TChildProps = {}> = ApolloReactHoc.DataProps<AppDataQuery, AppDataQueryVariables> & TChildProps;
export function withAppData<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AppDataQuery,
  AppDataQueryVariables,
  AppDataProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AppDataQuery, AppDataQueryVariables, AppDataProps<TChildProps>>(AppDataDocument, {
      alias: 'appData',
      ...operationOptions
    });
};

/**
 * __useAppDataQuery__
 *
 * To run a query within a React component, call `useAppDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppDataQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AppDataQuery, AppDataQueryVariables>) {
        return ApolloReactHooks.useQuery<AppDataQuery, AppDataQueryVariables>(AppDataDocument, baseOptions);
      }
export function useAppDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AppDataQuery, AppDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AppDataQuery, AppDataQueryVariables>(AppDataDocument, baseOptions);
        }
export type AppDataQueryHookResult = ReturnType<typeof useAppDataQuery>;
export type AppDataLazyQueryHookResult = ReturnType<typeof useAppDataLazyQuery>;
export type AppDataQueryResult = ApolloReactCommon.QueryResult<AppDataQuery, AppDataQueryVariables>;
export const CreateModalStateDocument = gql`
    query createModalState {
  is_create_modal_open @client
  create_modal_data @client {
    type
    accountId
    accountName
    companyId
    companyName
  }
}
    `;
export type CreateModalStateComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CreateModalStateQuery, CreateModalStateQueryVariables>, 'query'>;

    export const CreateModalStateComponent = (props: CreateModalStateComponentProps) => (
      <ApolloReactComponents.Query<CreateModalStateQuery, CreateModalStateQueryVariables> query={CreateModalStateDocument} {...props} />
    );
    
export type CreateModalStateProps<TChildProps = {}> = ApolloReactHoc.DataProps<CreateModalStateQuery, CreateModalStateQueryVariables> & TChildProps;
export function withCreateModalState<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateModalStateQuery,
  CreateModalStateQueryVariables,
  CreateModalStateProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, CreateModalStateQuery, CreateModalStateQueryVariables, CreateModalStateProps<TChildProps>>(CreateModalStateDocument, {
      alias: 'createModalState',
      ...operationOptions
    });
};

/**
 * __useCreateModalStateQuery__
 *
 * To run a query within a React component, call `useCreateModalStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateModalStateQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateModalStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateModalStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CreateModalStateQuery, CreateModalStateQueryVariables>) {
        return ApolloReactHooks.useQuery<CreateModalStateQuery, CreateModalStateQueryVariables>(CreateModalStateDocument, baseOptions);
      }
export function useCreateModalStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateModalStateQuery, CreateModalStateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CreateModalStateQuery, CreateModalStateQueryVariables>(CreateModalStateDocument, baseOptions);
        }
export type CreateModalStateQueryHookResult = ReturnType<typeof useCreateModalStateQuery>;
export type CreateModalStateLazyQueryHookResult = ReturnType<typeof useCreateModalStateLazyQuery>;
export type CreateModalStateQueryResult = ApolloReactCommon.QueryResult<CreateModalStateQuery, CreateModalStateQueryVariables>;
export const OpenCreateModalDocument = gql`
    mutation openCreateModal($data: CreateModalDataInput!) {
  openCreateModal(data: $data) @client
}
    `;
export type OpenCreateModalMutationFn = ApolloReactCommon.MutationFunction<OpenCreateModalMutation, OpenCreateModalMutationVariables>;
export type OpenCreateModalComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<OpenCreateModalMutation, OpenCreateModalMutationVariables>, 'mutation'>;

    export const OpenCreateModalComponent = (props: OpenCreateModalComponentProps) => (
      <ApolloReactComponents.Mutation<OpenCreateModalMutation, OpenCreateModalMutationVariables> mutation={OpenCreateModalDocument} {...props} />
    );
    
export type OpenCreateModalProps<TChildProps = {}> = ApolloReactHoc.MutateProps<OpenCreateModalMutation, OpenCreateModalMutationVariables> & TChildProps;
export function withOpenCreateModal<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OpenCreateModalMutation,
  OpenCreateModalMutationVariables,
  OpenCreateModalProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, OpenCreateModalMutation, OpenCreateModalMutationVariables, OpenCreateModalProps<TChildProps>>(OpenCreateModalDocument, {
      alias: 'openCreateModal',
      ...operationOptions
    });
};

/**
 * __useOpenCreateModalMutation__
 *
 * To run a mutation, you first call `useOpenCreateModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenCreateModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openCreateModalMutation, { data, loading, error }] = useOpenCreateModalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useOpenCreateModalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OpenCreateModalMutation, OpenCreateModalMutationVariables>) {
        return ApolloReactHooks.useMutation<OpenCreateModalMutation, OpenCreateModalMutationVariables>(OpenCreateModalDocument, baseOptions);
      }
export type OpenCreateModalMutationHookResult = ReturnType<typeof useOpenCreateModalMutation>;
export type OpenCreateModalMutationResult = ApolloReactCommon.MutationResult<OpenCreateModalMutation>;
export type OpenCreateModalMutationOptions = ApolloReactCommon.BaseMutationOptions<OpenCreateModalMutation, OpenCreateModalMutationVariables>;
export const CloseCreateModalDocument = gql`
    mutation closeCreateModal($id: String) {
  closeCreateModal(id: $id) @client
}
    `;
export type CloseCreateModalMutationFn = ApolloReactCommon.MutationFunction<CloseCreateModalMutation, CloseCreateModalMutationVariables>;
export type CloseCreateModalComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CloseCreateModalMutation, CloseCreateModalMutationVariables>, 'mutation'>;

    export const CloseCreateModalComponent = (props: CloseCreateModalComponentProps) => (
      <ApolloReactComponents.Mutation<CloseCreateModalMutation, CloseCreateModalMutationVariables> mutation={CloseCreateModalDocument} {...props} />
    );
    
export type CloseCreateModalProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CloseCreateModalMutation, CloseCreateModalMutationVariables> & TChildProps;
export function withCloseCreateModal<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CloseCreateModalMutation,
  CloseCreateModalMutationVariables,
  CloseCreateModalProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CloseCreateModalMutation, CloseCreateModalMutationVariables, CloseCreateModalProps<TChildProps>>(CloseCreateModalDocument, {
      alias: 'closeCreateModal',
      ...operationOptions
    });
};

/**
 * __useCloseCreateModalMutation__
 *
 * To run a mutation, you first call `useCloseCreateModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseCreateModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeCreateModalMutation, { data, loading, error }] = useCloseCreateModalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloseCreateModalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CloseCreateModalMutation, CloseCreateModalMutationVariables>) {
        return ApolloReactHooks.useMutation<CloseCreateModalMutation, CloseCreateModalMutationVariables>(CloseCreateModalDocument, baseOptions);
      }
export type CloseCreateModalMutationHookResult = ReturnType<typeof useCloseCreateModalMutation>;
export type CloseCreateModalMutationResult = ApolloReactCommon.MutationResult<CloseCreateModalMutation>;
export type CloseCreateModalMutationOptions = ApolloReactCommon.BaseMutationOptions<CloseCreateModalMutation, CloseCreateModalMutationVariables>;
export const OmnisearchDocument = gql`
    query omnisearch($query: String!, $limit: Int!) {
  accountSearch(query: $query, limit: $limit) {
    individual_accounts {
      ...AccountResult
    }
    organization_accounts {
      ...AccountResult
    }
    issuer_accounts {
      ...AccountResult
    }
  }
}
    ${AccountResultFragmentDoc}`;
export type OmnisearchComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OmnisearchQuery, OmnisearchQueryVariables>, 'query'> & ({ variables: OmnisearchQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OmnisearchComponent = (props: OmnisearchComponentProps) => (
      <ApolloReactComponents.Query<OmnisearchQuery, OmnisearchQueryVariables> query={OmnisearchDocument} {...props} />
    );
    
export type OmnisearchProps<TChildProps = {}> = ApolloReactHoc.DataProps<OmnisearchQuery, OmnisearchQueryVariables> & TChildProps;
export function withOmnisearch<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OmnisearchQuery,
  OmnisearchQueryVariables,
  OmnisearchProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, OmnisearchQuery, OmnisearchQueryVariables, OmnisearchProps<TChildProps>>(OmnisearchDocument, {
      alias: 'omnisearch',
      ...operationOptions
    });
};

/**
 * __useOmnisearchQuery__
 *
 * To run a query within a React component, call `useOmnisearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useOmnisearchQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOmnisearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useOmnisearchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OmnisearchQuery, OmnisearchQueryVariables>) {
        return ApolloReactHooks.useQuery<OmnisearchQuery, OmnisearchQueryVariables>(OmnisearchDocument, baseOptions);
      }
export function useOmnisearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OmnisearchQuery, OmnisearchQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OmnisearchQuery, OmnisearchQueryVariables>(OmnisearchDocument, baseOptions);
        }
export type OmnisearchQueryHookResult = ReturnType<typeof useOmnisearchQuery>;
export type OmnisearchLazyQueryHookResult = ReturnType<typeof useOmnisearchLazyQuery>;
export type OmnisearchQueryResult = ApolloReactCommon.QueryResult<OmnisearchQuery, OmnisearchQueryVariables>;
export const GetAllOfferingsDocument = gql`
    query getAllOfferings {
  allOfferings(limit: 1000, offset: 0) {
    data {
      ...GenericOffering
    }
  }
}
    ${GenericOfferingFragmentDoc}`;
export type GetAllOfferingsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAllOfferingsQuery, GetAllOfferingsQueryVariables>, 'query'>;

    export const GetAllOfferingsComponent = (props: GetAllOfferingsComponentProps) => (
      <ApolloReactComponents.Query<GetAllOfferingsQuery, GetAllOfferingsQueryVariables> query={GetAllOfferingsDocument} {...props} />
    );
    
export type GetAllOfferingsProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetAllOfferingsQuery, GetAllOfferingsQueryVariables> & TChildProps;
export function withGetAllOfferings<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAllOfferingsQuery,
  GetAllOfferingsQueryVariables,
  GetAllOfferingsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetAllOfferingsQuery, GetAllOfferingsQueryVariables, GetAllOfferingsProps<TChildProps>>(GetAllOfferingsDocument, {
      alias: 'getAllOfferings',
      ...operationOptions
    });
};

/**
 * __useGetAllOfferingsQuery__
 *
 * To run a query within a React component, call `useGetAllOfferingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOfferingsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOfferingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllOfferingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllOfferingsQuery, GetAllOfferingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllOfferingsQuery, GetAllOfferingsQueryVariables>(GetAllOfferingsDocument, baseOptions);
      }
export function useGetAllOfferingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllOfferingsQuery, GetAllOfferingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllOfferingsQuery, GetAllOfferingsQueryVariables>(GetAllOfferingsDocument, baseOptions);
        }
export type GetAllOfferingsQueryHookResult = ReturnType<typeof useGetAllOfferingsQuery>;
export type GetAllOfferingsLazyQueryHookResult = ReturnType<typeof useGetAllOfferingsLazyQuery>;
export type GetAllOfferingsQueryResult = ApolloReactCommon.QueryResult<GetAllOfferingsQuery, GetAllOfferingsQueryVariables>;
export const AllOfferingDatesDocument = gql`
    query allOfferingDates {
  allOfferings(limit: 1000, offset: 0) {
    data {
      ...OfferingDateData
    }
  }
}
    ${OfferingDateDataFragmentDoc}`;
export type AllOfferingDatesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AllOfferingDatesQuery, AllOfferingDatesQueryVariables>, 'query'>;

    export const AllOfferingDatesComponent = (props: AllOfferingDatesComponentProps) => (
      <ApolloReactComponents.Query<AllOfferingDatesQuery, AllOfferingDatesQueryVariables> query={AllOfferingDatesDocument} {...props} />
    );
    
export type AllOfferingDatesProps<TChildProps = {}> = ApolloReactHoc.DataProps<AllOfferingDatesQuery, AllOfferingDatesQueryVariables> & TChildProps;
export function withAllOfferingDates<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AllOfferingDatesQuery,
  AllOfferingDatesQueryVariables,
  AllOfferingDatesProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AllOfferingDatesQuery, AllOfferingDatesQueryVariables, AllOfferingDatesProps<TChildProps>>(AllOfferingDatesDocument, {
      alias: 'allOfferingDates',
      ...operationOptions
    });
};

/**
 * __useAllOfferingDatesQuery__
 *
 * To run a query within a React component, call `useAllOfferingDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllOfferingDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllOfferingDatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllOfferingDatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllOfferingDatesQuery, AllOfferingDatesQueryVariables>) {
        return ApolloReactHooks.useQuery<AllOfferingDatesQuery, AllOfferingDatesQueryVariables>(AllOfferingDatesDocument, baseOptions);
      }
export function useAllOfferingDatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllOfferingDatesQuery, AllOfferingDatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AllOfferingDatesQuery, AllOfferingDatesQueryVariables>(AllOfferingDatesDocument, baseOptions);
        }
export type AllOfferingDatesQueryHookResult = ReturnType<typeof useAllOfferingDatesQuery>;
export type AllOfferingDatesLazyQueryHookResult = ReturnType<typeof useAllOfferingDatesLazyQuery>;
export type AllOfferingDatesQueryResult = ApolloReactCommon.QueryResult<AllOfferingDatesQuery, AllOfferingDatesQueryVariables>;
export const GetOfferingDocument = gql`
    query getOffering($id: UUID!) {
  offering(id: $id) {
    ...SpecificOffering
  }
}
    ${SpecificOfferingFragmentDoc}`;
export type GetOfferingComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetOfferingQuery, GetOfferingQueryVariables>, 'query'> & ({ variables: GetOfferingQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetOfferingComponent = (props: GetOfferingComponentProps) => (
      <ApolloReactComponents.Query<GetOfferingQuery, GetOfferingQueryVariables> query={GetOfferingDocument} {...props} />
    );
    
export type GetOfferingProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetOfferingQuery, GetOfferingQueryVariables> & TChildProps;
export function withGetOffering<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetOfferingQuery,
  GetOfferingQueryVariables,
  GetOfferingProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetOfferingQuery, GetOfferingQueryVariables, GetOfferingProps<TChildProps>>(GetOfferingDocument, {
      alias: 'getOffering',
      ...operationOptions
    });
};

/**
 * __useGetOfferingQuery__
 *
 * To run a query within a React component, call `useGetOfferingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferingQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOfferingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOfferingQuery, GetOfferingQueryVariables>) {
        return ApolloReactHooks.useQuery<GetOfferingQuery, GetOfferingQueryVariables>(GetOfferingDocument, baseOptions);
      }
export function useGetOfferingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOfferingQuery, GetOfferingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetOfferingQuery, GetOfferingQueryVariables>(GetOfferingDocument, baseOptions);
        }
export type GetOfferingQueryHookResult = ReturnType<typeof useGetOfferingQuery>;
export type GetOfferingLazyQueryHookResult = ReturnType<typeof useGetOfferingLazyQuery>;
export type GetOfferingQueryResult = ApolloReactCommon.QueryResult<GetOfferingQuery, GetOfferingQueryVariables>;
export const CreateOfferingDocument = gql`
    mutation createOffering($form: CreateOfferingFormInput!) {
  createOffering(form: $form) {
    id
  }
}
    `;
export type CreateOfferingMutationFn = ApolloReactCommon.MutationFunction<CreateOfferingMutation, CreateOfferingMutationVariables>;
export type CreateOfferingComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateOfferingMutation, CreateOfferingMutationVariables>, 'mutation'>;

    export const CreateOfferingComponent = (props: CreateOfferingComponentProps) => (
      <ApolloReactComponents.Mutation<CreateOfferingMutation, CreateOfferingMutationVariables> mutation={CreateOfferingDocument} {...props} />
    );
    
export type CreateOfferingProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CreateOfferingMutation, CreateOfferingMutationVariables> & TChildProps;
export function withCreateOffering<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateOfferingMutation,
  CreateOfferingMutationVariables,
  CreateOfferingProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CreateOfferingMutation, CreateOfferingMutationVariables, CreateOfferingProps<TChildProps>>(CreateOfferingDocument, {
      alias: 'createOffering',
      ...operationOptions
    });
};

/**
 * __useCreateOfferingMutation__
 *
 * To run a mutation, you first call `useCreateOfferingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfferingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOfferingMutation, { data, loading, error }] = useCreateOfferingMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useCreateOfferingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOfferingMutation, CreateOfferingMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateOfferingMutation, CreateOfferingMutationVariables>(CreateOfferingDocument, baseOptions);
      }
export type CreateOfferingMutationHookResult = ReturnType<typeof useCreateOfferingMutation>;
export type CreateOfferingMutationResult = ApolloReactCommon.MutationResult<CreateOfferingMutation>;
export type CreateOfferingMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOfferingMutation, CreateOfferingMutationVariables>;
export const DeleteOfferingDocument = gql`
    mutation deleteOffering($offeringId: UUID!) {
  deleteOffering(offeringId: $offeringId)
}
    `;
export type DeleteOfferingMutationFn = ApolloReactCommon.MutationFunction<DeleteOfferingMutation, DeleteOfferingMutationVariables>;
export type DeleteOfferingComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteOfferingMutation, DeleteOfferingMutationVariables>, 'mutation'>;

    export const DeleteOfferingComponent = (props: DeleteOfferingComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteOfferingMutation, DeleteOfferingMutationVariables> mutation={DeleteOfferingDocument} {...props} />
    );
    
export type DeleteOfferingProps<TChildProps = {}> = ApolloReactHoc.MutateProps<DeleteOfferingMutation, DeleteOfferingMutationVariables> & TChildProps;
export function withDeleteOffering<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteOfferingMutation,
  DeleteOfferingMutationVariables,
  DeleteOfferingProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteOfferingMutation, DeleteOfferingMutationVariables, DeleteOfferingProps<TChildProps>>(DeleteOfferingDocument, {
      alias: 'deleteOffering',
      ...operationOptions
    });
};

/**
 * __useDeleteOfferingMutation__
 *
 * To run a mutation, you first call `useDeleteOfferingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfferingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOfferingMutation, { data, loading, error }] = useDeleteOfferingMutation({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *   },
 * });
 */
export function useDeleteOfferingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteOfferingMutation, DeleteOfferingMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteOfferingMutation, DeleteOfferingMutationVariables>(DeleteOfferingDocument, baseOptions);
      }
export type DeleteOfferingMutationHookResult = ReturnType<typeof useDeleteOfferingMutation>;
export type DeleteOfferingMutationResult = ApolloReactCommon.MutationResult<DeleteOfferingMutation>;
export type DeleteOfferingMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteOfferingMutation, DeleteOfferingMutationVariables>;
export const UnpublishOfferingDocument = gql`
    mutation unpublishOffering($offeringId: UUID!) {
  unpublishOffering(offeringId: $offeringId) {
    id
    status
  }
}
    `;
export type UnpublishOfferingMutationFn = ApolloReactCommon.MutationFunction<UnpublishOfferingMutation, UnpublishOfferingMutationVariables>;
export type UnpublishOfferingComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UnpublishOfferingMutation, UnpublishOfferingMutationVariables>, 'mutation'>;

    export const UnpublishOfferingComponent = (props: UnpublishOfferingComponentProps) => (
      <ApolloReactComponents.Mutation<UnpublishOfferingMutation, UnpublishOfferingMutationVariables> mutation={UnpublishOfferingDocument} {...props} />
    );
    
export type UnpublishOfferingProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UnpublishOfferingMutation, UnpublishOfferingMutationVariables> & TChildProps;
export function withUnpublishOffering<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UnpublishOfferingMutation,
  UnpublishOfferingMutationVariables,
  UnpublishOfferingProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UnpublishOfferingMutation, UnpublishOfferingMutationVariables, UnpublishOfferingProps<TChildProps>>(UnpublishOfferingDocument, {
      alias: 'unpublishOffering',
      ...operationOptions
    });
};

/**
 * __useUnpublishOfferingMutation__
 *
 * To run a mutation, you first call `useUnpublishOfferingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishOfferingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishOfferingMutation, { data, loading, error }] = useUnpublishOfferingMutation({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *   },
 * });
 */
export function useUnpublishOfferingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnpublishOfferingMutation, UnpublishOfferingMutationVariables>) {
        return ApolloReactHooks.useMutation<UnpublishOfferingMutation, UnpublishOfferingMutationVariables>(UnpublishOfferingDocument, baseOptions);
      }
export type UnpublishOfferingMutationHookResult = ReturnType<typeof useUnpublishOfferingMutation>;
export type UnpublishOfferingMutationResult = ApolloReactCommon.MutationResult<UnpublishOfferingMutation>;
export type UnpublishOfferingMutationOptions = ApolloReactCommon.BaseMutationOptions<UnpublishOfferingMutation, UnpublishOfferingMutationVariables>;
export const UpdateOfferingDocument = gql`
    mutation updateOffering($form: OfferingDetailsFormInput!) {
  updateOffering(form: $form) {
    ...SpecificOffering
  }
}
    ${SpecificOfferingFragmentDoc}`;
export type UpdateOfferingMutationFn = ApolloReactCommon.MutationFunction<UpdateOfferingMutation, UpdateOfferingMutationVariables>;
export type UpdateOfferingComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateOfferingMutation, UpdateOfferingMutationVariables>, 'mutation'>;

    export const UpdateOfferingComponent = (props: UpdateOfferingComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateOfferingMutation, UpdateOfferingMutationVariables> mutation={UpdateOfferingDocument} {...props} />
    );
    
export type UpdateOfferingProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateOfferingMutation, UpdateOfferingMutationVariables> & TChildProps;
export function withUpdateOffering<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateOfferingMutation,
  UpdateOfferingMutationVariables,
  UpdateOfferingProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateOfferingMutation, UpdateOfferingMutationVariables, UpdateOfferingProps<TChildProps>>(UpdateOfferingDocument, {
      alias: 'updateOffering',
      ...operationOptions
    });
};

/**
 * __useUpdateOfferingMutation__
 *
 * To run a mutation, you first call `useUpdateOfferingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfferingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfferingMutation, { data, loading, error }] = useUpdateOfferingMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateOfferingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOfferingMutation, UpdateOfferingMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateOfferingMutation, UpdateOfferingMutationVariables>(UpdateOfferingDocument, baseOptions);
      }
export type UpdateOfferingMutationHookResult = ReturnType<typeof useUpdateOfferingMutation>;
export type UpdateOfferingMutationResult = ApolloReactCommon.MutationResult<UpdateOfferingMutation>;
export type UpdateOfferingMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOfferingMutation, UpdateOfferingMutationVariables>;
export const UpdatePublishedOfferingDocument = gql`
    mutation updatePublishedOffering($form: UpdatePublishedOfferingFormInput!) {
  updatePublishedOffering(form: $form) {
    ...SpecificOffering
  }
}
    ${SpecificOfferingFragmentDoc}`;
export type UpdatePublishedOfferingMutationFn = ApolloReactCommon.MutationFunction<UpdatePublishedOfferingMutation, UpdatePublishedOfferingMutationVariables>;
export type UpdatePublishedOfferingComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdatePublishedOfferingMutation, UpdatePublishedOfferingMutationVariables>, 'mutation'>;

    export const UpdatePublishedOfferingComponent = (props: UpdatePublishedOfferingComponentProps) => (
      <ApolloReactComponents.Mutation<UpdatePublishedOfferingMutation, UpdatePublishedOfferingMutationVariables> mutation={UpdatePublishedOfferingDocument} {...props} />
    );
    
export type UpdatePublishedOfferingProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdatePublishedOfferingMutation, UpdatePublishedOfferingMutationVariables> & TChildProps;
export function withUpdatePublishedOffering<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdatePublishedOfferingMutation,
  UpdatePublishedOfferingMutationVariables,
  UpdatePublishedOfferingProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdatePublishedOfferingMutation, UpdatePublishedOfferingMutationVariables, UpdatePublishedOfferingProps<TChildProps>>(UpdatePublishedOfferingDocument, {
      alias: 'updatePublishedOffering',
      ...operationOptions
    });
};

/**
 * __useUpdatePublishedOfferingMutation__
 *
 * To run a mutation, you first call `useUpdatePublishedOfferingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublishedOfferingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublishedOfferingMutation, { data, loading, error }] = useUpdatePublishedOfferingMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdatePublishedOfferingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePublishedOfferingMutation, UpdatePublishedOfferingMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePublishedOfferingMutation, UpdatePublishedOfferingMutationVariables>(UpdatePublishedOfferingDocument, baseOptions);
      }
export type UpdatePublishedOfferingMutationHookResult = ReturnType<typeof useUpdatePublishedOfferingMutation>;
export type UpdatePublishedOfferingMutationResult = ApolloReactCommon.MutationResult<UpdatePublishedOfferingMutation>;
export type UpdatePublishedOfferingMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePublishedOfferingMutation, UpdatePublishedOfferingMutationVariables>;
export const UpdateOfferingEmailReminderDocument = gql`
    mutation updateOfferingEmailReminder($offeringId: UUID!, $emailType: OfferingEmailType!, $sendReminderAt: DateTime) {
  updateOfferingEmailReminder(offeringId: $offeringId, emailType: $emailType, sendReminderAt: $sendReminderAt) {
    id
    auto_reminder_email_at
    auto_order_reminder_email_at
    auto_feedback_email_at
  }
}
    `;
export type UpdateOfferingEmailReminderMutationFn = ApolloReactCommon.MutationFunction<UpdateOfferingEmailReminderMutation, UpdateOfferingEmailReminderMutationVariables>;
export type UpdateOfferingEmailReminderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateOfferingEmailReminderMutation, UpdateOfferingEmailReminderMutationVariables>, 'mutation'>;

    export const UpdateOfferingEmailReminderComponent = (props: UpdateOfferingEmailReminderComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateOfferingEmailReminderMutation, UpdateOfferingEmailReminderMutationVariables> mutation={UpdateOfferingEmailReminderDocument} {...props} />
    );
    
export type UpdateOfferingEmailReminderProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateOfferingEmailReminderMutation, UpdateOfferingEmailReminderMutationVariables> & TChildProps;
export function withUpdateOfferingEmailReminder<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateOfferingEmailReminderMutation,
  UpdateOfferingEmailReminderMutationVariables,
  UpdateOfferingEmailReminderProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateOfferingEmailReminderMutation, UpdateOfferingEmailReminderMutationVariables, UpdateOfferingEmailReminderProps<TChildProps>>(UpdateOfferingEmailReminderDocument, {
      alias: 'updateOfferingEmailReminder',
      ...operationOptions
    });
};

/**
 * __useUpdateOfferingEmailReminderMutation__
 *
 * To run a mutation, you first call `useUpdateOfferingEmailReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfferingEmailReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfferingEmailReminderMutation, { data, loading, error }] = useUpdateOfferingEmailReminderMutation({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *      emailType: // value for 'emailType'
 *      sendReminderAt: // value for 'sendReminderAt'
 *   },
 * });
 */
export function useUpdateOfferingEmailReminderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOfferingEmailReminderMutation, UpdateOfferingEmailReminderMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateOfferingEmailReminderMutation, UpdateOfferingEmailReminderMutationVariables>(UpdateOfferingEmailReminderDocument, baseOptions);
      }
export type UpdateOfferingEmailReminderMutationHookResult = ReturnType<typeof useUpdateOfferingEmailReminderMutation>;
export type UpdateOfferingEmailReminderMutationResult = ApolloReactCommon.MutationResult<UpdateOfferingEmailReminderMutation>;
export type UpdateOfferingEmailReminderMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOfferingEmailReminderMutation, UpdateOfferingEmailReminderMutationVariables>;
export const GetAllEquifundsDocument = gql`
    query getAllEquifunds {
  allEquifunds(limit: 1000000, offset: 0) {
    data {
      ...BasicFundInfo
    }
  }
}
    ${BasicFundInfoFragmentDoc}`;
export type GetAllEquifundsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAllEquifundsQuery, GetAllEquifundsQueryVariables>, 'query'>;

    export const GetAllEquifundsComponent = (props: GetAllEquifundsComponentProps) => (
      <ApolloReactComponents.Query<GetAllEquifundsQuery, GetAllEquifundsQueryVariables> query={GetAllEquifundsDocument} {...props} />
    );
    
export type GetAllEquifundsProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetAllEquifundsQuery, GetAllEquifundsQueryVariables> & TChildProps;
export function withGetAllEquifunds<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAllEquifundsQuery,
  GetAllEquifundsQueryVariables,
  GetAllEquifundsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetAllEquifundsQuery, GetAllEquifundsQueryVariables, GetAllEquifundsProps<TChildProps>>(GetAllEquifundsDocument, {
      alias: 'getAllEquifunds',
      ...operationOptions
    });
};

/**
 * __useGetAllEquifundsQuery__
 *
 * To run a query within a React component, call `useGetAllEquifundsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEquifundsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEquifundsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEquifundsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllEquifundsQuery, GetAllEquifundsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllEquifundsQuery, GetAllEquifundsQueryVariables>(GetAllEquifundsDocument, baseOptions);
      }
export function useGetAllEquifundsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllEquifundsQuery, GetAllEquifundsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllEquifundsQuery, GetAllEquifundsQueryVariables>(GetAllEquifundsDocument, baseOptions);
        }
export type GetAllEquifundsQueryHookResult = ReturnType<typeof useGetAllEquifundsQuery>;
export type GetAllEquifundsLazyQueryHookResult = ReturnType<typeof useGetAllEquifundsLazyQuery>;
export type GetAllEquifundsQueryResult = ApolloReactCommon.QueryResult<GetAllEquifundsQuery, GetAllEquifundsQueryVariables>;
export const UploadOfferingFilesDocument = gql`
    mutation uploadOfferingFiles($fileSerials: [String!]!, $offeringId: UUID!) {
  uploadOfferingDataRoomFiles(offeringId: $offeringId, fileSerials: $fileSerials) {
    id
    files {
      ...OfferingFile
    }
  }
}
    ${OfferingFileFragmentDoc}`;
export type UploadOfferingFilesMutationFn = ApolloReactCommon.MutationFunction<UploadOfferingFilesMutation, UploadOfferingFilesMutationVariables>;
export type UploadOfferingFilesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UploadOfferingFilesMutation, UploadOfferingFilesMutationVariables>, 'mutation'>;

    export const UploadOfferingFilesComponent = (props: UploadOfferingFilesComponentProps) => (
      <ApolloReactComponents.Mutation<UploadOfferingFilesMutation, UploadOfferingFilesMutationVariables> mutation={UploadOfferingFilesDocument} {...props} />
    );
    
export type UploadOfferingFilesProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UploadOfferingFilesMutation, UploadOfferingFilesMutationVariables> & TChildProps;
export function withUploadOfferingFiles<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UploadOfferingFilesMutation,
  UploadOfferingFilesMutationVariables,
  UploadOfferingFilesProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UploadOfferingFilesMutation, UploadOfferingFilesMutationVariables, UploadOfferingFilesProps<TChildProps>>(UploadOfferingFilesDocument, {
      alias: 'uploadOfferingFiles',
      ...operationOptions
    });
};

/**
 * __useUploadOfferingFilesMutation__
 *
 * To run a mutation, you first call `useUploadOfferingFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadOfferingFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadOfferingFilesMutation, { data, loading, error }] = useUploadOfferingFilesMutation({
 *   variables: {
 *      fileSerials: // value for 'fileSerials'
 *      offeringId: // value for 'offeringId'
 *   },
 * });
 */
export function useUploadOfferingFilesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadOfferingFilesMutation, UploadOfferingFilesMutationVariables>) {
        return ApolloReactHooks.useMutation<UploadOfferingFilesMutation, UploadOfferingFilesMutationVariables>(UploadOfferingFilesDocument, baseOptions);
      }
export type UploadOfferingFilesMutationHookResult = ReturnType<typeof useUploadOfferingFilesMutation>;
export type UploadOfferingFilesMutationResult = ApolloReactCommon.MutationResult<UploadOfferingFilesMutation>;
export type UploadOfferingFilesMutationOptions = ApolloReactCommon.BaseMutationOptions<UploadOfferingFilesMutation, UploadOfferingFilesMutationVariables>;
export const UploadOfferingParticipantsDocument = gql`
    mutation uploadOfferingParticipants($fileSerials: [String!]!, $offeringId: UUID!) {
  uploadInvitationCSVs(offeringId: $offeringId, fileSerials: $fileSerials) {
    ...OfferingFiles
  }
}
    ${OfferingFilesFragmentDoc}`;
export type UploadOfferingParticipantsMutationFn = ApolloReactCommon.MutationFunction<UploadOfferingParticipantsMutation, UploadOfferingParticipantsMutationVariables>;
export type UploadOfferingParticipantsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UploadOfferingParticipantsMutation, UploadOfferingParticipantsMutationVariables>, 'mutation'>;

    export const UploadOfferingParticipantsComponent = (props: UploadOfferingParticipantsComponentProps) => (
      <ApolloReactComponents.Mutation<UploadOfferingParticipantsMutation, UploadOfferingParticipantsMutationVariables> mutation={UploadOfferingParticipantsDocument} {...props} />
    );
    
export type UploadOfferingParticipantsProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UploadOfferingParticipantsMutation, UploadOfferingParticipantsMutationVariables> & TChildProps;
export function withUploadOfferingParticipants<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UploadOfferingParticipantsMutation,
  UploadOfferingParticipantsMutationVariables,
  UploadOfferingParticipantsProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UploadOfferingParticipantsMutation, UploadOfferingParticipantsMutationVariables, UploadOfferingParticipantsProps<TChildProps>>(UploadOfferingParticipantsDocument, {
      alias: 'uploadOfferingParticipants',
      ...operationOptions
    });
};

/**
 * __useUploadOfferingParticipantsMutation__
 *
 * To run a mutation, you first call `useUploadOfferingParticipantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadOfferingParticipantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadOfferingParticipantsMutation, { data, loading, error }] = useUploadOfferingParticipantsMutation({
 *   variables: {
 *      fileSerials: // value for 'fileSerials'
 *      offeringId: // value for 'offeringId'
 *   },
 * });
 */
export function useUploadOfferingParticipantsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadOfferingParticipantsMutation, UploadOfferingParticipantsMutationVariables>) {
        return ApolloReactHooks.useMutation<UploadOfferingParticipantsMutation, UploadOfferingParticipantsMutationVariables>(UploadOfferingParticipantsDocument, baseOptions);
      }
export type UploadOfferingParticipantsMutationHookResult = ReturnType<typeof useUploadOfferingParticipantsMutation>;
export type UploadOfferingParticipantsMutationResult = ApolloReactCommon.MutationResult<UploadOfferingParticipantsMutation>;
export type UploadOfferingParticipantsMutationOptions = ApolloReactCommon.BaseMutationOptions<UploadOfferingParticipantsMutation, UploadOfferingParticipantsMutationVariables>;
export const DeleteOfferingDataroomFileDocument = gql`
    mutation deleteOfferingDataroomFile($offeringId: UUID!, $fileId: Int!) {
  deleteDataroomFile(offeringId: $offeringId, fileId: $fileId) {
    id
    files {
      ...OfferingFile
    }
  }
}
    ${OfferingFileFragmentDoc}`;
export type DeleteOfferingDataroomFileMutationFn = ApolloReactCommon.MutationFunction<DeleteOfferingDataroomFileMutation, DeleteOfferingDataroomFileMutationVariables>;
export type DeleteOfferingDataroomFileComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteOfferingDataroomFileMutation, DeleteOfferingDataroomFileMutationVariables>, 'mutation'>;

    export const DeleteOfferingDataroomFileComponent = (props: DeleteOfferingDataroomFileComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteOfferingDataroomFileMutation, DeleteOfferingDataroomFileMutationVariables> mutation={DeleteOfferingDataroomFileDocument} {...props} />
    );
    
export type DeleteOfferingDataroomFileProps<TChildProps = {}> = ApolloReactHoc.MutateProps<DeleteOfferingDataroomFileMutation, DeleteOfferingDataroomFileMutationVariables> & TChildProps;
export function withDeleteOfferingDataroomFile<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteOfferingDataroomFileMutation,
  DeleteOfferingDataroomFileMutationVariables,
  DeleteOfferingDataroomFileProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteOfferingDataroomFileMutation, DeleteOfferingDataroomFileMutationVariables, DeleteOfferingDataroomFileProps<TChildProps>>(DeleteOfferingDataroomFileDocument, {
      alias: 'deleteOfferingDataroomFile',
      ...operationOptions
    });
};

/**
 * __useDeleteOfferingDataroomFileMutation__
 *
 * To run a mutation, you first call `useDeleteOfferingDataroomFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfferingDataroomFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOfferingDataroomFileMutation, { data, loading, error }] = useDeleteOfferingDataroomFileMutation({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDeleteOfferingDataroomFileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteOfferingDataroomFileMutation, DeleteOfferingDataroomFileMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteOfferingDataroomFileMutation, DeleteOfferingDataroomFileMutationVariables>(DeleteOfferingDataroomFileDocument, baseOptions);
      }
export type DeleteOfferingDataroomFileMutationHookResult = ReturnType<typeof useDeleteOfferingDataroomFileMutation>;
export type DeleteOfferingDataroomFileMutationResult = ApolloReactCommon.MutationResult<DeleteOfferingDataroomFileMutation>;
export type DeleteOfferingDataroomFileMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteOfferingDataroomFileMutation, DeleteOfferingDataroomFileMutationVariables>;
export const SendDummyEmailDocument = gql`
    mutation sendDummyEmail($offeringId: UUID!, $emailType: OfferingEmailType!) {
  sendDummyOfferingEmails(offeringId: $offeringId, emailType: $emailType)
}
    `;
export type SendDummyEmailMutationFn = ApolloReactCommon.MutationFunction<SendDummyEmailMutation, SendDummyEmailMutationVariables>;
export type SendDummyEmailComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SendDummyEmailMutation, SendDummyEmailMutationVariables>, 'mutation'>;

    export const SendDummyEmailComponent = (props: SendDummyEmailComponentProps) => (
      <ApolloReactComponents.Mutation<SendDummyEmailMutation, SendDummyEmailMutationVariables> mutation={SendDummyEmailDocument} {...props} />
    );
    
export type SendDummyEmailProps<TChildProps = {}> = ApolloReactHoc.MutateProps<SendDummyEmailMutation, SendDummyEmailMutationVariables> & TChildProps;
export function withSendDummyEmail<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SendDummyEmailMutation,
  SendDummyEmailMutationVariables,
  SendDummyEmailProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, SendDummyEmailMutation, SendDummyEmailMutationVariables, SendDummyEmailProps<TChildProps>>(SendDummyEmailDocument, {
      alias: 'sendDummyEmail',
      ...operationOptions
    });
};

/**
 * __useSendDummyEmailMutation__
 *
 * To run a mutation, you first call `useSendDummyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDummyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDummyEmailMutation, { data, loading, error }] = useSendDummyEmailMutation({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *      emailType: // value for 'emailType'
 *   },
 * });
 */
export function useSendDummyEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendDummyEmailMutation, SendDummyEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendDummyEmailMutation, SendDummyEmailMutationVariables>(SendDummyEmailDocument, baseOptions);
      }
export type SendDummyEmailMutationHookResult = ReturnType<typeof useSendDummyEmailMutation>;
export type SendDummyEmailMutationResult = ApolloReactCommon.MutationResult<SendDummyEmailMutation>;
export type SendDummyEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<SendDummyEmailMutation, SendDummyEmailMutationVariables>;
export const SendOfferingEmailsDocument = gql`
    mutation sendOfferingEmails($offeringId: UUID!, $emailType: OfferingEmailType!) {
  sendOfferingEmails(offeringId: $offeringId, emailType: $emailType)
}
    `;
export type SendOfferingEmailsMutationFn = ApolloReactCommon.MutationFunction<SendOfferingEmailsMutation, SendOfferingEmailsMutationVariables>;
export type SendOfferingEmailsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SendOfferingEmailsMutation, SendOfferingEmailsMutationVariables>, 'mutation'>;

    export const SendOfferingEmailsComponent = (props: SendOfferingEmailsComponentProps) => (
      <ApolloReactComponents.Mutation<SendOfferingEmailsMutation, SendOfferingEmailsMutationVariables> mutation={SendOfferingEmailsDocument} {...props} />
    );
    
export type SendOfferingEmailsProps<TChildProps = {}> = ApolloReactHoc.MutateProps<SendOfferingEmailsMutation, SendOfferingEmailsMutationVariables> & TChildProps;
export function withSendOfferingEmails<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SendOfferingEmailsMutation,
  SendOfferingEmailsMutationVariables,
  SendOfferingEmailsProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, SendOfferingEmailsMutation, SendOfferingEmailsMutationVariables, SendOfferingEmailsProps<TChildProps>>(SendOfferingEmailsDocument, {
      alias: 'sendOfferingEmails',
      ...operationOptions
    });
};

/**
 * __useSendOfferingEmailsMutation__
 *
 * To run a mutation, you first call `useSendOfferingEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOfferingEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOfferingEmailsMutation, { data, loading, error }] = useSendOfferingEmailsMutation({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *      emailType: // value for 'emailType'
 *   },
 * });
 */
export function useSendOfferingEmailsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendOfferingEmailsMutation, SendOfferingEmailsMutationVariables>) {
        return ApolloReactHooks.useMutation<SendOfferingEmailsMutation, SendOfferingEmailsMutationVariables>(SendOfferingEmailsDocument, baseOptions);
      }
export type SendOfferingEmailsMutationHookResult = ReturnType<typeof useSendOfferingEmailsMutation>;
export type SendOfferingEmailsMutationResult = ApolloReactCommon.MutationResult<SendOfferingEmailsMutation>;
export type SendOfferingEmailsMutationOptions = ApolloReactCommon.BaseMutationOptions<SendOfferingEmailsMutation, SendOfferingEmailsMutationVariables>;
export const GetOfferingFilesDocument = gql`
    query getOfferingFiles($offeringId: UUID!) {
  offering(id: $offeringId) {
    ...OfferingFiles
  }
}
    ${OfferingFilesFragmentDoc}`;
export type GetOfferingFilesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetOfferingFilesQuery, GetOfferingFilesQueryVariables>, 'query'> & ({ variables: GetOfferingFilesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetOfferingFilesComponent = (props: GetOfferingFilesComponentProps) => (
      <ApolloReactComponents.Query<GetOfferingFilesQuery, GetOfferingFilesQueryVariables> query={GetOfferingFilesDocument} {...props} />
    );
    
export type GetOfferingFilesProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetOfferingFilesQuery, GetOfferingFilesQueryVariables> & TChildProps;
export function withGetOfferingFiles<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetOfferingFilesQuery,
  GetOfferingFilesQueryVariables,
  GetOfferingFilesProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetOfferingFilesQuery, GetOfferingFilesQueryVariables, GetOfferingFilesProps<TChildProps>>(GetOfferingFilesDocument, {
      alias: 'getOfferingFiles',
      ...operationOptions
    });
};

/**
 * __useGetOfferingFilesQuery__
 *
 * To run a query within a React component, call `useGetOfferingFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferingFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferingFilesQuery({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *   },
 * });
 */
export function useGetOfferingFilesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOfferingFilesQuery, GetOfferingFilesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetOfferingFilesQuery, GetOfferingFilesQueryVariables>(GetOfferingFilesDocument, baseOptions);
      }
export function useGetOfferingFilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOfferingFilesQuery, GetOfferingFilesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetOfferingFilesQuery, GetOfferingFilesQueryVariables>(GetOfferingFilesDocument, baseOptions);
        }
export type GetOfferingFilesQueryHookResult = ReturnType<typeof useGetOfferingFilesQuery>;
export type GetOfferingFilesLazyQueryHookResult = ReturnType<typeof useGetOfferingFilesLazyQuery>;
export type GetOfferingFilesQueryResult = ApolloReactCommon.QueryResult<GetOfferingFilesQuery, GetOfferingFilesQueryVariables>;
export const GetOfferingParticipantsDocument = gql`
    query getOfferingParticipants($id: UUID!, $offset: Int!, $limit: Int!) {
  offering(id: $id) {
    id
    paginatedParticipants(offset: $offset, limit: $limit) {
      count
      offset
      limit
      data {
        ...Participant
      }
    }
  }
}
    ${ParticipantFragmentDoc}`;
export type GetOfferingParticipantsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetOfferingParticipantsQuery, GetOfferingParticipantsQueryVariables>, 'query'> & ({ variables: GetOfferingParticipantsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetOfferingParticipantsComponent = (props: GetOfferingParticipantsComponentProps) => (
      <ApolloReactComponents.Query<GetOfferingParticipantsQuery, GetOfferingParticipantsQueryVariables> query={GetOfferingParticipantsDocument} {...props} />
    );
    
export type GetOfferingParticipantsProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetOfferingParticipantsQuery, GetOfferingParticipantsQueryVariables> & TChildProps;
export function withGetOfferingParticipants<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetOfferingParticipantsQuery,
  GetOfferingParticipantsQueryVariables,
  GetOfferingParticipantsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetOfferingParticipantsQuery, GetOfferingParticipantsQueryVariables, GetOfferingParticipantsProps<TChildProps>>(GetOfferingParticipantsDocument, {
      alias: 'getOfferingParticipants',
      ...operationOptions
    });
};

/**
 * __useGetOfferingParticipantsQuery__
 *
 * To run a query within a React component, call `useGetOfferingParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferingParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferingParticipantsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetOfferingParticipantsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOfferingParticipantsQuery, GetOfferingParticipantsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetOfferingParticipantsQuery, GetOfferingParticipantsQueryVariables>(GetOfferingParticipantsDocument, baseOptions);
      }
export function useGetOfferingParticipantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOfferingParticipantsQuery, GetOfferingParticipantsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetOfferingParticipantsQuery, GetOfferingParticipantsQueryVariables>(GetOfferingParticipantsDocument, baseOptions);
        }
export type GetOfferingParticipantsQueryHookResult = ReturnType<typeof useGetOfferingParticipantsQuery>;
export type GetOfferingParticipantsLazyQueryHookResult = ReturnType<typeof useGetOfferingParticipantsLazyQuery>;
export type GetOfferingParticipantsQueryResult = ApolloReactCommon.QueryResult<GetOfferingParticipantsQuery, GetOfferingParticipantsQueryVariables>;
export const GetBidsByOfferingDocument = gql`
    query getBidsByOffering($id: UUID!) {
  offering(id: $id) {
    id
    name
    bids {
      ...BidDetail
    }
  }
}
    ${BidDetailFragmentDoc}`;
export type GetBidsByOfferingComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetBidsByOfferingQuery, GetBidsByOfferingQueryVariables>, 'query'> & ({ variables: GetBidsByOfferingQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetBidsByOfferingComponent = (props: GetBidsByOfferingComponentProps) => (
      <ApolloReactComponents.Query<GetBidsByOfferingQuery, GetBidsByOfferingQueryVariables> query={GetBidsByOfferingDocument} {...props} />
    );
    
export type GetBidsByOfferingProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetBidsByOfferingQuery, GetBidsByOfferingQueryVariables> & TChildProps;
export function withGetBidsByOffering<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetBidsByOfferingQuery,
  GetBidsByOfferingQueryVariables,
  GetBidsByOfferingProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetBidsByOfferingQuery, GetBidsByOfferingQueryVariables, GetBidsByOfferingProps<TChildProps>>(GetBidsByOfferingDocument, {
      alias: 'getBidsByOffering',
      ...operationOptions
    });
};

/**
 * __useGetBidsByOfferingQuery__
 *
 * To run a query within a React component, call `useGetBidsByOfferingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBidsByOfferingQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBidsByOfferingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBidsByOfferingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBidsByOfferingQuery, GetBidsByOfferingQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBidsByOfferingQuery, GetBidsByOfferingQueryVariables>(GetBidsByOfferingDocument, baseOptions);
      }
export function useGetBidsByOfferingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBidsByOfferingQuery, GetBidsByOfferingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBidsByOfferingQuery, GetBidsByOfferingQueryVariables>(GetBidsByOfferingDocument, baseOptions);
        }
export type GetBidsByOfferingQueryHookResult = ReturnType<typeof useGetBidsByOfferingQuery>;
export type GetBidsByOfferingLazyQueryHookResult = ReturnType<typeof useGetBidsByOfferingLazyQuery>;
export type GetBidsByOfferingQueryResult = ApolloReactCommon.QueryResult<GetBidsByOfferingQuery, GetBidsByOfferingQueryVariables>;
export const ClientTypesDocument = gql`
    query clientTypes($accountType: String) {
  client_types(accountType: $accountType) {
    id
    name
    account_type
  }
}
    `;
export type ClientTypesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ClientTypesQuery, ClientTypesQueryVariables>, 'query'>;

    export const ClientTypesComponent = (props: ClientTypesComponentProps) => (
      <ApolloReactComponents.Query<ClientTypesQuery, ClientTypesQueryVariables> query={ClientTypesDocument} {...props} />
    );
    
export type ClientTypesProps<TChildProps = {}> = ApolloReactHoc.DataProps<ClientTypesQuery, ClientTypesQueryVariables> & TChildProps;
export function withClientTypes<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ClientTypesQuery,
  ClientTypesQueryVariables,
  ClientTypesProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, ClientTypesQuery, ClientTypesQueryVariables, ClientTypesProps<TChildProps>>(ClientTypesDocument, {
      alias: 'clientTypes',
      ...operationOptions
    });
};

/**
 * __useClientTypesQuery__
 *
 * To run a query within a React component, call `useClientTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientTypesQuery({
 *   variables: {
 *      accountType: // value for 'accountType'
 *   },
 * });
 */
export function useClientTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ClientTypesQuery, ClientTypesQueryVariables>) {
        return ApolloReactHooks.useQuery<ClientTypesQuery, ClientTypesQueryVariables>(ClientTypesDocument, baseOptions);
      }
export function useClientTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClientTypesQuery, ClientTypesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ClientTypesQuery, ClientTypesQueryVariables>(ClientTypesDocument, baseOptions);
        }
export type ClientTypesQueryHookResult = ReturnType<typeof useClientTypesQuery>;
export type ClientTypesLazyQueryHookResult = ReturnType<typeof useClientTypesLazyQuery>;
export type ClientTypesQueryResult = ApolloReactCommon.QueryResult<ClientTypesQuery, ClientTypesQueryVariables>;
export const CrmMetadataDocument = gql`
    query CrmMetadata {
  client_types {
    id
    name
    account_type
  }
  sectors {
    id
    name
  }
  issuers {
    id
    issuer_account {
      id
      company {
        id
        name
      }
    }
  }
  adminsWithAccountCoverage {
    id
    first_name
    last_name
  }
}
    `;
export type CrmMetadataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CrmMetadataQuery, CrmMetadataQueryVariables>, 'query'>;

    export const CrmMetadataComponent = (props: CrmMetadataComponentProps) => (
      <ApolloReactComponents.Query<CrmMetadataQuery, CrmMetadataQueryVariables> query={CrmMetadataDocument} {...props} />
    );
    
export type CrmMetadataProps<TChildProps = {}> = ApolloReactHoc.DataProps<CrmMetadataQuery, CrmMetadataQueryVariables> & TChildProps;
export function withCrmMetadata<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CrmMetadataQuery,
  CrmMetadataQueryVariables,
  CrmMetadataProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, CrmMetadataQuery, CrmMetadataQueryVariables, CrmMetadataProps<TChildProps>>(CrmMetadataDocument, {
      alias: 'crmMetadata',
      ...operationOptions
    });
};

/**
 * __useCrmMetadataQuery__
 *
 * To run a query within a React component, call `useCrmMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useCrmMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CrmMetadataQuery, CrmMetadataQueryVariables>) {
        return ApolloReactHooks.useQuery<CrmMetadataQuery, CrmMetadataQueryVariables>(CrmMetadataDocument, baseOptions);
      }
export function useCrmMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CrmMetadataQuery, CrmMetadataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CrmMetadataQuery, CrmMetadataQueryVariables>(CrmMetadataDocument, baseOptions);
        }
export type CrmMetadataQueryHookResult = ReturnType<typeof useCrmMetadataQuery>;
export type CrmMetadataLazyQueryHookResult = ReturnType<typeof useCrmMetadataLazyQuery>;
export type CrmMetadataQueryResult = ApolloReactCommon.QueryResult<CrmMetadataQuery, CrmMetadataQueryVariables>;
export const UpdateDealStatusDocument = gql`
    mutation UpdateDealStatus($dealId: Int!, $status: DealStatusType!) {
  updateDealStatus(dealId: $dealId, newStatus: $status) {
    id
    active_deal_status
    status_last_updated_at
    probability_to_close
  }
}
    `;
export type UpdateDealStatusMutationFn = ApolloReactCommon.MutationFunction<UpdateDealStatusMutation, UpdateDealStatusMutationVariables>;
export type UpdateDealStatusComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateDealStatusMutation, UpdateDealStatusMutationVariables>, 'mutation'>;

    export const UpdateDealStatusComponent = (props: UpdateDealStatusComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateDealStatusMutation, UpdateDealStatusMutationVariables> mutation={UpdateDealStatusDocument} {...props} />
    );
    
export type UpdateDealStatusProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateDealStatusMutation, UpdateDealStatusMutationVariables> & TChildProps;
export function withUpdateDealStatus<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateDealStatusMutation,
  UpdateDealStatusMutationVariables,
  UpdateDealStatusProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateDealStatusMutation, UpdateDealStatusMutationVariables, UpdateDealStatusProps<TChildProps>>(UpdateDealStatusDocument, {
      alias: 'updateDealStatus',
      ...operationOptions
    });
};

/**
 * __useUpdateDealStatusMutation__
 *
 * To run a mutation, you first call `useUpdateDealStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDealStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDealStatusMutation, { data, loading, error }] = useUpdateDealStatusMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateDealStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDealStatusMutation, UpdateDealStatusMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateDealStatusMutation, UpdateDealStatusMutationVariables>(UpdateDealStatusDocument, baseOptions);
      }
export type UpdateDealStatusMutationHookResult = ReturnType<typeof useUpdateDealStatusMutation>;
export type UpdateDealStatusMutationResult = ApolloReactCommon.MutationResult<UpdateDealStatusMutation>;
export type UpdateDealStatusMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDealStatusMutation, UpdateDealStatusMutationVariables>;
export const AppendErrorDocument = gql`
    mutation appendError($errorMsg: String!) {
  appendError(errorMsg: $errorMsg) @client
}
    `;
export type AppendErrorMutationFn = ApolloReactCommon.MutationFunction<AppendErrorMutation, AppendErrorMutationVariables>;
export type AppendErrorComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AppendErrorMutation, AppendErrorMutationVariables>, 'mutation'>;

    export const AppendErrorComponent = (props: AppendErrorComponentProps) => (
      <ApolloReactComponents.Mutation<AppendErrorMutation, AppendErrorMutationVariables> mutation={AppendErrorDocument} {...props} />
    );
    
export type AppendErrorProps<TChildProps = {}> = ApolloReactHoc.MutateProps<AppendErrorMutation, AppendErrorMutationVariables> & TChildProps;
export function withAppendError<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AppendErrorMutation,
  AppendErrorMutationVariables,
  AppendErrorProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, AppendErrorMutation, AppendErrorMutationVariables, AppendErrorProps<TChildProps>>(AppendErrorDocument, {
      alias: 'appendError',
      ...operationOptions
    });
};

/**
 * __useAppendErrorMutation__
 *
 * To run a mutation, you first call `useAppendErrorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppendErrorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appendErrorMutation, { data, loading, error }] = useAppendErrorMutation({
 *   variables: {
 *      errorMsg: // value for 'errorMsg'
 *   },
 * });
 */
export function useAppendErrorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AppendErrorMutation, AppendErrorMutationVariables>) {
        return ApolloReactHooks.useMutation<AppendErrorMutation, AppendErrorMutationVariables>(AppendErrorDocument, baseOptions);
      }
export type AppendErrorMutationHookResult = ReturnType<typeof useAppendErrorMutation>;
export type AppendErrorMutationResult = ApolloReactCommon.MutationResult<AppendErrorMutation>;
export type AppendErrorMutationOptions = ApolloReactCommon.BaseMutationOptions<AppendErrorMutation, AppendErrorMutationVariables>;
export const ClearErrorsDocument = gql`
    mutation clearErrors($errorMsg: String) {
  clearErrors(errorMsg: $errorMsg) @client
}
    `;
export type ClearErrorsMutationFn = ApolloReactCommon.MutationFunction<ClearErrorsMutation, ClearErrorsMutationVariables>;
export type ClearErrorsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ClearErrorsMutation, ClearErrorsMutationVariables>, 'mutation'>;

    export const ClearErrorsComponent = (props: ClearErrorsComponentProps) => (
      <ApolloReactComponents.Mutation<ClearErrorsMutation, ClearErrorsMutationVariables> mutation={ClearErrorsDocument} {...props} />
    );
    
export type ClearErrorsProps<TChildProps = {}> = ApolloReactHoc.MutateProps<ClearErrorsMutation, ClearErrorsMutationVariables> & TChildProps;
export function withClearErrors<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ClearErrorsMutation,
  ClearErrorsMutationVariables,
  ClearErrorsProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, ClearErrorsMutation, ClearErrorsMutationVariables, ClearErrorsProps<TChildProps>>(ClearErrorsDocument, {
      alias: 'clearErrors',
      ...operationOptions
    });
};

/**
 * __useClearErrorsMutation__
 *
 * To run a mutation, you first call `useClearErrorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearErrorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearErrorsMutation, { data, loading, error }] = useClearErrorsMutation({
 *   variables: {
 *      errorMsg: // value for 'errorMsg'
 *   },
 * });
 */
export function useClearErrorsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ClearErrorsMutation, ClearErrorsMutationVariables>) {
        return ApolloReactHooks.useMutation<ClearErrorsMutation, ClearErrorsMutationVariables>(ClearErrorsDocument, baseOptions);
      }
export type ClearErrorsMutationHookResult = ReturnType<typeof useClearErrorsMutation>;
export type ClearErrorsMutationResult = ApolloReactCommon.MutationResult<ClearErrorsMutation>;
export type ClearErrorsMutationOptions = ApolloReactCommon.BaseMutationOptions<ClearErrorsMutation, ClearErrorsMutationVariables>;
export const ErrorsDocument = gql`
    query errors {
  errors @client
}
    `;
export type ErrorsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ErrorsQuery, ErrorsQueryVariables>, 'query'>;

    export const ErrorsComponent = (props: ErrorsComponentProps) => (
      <ApolloReactComponents.Query<ErrorsQuery, ErrorsQueryVariables> query={ErrorsDocument} {...props} />
    );
    
export type ErrorsProps<TChildProps = {}> = ApolloReactHoc.DataProps<ErrorsQuery, ErrorsQueryVariables> & TChildProps;
export function withErrors<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ErrorsQuery,
  ErrorsQueryVariables,
  ErrorsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, ErrorsQuery, ErrorsQueryVariables, ErrorsProps<TChildProps>>(ErrorsDocument, {
      alias: 'errors',
      ...operationOptions
    });
};

/**
 * __useErrorsQuery__
 *
 * To run a query within a React component, call `useErrorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErrorsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErrorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useErrorsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ErrorsQuery, ErrorsQueryVariables>) {
        return ApolloReactHooks.useQuery<ErrorsQuery, ErrorsQueryVariables>(ErrorsDocument, baseOptions);
      }
export function useErrorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ErrorsQuery, ErrorsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ErrorsQuery, ErrorsQueryVariables>(ErrorsDocument, baseOptions);
        }
export type ErrorsQueryHookResult = ReturnType<typeof useErrorsQuery>;
export type ErrorsLazyQueryHookResult = ReturnType<typeof useErrorsLazyQuery>;
export type ErrorsQueryResult = ApolloReactCommon.QueryResult<ErrorsQuery, ErrorsQueryVariables>;
export const AccountHoldingsDocument = gql`
    query accountHoldings($accountId: UUID!) {
  account(id: $accountId) {
    id
    name
    holdings {
      ...AccountHolding
    }
  }
}
    ${AccountHoldingFragmentDoc}`;
export type AccountHoldingsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountHoldingsQuery, AccountHoldingsQueryVariables>, 'query'> & ({ variables: AccountHoldingsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountHoldingsComponent = (props: AccountHoldingsComponentProps) => (
      <ApolloReactComponents.Query<AccountHoldingsQuery, AccountHoldingsQueryVariables> query={AccountHoldingsDocument} {...props} />
    );
    
export type AccountHoldingsProps<TChildProps = {}> = ApolloReactHoc.DataProps<AccountHoldingsQuery, AccountHoldingsQueryVariables> & TChildProps;
export function withAccountHoldings<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountHoldingsQuery,
  AccountHoldingsQueryVariables,
  AccountHoldingsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AccountHoldingsQuery, AccountHoldingsQueryVariables, AccountHoldingsProps<TChildProps>>(AccountHoldingsDocument, {
      alias: 'accountHoldings',
      ...operationOptions
    });
};

/**
 * __useAccountHoldingsQuery__
 *
 * To run a query within a React component, call `useAccountHoldingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountHoldingsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountHoldingsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountHoldingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountHoldingsQuery, AccountHoldingsQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountHoldingsQuery, AccountHoldingsQueryVariables>(AccountHoldingsDocument, baseOptions);
      }
export function useAccountHoldingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountHoldingsQuery, AccountHoldingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountHoldingsQuery, AccountHoldingsQueryVariables>(AccountHoldingsDocument, baseOptions);
        }
export type AccountHoldingsQueryHookResult = ReturnType<typeof useAccountHoldingsQuery>;
export type AccountHoldingsLazyQueryHookResult = ReturnType<typeof useAccountHoldingsLazyQuery>;
export type AccountHoldingsQueryResult = ApolloReactCommon.QueryResult<AccountHoldingsQuery, AccountHoldingsQueryVariables>;
export const CreateHoldingDocument = gql`
    mutation createHolding($form: NewHoldingInput!) {
  createHolding(form: $form) {
    id
    company {
      id
      name
      crm_account {
        id
      }
    }
    estimated_num_shares
    confirmed_num_shares
    share_dollar_amt_est
    current_value
    share_class
    updated_at
  }
}
    `;
export type CreateHoldingMutationFn = ApolloReactCommon.MutationFunction<CreateHoldingMutation, CreateHoldingMutationVariables>;
export type CreateHoldingComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateHoldingMutation, CreateHoldingMutationVariables>, 'mutation'>;

    export const CreateHoldingComponent = (props: CreateHoldingComponentProps) => (
      <ApolloReactComponents.Mutation<CreateHoldingMutation, CreateHoldingMutationVariables> mutation={CreateHoldingDocument} {...props} />
    );
    
export type CreateHoldingProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CreateHoldingMutation, CreateHoldingMutationVariables> & TChildProps;
export function withCreateHolding<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateHoldingMutation,
  CreateHoldingMutationVariables,
  CreateHoldingProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CreateHoldingMutation, CreateHoldingMutationVariables, CreateHoldingProps<TChildProps>>(CreateHoldingDocument, {
      alias: 'createHolding',
      ...operationOptions
    });
};

/**
 * __useCreateHoldingMutation__
 *
 * To run a mutation, you first call `useCreateHoldingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHoldingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHoldingMutation, { data, loading, error }] = useCreateHoldingMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useCreateHoldingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateHoldingMutation, CreateHoldingMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateHoldingMutation, CreateHoldingMutationVariables>(CreateHoldingDocument, baseOptions);
      }
export type CreateHoldingMutationHookResult = ReturnType<typeof useCreateHoldingMutation>;
export type CreateHoldingMutationResult = ApolloReactCommon.MutationResult<CreateHoldingMutation>;
export type CreateHoldingMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateHoldingMutation, CreateHoldingMutationVariables>;
export const HoldingDocument = gql`
    query holding($id: Int!) {
  holding(id: $id) {
    ...AccountHolding
  }
}
    ${AccountHoldingFragmentDoc}`;
export type HoldingComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<HoldingQuery, HoldingQueryVariables>, 'query'> & ({ variables: HoldingQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const HoldingComponent = (props: HoldingComponentProps) => (
      <ApolloReactComponents.Query<HoldingQuery, HoldingQueryVariables> query={HoldingDocument} {...props} />
    );
    
export type HoldingProps<TChildProps = {}> = ApolloReactHoc.DataProps<HoldingQuery, HoldingQueryVariables> & TChildProps;
export function withHolding<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  HoldingQuery,
  HoldingQueryVariables,
  HoldingProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, HoldingQuery, HoldingQueryVariables, HoldingProps<TChildProps>>(HoldingDocument, {
      alias: 'holding',
      ...operationOptions
    });
};

/**
 * __useHoldingQuery__
 *
 * To run a query within a React component, call `useHoldingQuery` and pass it any options that fit your needs.
 * When your component renders, `useHoldingQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHoldingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHoldingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HoldingQuery, HoldingQueryVariables>) {
        return ApolloReactHooks.useQuery<HoldingQuery, HoldingQueryVariables>(HoldingDocument, baseOptions);
      }
export function useHoldingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HoldingQuery, HoldingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<HoldingQuery, HoldingQueryVariables>(HoldingDocument, baseOptions);
        }
export type HoldingQueryHookResult = ReturnType<typeof useHoldingQuery>;
export type HoldingLazyQueryHookResult = ReturnType<typeof useHoldingLazyQuery>;
export type HoldingQueryResult = ApolloReactCommon.QueryResult<HoldingQuery, HoldingQueryVariables>;
export const CreateInteractionDocument = gql`
    mutation createInteraction($form: NewInteractionInput!) {
  createInteraction(form: $form) {
    ...InteractionData
  }
}
    ${InteractionDataFragmentDoc}`;
export type CreateInteractionMutationFn = ApolloReactCommon.MutationFunction<CreateInteractionMutation, CreateInteractionMutationVariables>;
export type CreateInteractionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateInteractionMutation, CreateInteractionMutationVariables>, 'mutation'>;

    export const CreateInteractionComponent = (props: CreateInteractionComponentProps) => (
      <ApolloReactComponents.Mutation<CreateInteractionMutation, CreateInteractionMutationVariables> mutation={CreateInteractionDocument} {...props} />
    );
    
export type CreateInteractionProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CreateInteractionMutation, CreateInteractionMutationVariables> & TChildProps;
export function withCreateInteraction<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateInteractionMutation,
  CreateInteractionMutationVariables,
  CreateInteractionProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CreateInteractionMutation, CreateInteractionMutationVariables, CreateInteractionProps<TChildProps>>(CreateInteractionDocument, {
      alias: 'createInteraction',
      ...operationOptions
    });
};

/**
 * __useCreateInteractionMutation__
 *
 * To run a mutation, you first call `useCreateInteractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInteractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInteractionMutation, { data, loading, error }] = useCreateInteractionMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useCreateInteractionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateInteractionMutation, CreateInteractionMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateInteractionMutation, CreateInteractionMutationVariables>(CreateInteractionDocument, baseOptions);
      }
export type CreateInteractionMutationHookResult = ReturnType<typeof useCreateInteractionMutation>;
export type CreateInteractionMutationResult = ApolloReactCommon.MutationResult<CreateInteractionMutation>;
export type CreateInteractionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateInteractionMutation, CreateInteractionMutationVariables>;
export const UpdateInteractionDocument = gql`
    mutation updateInteraction($form: UpdateInteractionInput!) {
  updateInteraction(form: $form) {
    ...InteractionData
  }
}
    ${InteractionDataFragmentDoc}`;
export type UpdateInteractionMutationFn = ApolloReactCommon.MutationFunction<UpdateInteractionMutation, UpdateInteractionMutationVariables>;
export type UpdateInteractionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateInteractionMutation, UpdateInteractionMutationVariables>, 'mutation'>;

    export const UpdateInteractionComponent = (props: UpdateInteractionComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateInteractionMutation, UpdateInteractionMutationVariables> mutation={UpdateInteractionDocument} {...props} />
    );
    
export type UpdateInteractionProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateInteractionMutation, UpdateInteractionMutationVariables> & TChildProps;
export function withUpdateInteraction<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateInteractionMutation,
  UpdateInteractionMutationVariables,
  UpdateInteractionProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateInteractionMutation, UpdateInteractionMutationVariables, UpdateInteractionProps<TChildProps>>(UpdateInteractionDocument, {
      alias: 'updateInteraction',
      ...operationOptions
    });
};

/**
 * __useUpdateInteractionMutation__
 *
 * To run a mutation, you first call `useUpdateInteractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInteractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInteractionMutation, { data, loading, error }] = useUpdateInteractionMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateInteractionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateInteractionMutation, UpdateInteractionMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateInteractionMutation, UpdateInteractionMutationVariables>(UpdateInteractionDocument, baseOptions);
      }
export type UpdateInteractionMutationHookResult = ReturnType<typeof useUpdateInteractionMutation>;
export type UpdateInteractionMutationResult = ApolloReactCommon.MutationResult<UpdateInteractionMutation>;
export type UpdateInteractionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateInteractionMutation, UpdateInteractionMutationVariables>;
export const DeleteInteractionDocument = gql`
    mutation deleteInteraction($id: UUID!) {
  deleteInteraction(id: $id)
}
    `;
export type DeleteInteractionMutationFn = ApolloReactCommon.MutationFunction<DeleteInteractionMutation, DeleteInteractionMutationVariables>;
export type DeleteInteractionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteInteractionMutation, DeleteInteractionMutationVariables>, 'mutation'>;

    export const DeleteInteractionComponent = (props: DeleteInteractionComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteInteractionMutation, DeleteInteractionMutationVariables> mutation={DeleteInteractionDocument} {...props} />
    );
    
export type DeleteInteractionProps<TChildProps = {}> = ApolloReactHoc.MutateProps<DeleteInteractionMutation, DeleteInteractionMutationVariables> & TChildProps;
export function withDeleteInteraction<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteInteractionMutation,
  DeleteInteractionMutationVariables,
  DeleteInteractionProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteInteractionMutation, DeleteInteractionMutationVariables, DeleteInteractionProps<TChildProps>>(DeleteInteractionDocument, {
      alias: 'deleteInteraction',
      ...operationOptions
    });
};

/**
 * __useDeleteInteractionMutation__
 *
 * To run a mutation, you first call `useDeleteInteractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInteractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInteractionMutation, { data, loading, error }] = useDeleteInteractionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInteractionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteInteractionMutation, DeleteInteractionMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteInteractionMutation, DeleteInteractionMutationVariables>(DeleteInteractionDocument, baseOptions);
      }
export type DeleteInteractionMutationHookResult = ReturnType<typeof useDeleteInteractionMutation>;
export type DeleteInteractionMutationResult = ApolloReactCommon.MutationResult<DeleteInteractionMutation>;
export type DeleteInteractionMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteInteractionMutation, DeleteInteractionMutationVariables>;
export const OpportunityAccountDocument = gql`
    query opportunityAccount($opportunityId: UUID!) {
  opportunity(id: $opportunityId) {
    id
    trade_intent {
      id
      type
    }
    account {
      id
      name
      phone_number
      formatted_phone_number
      email
      parents {
        id
        title
        parent_account {
          id
          name
        }
      }
    }
  }
}
    `;
export type OpportunityAccountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OpportunityAccountQuery, OpportunityAccountQueryVariables>, 'query'> & ({ variables: OpportunityAccountQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OpportunityAccountComponent = (props: OpportunityAccountComponentProps) => (
      <ApolloReactComponents.Query<OpportunityAccountQuery, OpportunityAccountQueryVariables> query={OpportunityAccountDocument} {...props} />
    );
    
export type OpportunityAccountProps<TChildProps = {}> = ApolloReactHoc.DataProps<OpportunityAccountQuery, OpportunityAccountQueryVariables> & TChildProps;
export function withOpportunityAccount<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OpportunityAccountQuery,
  OpportunityAccountQueryVariables,
  OpportunityAccountProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, OpportunityAccountQuery, OpportunityAccountQueryVariables, OpportunityAccountProps<TChildProps>>(OpportunityAccountDocument, {
      alias: 'opportunityAccount',
      ...operationOptions
    });
};

/**
 * __useOpportunityAccountQuery__
 *
 * To run a query within a React component, call `useOpportunityAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityAccountQuery({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *   },
 * });
 */
export function useOpportunityAccountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OpportunityAccountQuery, OpportunityAccountQueryVariables>) {
        return ApolloReactHooks.useQuery<OpportunityAccountQuery, OpportunityAccountQueryVariables>(OpportunityAccountDocument, baseOptions);
      }
export function useOpportunityAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OpportunityAccountQuery, OpportunityAccountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OpportunityAccountQuery, OpportunityAccountQueryVariables>(OpportunityAccountDocument, baseOptions);
        }
export type OpportunityAccountQueryHookResult = ReturnType<typeof useOpportunityAccountQuery>;
export type OpportunityAccountLazyQueryHookResult = ReturnType<typeof useOpportunityAccountLazyQuery>;
export type OpportunityAccountQueryResult = ApolloReactCommon.QueryResult<OpportunityAccountQuery, OpportunityAccountQueryVariables>;
export const ClientContextDocument = gql`
    query clientContext($opportunityId: UUID!) {
  opportunity(id: $opportunityId) {
    id
    trade_intent {
      id
      type
    }
    account {
      id
      relationship_strength
      relationship_sensitivity
      relationship_notes
      notes
      owners {
        ...Owner
      }
      deals(onlyClosed: true) {
        ...AccountDeal
      }
    }
  }
}
    ${OwnerFragmentDoc}
${AccountDealFragmentDoc}`;
export type ClientContextComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ClientContextQuery, ClientContextQueryVariables>, 'query'> & ({ variables: ClientContextQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ClientContextComponent = (props: ClientContextComponentProps) => (
      <ApolloReactComponents.Query<ClientContextQuery, ClientContextQueryVariables> query={ClientContextDocument} {...props} />
    );
    
export type ClientContextProps<TChildProps = {}> = ApolloReactHoc.DataProps<ClientContextQuery, ClientContextQueryVariables> & TChildProps;
export function withClientContext<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ClientContextQuery,
  ClientContextQueryVariables,
  ClientContextProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, ClientContextQuery, ClientContextQueryVariables, ClientContextProps<TChildProps>>(ClientContextDocument, {
      alias: 'clientContext',
      ...operationOptions
    });
};

/**
 * __useClientContextQuery__
 *
 * To run a query within a React component, call `useClientContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientContextQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientContextQuery({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *   },
 * });
 */
export function useClientContextQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ClientContextQuery, ClientContextQueryVariables>) {
        return ApolloReactHooks.useQuery<ClientContextQuery, ClientContextQueryVariables>(ClientContextDocument, baseOptions);
      }
export function useClientContextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClientContextQuery, ClientContextQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ClientContextQuery, ClientContextQueryVariables>(ClientContextDocument, baseOptions);
        }
export type ClientContextQueryHookResult = ReturnType<typeof useClientContextQuery>;
export type ClientContextLazyQueryHookResult = ReturnType<typeof useClientContextLazyQuery>;
export type ClientContextQueryResult = ApolloReactCommon.QueryResult<ClientContextQuery, ClientContextQueryVariables>;
export const OpportunityDetailsDocument = gql`
    query opportunityDetails($opportunityId: UUID!) {
  opportunity(id: $opportunityId) {
    ...OpportunityDetails
  }
}
    ${OpportunityDetailsFragmentDoc}`;
export type OpportunityDetailsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OpportunityDetailsQuery, OpportunityDetailsQueryVariables>, 'query'> & ({ variables: OpportunityDetailsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OpportunityDetailsComponent = (props: OpportunityDetailsComponentProps) => (
      <ApolloReactComponents.Query<OpportunityDetailsQuery, OpportunityDetailsQueryVariables> query={OpportunityDetailsDocument} {...props} />
    );
    
export type OpportunityDetailsProps<TChildProps = {}> = ApolloReactHoc.DataProps<OpportunityDetailsQuery, OpportunityDetailsQueryVariables> & TChildProps;
export function withOpportunityDetails<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OpportunityDetailsQuery,
  OpportunityDetailsQueryVariables,
  OpportunityDetailsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, OpportunityDetailsQuery, OpportunityDetailsQueryVariables, OpportunityDetailsProps<TChildProps>>(OpportunityDetailsDocument, {
      alias: 'opportunityDetails',
      ...operationOptions
    });
};

/**
 * __useOpportunityDetailsQuery__
 *
 * To run a query within a React component, call `useOpportunityDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityDetailsQuery({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *   },
 * });
 */
export function useOpportunityDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OpportunityDetailsQuery, OpportunityDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<OpportunityDetailsQuery, OpportunityDetailsQueryVariables>(OpportunityDetailsDocument, baseOptions);
      }
export function useOpportunityDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OpportunityDetailsQuery, OpportunityDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OpportunityDetailsQuery, OpportunityDetailsQueryVariables>(OpportunityDetailsDocument, baseOptions);
        }
export type OpportunityDetailsQueryHookResult = ReturnType<typeof useOpportunityDetailsQuery>;
export type OpportunityDetailsLazyQueryHookResult = ReturnType<typeof useOpportunityDetailsLazyQuery>;
export type OpportunityDetailsQueryResult = ApolloReactCommon.QueryResult<OpportunityDetailsQuery, OpportunityDetailsQueryVariables>;
export const CreateOrderRequestDocument = gql`
    mutation createOrderRequest($opportunityId: UUID!, $assigneeId: Int, $notes: String!) {
  requestOrderForOpportunity(opportunityId: $opportunityId, assigneeAdminId: $assigneeId, notes: $notes)
}
    `;
export type CreateOrderRequestMutationFn = ApolloReactCommon.MutationFunction<CreateOrderRequestMutation, CreateOrderRequestMutationVariables>;
export type CreateOrderRequestComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateOrderRequestMutation, CreateOrderRequestMutationVariables>, 'mutation'>;

    export const CreateOrderRequestComponent = (props: CreateOrderRequestComponentProps) => (
      <ApolloReactComponents.Mutation<CreateOrderRequestMutation, CreateOrderRequestMutationVariables> mutation={CreateOrderRequestDocument} {...props} />
    );
    
export type CreateOrderRequestProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CreateOrderRequestMutation, CreateOrderRequestMutationVariables> & TChildProps;
export function withCreateOrderRequest<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateOrderRequestMutation,
  CreateOrderRequestMutationVariables,
  CreateOrderRequestProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CreateOrderRequestMutation, CreateOrderRequestMutationVariables, CreateOrderRequestProps<TChildProps>>(CreateOrderRequestDocument, {
      alias: 'createOrderRequest',
      ...operationOptions
    });
};

/**
 * __useCreateOrderRequestMutation__
 *
 * To run a mutation, you first call `useCreateOrderRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderRequestMutation, { data, loading, error }] = useCreateOrderRequestMutation({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *      assigneeId: // value for 'assigneeId'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useCreateOrderRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrderRequestMutation, CreateOrderRequestMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateOrderRequestMutation, CreateOrderRequestMutationVariables>(CreateOrderRequestDocument, baseOptions);
      }
export type CreateOrderRequestMutationHookResult = ReturnType<typeof useCreateOrderRequestMutation>;
export type CreateOrderRequestMutationResult = ApolloReactCommon.MutationResult<CreateOrderRequestMutation>;
export type CreateOrderRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOrderRequestMutation, CreateOrderRequestMutationVariables>;
export const CreateOrUpdateOpportunityDocument = gql`
    mutation createOrUpdateOpportunity($form: OpportunityFormInput!) {
  createOrUpdateOpportunity(form: $form) {
    ...OpportunityData
    ...Opportunity
  }
}
    ${OpportunityDataFragmentDoc}
${OpportunityFragmentDoc}`;
export type CreateOrUpdateOpportunityMutationFn = ApolloReactCommon.MutationFunction<CreateOrUpdateOpportunityMutation, CreateOrUpdateOpportunityMutationVariables>;
export type CreateOrUpdateOpportunityComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateOrUpdateOpportunityMutation, CreateOrUpdateOpportunityMutationVariables>, 'mutation'>;

    export const CreateOrUpdateOpportunityComponent = (props: CreateOrUpdateOpportunityComponentProps) => (
      <ApolloReactComponents.Mutation<CreateOrUpdateOpportunityMutation, CreateOrUpdateOpportunityMutationVariables> mutation={CreateOrUpdateOpportunityDocument} {...props} />
    );
    
export type CreateOrUpdateOpportunityProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CreateOrUpdateOpportunityMutation, CreateOrUpdateOpportunityMutationVariables> & TChildProps;
export function withCreateOrUpdateOpportunity<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateOrUpdateOpportunityMutation,
  CreateOrUpdateOpportunityMutationVariables,
  CreateOrUpdateOpportunityProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CreateOrUpdateOpportunityMutation, CreateOrUpdateOpportunityMutationVariables, CreateOrUpdateOpportunityProps<TChildProps>>(CreateOrUpdateOpportunityDocument, {
      alias: 'createOrUpdateOpportunity',
      ...operationOptions
    });
};

/**
 * __useCreateOrUpdateOpportunityMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateOpportunityMutation, { data, loading, error }] = useCreateOrUpdateOpportunityMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useCreateOrUpdateOpportunityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrUpdateOpportunityMutation, CreateOrUpdateOpportunityMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateOrUpdateOpportunityMutation, CreateOrUpdateOpportunityMutationVariables>(CreateOrUpdateOpportunityDocument, baseOptions);
      }
export type CreateOrUpdateOpportunityMutationHookResult = ReturnType<typeof useCreateOrUpdateOpportunityMutation>;
export type CreateOrUpdateOpportunityMutationResult = ApolloReactCommon.MutationResult<CreateOrUpdateOpportunityMutation>;
export type CreateOrUpdateOpportunityMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOrUpdateOpportunityMutation, CreateOrUpdateOpportunityMutationVariables>;
export const AccountOpportunitiesDocument = gql`
    query accountOpportunities($id: UUID!) {
  account(id: $id) {
    id
    opportunities {
      ...OpportunityData
    }
  }
}
    ${OpportunityDataFragmentDoc}`;
export type AccountOpportunitiesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountOpportunitiesQuery, AccountOpportunitiesQueryVariables>, 'query'> & ({ variables: AccountOpportunitiesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountOpportunitiesComponent = (props: AccountOpportunitiesComponentProps) => (
      <ApolloReactComponents.Query<AccountOpportunitiesQuery, AccountOpportunitiesQueryVariables> query={AccountOpportunitiesDocument} {...props} />
    );
    
export type AccountOpportunitiesProps<TChildProps = {}> = ApolloReactHoc.DataProps<AccountOpportunitiesQuery, AccountOpportunitiesQueryVariables> & TChildProps;
export function withAccountOpportunities<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountOpportunitiesQuery,
  AccountOpportunitiesQueryVariables,
  AccountOpportunitiesProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AccountOpportunitiesQuery, AccountOpportunitiesQueryVariables, AccountOpportunitiesProps<TChildProps>>(AccountOpportunitiesDocument, {
      alias: 'accountOpportunities',
      ...operationOptions
    });
};

/**
 * __useAccountOpportunitiesQuery__
 *
 * To run a query within a React component, call `useAccountOpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountOpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountOpportunitiesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountOpportunitiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountOpportunitiesQuery, AccountOpportunitiesQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountOpportunitiesQuery, AccountOpportunitiesQueryVariables>(AccountOpportunitiesDocument, baseOptions);
      }
export function useAccountOpportunitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountOpportunitiesQuery, AccountOpportunitiesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountOpportunitiesQuery, AccountOpportunitiesQueryVariables>(AccountOpportunitiesDocument, baseOptions);
        }
export type AccountOpportunitiesQueryHookResult = ReturnType<typeof useAccountOpportunitiesQuery>;
export type AccountOpportunitiesLazyQueryHookResult = ReturnType<typeof useAccountOpportunitiesLazyQuery>;
export type AccountOpportunitiesQueryResult = ApolloReactCommon.QueryResult<AccountOpportunitiesQuery, AccountOpportunitiesQueryVariables>;
export const BrokersTypeaheadDocument = gql`
    query brokersTypeahead($query: String!) {
  brokersTypeahead(query: $query, limit: 10) {
    id
    name
  }
}
    `;
export type BrokersTypeaheadComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BrokersTypeaheadQuery, BrokersTypeaheadQueryVariables>, 'query'> & ({ variables: BrokersTypeaheadQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BrokersTypeaheadComponent = (props: BrokersTypeaheadComponentProps) => (
      <ApolloReactComponents.Query<BrokersTypeaheadQuery, BrokersTypeaheadQueryVariables> query={BrokersTypeaheadDocument} {...props} />
    );
    
export type BrokersTypeaheadProps<TChildProps = {}> = ApolloReactHoc.DataProps<BrokersTypeaheadQuery, BrokersTypeaheadQueryVariables> & TChildProps;
export function withBrokersTypeahead<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BrokersTypeaheadQuery,
  BrokersTypeaheadQueryVariables,
  BrokersTypeaheadProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, BrokersTypeaheadQuery, BrokersTypeaheadQueryVariables, BrokersTypeaheadProps<TChildProps>>(BrokersTypeaheadDocument, {
      alias: 'brokersTypeahead',
      ...operationOptions
    });
};

/**
 * __useBrokersTypeaheadQuery__
 *
 * To run a query within a React component, call `useBrokersTypeaheadQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrokersTypeaheadQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrokersTypeaheadQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useBrokersTypeaheadQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BrokersTypeaheadQuery, BrokersTypeaheadQueryVariables>) {
        return ApolloReactHooks.useQuery<BrokersTypeaheadQuery, BrokersTypeaheadQueryVariables>(BrokersTypeaheadDocument, baseOptions);
      }
export function useBrokersTypeaheadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BrokersTypeaheadQuery, BrokersTypeaheadQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BrokersTypeaheadQuery, BrokersTypeaheadQueryVariables>(BrokersTypeaheadDocument, baseOptions);
        }
export type BrokersTypeaheadQueryHookResult = ReturnType<typeof useBrokersTypeaheadQuery>;
export type BrokersTypeaheadLazyQueryHookResult = ReturnType<typeof useBrokersTypeaheadLazyQuery>;
export type BrokersTypeaheadQueryResult = ApolloReactCommon.QueryResult<BrokersTypeaheadQuery, BrokersTypeaheadQueryVariables>;
export const OpportunitiesTypeaheadDocument = gql`
    query opportunitiesTypeahead($accountId: UUID!, $query: String!) {
  opportunitiesTypeahead(accountId: $accountId, query: $query, limit: 10) {
    id
    trade_intent {
      id
      type
      dollar_amount
      share_price
      num_shares
    }
    company {
      id
      name
    }
  }
}
    `;
export type OpportunitiesTypeaheadComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OpportunitiesTypeaheadQuery, OpportunitiesTypeaheadQueryVariables>, 'query'> & ({ variables: OpportunitiesTypeaheadQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OpportunitiesTypeaheadComponent = (props: OpportunitiesTypeaheadComponentProps) => (
      <ApolloReactComponents.Query<OpportunitiesTypeaheadQuery, OpportunitiesTypeaheadQueryVariables> query={OpportunitiesTypeaheadDocument} {...props} />
    );
    
export type OpportunitiesTypeaheadProps<TChildProps = {}> = ApolloReactHoc.DataProps<OpportunitiesTypeaheadQuery, OpportunitiesTypeaheadQueryVariables> & TChildProps;
export function withOpportunitiesTypeahead<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OpportunitiesTypeaheadQuery,
  OpportunitiesTypeaheadQueryVariables,
  OpportunitiesTypeaheadProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, OpportunitiesTypeaheadQuery, OpportunitiesTypeaheadQueryVariables, OpportunitiesTypeaheadProps<TChildProps>>(OpportunitiesTypeaheadDocument, {
      alias: 'opportunitiesTypeahead',
      ...operationOptions
    });
};

/**
 * __useOpportunitiesTypeaheadQuery__
 *
 * To run a query within a React component, call `useOpportunitiesTypeaheadQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunitiesTypeaheadQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunitiesTypeaheadQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useOpportunitiesTypeaheadQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OpportunitiesTypeaheadQuery, OpportunitiesTypeaheadQueryVariables>) {
        return ApolloReactHooks.useQuery<OpportunitiesTypeaheadQuery, OpportunitiesTypeaheadQueryVariables>(OpportunitiesTypeaheadDocument, baseOptions);
      }
export function useOpportunitiesTypeaheadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OpportunitiesTypeaheadQuery, OpportunitiesTypeaheadQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OpportunitiesTypeaheadQuery, OpportunitiesTypeaheadQueryVariables>(OpportunitiesTypeaheadDocument, baseOptions);
        }
export type OpportunitiesTypeaheadQueryHookResult = ReturnType<typeof useOpportunitiesTypeaheadQuery>;
export type OpportunitiesTypeaheadLazyQueryHookResult = ReturnType<typeof useOpportunitiesTypeaheadLazyQuery>;
export type OpportunitiesTypeaheadQueryResult = ApolloReactCommon.QueryResult<OpportunitiesTypeaheadQuery, OpportunitiesTypeaheadQueryVariables>;
export const OpportunityTagDocument = gql`
    query opportunityTag($id: UUID!) {
  opportunity(id: $id) {
    id
    company {
      id
      name
    }
    trade_intent {
      id
      type
    }
  }
}
    `;
export type OpportunityTagComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OpportunityTagQuery, OpportunityTagQueryVariables>, 'query'> & ({ variables: OpportunityTagQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OpportunityTagComponent = (props: OpportunityTagComponentProps) => (
      <ApolloReactComponents.Query<OpportunityTagQuery, OpportunityTagQueryVariables> query={OpportunityTagDocument} {...props} />
    );
    
export type OpportunityTagProps<TChildProps = {}> = ApolloReactHoc.DataProps<OpportunityTagQuery, OpportunityTagQueryVariables> & TChildProps;
export function withOpportunityTag<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OpportunityTagQuery,
  OpportunityTagQueryVariables,
  OpportunityTagProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, OpportunityTagQuery, OpportunityTagQueryVariables, OpportunityTagProps<TChildProps>>(OpportunityTagDocument, {
      alias: 'opportunityTag',
      ...operationOptions
    });
};

/**
 * __useOpportunityTagQuery__
 *
 * To run a query within a React component, call `useOpportunityTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityTagQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpportunityTagQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OpportunityTagQuery, OpportunityTagQueryVariables>) {
        return ApolloReactHooks.useQuery<OpportunityTagQuery, OpportunityTagQueryVariables>(OpportunityTagDocument, baseOptions);
      }
export function useOpportunityTagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OpportunityTagQuery, OpportunityTagQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OpportunityTagQuery, OpportunityTagQueryVariables>(OpportunityTagDocument, baseOptions);
        }
export type OpportunityTagQueryHookResult = ReturnType<typeof useOpportunityTagQuery>;
export type OpportunityTagLazyQueryHookResult = ReturnType<typeof useOpportunityTagLazyQuery>;
export type OpportunityTagQueryResult = ApolloReactCommon.QueryResult<OpportunityTagQuery, OpportunityTagQueryVariables>;
export const OpportunityDocument = gql`
    query opportunity($id: UUID!) {
  opportunity(id: $id) {
    id
    type
    notes
    latest_activity
    account_id
    status
    updated_at
    expired_at
    source
    certainty
    company {
      id
      name
      logo_url
      crm_account {
        id
      }
    }
    account {
      id
      name
    }
    trade_intent {
      id
      type
      acceptable_structures
      share_price
      dollar_amount
      expired_at
      fee
      holding {
        id
      }
      entity {
        id
        type
        name
      }
      active_deals {
        id
        active_deal_status
        date_created
      }
    }
  }
}
    `;
export type OpportunityComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OpportunityQuery, OpportunityQueryVariables>, 'query'> & ({ variables: OpportunityQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OpportunityComponent = (props: OpportunityComponentProps) => (
      <ApolloReactComponents.Query<OpportunityQuery, OpportunityQueryVariables> query={OpportunityDocument} {...props} />
    );
    
export type OpportunityProps<TChildProps = {}> = ApolloReactHoc.DataProps<OpportunityQuery, OpportunityQueryVariables> & TChildProps;
export function withOpportunity<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OpportunityQuery,
  OpportunityQueryVariables,
  OpportunityProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, OpportunityQuery, OpportunityQueryVariables, OpportunityProps<TChildProps>>(OpportunityDocument, {
      alias: 'opportunity',
      ...operationOptions
    });
};

/**
 * __useOpportunityQuery__
 *
 * To run a query within a React component, call `useOpportunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpportunityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OpportunityQuery, OpportunityQueryVariables>) {
        return ApolloReactHooks.useQuery<OpportunityQuery, OpportunityQueryVariables>(OpportunityDocument, baseOptions);
      }
export function useOpportunityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OpportunityQuery, OpportunityQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OpportunityQuery, OpportunityQueryVariables>(OpportunityDocument, baseOptions);
        }
export type OpportunityQueryHookResult = ReturnType<typeof useOpportunityQuery>;
export type OpportunityLazyQueryHookResult = ReturnType<typeof useOpportunityLazyQuery>;
export type OpportunityQueryResult = ApolloReactCommon.QueryResult<OpportunityQuery, OpportunityQueryVariables>;
export const OpportunityStatusViewDocument = gql`
    query OpportunityStatusView($id: UUID!) {
  opportunity(id: $id) {
    ...OpportunityStatusFragment
  }
}
    ${OpportunityStatusFragmentFragmentDoc}`;
export type OpportunityStatusViewComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OpportunityStatusViewQuery, OpportunityStatusViewQueryVariables>, 'query'> & ({ variables: OpportunityStatusViewQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OpportunityStatusViewComponent = (props: OpportunityStatusViewComponentProps) => (
      <ApolloReactComponents.Query<OpportunityStatusViewQuery, OpportunityStatusViewQueryVariables> query={OpportunityStatusViewDocument} {...props} />
    );
    
export type OpportunityStatusViewProps<TChildProps = {}> = ApolloReactHoc.DataProps<OpportunityStatusViewQuery, OpportunityStatusViewQueryVariables> & TChildProps;
export function withOpportunityStatusView<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OpportunityStatusViewQuery,
  OpportunityStatusViewQueryVariables,
  OpportunityStatusViewProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, OpportunityStatusViewQuery, OpportunityStatusViewQueryVariables, OpportunityStatusViewProps<TChildProps>>(OpportunityStatusViewDocument, {
      alias: 'opportunityStatusView',
      ...operationOptions
    });
};

/**
 * __useOpportunityStatusViewQuery__
 *
 * To run a query within a React component, call `useOpportunityStatusViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityStatusViewQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityStatusViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpportunityStatusViewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OpportunityStatusViewQuery, OpportunityStatusViewQueryVariables>) {
        return ApolloReactHooks.useQuery<OpportunityStatusViewQuery, OpportunityStatusViewQueryVariables>(OpportunityStatusViewDocument, baseOptions);
      }
export function useOpportunityStatusViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OpportunityStatusViewQuery, OpportunityStatusViewQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OpportunityStatusViewQuery, OpportunityStatusViewQueryVariables>(OpportunityStatusViewDocument, baseOptions);
        }
export type OpportunityStatusViewQueryHookResult = ReturnType<typeof useOpportunityStatusViewQuery>;
export type OpportunityStatusViewLazyQueryHookResult = ReturnType<typeof useOpportunityStatusViewLazyQuery>;
export type OpportunityStatusViewQueryResult = ApolloReactCommon.QueryResult<OpportunityStatusViewQuery, OpportunityStatusViewQueryVariables>;
export const OpportunityStakeholdersDocument = gql`
    query opportunityStakeholders($id: UUID!) {
  opportunity(id: $id) {
    id
    account_id
    stakeholders {
      ...AccountRelationshipData
    }
  }
}
    ${AccountRelationshipDataFragmentDoc}`;
export type OpportunityStakeholdersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OpportunityStakeholdersQuery, OpportunityStakeholdersQueryVariables>, 'query'> & ({ variables: OpportunityStakeholdersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OpportunityStakeholdersComponent = (props: OpportunityStakeholdersComponentProps) => (
      <ApolloReactComponents.Query<OpportunityStakeholdersQuery, OpportunityStakeholdersQueryVariables> query={OpportunityStakeholdersDocument} {...props} />
    );
    
export type OpportunityStakeholdersProps<TChildProps = {}> = ApolloReactHoc.DataProps<OpportunityStakeholdersQuery, OpportunityStakeholdersQueryVariables> & TChildProps;
export function withOpportunityStakeholders<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OpportunityStakeholdersQuery,
  OpportunityStakeholdersQueryVariables,
  OpportunityStakeholdersProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, OpportunityStakeholdersQuery, OpportunityStakeholdersQueryVariables, OpportunityStakeholdersProps<TChildProps>>(OpportunityStakeholdersDocument, {
      alias: 'opportunityStakeholders',
      ...operationOptions
    });
};

/**
 * __useOpportunityStakeholdersQuery__
 *
 * To run a query within a React component, call `useOpportunityStakeholdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityStakeholdersQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityStakeholdersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpportunityStakeholdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OpportunityStakeholdersQuery, OpportunityStakeholdersQueryVariables>) {
        return ApolloReactHooks.useQuery<OpportunityStakeholdersQuery, OpportunityStakeholdersQueryVariables>(OpportunityStakeholdersDocument, baseOptions);
      }
export function useOpportunityStakeholdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OpportunityStakeholdersQuery, OpportunityStakeholdersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OpportunityStakeholdersQuery, OpportunityStakeholdersQueryVariables>(OpportunityStakeholdersDocument, baseOptions);
        }
export type OpportunityStakeholdersQueryHookResult = ReturnType<typeof useOpportunityStakeholdersQuery>;
export type OpportunityStakeholdersLazyQueryHookResult = ReturnType<typeof useOpportunityStakeholdersLazyQuery>;
export type OpportunityStakeholdersQueryResult = ApolloReactCommon.QueryResult<OpportunityStakeholdersQuery, OpportunityStakeholdersQueryVariables>;
export const OpportunityPricingDocument = gql`
    query opportunityPricing($id: UUID!) {
  opportunity(id: $id) {
    id
    company {
      id
      last_round_estimated_number_of_shares
    }
    trade_intent {
      ...TradeIntentFragment
    }
  }
}
    ${TradeIntentFragmentFragmentDoc}`;
export type OpportunityPricingComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OpportunityPricingQuery, OpportunityPricingQueryVariables>, 'query'> & ({ variables: OpportunityPricingQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OpportunityPricingComponent = (props: OpportunityPricingComponentProps) => (
      <ApolloReactComponents.Query<OpportunityPricingQuery, OpportunityPricingQueryVariables> query={OpportunityPricingDocument} {...props} />
    );
    
export type OpportunityPricingProps<TChildProps = {}> = ApolloReactHoc.DataProps<OpportunityPricingQuery, OpportunityPricingQueryVariables> & TChildProps;
export function withOpportunityPricing<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OpportunityPricingQuery,
  OpportunityPricingQueryVariables,
  OpportunityPricingProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, OpportunityPricingQuery, OpportunityPricingQueryVariables, OpportunityPricingProps<TChildProps>>(OpportunityPricingDocument, {
      alias: 'opportunityPricing',
      ...operationOptions
    });
};

/**
 * __useOpportunityPricingQuery__
 *
 * To run a query within a React component, call `useOpportunityPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityPricingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpportunityPricingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OpportunityPricingQuery, OpportunityPricingQueryVariables>) {
        return ApolloReactHooks.useQuery<OpportunityPricingQuery, OpportunityPricingQueryVariables>(OpportunityPricingDocument, baseOptions);
      }
export function useOpportunityPricingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OpportunityPricingQuery, OpportunityPricingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OpportunityPricingQuery, OpportunityPricingQueryVariables>(OpportunityPricingDocument, baseOptions);
        }
export type OpportunityPricingQueryHookResult = ReturnType<typeof useOpportunityPricingQuery>;
export type OpportunityPricingLazyQueryHookResult = ReturnType<typeof useOpportunityPricingLazyQuery>;
export type OpportunityPricingQueryResult = ApolloReactCommon.QueryResult<OpportunityPricingQuery, OpportunityPricingQueryVariables>;
export const AccountRelationshipsTypeaheadDocument = gql`
    query accountRelationshipsTypeahead($query: String!, $accountId: UUID!) {
  accountRelationshipsTypeahead(query: $query, limit: 15, accountId: $accountId) {
    ...AccountRelationshipData
  }
}
    ${AccountRelationshipDataFragmentDoc}`;
export type AccountRelationshipsTypeaheadComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountRelationshipsTypeaheadQuery, AccountRelationshipsTypeaheadQueryVariables>, 'query'> & ({ variables: AccountRelationshipsTypeaheadQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountRelationshipsTypeaheadComponent = (props: AccountRelationshipsTypeaheadComponentProps) => (
      <ApolloReactComponents.Query<AccountRelationshipsTypeaheadQuery, AccountRelationshipsTypeaheadQueryVariables> query={AccountRelationshipsTypeaheadDocument} {...props} />
    );
    
export type AccountRelationshipsTypeaheadProps<TChildProps = {}> = ApolloReactHoc.DataProps<AccountRelationshipsTypeaheadQuery, AccountRelationshipsTypeaheadQueryVariables> & TChildProps;
export function withAccountRelationshipsTypeahead<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountRelationshipsTypeaheadQuery,
  AccountRelationshipsTypeaheadQueryVariables,
  AccountRelationshipsTypeaheadProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AccountRelationshipsTypeaheadQuery, AccountRelationshipsTypeaheadQueryVariables, AccountRelationshipsTypeaheadProps<TChildProps>>(AccountRelationshipsTypeaheadDocument, {
      alias: 'accountRelationshipsTypeahead',
      ...operationOptions
    });
};

/**
 * __useAccountRelationshipsTypeaheadQuery__
 *
 * To run a query within a React component, call `useAccountRelationshipsTypeaheadQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountRelationshipsTypeaheadQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountRelationshipsTypeaheadQuery({
 *   variables: {
 *      query: // value for 'query'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountRelationshipsTypeaheadQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountRelationshipsTypeaheadQuery, AccountRelationshipsTypeaheadQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountRelationshipsTypeaheadQuery, AccountRelationshipsTypeaheadQueryVariables>(AccountRelationshipsTypeaheadDocument, baseOptions);
      }
export function useAccountRelationshipsTypeaheadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountRelationshipsTypeaheadQuery, AccountRelationshipsTypeaheadQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountRelationshipsTypeaheadQuery, AccountRelationshipsTypeaheadQueryVariables>(AccountRelationshipsTypeaheadDocument, baseOptions);
        }
export type AccountRelationshipsTypeaheadQueryHookResult = ReturnType<typeof useAccountRelationshipsTypeaheadQuery>;
export type AccountRelationshipsTypeaheadLazyQueryHookResult = ReturnType<typeof useAccountRelationshipsTypeaheadLazyQuery>;
export type AccountRelationshipsTypeaheadQueryResult = ApolloReactCommon.QueryResult<AccountRelationshipsTypeaheadQuery, AccountRelationshipsTypeaheadQueryVariables>;
export const OpportunityInteractionsDocument = gql`
    query opportunityInteractions($id: UUID!, $groupFilter: InteractionFilter) {
  opportunity(id: $id) {
    id
    account_id
    interactions(groupFilter: $groupFilter) {
      ...InteractionWithRollupsData
    }
  }
}
    ${InteractionWithRollupsDataFragmentDoc}`;
export type OpportunityInteractionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OpportunityInteractionsQuery, OpportunityInteractionsQueryVariables>, 'query'> & ({ variables: OpportunityInteractionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OpportunityInteractionsComponent = (props: OpportunityInteractionsComponentProps) => (
      <ApolloReactComponents.Query<OpportunityInteractionsQuery, OpportunityInteractionsQueryVariables> query={OpportunityInteractionsDocument} {...props} />
    );
    
export type OpportunityInteractionsProps<TChildProps = {}> = ApolloReactHoc.DataProps<OpportunityInteractionsQuery, OpportunityInteractionsQueryVariables> & TChildProps;
export function withOpportunityInteractions<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OpportunityInteractionsQuery,
  OpportunityInteractionsQueryVariables,
  OpportunityInteractionsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, OpportunityInteractionsQuery, OpportunityInteractionsQueryVariables, OpportunityInteractionsProps<TChildProps>>(OpportunityInteractionsDocument, {
      alias: 'opportunityInteractions',
      ...operationOptions
    });
};

/**
 * __useOpportunityInteractionsQuery__
 *
 * To run a query within a React component, call `useOpportunityInteractionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityInteractionsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityInteractionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      groupFilter: // value for 'groupFilter'
 *   },
 * });
 */
export function useOpportunityInteractionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OpportunityInteractionsQuery, OpportunityInteractionsQueryVariables>) {
        return ApolloReactHooks.useQuery<OpportunityInteractionsQuery, OpportunityInteractionsQueryVariables>(OpportunityInteractionsDocument, baseOptions);
      }
export function useOpportunityInteractionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OpportunityInteractionsQuery, OpportunityInteractionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OpportunityInteractionsQuery, OpportunityInteractionsQueryVariables>(OpportunityInteractionsDocument, baseOptions);
        }
export type OpportunityInteractionsQueryHookResult = ReturnType<typeof useOpportunityInteractionsQuery>;
export type OpportunityInteractionsLazyQueryHookResult = ReturnType<typeof useOpportunityInteractionsLazyQuery>;
export type OpportunityInteractionsQueryResult = ApolloReactCommon.QueryResult<OpportunityInteractionsQuery, OpportunityInteractionsQueryVariables>;
export const MinimalOpportunitiesDocument = gql`
    query minimalOpportunities($accountId: UUID!) {
  account(id: $accountId) {
    id
    opportunities {
      id
      created_at
      status
      trade_intent {
        id
        type
        share_price
        dollar_amount
      }
      account {
        id
        email
        name
      }
      company {
        id
        name
        logo_url
      }
    }
  }
}
    `;
export type MinimalOpportunitiesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MinimalOpportunitiesQuery, MinimalOpportunitiesQueryVariables>, 'query'> & ({ variables: MinimalOpportunitiesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MinimalOpportunitiesComponent = (props: MinimalOpportunitiesComponentProps) => (
      <ApolloReactComponents.Query<MinimalOpportunitiesQuery, MinimalOpportunitiesQueryVariables> query={MinimalOpportunitiesDocument} {...props} />
    );
    
export type MinimalOpportunitiesProps<TChildProps = {}> = ApolloReactHoc.DataProps<MinimalOpportunitiesQuery, MinimalOpportunitiesQueryVariables> & TChildProps;
export function withMinimalOpportunities<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MinimalOpportunitiesQuery,
  MinimalOpportunitiesQueryVariables,
  MinimalOpportunitiesProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, MinimalOpportunitiesQuery, MinimalOpportunitiesQueryVariables, MinimalOpportunitiesProps<TChildProps>>(MinimalOpportunitiesDocument, {
      alias: 'minimalOpportunities',
      ...operationOptions
    });
};

/**
 * __useMinimalOpportunitiesQuery__
 *
 * To run a query within a React component, call `useMinimalOpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMinimalOpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMinimalOpportunitiesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useMinimalOpportunitiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MinimalOpportunitiesQuery, MinimalOpportunitiesQueryVariables>) {
        return ApolloReactHooks.useQuery<MinimalOpportunitiesQuery, MinimalOpportunitiesQueryVariables>(MinimalOpportunitiesDocument, baseOptions);
      }
export function useMinimalOpportunitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MinimalOpportunitiesQuery, MinimalOpportunitiesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MinimalOpportunitiesQuery, MinimalOpportunitiesQueryVariables>(MinimalOpportunitiesDocument, baseOptions);
        }
export type MinimalOpportunitiesQueryHookResult = ReturnType<typeof useMinimalOpportunitiesQuery>;
export type MinimalOpportunitiesLazyQueryHookResult = ReturnType<typeof useMinimalOpportunitiesLazyQuery>;
export type MinimalOpportunitiesQueryResult = ApolloReactCommon.QueryResult<MinimalOpportunitiesQuery, MinimalOpportunitiesQueryVariables>;
export const GetAllOpportunitiesDocument = gql`
    query getAllOpportunities($accountId: UUID!) {
  account(id: $accountId) {
    id
    opportunities {
      ...Opportunity
    }
  }
}
    ${OpportunityFragmentDoc}`;
export type GetAllOpportunitiesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAllOpportunitiesQuery, GetAllOpportunitiesQueryVariables>, 'query'> & ({ variables: GetAllOpportunitiesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAllOpportunitiesComponent = (props: GetAllOpportunitiesComponentProps) => (
      <ApolloReactComponents.Query<GetAllOpportunitiesQuery, GetAllOpportunitiesQueryVariables> query={GetAllOpportunitiesDocument} {...props} />
    );
    
export type GetAllOpportunitiesProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetAllOpportunitiesQuery, GetAllOpportunitiesQueryVariables> & TChildProps;
export function withGetAllOpportunities<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAllOpportunitiesQuery,
  GetAllOpportunitiesQueryVariables,
  GetAllOpportunitiesProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetAllOpportunitiesQuery, GetAllOpportunitiesQueryVariables, GetAllOpportunitiesProps<TChildProps>>(GetAllOpportunitiesDocument, {
      alias: 'getAllOpportunities',
      ...operationOptions
    });
};

/**
 * __useGetAllOpportunitiesQuery__
 *
 * To run a query within a React component, call `useGetAllOpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOpportunitiesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetAllOpportunitiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllOpportunitiesQuery, GetAllOpportunitiesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllOpportunitiesQuery, GetAllOpportunitiesQueryVariables>(GetAllOpportunitiesDocument, baseOptions);
      }
export function useGetAllOpportunitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllOpportunitiesQuery, GetAllOpportunitiesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllOpportunitiesQuery, GetAllOpportunitiesQueryVariables>(GetAllOpportunitiesDocument, baseOptions);
        }
export type GetAllOpportunitiesQueryHookResult = ReturnType<typeof useGetAllOpportunitiesQuery>;
export type GetAllOpportunitiesLazyQueryHookResult = ReturnType<typeof useGetAllOpportunitiesLazyQuery>;
export type GetAllOpportunitiesQueryResult = ApolloReactCommon.QueryResult<GetAllOpportunitiesQuery, GetAllOpportunitiesQueryVariables>;
export const GetFilteredOpportunitiesDocument = gql`
    query getFilteredOpportunities($limit: Int!, $offset: Int!, $filter: OpportunityFilterInput!) {
  opportunities(limit: $limit, offset: $offset, filter: $filter) {
    count
    offset
    limit
    data {
      ...Opportunity
    }
  }
}
    ${OpportunityFragmentDoc}`;
export type GetFilteredOpportunitiesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFilteredOpportunitiesQuery, GetFilteredOpportunitiesQueryVariables>, 'query'> & ({ variables: GetFilteredOpportunitiesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetFilteredOpportunitiesComponent = (props: GetFilteredOpportunitiesComponentProps) => (
      <ApolloReactComponents.Query<GetFilteredOpportunitiesQuery, GetFilteredOpportunitiesQueryVariables> query={GetFilteredOpportunitiesDocument} {...props} />
    );
    
export type GetFilteredOpportunitiesProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetFilteredOpportunitiesQuery, GetFilteredOpportunitiesQueryVariables> & TChildProps;
export function withGetFilteredOpportunities<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFilteredOpportunitiesQuery,
  GetFilteredOpportunitiesQueryVariables,
  GetFilteredOpportunitiesProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetFilteredOpportunitiesQuery, GetFilteredOpportunitiesQueryVariables, GetFilteredOpportunitiesProps<TChildProps>>(GetFilteredOpportunitiesDocument, {
      alias: 'getFilteredOpportunities',
      ...operationOptions
    });
};

/**
 * __useGetFilteredOpportunitiesQuery__
 *
 * To run a query within a React component, call `useGetFilteredOpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilteredOpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilteredOpportunitiesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetFilteredOpportunitiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFilteredOpportunitiesQuery, GetFilteredOpportunitiesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFilteredOpportunitiesQuery, GetFilteredOpportunitiesQueryVariables>(GetFilteredOpportunitiesDocument, baseOptions);
      }
export function useGetFilteredOpportunitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFilteredOpportunitiesQuery, GetFilteredOpportunitiesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFilteredOpportunitiesQuery, GetFilteredOpportunitiesQueryVariables>(GetFilteredOpportunitiesDocument, baseOptions);
        }
export type GetFilteredOpportunitiesQueryHookResult = ReturnType<typeof useGetFilteredOpportunitiesQuery>;
export type GetFilteredOpportunitiesLazyQueryHookResult = ReturnType<typeof useGetFilteredOpportunitiesLazyQuery>;
export type GetFilteredOpportunitiesQueryResult = ApolloReactCommon.QueryResult<GetFilteredOpportunitiesQuery, GetFilteredOpportunitiesQueryVariables>;
export const OpportunityHeaderDocument = gql`
    query opportunityHeader($opportunityId: UUID!) {
  opportunity(id: $opportunityId) {
    id
    type
    created_at
    latest_activity
    status
    certainty
    source
    company {
      id
      name
      logo_url
      crm_account {
        id
      }
    }
    trade_intent {
      id
      type
      share_price
      max_dollar_amount
      min_dollar_amount
      min_num_shares
      max_num_shares
      valuation
      size_type
      acceptable_structures
      fee
    }
    account {
      id
      name
      email
    }
  }
}
    `;
export type OpportunityHeaderComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OpportunityHeaderQuery, OpportunityHeaderQueryVariables>, 'query'> & ({ variables: OpportunityHeaderQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OpportunityHeaderComponent = (props: OpportunityHeaderComponentProps) => (
      <ApolloReactComponents.Query<OpportunityHeaderQuery, OpportunityHeaderQueryVariables> query={OpportunityHeaderDocument} {...props} />
    );
    
export type OpportunityHeaderProps<TChildProps = {}> = ApolloReactHoc.DataProps<OpportunityHeaderQuery, OpportunityHeaderQueryVariables> & TChildProps;
export function withOpportunityHeader<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OpportunityHeaderQuery,
  OpportunityHeaderQueryVariables,
  OpportunityHeaderProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, OpportunityHeaderQuery, OpportunityHeaderQueryVariables, OpportunityHeaderProps<TChildProps>>(OpportunityHeaderDocument, {
      alias: 'opportunityHeader',
      ...operationOptions
    });
};

/**
 * __useOpportunityHeaderQuery__
 *
 * To run a query within a React component, call `useOpportunityHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityHeaderQuery({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *   },
 * });
 */
export function useOpportunityHeaderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OpportunityHeaderQuery, OpportunityHeaderQueryVariables>) {
        return ApolloReactHooks.useQuery<OpportunityHeaderQuery, OpportunityHeaderQueryVariables>(OpportunityHeaderDocument, baseOptions);
      }
export function useOpportunityHeaderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OpportunityHeaderQuery, OpportunityHeaderQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OpportunityHeaderQuery, OpportunityHeaderQueryVariables>(OpportunityHeaderDocument, baseOptions);
        }
export type OpportunityHeaderQueryHookResult = ReturnType<typeof useOpportunityHeaderQuery>;
export type OpportunityHeaderLazyQueryHookResult = ReturnType<typeof useOpportunityHeaderLazyQuery>;
export type OpportunityHeaderQueryResult = ApolloReactCommon.QueryResult<OpportunityHeaderQuery, OpportunityHeaderQueryVariables>;
export const UpdateOpportunityDetailsDocument = gql`
    mutation updateOpportunityDetails($form: UpdateOpportunityDetailsFormInput!) {
  updateOpportunityDetails(form: $form) {
    ...OpportunityDetails
  }
}
    ${OpportunityDetailsFragmentDoc}`;
export type UpdateOpportunityDetailsMutationFn = ApolloReactCommon.MutationFunction<UpdateOpportunityDetailsMutation, UpdateOpportunityDetailsMutationVariables>;
export type UpdateOpportunityDetailsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateOpportunityDetailsMutation, UpdateOpportunityDetailsMutationVariables>, 'mutation'>;

    export const UpdateOpportunityDetailsComponent = (props: UpdateOpportunityDetailsComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateOpportunityDetailsMutation, UpdateOpportunityDetailsMutationVariables> mutation={UpdateOpportunityDetailsDocument} {...props} />
    );
    
export type UpdateOpportunityDetailsProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateOpportunityDetailsMutation, UpdateOpportunityDetailsMutationVariables> & TChildProps;
export function withUpdateOpportunityDetails<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateOpportunityDetailsMutation,
  UpdateOpportunityDetailsMutationVariables,
  UpdateOpportunityDetailsProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateOpportunityDetailsMutation, UpdateOpportunityDetailsMutationVariables, UpdateOpportunityDetailsProps<TChildProps>>(UpdateOpportunityDetailsDocument, {
      alias: 'updateOpportunityDetails',
      ...operationOptions
    });
};

/**
 * __useUpdateOpportunityDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateOpportunityDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOpportunityDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOpportunityDetailsMutation, { data, loading, error }] = useUpdateOpportunityDetailsMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateOpportunityDetailsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOpportunityDetailsMutation, UpdateOpportunityDetailsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateOpportunityDetailsMutation, UpdateOpportunityDetailsMutationVariables>(UpdateOpportunityDetailsDocument, baseOptions);
      }
export type UpdateOpportunityDetailsMutationHookResult = ReturnType<typeof useUpdateOpportunityDetailsMutation>;
export type UpdateOpportunityDetailsMutationResult = ApolloReactCommon.MutationResult<UpdateOpportunityDetailsMutation>;
export type UpdateOpportunityDetailsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOpportunityDetailsMutation, UpdateOpportunityDetailsMutationVariables>;
export const ApplyOpportunityActionDocument = gql`
    mutation applyOpportunityAction($form: OpportunityActionInput!) {
  applyOpportunityAction(form: $form) {
    ...OpportunityDetails
  }
}
    ${OpportunityDetailsFragmentDoc}`;
export type ApplyOpportunityActionMutationFn = ApolloReactCommon.MutationFunction<ApplyOpportunityActionMutation, ApplyOpportunityActionMutationVariables>;
export type ApplyOpportunityActionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ApplyOpportunityActionMutation, ApplyOpportunityActionMutationVariables>, 'mutation'>;

    export const ApplyOpportunityActionComponent = (props: ApplyOpportunityActionComponentProps) => (
      <ApolloReactComponents.Mutation<ApplyOpportunityActionMutation, ApplyOpportunityActionMutationVariables> mutation={ApplyOpportunityActionDocument} {...props} />
    );
    
export type ApplyOpportunityActionProps<TChildProps = {}> = ApolloReactHoc.MutateProps<ApplyOpportunityActionMutation, ApplyOpportunityActionMutationVariables> & TChildProps;
export function withApplyOpportunityAction<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ApplyOpportunityActionMutation,
  ApplyOpportunityActionMutationVariables,
  ApplyOpportunityActionProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, ApplyOpportunityActionMutation, ApplyOpportunityActionMutationVariables, ApplyOpportunityActionProps<TChildProps>>(ApplyOpportunityActionDocument, {
      alias: 'applyOpportunityAction',
      ...operationOptions
    });
};

/**
 * __useApplyOpportunityActionMutation__
 *
 * To run a mutation, you first call `useApplyOpportunityActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyOpportunityActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyOpportunityActionMutation, { data, loading, error }] = useApplyOpportunityActionMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useApplyOpportunityActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApplyOpportunityActionMutation, ApplyOpportunityActionMutationVariables>) {
        return ApolloReactHooks.useMutation<ApplyOpportunityActionMutation, ApplyOpportunityActionMutationVariables>(ApplyOpportunityActionDocument, baseOptions);
      }
export type ApplyOpportunityActionMutationHookResult = ReturnType<typeof useApplyOpportunityActionMutation>;
export type ApplyOpportunityActionMutationResult = ApolloReactCommon.MutationResult<ApplyOpportunityActionMutation>;
export type ApplyOpportunityActionMutationOptions = ApolloReactCommon.BaseMutationOptions<ApplyOpportunityActionMutation, ApplyOpportunityActionMutationVariables>;
export const ExpireOpportunityDocument = gql`
    mutation expireOpportunity($id: UUID!) {
  applyOpportunityAction(form: {opportunityId: $id, expired: true}) {
    ...OpportunityDetails
  }
}
    ${OpportunityDetailsFragmentDoc}`;
export type ExpireOpportunityMutationFn = ApolloReactCommon.MutationFunction<ExpireOpportunityMutation, ExpireOpportunityMutationVariables>;
export type ExpireOpportunityComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ExpireOpportunityMutation, ExpireOpportunityMutationVariables>, 'mutation'>;

    export const ExpireOpportunityComponent = (props: ExpireOpportunityComponentProps) => (
      <ApolloReactComponents.Mutation<ExpireOpportunityMutation, ExpireOpportunityMutationVariables> mutation={ExpireOpportunityDocument} {...props} />
    );
    
export type ExpireOpportunityProps<TChildProps = {}> = ApolloReactHoc.MutateProps<ExpireOpportunityMutation, ExpireOpportunityMutationVariables> & TChildProps;
export function withExpireOpportunity<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ExpireOpportunityMutation,
  ExpireOpportunityMutationVariables,
  ExpireOpportunityProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, ExpireOpportunityMutation, ExpireOpportunityMutationVariables, ExpireOpportunityProps<TChildProps>>(ExpireOpportunityDocument, {
      alias: 'expireOpportunity',
      ...operationOptions
    });
};

/**
 * __useExpireOpportunityMutation__
 *
 * To run a mutation, you first call `useExpireOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExpireOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [expireOpportunityMutation, { data, loading, error }] = useExpireOpportunityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExpireOpportunityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ExpireOpportunityMutation, ExpireOpportunityMutationVariables>) {
        return ApolloReactHooks.useMutation<ExpireOpportunityMutation, ExpireOpportunityMutationVariables>(ExpireOpportunityDocument, baseOptions);
      }
export type ExpireOpportunityMutationHookResult = ReturnType<typeof useExpireOpportunityMutation>;
export type ExpireOpportunityMutationResult = ApolloReactCommon.MutationResult<ExpireOpportunityMutation>;
export type ExpireOpportunityMutationOptions = ApolloReactCommon.BaseMutationOptions<ExpireOpportunityMutation, ExpireOpportunityMutationVariables>;
export const CancelOpportunityDocument = gql`
    mutation cancelOpportunity($id: UUID!, $cancellationForm: OpportunityCancellationFormInput!) {
  applyOpportunityAction(form: {opportunityId: $id, cancellation: $cancellationForm}) {
    ...OpportunityDetails
  }
}
    ${OpportunityDetailsFragmentDoc}`;
export type CancelOpportunityMutationFn = ApolloReactCommon.MutationFunction<CancelOpportunityMutation, CancelOpportunityMutationVariables>;
export type CancelOpportunityComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CancelOpportunityMutation, CancelOpportunityMutationVariables>, 'mutation'>;

    export const CancelOpportunityComponent = (props: CancelOpportunityComponentProps) => (
      <ApolloReactComponents.Mutation<CancelOpportunityMutation, CancelOpportunityMutationVariables> mutation={CancelOpportunityDocument} {...props} />
    );
    
export type CancelOpportunityProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CancelOpportunityMutation, CancelOpportunityMutationVariables> & TChildProps;
export function withCancelOpportunity<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CancelOpportunityMutation,
  CancelOpportunityMutationVariables,
  CancelOpportunityProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CancelOpportunityMutation, CancelOpportunityMutationVariables, CancelOpportunityProps<TChildProps>>(CancelOpportunityDocument, {
      alias: 'cancelOpportunity',
      ...operationOptions
    });
};

/**
 * __useCancelOpportunityMutation__
 *
 * To run a mutation, you first call `useCancelOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOpportunityMutation, { data, loading, error }] = useCancelOpportunityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      cancellationForm: // value for 'cancellationForm'
 *   },
 * });
 */
export function useCancelOpportunityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelOpportunityMutation, CancelOpportunityMutationVariables>) {
        return ApolloReactHooks.useMutation<CancelOpportunityMutation, CancelOpportunityMutationVariables>(CancelOpportunityDocument, baseOptions);
      }
export type CancelOpportunityMutationHookResult = ReturnType<typeof useCancelOpportunityMutation>;
export type CancelOpportunityMutationResult = ApolloReactCommon.MutationResult<CancelOpportunityMutation>;
export type CancelOpportunityMutationOptions = ApolloReactCommon.BaseMutationOptions<CancelOpportunityMutation, CancelOpportunityMutationVariables>;
export const OpportunityCompanyFinancingDocument = gql`
    query opportunityCompanyFinancing($opportunityId: UUID!) {
  opportunity(id: $opportunityId) {
    id
    company {
      id
      last_round {
        ...FundingRound
      }
    }
  }
}
    ${FundingRoundFragmentDoc}`;
export type OpportunityCompanyFinancingComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OpportunityCompanyFinancingQuery, OpportunityCompanyFinancingQueryVariables>, 'query'> & ({ variables: OpportunityCompanyFinancingQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OpportunityCompanyFinancingComponent = (props: OpportunityCompanyFinancingComponentProps) => (
      <ApolloReactComponents.Query<OpportunityCompanyFinancingQuery, OpportunityCompanyFinancingQueryVariables> query={OpportunityCompanyFinancingDocument} {...props} />
    );
    
export type OpportunityCompanyFinancingProps<TChildProps = {}> = ApolloReactHoc.DataProps<OpportunityCompanyFinancingQuery, OpportunityCompanyFinancingQueryVariables> & TChildProps;
export function withOpportunityCompanyFinancing<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OpportunityCompanyFinancingQuery,
  OpportunityCompanyFinancingQueryVariables,
  OpportunityCompanyFinancingProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, OpportunityCompanyFinancingQuery, OpportunityCompanyFinancingQueryVariables, OpportunityCompanyFinancingProps<TChildProps>>(OpportunityCompanyFinancingDocument, {
      alias: 'opportunityCompanyFinancing',
      ...operationOptions
    });
};

/**
 * __useOpportunityCompanyFinancingQuery__
 *
 * To run a query within a React component, call `useOpportunityCompanyFinancingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityCompanyFinancingQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityCompanyFinancingQuery({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *   },
 * });
 */
export function useOpportunityCompanyFinancingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OpportunityCompanyFinancingQuery, OpportunityCompanyFinancingQueryVariables>) {
        return ApolloReactHooks.useQuery<OpportunityCompanyFinancingQuery, OpportunityCompanyFinancingQueryVariables>(OpportunityCompanyFinancingDocument, baseOptions);
      }
export function useOpportunityCompanyFinancingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OpportunityCompanyFinancingQuery, OpportunityCompanyFinancingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OpportunityCompanyFinancingQuery, OpportunityCompanyFinancingQueryVariables>(OpportunityCompanyFinancingDocument, baseOptions);
        }
export type OpportunityCompanyFinancingQueryHookResult = ReturnType<typeof useOpportunityCompanyFinancingQuery>;
export type OpportunityCompanyFinancingLazyQueryHookResult = ReturnType<typeof useOpportunityCompanyFinancingLazyQuery>;
export type OpportunityCompanyFinancingQueryResult = ApolloReactCommon.QueryResult<OpportunityCompanyFinancingQuery, OpportunityCompanyFinancingQueryVariables>;
export const AccountTableSchemaDocument = gql`
    query accountTableSchema {
  accountsTableSchema {
    fields
  }
}
    `;
export type AccountTableSchemaComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountTableSchemaQuery, AccountTableSchemaQueryVariables>, 'query'>;

    export const AccountTableSchemaComponent = (props: AccountTableSchemaComponentProps) => (
      <ApolloReactComponents.Query<AccountTableSchemaQuery, AccountTableSchemaQueryVariables> query={AccountTableSchemaDocument} {...props} />
    );
    
export type AccountTableSchemaProps<TChildProps = {}> = ApolloReactHoc.DataProps<AccountTableSchemaQuery, AccountTableSchemaQueryVariables> & TChildProps;
export function withAccountTableSchema<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountTableSchemaQuery,
  AccountTableSchemaQueryVariables,
  AccountTableSchemaProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AccountTableSchemaQuery, AccountTableSchemaQueryVariables, AccountTableSchemaProps<TChildProps>>(AccountTableSchemaDocument, {
      alias: 'accountTableSchema',
      ...operationOptions
    });
};

/**
 * __useAccountTableSchemaQuery__
 *
 * To run a query within a React component, call `useAccountTableSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountTableSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountTableSchemaQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountTableSchemaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountTableSchemaQuery, AccountTableSchemaQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountTableSchemaQuery, AccountTableSchemaQueryVariables>(AccountTableSchemaDocument, baseOptions);
      }
export function useAccountTableSchemaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountTableSchemaQuery, AccountTableSchemaQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountTableSchemaQuery, AccountTableSchemaQueryVariables>(AccountTableSchemaDocument, baseOptions);
        }
export type AccountTableSchemaQueryHookResult = ReturnType<typeof useAccountTableSchemaQuery>;
export type AccountTableSchemaLazyQueryHookResult = ReturnType<typeof useAccountTableSchemaLazyQuery>;
export type AccountTableSchemaQueryResult = ApolloReactCommon.QueryResult<AccountTableSchemaQuery, AccountTableSchemaQueryVariables>;
export const FilteredAccountsTableDocument = gql`
    query filteredAccountsTable($query: String!, $limit: Int!, $offset: Int!) {
  filterAccounts(query: $query, limit: $limit, offset: $offset) {
    count
  }
}
    `;
export type FilteredAccountsTableComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FilteredAccountsTableQuery, FilteredAccountsTableQueryVariables>, 'query'> & ({ variables: FilteredAccountsTableQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FilteredAccountsTableComponent = (props: FilteredAccountsTableComponentProps) => (
      <ApolloReactComponents.Query<FilteredAccountsTableQuery, FilteredAccountsTableQueryVariables> query={FilteredAccountsTableDocument} {...props} />
    );
    
export type FilteredAccountsTableProps<TChildProps = {}> = ApolloReactHoc.DataProps<FilteredAccountsTableQuery, FilteredAccountsTableQueryVariables> & TChildProps;
export function withFilteredAccountsTable<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FilteredAccountsTableQuery,
  FilteredAccountsTableQueryVariables,
  FilteredAccountsTableProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, FilteredAccountsTableQuery, FilteredAccountsTableQueryVariables, FilteredAccountsTableProps<TChildProps>>(FilteredAccountsTableDocument, {
      alias: 'filteredAccountsTable',
      ...operationOptions
    });
};

/**
 * __useFilteredAccountsTableQuery__
 *
 * To run a query within a React component, call `useFilteredAccountsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredAccountsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredAccountsTableQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFilteredAccountsTableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FilteredAccountsTableQuery, FilteredAccountsTableQueryVariables>) {
        return ApolloReactHooks.useQuery<FilteredAccountsTableQuery, FilteredAccountsTableQueryVariables>(FilteredAccountsTableDocument, baseOptions);
      }
export function useFilteredAccountsTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FilteredAccountsTableQuery, FilteredAccountsTableQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FilteredAccountsTableQuery, FilteredAccountsTableQueryVariables>(FilteredAccountsTableDocument, baseOptions);
        }
export type FilteredAccountsTableQueryHookResult = ReturnType<typeof useFilteredAccountsTableQuery>;
export type FilteredAccountsTableLazyQueryHookResult = ReturnType<typeof useFilteredAccountsTableLazyQuery>;
export type FilteredAccountsTableQueryResult = ApolloReactCommon.QueryResult<FilteredAccountsTableQuery, FilteredAccountsTableQueryVariables>;
export const CreateOrUpdateSegmentDocument = gql`
    mutation createOrUpdateSegment($form: CreateOrUpdateSegmentFormInput!) {
  createOrUpdateSegment(form: $form) {
    ...SegmentQuery
  }
}
    ${SegmentQueryFragmentDoc}`;
export type CreateOrUpdateSegmentMutationFn = ApolloReactCommon.MutationFunction<CreateOrUpdateSegmentMutation, CreateOrUpdateSegmentMutationVariables>;
export type CreateOrUpdateSegmentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateOrUpdateSegmentMutation, CreateOrUpdateSegmentMutationVariables>, 'mutation'>;

    export const CreateOrUpdateSegmentComponent = (props: CreateOrUpdateSegmentComponentProps) => (
      <ApolloReactComponents.Mutation<CreateOrUpdateSegmentMutation, CreateOrUpdateSegmentMutationVariables> mutation={CreateOrUpdateSegmentDocument} {...props} />
    );
    
export type CreateOrUpdateSegmentProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CreateOrUpdateSegmentMutation, CreateOrUpdateSegmentMutationVariables> & TChildProps;
export function withCreateOrUpdateSegment<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateOrUpdateSegmentMutation,
  CreateOrUpdateSegmentMutationVariables,
  CreateOrUpdateSegmentProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CreateOrUpdateSegmentMutation, CreateOrUpdateSegmentMutationVariables, CreateOrUpdateSegmentProps<TChildProps>>(CreateOrUpdateSegmentDocument, {
      alias: 'createOrUpdateSegment',
      ...operationOptions
    });
};

/**
 * __useCreateOrUpdateSegmentMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateSegmentMutation, { data, loading, error }] = useCreateOrUpdateSegmentMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useCreateOrUpdateSegmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrUpdateSegmentMutation, CreateOrUpdateSegmentMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateOrUpdateSegmentMutation, CreateOrUpdateSegmentMutationVariables>(CreateOrUpdateSegmentDocument, baseOptions);
      }
export type CreateOrUpdateSegmentMutationHookResult = ReturnType<typeof useCreateOrUpdateSegmentMutation>;
export type CreateOrUpdateSegmentMutationResult = ApolloReactCommon.MutationResult<CreateOrUpdateSegmentMutation>;
export type CreateOrUpdateSegmentMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOrUpdateSegmentMutation, CreateOrUpdateSegmentMutationVariables>;
export const SegmentQueriesDocument = gql`
    query segmentQueries {
  segmentQueries {
    ...SegmentQuery
  }
}
    ${SegmentQueryFragmentDoc}`;
export type SegmentQueriesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SegmentQueriesQuery, SegmentQueriesQueryVariables>, 'query'>;

    export const SegmentQueriesComponent = (props: SegmentQueriesComponentProps) => (
      <ApolloReactComponents.Query<SegmentQueriesQuery, SegmentQueriesQueryVariables> query={SegmentQueriesDocument} {...props} />
    );
    
export type SegmentQueriesProps<TChildProps = {}> = ApolloReactHoc.DataProps<SegmentQueriesQuery, SegmentQueriesQueryVariables> & TChildProps;
export function withSegmentQueries<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SegmentQueriesQuery,
  SegmentQueriesQueryVariables,
  SegmentQueriesProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, SegmentQueriesQuery, SegmentQueriesQueryVariables, SegmentQueriesProps<TChildProps>>(SegmentQueriesDocument, {
      alias: 'segmentQueries',
      ...operationOptions
    });
};

/**
 * __useSegmentQueriesQuery__
 *
 * To run a query within a React component, call `useSegmentQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentQueriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSegmentQueriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SegmentQueriesQuery, SegmentQueriesQueryVariables>) {
        return ApolloReactHooks.useQuery<SegmentQueriesQuery, SegmentQueriesQueryVariables>(SegmentQueriesDocument, baseOptions);
      }
export function useSegmentQueriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SegmentQueriesQuery, SegmentQueriesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SegmentQueriesQuery, SegmentQueriesQueryVariables>(SegmentQueriesDocument, baseOptions);
        }
export type SegmentQueriesQueryHookResult = ReturnType<typeof useSegmentQueriesQuery>;
export type SegmentQueriesLazyQueryHookResult = ReturnType<typeof useSegmentQueriesLazyQuery>;
export type SegmentQueriesQueryResult = ApolloReactCommon.QueryResult<SegmentQueriesQuery, SegmentQueriesQueryVariables>;
export const SegmentDocument = gql`
    query segment($id: UUID!) {
  segmentQuery(id: $id) {
    id
    name
    query
  }
}
    `;
export type SegmentComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SegmentQuery, SegmentQueryVariables>, 'query'> & ({ variables: SegmentQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SegmentComponent = (props: SegmentComponentProps) => (
      <ApolloReactComponents.Query<SegmentQuery, SegmentQueryVariables> query={SegmentDocument} {...props} />
    );
    
export type SegmentProps<TChildProps = {}> = ApolloReactHoc.DataProps<SegmentQuery, SegmentQueryVariables> & TChildProps;
export function withSegment<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SegmentQuery,
  SegmentQueryVariables,
  SegmentProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, SegmentQuery, SegmentQueryVariables, SegmentProps<TChildProps>>(SegmentDocument, {
      alias: 'segment',
      ...operationOptions
    });
};

/**
 * __useSegmentQuery__
 *
 * To run a query within a React component, call `useSegmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSegmentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SegmentQuery, SegmentQueryVariables>) {
        return ApolloReactHooks.useQuery<SegmentQuery, SegmentQueryVariables>(SegmentDocument, baseOptions);
      }
export function useSegmentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SegmentQuery, SegmentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SegmentQuery, SegmentQueryVariables>(SegmentDocument, baseOptions);
        }
export type SegmentQueryHookResult = ReturnType<typeof useSegmentQuery>;
export type SegmentLazyQueryHookResult = ReturnType<typeof useSegmentLazyQuery>;
export type SegmentQueryResult = ApolloReactCommon.QueryResult<SegmentQuery, SegmentQueryVariables>;
export const DownloadQueryDocument = gql`
    mutation downloadQuery($query: String!) {
  exportAccountsQueryToCsv(query: $query) {
    id
    url
  }
}
    `;
export type DownloadQueryMutationFn = ApolloReactCommon.MutationFunction<DownloadQueryMutation, DownloadQueryMutationVariables>;
export type DownloadQueryComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DownloadQueryMutation, DownloadQueryMutationVariables>, 'mutation'>;

    export const DownloadQueryComponent = (props: DownloadQueryComponentProps) => (
      <ApolloReactComponents.Mutation<DownloadQueryMutation, DownloadQueryMutationVariables> mutation={DownloadQueryDocument} {...props} />
    );
    
export type DownloadQueryProps<TChildProps = {}> = ApolloReactHoc.MutateProps<DownloadQueryMutation, DownloadQueryMutationVariables> & TChildProps;
export function withDownloadQuery<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DownloadQueryMutation,
  DownloadQueryMutationVariables,
  DownloadQueryProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, DownloadQueryMutation, DownloadQueryMutationVariables, DownloadQueryProps<TChildProps>>(DownloadQueryDocument, {
      alias: 'downloadQuery',
      ...operationOptions
    });
};

/**
 * __useDownloadQueryMutation__
 *
 * To run a mutation, you first call `useDownloadQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadQueryMutation, { data, loading, error }] = useDownloadQueryMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useDownloadQueryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DownloadQueryMutation, DownloadQueryMutationVariables>) {
        return ApolloReactHooks.useMutation<DownloadQueryMutation, DownloadQueryMutationVariables>(DownloadQueryDocument, baseOptions);
      }
export type DownloadQueryMutationHookResult = ReturnType<typeof useDownloadQueryMutation>;
export type DownloadQueryMutationResult = ApolloReactCommon.MutationResult<DownloadQueryMutation>;
export type DownloadQueryMutationOptions = ApolloReactCommon.BaseMutationOptions<DownloadQueryMutation, DownloadQueryMutationVariables>;
export const AllTodosDocument = gql`
    query allTodos {
  allTodos {
    ...Todo
  }
}
    ${TodoFragmentDoc}`;
export type AllTodosComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AllTodosQuery, AllTodosQueryVariables>, 'query'>;

    export const AllTodosComponent = (props: AllTodosComponentProps) => (
      <ApolloReactComponents.Query<AllTodosQuery, AllTodosQueryVariables> query={AllTodosDocument} {...props} />
    );
    
export type AllTodosProps<TChildProps = {}> = ApolloReactHoc.DataProps<AllTodosQuery, AllTodosQueryVariables> & TChildProps;
export function withAllTodos<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AllTodosQuery,
  AllTodosQueryVariables,
  AllTodosProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AllTodosQuery, AllTodosQueryVariables, AllTodosProps<TChildProps>>(AllTodosDocument, {
      alias: 'allTodos',
      ...operationOptions
    });
};

/**
 * __useAllTodosQuery__
 *
 * To run a query within a React component, call `useAllTodosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTodosQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTodosQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllTodosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllTodosQuery, AllTodosQueryVariables>) {
        return ApolloReactHooks.useQuery<AllTodosQuery, AllTodosQueryVariables>(AllTodosDocument, baseOptions);
      }
export function useAllTodosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllTodosQuery, AllTodosQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AllTodosQuery, AllTodosQueryVariables>(AllTodosDocument, baseOptions);
        }
export type AllTodosQueryHookResult = ReturnType<typeof useAllTodosQuery>;
export type AllTodosLazyQueryHookResult = ReturnType<typeof useAllTodosLazyQuery>;
export type AllTodosQueryResult = ApolloReactCommon.QueryResult<AllTodosQuery, AllTodosQueryVariables>;
export const ClaimAccountRollupDocument = gql`
    query claimAccountRollup($accountId: UUID!) {
  account(id: $accountId) {
    ...ClaimAccountRollup
  }
  currentAdmin {
    id
  }
}
    ${ClaimAccountRollupFragmentDoc}`;
export type ClaimAccountRollupComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ClaimAccountRollupQuery, ClaimAccountRollupQueryVariables>, 'query'> & ({ variables: ClaimAccountRollupQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ClaimAccountRollupComponent = (props: ClaimAccountRollupComponentProps) => (
      <ApolloReactComponents.Query<ClaimAccountRollupQuery, ClaimAccountRollupQueryVariables> query={ClaimAccountRollupDocument} {...props} />
    );
    
export type ClaimAccountRollupProps<TChildProps = {}> = ApolloReactHoc.DataProps<ClaimAccountRollupQuery, ClaimAccountRollupQueryVariables> & TChildProps;
export function withClaimAccountRollup<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ClaimAccountRollupQuery,
  ClaimAccountRollupQueryVariables,
  ClaimAccountRollupProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, ClaimAccountRollupQuery, ClaimAccountRollupQueryVariables, ClaimAccountRollupProps<TChildProps>>(ClaimAccountRollupDocument, {
      alias: 'claimAccountRollup',
      ...operationOptions
    });
};

/**
 * __useClaimAccountRollupQuery__
 *
 * To run a query within a React component, call `useClaimAccountRollupQuery` and pass it any options that fit your needs.
 * When your component renders, `useClaimAccountRollupQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClaimAccountRollupQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useClaimAccountRollupQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ClaimAccountRollupQuery, ClaimAccountRollupQueryVariables>) {
        return ApolloReactHooks.useQuery<ClaimAccountRollupQuery, ClaimAccountRollupQueryVariables>(ClaimAccountRollupDocument, baseOptions);
      }
export function useClaimAccountRollupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClaimAccountRollupQuery, ClaimAccountRollupQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ClaimAccountRollupQuery, ClaimAccountRollupQueryVariables>(ClaimAccountRollupDocument, baseOptions);
        }
export type ClaimAccountRollupQueryHookResult = ReturnType<typeof useClaimAccountRollupQuery>;
export type ClaimAccountRollupLazyQueryHookResult = ReturnType<typeof useClaimAccountRollupLazyQuery>;
export type ClaimAccountRollupQueryResult = ApolloReactCommon.QueryResult<ClaimAccountRollupQuery, ClaimAccountRollupQueryVariables>;
export const AccountOutreachRollupDocument = gql`
    query accountOutreachRollup($accountId: UUID!) {
  account(id: $accountId) {
    ...AccountOutreachRollup
  }
  currentAdmin {
    id
  }
}
    ${AccountOutreachRollupFragmentDoc}`;
export type AccountOutreachRollupComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountOutreachRollupQuery, AccountOutreachRollupQueryVariables>, 'query'> & ({ variables: AccountOutreachRollupQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountOutreachRollupComponent = (props: AccountOutreachRollupComponentProps) => (
      <ApolloReactComponents.Query<AccountOutreachRollupQuery, AccountOutreachRollupQueryVariables> query={AccountOutreachRollupDocument} {...props} />
    );
    
export type AccountOutreachRollupProps<TChildProps = {}> = ApolloReactHoc.DataProps<AccountOutreachRollupQuery, AccountOutreachRollupQueryVariables> & TChildProps;
export function withAccountOutreachRollup<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountOutreachRollupQuery,
  AccountOutreachRollupQueryVariables,
  AccountOutreachRollupProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AccountOutreachRollupQuery, AccountOutreachRollupQueryVariables, AccountOutreachRollupProps<TChildProps>>(AccountOutreachRollupDocument, {
      alias: 'accountOutreachRollup',
      ...operationOptions
    });
};

/**
 * __useAccountOutreachRollupQuery__
 *
 * To run a query within a React component, call `useAccountOutreachRollupQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountOutreachRollupQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountOutreachRollupQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountOutreachRollupQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountOutreachRollupQuery, AccountOutreachRollupQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountOutreachRollupQuery, AccountOutreachRollupQueryVariables>(AccountOutreachRollupDocument, baseOptions);
      }
export function useAccountOutreachRollupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountOutreachRollupQuery, AccountOutreachRollupQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountOutreachRollupQuery, AccountOutreachRollupQueryVariables>(AccountOutreachRollupDocument, baseOptions);
        }
export type AccountOutreachRollupQueryHookResult = ReturnType<typeof useAccountOutreachRollupQuery>;
export type AccountOutreachRollupLazyQueryHookResult = ReturnType<typeof useAccountOutreachRollupLazyQuery>;
export type AccountOutreachRollupQueryResult = ApolloReactCommon.QueryResult<AccountOutreachRollupQuery, AccountOutreachRollupQueryVariables>;
export const DismissReminderDocument = gql`
    mutation dismissReminder($reminderId: UUID!) {
  dismissTodo(id: $reminderId)
}
    `;
export type DismissReminderMutationFn = ApolloReactCommon.MutationFunction<DismissReminderMutation, DismissReminderMutationVariables>;
export type DismissReminderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DismissReminderMutation, DismissReminderMutationVariables>, 'mutation'>;

    export const DismissReminderComponent = (props: DismissReminderComponentProps) => (
      <ApolloReactComponents.Mutation<DismissReminderMutation, DismissReminderMutationVariables> mutation={DismissReminderDocument} {...props} />
    );
    
export type DismissReminderProps<TChildProps = {}> = ApolloReactHoc.MutateProps<DismissReminderMutation, DismissReminderMutationVariables> & TChildProps;
export function withDismissReminder<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DismissReminderMutation,
  DismissReminderMutationVariables,
  DismissReminderProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, DismissReminderMutation, DismissReminderMutationVariables, DismissReminderProps<TChildProps>>(DismissReminderDocument, {
      alias: 'dismissReminder',
      ...operationOptions
    });
};

/**
 * __useDismissReminderMutation__
 *
 * To run a mutation, you first call `useDismissReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissReminderMutation, { data, loading, error }] = useDismissReminderMutation({
 *   variables: {
 *      reminderId: // value for 'reminderId'
 *   },
 * });
 */
export function useDismissReminderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DismissReminderMutation, DismissReminderMutationVariables>) {
        return ApolloReactHooks.useMutation<DismissReminderMutation, DismissReminderMutationVariables>(DismissReminderDocument, baseOptions);
      }
export type DismissReminderMutationHookResult = ReturnType<typeof useDismissReminderMutation>;
export type DismissReminderMutationResult = ApolloReactCommon.MutationResult<DismissReminderMutation>;
export type DismissReminderMutationOptions = ApolloReactCommon.BaseMutationOptions<DismissReminderMutation, DismissReminderMutationVariables>;
export const RestoreReminderDocument = gql`
    mutation restoreReminder($reminderId: UUID!) {
  restoreTodo(id: $reminderId)
}
    `;
export type RestoreReminderMutationFn = ApolloReactCommon.MutationFunction<RestoreReminderMutation, RestoreReminderMutationVariables>;
export type RestoreReminderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RestoreReminderMutation, RestoreReminderMutationVariables>, 'mutation'>;

    export const RestoreReminderComponent = (props: RestoreReminderComponentProps) => (
      <ApolloReactComponents.Mutation<RestoreReminderMutation, RestoreReminderMutationVariables> mutation={RestoreReminderDocument} {...props} />
    );
    
export type RestoreReminderProps<TChildProps = {}> = ApolloReactHoc.MutateProps<RestoreReminderMutation, RestoreReminderMutationVariables> & TChildProps;
export function withRestoreReminder<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RestoreReminderMutation,
  RestoreReminderMutationVariables,
  RestoreReminderProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, RestoreReminderMutation, RestoreReminderMutationVariables, RestoreReminderProps<TChildProps>>(RestoreReminderDocument, {
      alias: 'restoreReminder',
      ...operationOptions
    });
};

/**
 * __useRestoreReminderMutation__
 *
 * To run a mutation, you first call `useRestoreReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreReminderMutation, { data, loading, error }] = useRestoreReminderMutation({
 *   variables: {
 *      reminderId: // value for 'reminderId'
 *   },
 * });
 */
export function useRestoreReminderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RestoreReminderMutation, RestoreReminderMutationVariables>) {
        return ApolloReactHooks.useMutation<RestoreReminderMutation, RestoreReminderMutationVariables>(RestoreReminderDocument, baseOptions);
      }
export type RestoreReminderMutationHookResult = ReturnType<typeof useRestoreReminderMutation>;
export type RestoreReminderMutationResult = ApolloReactCommon.MutationResult<RestoreReminderMutation>;
export type RestoreReminderMutationOptions = ApolloReactCommon.BaseMutationOptions<RestoreReminderMutation, RestoreReminderMutationVariables>;
export const SetOutreachScheduleDocument = gql`
    mutation setOutreachSchedule($accountId: UUID!, $schedule: Duration) {
  setOutreachSchedule(accountId: $accountId, schedule: $schedule) {
    id
    outreach_schedule
  }
}
    `;
export type SetOutreachScheduleMutationFn = ApolloReactCommon.MutationFunction<SetOutreachScheduleMutation, SetOutreachScheduleMutationVariables>;
export type SetOutreachScheduleComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SetOutreachScheduleMutation, SetOutreachScheduleMutationVariables>, 'mutation'>;

    export const SetOutreachScheduleComponent = (props: SetOutreachScheduleComponentProps) => (
      <ApolloReactComponents.Mutation<SetOutreachScheduleMutation, SetOutreachScheduleMutationVariables> mutation={SetOutreachScheduleDocument} {...props} />
    );
    
export type SetOutreachScheduleProps<TChildProps = {}> = ApolloReactHoc.MutateProps<SetOutreachScheduleMutation, SetOutreachScheduleMutationVariables> & TChildProps;
export function withSetOutreachSchedule<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SetOutreachScheduleMutation,
  SetOutreachScheduleMutationVariables,
  SetOutreachScheduleProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, SetOutreachScheduleMutation, SetOutreachScheduleMutationVariables, SetOutreachScheduleProps<TChildProps>>(SetOutreachScheduleDocument, {
      alias: 'setOutreachSchedule',
      ...operationOptions
    });
};

/**
 * __useSetOutreachScheduleMutation__
 *
 * To run a mutation, you first call `useSetOutreachScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOutreachScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOutreachScheduleMutation, { data, loading, error }] = useSetOutreachScheduleMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      schedule: // value for 'schedule'
 *   },
 * });
 */
export function useSetOutreachScheduleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetOutreachScheduleMutation, SetOutreachScheduleMutationVariables>) {
        return ApolloReactHooks.useMutation<SetOutreachScheduleMutation, SetOutreachScheduleMutationVariables>(SetOutreachScheduleDocument, baseOptions);
      }
export type SetOutreachScheduleMutationHookResult = ReturnType<typeof useSetOutreachScheduleMutation>;
export type SetOutreachScheduleMutationResult = ApolloReactCommon.MutationResult<SetOutreachScheduleMutation>;
export type SetOutreachScheduleMutationOptions = ApolloReactCommon.BaseMutationOptions<SetOutreachScheduleMutation, SetOutreachScheduleMutationVariables>;
export const ResetOutreachScheduleDocument = gql`
    mutation resetOutreachSchedule($accountId: UUID!) {
  resetOutreachSchedule(accountId: $accountId) {
    id
    outreach_schedule
  }
}
    `;
export type ResetOutreachScheduleMutationFn = ApolloReactCommon.MutationFunction<ResetOutreachScheduleMutation, ResetOutreachScheduleMutationVariables>;
export type ResetOutreachScheduleComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ResetOutreachScheduleMutation, ResetOutreachScheduleMutationVariables>, 'mutation'>;

    export const ResetOutreachScheduleComponent = (props: ResetOutreachScheduleComponentProps) => (
      <ApolloReactComponents.Mutation<ResetOutreachScheduleMutation, ResetOutreachScheduleMutationVariables> mutation={ResetOutreachScheduleDocument} {...props} />
    );
    
export type ResetOutreachScheduleProps<TChildProps = {}> = ApolloReactHoc.MutateProps<ResetOutreachScheduleMutation, ResetOutreachScheduleMutationVariables> & TChildProps;
export function withResetOutreachSchedule<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ResetOutreachScheduleMutation,
  ResetOutreachScheduleMutationVariables,
  ResetOutreachScheduleProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, ResetOutreachScheduleMutation, ResetOutreachScheduleMutationVariables, ResetOutreachScheduleProps<TChildProps>>(ResetOutreachScheduleDocument, {
      alias: 'resetOutreachSchedule',
      ...operationOptions
    });
};

/**
 * __useResetOutreachScheduleMutation__
 *
 * To run a mutation, you first call `useResetOutreachScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetOutreachScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetOutreachScheduleMutation, { data, loading, error }] = useResetOutreachScheduleMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useResetOutreachScheduleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetOutreachScheduleMutation, ResetOutreachScheduleMutationVariables>) {
        return ApolloReactHooks.useMutation<ResetOutreachScheduleMutation, ResetOutreachScheduleMutationVariables>(ResetOutreachScheduleDocument, baseOptions);
      }
export type ResetOutreachScheduleMutationHookResult = ReturnType<typeof useResetOutreachScheduleMutation>;
export type ResetOutreachScheduleMutationResult = ApolloReactCommon.MutationResult<ResetOutreachScheduleMutation>;
export type ResetOutreachScheduleMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetOutreachScheduleMutation, ResetOutreachScheduleMutationVariables>;
export const QuickAssignFirstOwnerDocument = gql`
    mutation quickAssignFirstOwner($accountId: UUID!, $ownerId: Int!) {
  quickAssignFirstOwner(accountId: $accountId, ownerId: $ownerId) {
    id
    owners {
      ...Owner
    }
  }
}
    ${OwnerFragmentDoc}`;
export type QuickAssignFirstOwnerMutationFn = ApolloReactCommon.MutationFunction<QuickAssignFirstOwnerMutation, QuickAssignFirstOwnerMutationVariables>;
export type QuickAssignFirstOwnerComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<QuickAssignFirstOwnerMutation, QuickAssignFirstOwnerMutationVariables>, 'mutation'>;

    export const QuickAssignFirstOwnerComponent = (props: QuickAssignFirstOwnerComponentProps) => (
      <ApolloReactComponents.Mutation<QuickAssignFirstOwnerMutation, QuickAssignFirstOwnerMutationVariables> mutation={QuickAssignFirstOwnerDocument} {...props} />
    );
    
export type QuickAssignFirstOwnerProps<TChildProps = {}> = ApolloReactHoc.MutateProps<QuickAssignFirstOwnerMutation, QuickAssignFirstOwnerMutationVariables> & TChildProps;
export function withQuickAssignFirstOwner<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  QuickAssignFirstOwnerMutation,
  QuickAssignFirstOwnerMutationVariables,
  QuickAssignFirstOwnerProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, QuickAssignFirstOwnerMutation, QuickAssignFirstOwnerMutationVariables, QuickAssignFirstOwnerProps<TChildProps>>(QuickAssignFirstOwnerDocument, {
      alias: 'quickAssignFirstOwner',
      ...operationOptions
    });
};

/**
 * __useQuickAssignFirstOwnerMutation__
 *
 * To run a mutation, you first call `useQuickAssignFirstOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuickAssignFirstOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quickAssignFirstOwnerMutation, { data, loading, error }] = useQuickAssignFirstOwnerMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      ownerId: // value for 'ownerId'
 *   },
 * });
 */
export function useQuickAssignFirstOwnerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<QuickAssignFirstOwnerMutation, QuickAssignFirstOwnerMutationVariables>) {
        return ApolloReactHooks.useMutation<QuickAssignFirstOwnerMutation, QuickAssignFirstOwnerMutationVariables>(QuickAssignFirstOwnerDocument, baseOptions);
      }
export type QuickAssignFirstOwnerMutationHookResult = ReturnType<typeof useQuickAssignFirstOwnerMutation>;
export type QuickAssignFirstOwnerMutationResult = ApolloReactCommon.MutationResult<QuickAssignFirstOwnerMutation>;
export type QuickAssignFirstOwnerMutationOptions = ApolloReactCommon.BaseMutationOptions<QuickAssignFirstOwnerMutation, QuickAssignFirstOwnerMutationVariables>;
export const AddProfileAccountTodoDocument = gql`
    mutation addProfileAccountTodo($assigneeId: Int!, $accountId: UUID!) {
  addProfileAccountTodo(assigneeId: $assigneeId, accountId: $accountId) {
    id
    meta
  }
}
    `;
export type AddProfileAccountTodoMutationFn = ApolloReactCommon.MutationFunction<AddProfileAccountTodoMutation, AddProfileAccountTodoMutationVariables>;
export type AddProfileAccountTodoComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddProfileAccountTodoMutation, AddProfileAccountTodoMutationVariables>, 'mutation'>;

    export const AddProfileAccountTodoComponent = (props: AddProfileAccountTodoComponentProps) => (
      <ApolloReactComponents.Mutation<AddProfileAccountTodoMutation, AddProfileAccountTodoMutationVariables> mutation={AddProfileAccountTodoDocument} {...props} />
    );
    
export type AddProfileAccountTodoProps<TChildProps = {}> = ApolloReactHoc.MutateProps<AddProfileAccountTodoMutation, AddProfileAccountTodoMutationVariables> & TChildProps;
export function withAddProfileAccountTodo<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddProfileAccountTodoMutation,
  AddProfileAccountTodoMutationVariables,
  AddProfileAccountTodoProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, AddProfileAccountTodoMutation, AddProfileAccountTodoMutationVariables, AddProfileAccountTodoProps<TChildProps>>(AddProfileAccountTodoDocument, {
      alias: 'addProfileAccountTodo',
      ...operationOptions
    });
};

/**
 * __useAddProfileAccountTodoMutation__
 *
 * To run a mutation, you first call `useAddProfileAccountTodoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProfileAccountTodoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProfileAccountTodoMutation, { data, loading, error }] = useAddProfileAccountTodoMutation({
 *   variables: {
 *      assigneeId: // value for 'assigneeId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAddProfileAccountTodoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddProfileAccountTodoMutation, AddProfileAccountTodoMutationVariables>) {
        return ApolloReactHooks.useMutation<AddProfileAccountTodoMutation, AddProfileAccountTodoMutationVariables>(AddProfileAccountTodoDocument, baseOptions);
      }
export type AddProfileAccountTodoMutationHookResult = ReturnType<typeof useAddProfileAccountTodoMutation>;
export type AddProfileAccountTodoMutationResult = ApolloReactCommon.MutationResult<AddProfileAccountTodoMutation>;
export type AddProfileAccountTodoMutationOptions = ApolloReactCommon.BaseMutationOptions<AddProfileAccountTodoMutation, AddProfileAccountTodoMutationVariables>;
export const AddLeadDocument = gql`
    mutation addLead($accountId: UUID!) {
  addLead(accountId: $accountId) {
    id
    name
  }
}
    `;
export type AddLeadMutationFn = ApolloReactCommon.MutationFunction<AddLeadMutation, AddLeadMutationVariables>;
export type AddLeadComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddLeadMutation, AddLeadMutationVariables>, 'mutation'>;

    export const AddLeadComponent = (props: AddLeadComponentProps) => (
      <ApolloReactComponents.Mutation<AddLeadMutation, AddLeadMutationVariables> mutation={AddLeadDocument} {...props} />
    );
    
export type AddLeadProps<TChildProps = {}> = ApolloReactHoc.MutateProps<AddLeadMutation, AddLeadMutationVariables> & TChildProps;
export function withAddLead<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddLeadMutation,
  AddLeadMutationVariables,
  AddLeadProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, AddLeadMutation, AddLeadMutationVariables, AddLeadProps<TChildProps>>(AddLeadDocument, {
      alias: 'addLead',
      ...operationOptions
    });
};

/**
 * __useAddLeadMutation__
 *
 * To run a mutation, you first call `useAddLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLeadMutation, { data, loading, error }] = useAddLeadMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAddLeadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddLeadMutation, AddLeadMutationVariables>) {
        return ApolloReactHooks.useMutation<AddLeadMutation, AddLeadMutationVariables>(AddLeadDocument, baseOptions);
      }
export type AddLeadMutationHookResult = ReturnType<typeof useAddLeadMutation>;
export type AddLeadMutationResult = ApolloReactCommon.MutationResult<AddLeadMutation>;
export type AddLeadMutationOptions = ApolloReactCommon.BaseMutationOptions<AddLeadMutation, AddLeadMutationVariables>;
export const DismissLeadDocument = gql`
    mutation dismissLead($accountId: UUID!) {
  dismissLead(accountId: $accountId) {
    id
    name
  }
}
    `;
export type DismissLeadMutationFn = ApolloReactCommon.MutationFunction<DismissLeadMutation, DismissLeadMutationVariables>;
export type DismissLeadComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DismissLeadMutation, DismissLeadMutationVariables>, 'mutation'>;

    export const DismissLeadComponent = (props: DismissLeadComponentProps) => (
      <ApolloReactComponents.Mutation<DismissLeadMutation, DismissLeadMutationVariables> mutation={DismissLeadDocument} {...props} />
    );
    
export type DismissLeadProps<TChildProps = {}> = ApolloReactHoc.MutateProps<DismissLeadMutation, DismissLeadMutationVariables> & TChildProps;
export function withDismissLead<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DismissLeadMutation,
  DismissLeadMutationVariables,
  DismissLeadProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, DismissLeadMutation, DismissLeadMutationVariables, DismissLeadProps<TChildProps>>(DismissLeadDocument, {
      alias: 'dismissLead',
      ...operationOptions
    });
};

/**
 * __useDismissLeadMutation__
 *
 * To run a mutation, you first call `useDismissLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissLeadMutation, { data, loading, error }] = useDismissLeadMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDismissLeadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DismissLeadMutation, DismissLeadMutationVariables>) {
        return ApolloReactHooks.useMutation<DismissLeadMutation, DismissLeadMutationVariables>(DismissLeadDocument, baseOptions);
      }
export type DismissLeadMutationHookResult = ReturnType<typeof useDismissLeadMutation>;
export type DismissLeadMutationResult = ApolloReactCommon.MutationResult<DismissLeadMutation>;
export type DismissLeadMutationOptions = ApolloReactCommon.BaseMutationOptions<DismissLeadMutation, DismissLeadMutationVariables>;
export const ProfileLeadDocument = gql`
    mutation profileLead($accountId: UUID!, $qualified: Boolean!) {
  profileLead(accountId: $accountId, qualified: $qualified) {
    id
    name
    qualified
  }
}
    `;
export type ProfileLeadMutationFn = ApolloReactCommon.MutationFunction<ProfileLeadMutation, ProfileLeadMutationVariables>;
export type ProfileLeadComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ProfileLeadMutation, ProfileLeadMutationVariables>, 'mutation'>;

    export const ProfileLeadComponent = (props: ProfileLeadComponentProps) => (
      <ApolloReactComponents.Mutation<ProfileLeadMutation, ProfileLeadMutationVariables> mutation={ProfileLeadDocument} {...props} />
    );
    
export type ProfileLeadProps<TChildProps = {}> = ApolloReactHoc.MutateProps<ProfileLeadMutation, ProfileLeadMutationVariables> & TChildProps;
export function withProfileLead<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProfileLeadMutation,
  ProfileLeadMutationVariables,
  ProfileLeadProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, ProfileLeadMutation, ProfileLeadMutationVariables, ProfileLeadProps<TChildProps>>(ProfileLeadDocument, {
      alias: 'profileLead',
      ...operationOptions
    });
};

/**
 * __useProfileLeadMutation__
 *
 * To run a mutation, you first call `useProfileLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileLeadMutation, { data, loading, error }] = useProfileLeadMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      qualified: // value for 'qualified'
 *   },
 * });
 */
export function useProfileLeadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProfileLeadMutation, ProfileLeadMutationVariables>) {
        return ApolloReactHooks.useMutation<ProfileLeadMutation, ProfileLeadMutationVariables>(ProfileLeadDocument, baseOptions);
      }
export type ProfileLeadMutationHookResult = ReturnType<typeof useProfileLeadMutation>;
export type ProfileLeadMutationResult = ApolloReactCommon.MutationResult<ProfileLeadMutation>;
export type ProfileLeadMutationOptions = ApolloReactCommon.BaseMutationOptions<ProfileLeadMutation, ProfileLeadMutationVariables>;
export const AssignLeadDocument = gql`
    mutation assignLead($accountId: UUID!, $assigneeId: Int!) {
  assignLead(accountId: $accountId, assigneeId: $assigneeId) {
    id
    name
    profilingAssignees {
      name
    }
  }
}
    `;
export type AssignLeadMutationFn = ApolloReactCommon.MutationFunction<AssignLeadMutation, AssignLeadMutationVariables>;
export type AssignLeadComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AssignLeadMutation, AssignLeadMutationVariables>, 'mutation'>;

    export const AssignLeadComponent = (props: AssignLeadComponentProps) => (
      <ApolloReactComponents.Mutation<AssignLeadMutation, AssignLeadMutationVariables> mutation={AssignLeadDocument} {...props} />
    );
    
export type AssignLeadProps<TChildProps = {}> = ApolloReactHoc.MutateProps<AssignLeadMutation, AssignLeadMutationVariables> & TChildProps;
export function withAssignLead<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AssignLeadMutation,
  AssignLeadMutationVariables,
  AssignLeadProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, AssignLeadMutation, AssignLeadMutationVariables, AssignLeadProps<TChildProps>>(AssignLeadDocument, {
      alias: 'assignLead',
      ...operationOptions
    });
};

/**
 * __useAssignLeadMutation__
 *
 * To run a mutation, you first call `useAssignLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignLeadMutation, { data, loading, error }] = useAssignLeadMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      assigneeId: // value for 'assigneeId'
 *   },
 * });
 */
export function useAssignLeadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignLeadMutation, AssignLeadMutationVariables>) {
        return ApolloReactHooks.useMutation<AssignLeadMutation, AssignLeadMutationVariables>(AssignLeadDocument, baseOptions);
      }
export type AssignLeadMutationHookResult = ReturnType<typeof useAssignLeadMutation>;
export type AssignLeadMutationResult = ApolloReactCommon.MutationResult<AssignLeadMutation>;
export type AssignLeadMutationOptions = ApolloReactCommon.BaseMutationOptions<AssignLeadMutation, AssignLeadMutationVariables>;
export const AllSalesUsersDocument = gql`
    query allSalesUsers {
  allUsersByCapability(capability: Sales) {
    id
    name
  }
}
    `;
export type AllSalesUsersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AllSalesUsersQuery, AllSalesUsersQueryVariables>, 'query'>;

    export const AllSalesUsersComponent = (props: AllSalesUsersComponentProps) => (
      <ApolloReactComponents.Query<AllSalesUsersQuery, AllSalesUsersQueryVariables> query={AllSalesUsersDocument} {...props} />
    );
    
export type AllSalesUsersProps<TChildProps = {}> = ApolloReactHoc.DataProps<AllSalesUsersQuery, AllSalesUsersQueryVariables> & TChildProps;
export function withAllSalesUsers<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AllSalesUsersQuery,
  AllSalesUsersQueryVariables,
  AllSalesUsersProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, AllSalesUsersQuery, AllSalesUsersQueryVariables, AllSalesUsersProps<TChildProps>>(AllSalesUsersDocument, {
      alias: 'allSalesUsers',
      ...operationOptions
    });
};

/**
 * __useAllSalesUsersQuery__
 *
 * To run a query within a React component, call `useAllSalesUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSalesUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSalesUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllSalesUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllSalesUsersQuery, AllSalesUsersQueryVariables>) {
        return ApolloReactHooks.useQuery<AllSalesUsersQuery, AllSalesUsersQueryVariables>(AllSalesUsersDocument, baseOptions);
      }
export function useAllSalesUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllSalesUsersQuery, AllSalesUsersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AllSalesUsersQuery, AllSalesUsersQueryVariables>(AllSalesUsersDocument, baseOptions);
        }
export type AllSalesUsersQueryHookResult = ReturnType<typeof useAllSalesUsersQuery>;
export type AllSalesUsersLazyQueryHookResult = ReturnType<typeof useAllSalesUsersLazyQuery>;
export type AllSalesUsersQueryResult = ApolloReactCommon.QueryResult<AllSalesUsersQuery, AllSalesUsersQueryVariables>;

      export interface IntrospectionResultData {
        __schema: {
          types: {
            kind: string;
            name: string;
            possibleTypes: {
              name: string;
            }[];
          }[];
        };
      }
      const result: IntrospectionResultData = {
  "__schema": {
    "types": [
      {
        "kind": "UNION",
        "name": "Source",
        "possibleTypes": [
          {
            "name": "AccountSource"
          },
          {
            "name": "OpportunitySource"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ProtectedViewOfBankAccountCollectionView",
        "possibleTypes": [
          {
            "name": "UnauthorizedView"
          },
          {
            "name": "AuthorizedBankAccountCollectionView"
          }
        ]
      }
    ]
  }
};
      export default result;
    